var TurnTo =
TurnToWpJsonp([10],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {function closest(el, selector) {
    var matches = Element.prototype.matches ? el.matches(selector) : el.msMatchesSelector(selector);
    if (!matches && el.parentNode.nodeName === 'BODY') {
        return null;
    }
    return matches ? el : closest(el.parentNode, selector);
}
function elementIsVisible(elem) {
    return elem && elem.offsetWidth > 0 && elem.offsetHeight > 0;
}
function getLikelyTabbableElems(parent) {
    return parent.querySelectorAll('[tabindex],a,input,select,textarea,button,object');
}
// The checkboxes and radio buttons are hidden, so not really visible, even though there
// is a radio/checkbox styled element on the screen.  So, need to do a special check
// for them.  Going to assume they are tabbable if the parent is visible
function isTabbableCheckboxOrRadio(elem) {
    var nodeName = elem.nodeName.toLowerCase();
    return nodeName === 'input' && (elem.type === 'radio' || elem.type === 'checkbox') &&
        elementIsVisible(elem.parentNode);
}
function elemHasTabIndex(elem) {
    // The checkboxes and radio buttons are hidden, so not really visible, even though there
    // is a radio/checkbox styled element on the screen.  So, need to do a special check
    // for them
    if (elementIsVisible(elem) || isTabbableCheckboxOrRadio(elem)) {
        var tabIndex = elem.getAttribute('tabindex');
        var nodeName = elem.nodeName.toLowerCase();
        var hasTabindex = tabIndex !== null && tabIndex >= 0;
        if (/^(input|select|textarea|button|object)$/.test(nodeName)) {
            hasTabindex = !elem.disabled;
            // NOTE: Not checking for disabled fieldsets. Add later if needed. The following comment
            // is from jQuery:
            // Form controls within a disabled fieldset are disabled.
            // However, controls within the fieldset's legend do not get disabled.
            // Since controls generally aren't placed inside legends, we skip
            // this portion of the check.
        }
        else if (nodeName === 'a') {
            hasTabindex = elem.href || hasTabindex;
        }
        return hasTabindex;
    }
    return false;
}
function scrollToElement(el) {
    if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
}
function whenElementIsVisible(elOrFunc, maxAttempts, attempt) {
    if (maxAttempts === void 0) { maxAttempts = 10; }
    if (attempt === void 0) { attempt = 1; }
    return new Promise(function (resolve, reject) {
        // elOrFunc is an element or a function.  If a function, it is called to get the el. This is
        // to handle cases where the method of retrieving the el must continue to be called.  The
        // most obvious case is a $refs reference that is not yet rendered
        var el = typeof elOrFunc === 'function' ? elOrFunc() : elOrFunc;
        if (elementIsVisible(el)) {
            resolve(el);
        }
        else if (attempt < maxAttempts) {
            window.requestAnimationFrame(function () {
                whenElementIsVisible(elOrFunc, maxAttempts, attempt + 1)
                    .then(function (visibleEl) { return resolve(visibleEl); }).catch(function () { return reject(); });
            });
        }
        else {
            reject();
        }
    });
}
// scrolls up to the given y value (toY).
// The rate is how far to move given a certain number of milliseconds have passed.
// previousTime is only to be set by the recursive call within this function.
function smoothScrollUp(toY, rate, previousTime) {
    if (previousTime === void 0) { previousTime = null; }
    return new Promise(function (resolve, reject) {
        if (window.pageYOffset <= toY) {
            resolve();
            return;
        }
        window.requestAnimationFrame(function (timestamp) {
            if (previousTime) {
                var elapsed = timestamp - previousTime;
                var distance = Math.min(elapsed * rate, window.pageYOffset - toY);
                window.scrollTo(window.pageXOffset, window.pageYOffset - distance);
            }
            smoothScrollUp(toY, rate, timestamp).then(function () { return resolve(); }).catch(function () { return reject(); });
        });
    });
}
function getRefEl(refs, refName) {
    var ref = refs[refName];
    if (!ref) {
        return null;
    }
    return ref.tagName ? ref : ref.$el;
}
function whenRefIsVisible(refs, refName, maxAttempts) {
    if (maxAttempts === void 0) { maxAttempts = 10; }
    return whenElementIsVisible(function () { return getRefEl(refs, refName); }, maxAttempts);
}
var domReadyPromise = null;
/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * Same functionality as jQuery.closest where the element is passed in instead of called on
     * and it returns null if closest not found.
     * @param el - element to find closest for
     * @param selector - selector being searched for to be closest
     */
    closest: closest,
    /**
     * Determines whether the given element is visible or not
     * @param - the element
     */
    elementIsVisible: elementIsVisible,
    /**
     * Returns an array of elements within the given parent element that are tabbable.
     * Basics of implementation are from jQuery.
     */
    getTabbableElements: function (parent) {
        var likelyTabbableNodeList = getLikelyTabbableElems(parent);
        var tabbableElements = [];
        for (var i = 0; i < likelyTabbableNodeList.length; i++) {
            var elem = likelyTabbableNodeList[i];
            // The checkboxes and radio buttons are hidden, so not really visible, even though there
            // is a radio/checkbox styled element on the screen.  So, need to do a special check
            // for them
            if (elemHasTabIndex(elem)) {
                tabbableElements.push(elem);
            }
        }
        return tabbableElements;
    },
    /**
     * Creates a div with the given id and appends to the body if it doesn't already exist
     * @param id
     */
    appendDivToBody: function (id) {
        if (!document.getElementById(id)) {
            var container = document.createElement('div');
            container.id = id;
            document.body.appendChild(container);
        }
    },
    /**
     * Removes child element of body with the given id
     * @param id
     */
    removeFromBody: function (id) {
        var container = document.getElementById(id);
        if (container) {
            document.body.removeChild(container);
        }
    },
    onDomReady: function () {
        if (domReadyPromise) {
            return domReadyPromise;
        }
        domReadyPromise = new Promise(function (resolve) {
            if (document.readyState === 'complete' ||
                (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
                resolve();
            }
            else {
                document.addEventListener('DOMContentLoaded', resolve());
            }
        });
        return domReadyPromise;
    },
    /**
     * Foucs on the given element when it is visible
     * @param el
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    safeFocus: function (elOrFunc, maxAttempts) {
        if (maxAttempts === void 0) { maxAttempts = 10; }
        return whenElementIsVisible(elOrFunc, maxAttempts).then(function (visibleEl) {
            visibleEl.focus();
        });
    },
    /**
     * Foucs on the given element when it is visible
     * @param refs - this would be this.$refs inside a Vue component
     * @param refName - the name of the ref, called like this.$refs[refName]
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    safeFocusRef: function (refs, refName, maxAttempts) {
        if (maxAttempts === void 0) { maxAttempts = 10; }
        return whenRefIsVisible(refs, refName, maxAttempts).then(function (visibleEl) {
            visibleEl.focus();
        });
    },
    /**
     * Scroll down or up to the given element
     */
    scrollToElement: scrollToElement,
    /**
     * Same as scrollToRef, but will not scroll down, only up
     * @param refs
     * @param refName
     * @param additionalPx - how many pixels to scroll past the given ref element
     * @param animationTimeMillis - how quickly to scroll up in milliseconds
     */
    scrollUpToRef: function (refs, refName, additionalPx, animationTimeMillis) {
        if (additionalPx === void 0) { additionalPx = 0; }
        if (animationTimeMillis === void 0) { animationTimeMillis = 500; }
        var el = getRefEl(refs, refName);
        if (el) {
            var viewportOffset = el.getBoundingClientRect();
            // these are relative to the viewport, i.e. the window
            var top_1 = viewportOffset.top;
            if (top_1 <= 0) {
                // top is negative, so like subtracting from how far page is currently scrolled
                var scrollToY = Math.floor(window.pageYOffset + top_1 - (additionalPx || 0));
                // distance (currentY - toY) / animationTime
                var rate = (window.pageYOffset - scrollToY) / animationTimeMillis;
                return smoothScrollUp(scrollToY, rate);
            }
            return Promise.resolve(); // already up to top
        }
        return Promise.reject(new Error("ref, " + refName + " is not an element"));
    },
    /**
     * Can be used to set the cursor at the end of text in a text field or textarea as well
     * as a contenteditable div
     * @param el - the element
     */
    setCursorAtEndOfText: function (el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    },
    /**
     * Returns a promise to resolve when the element becomes visible for the given number of
     * attempts.  An attempt is the time it takes for window.requestAnimationFrame() to be called.
     * It will be rejected if it is not visible after the given number of attempts.
     *
     * @param el - element to check for
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    whenElementIsVisible: whenElementIsVisible,
    /**
     * Returns a promise to resolve when the element the ref refers to becomes visible for the given
     * number of attempts.  An attempt is the time it takes for window.requestAnimationFrame() to be
     * called. It will be rejected if it is not visible after the given number of attempts.
     *
     * @param refs - this would be this.$refs inside a Vue component
     * @param refName - the name of the ref, called like this.$refs[refName]
     * @param maxAttempts (optional with default of 10) - max attempts at checking
     */
    whenRefIsVisible: whenRefIsVisible
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GlobalConfig */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
var GlobalConfig = /** @class */ (function () {
    function GlobalConfig(config) {
        this.additionalPagingScroll = config.additionalPagingScroll;
        this.authSettings = config.authSettings;
        this.mediaEnabled = config.mediaEnabled;
        this.multiItemAnswerEnabled = config.multiItemAnswerEnabled;
        this.multiItemPickerTitleLength = config.multiItemPickerTitleLength;
        this.siteName = config.siteName;
        this.ssoEnabled = config.ssoEnabled;
    }
    GlobalConfig.prototype.isAllowAnon = function () {
        return this.authSettings.question === 1;
    };
    GlobalConfig.prototype.isConfirmReq = function (ugcType) {
        if (ugcType === 'question' && this.authSettings.question === 3) {
            return true;
        }
        else if (['answer', 'reply'].indexOf(ugcType) > -1 && this.authSettings.answerReply === 2) {
            return true;
        }
        else if (ugcType === 'review' && this.authSettings.review === 3) {
            return true;
        }
        return false;
    };
    GlobalConfig.prototype.isPurchaseReq = function () {
        return this.authSettings.review === 4;
    };
    return GlobalConfig;
}());

var defaultConfig;
function loadConfig(config) {
    defaultConfig = new GlobalConfig(config);
}



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_msg__ = __webpack_require__(5);




var Source;
(function (Source) {
    Source[Source["RSE"] = 0] = "RSE";
    Source[Source["DO_MORE"] = 1] = "DO_MORE";
    Source[Source["INLINE"] = 2] = "INLINE";
})(Source || (Source = {}));
var DEFAULT_STATE = JSON.stringify({
    addedMedia: [],
    catItem: null,
    currentPage: null,
    isLaunchingWriteReview: false,
    launchData: {},
    launchingElem: undefined,
    qaLaunchData: {},
    pageHistory: [],
    prevLaunchToken: null,
    isOpen: false,
    sellerRatingLaunchData: {},
    sku: '',
    siteKey: __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey
});
var SubmissionStore = /** @class */ (function () {
    function SubmissionStore() {
        this.state = JSON.parse(DEFAULT_STATE);
        this.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
    }
    SubmissionStore.prototype.addMedia = function (media) {
        var _this = this;
        media.forEach(function (item) { return _this.state.addedMedia.push(item); });
    };
    SubmissionStore.prototype.close = function () {
        if (this.state.launchingElem) {
            this.state.launchingElem.focus();
        }
        else {
            __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].safeFocus(document.body);
        }
        this.state.isOpen = false;
    };
    // returns the index of the item removed
    SubmissionStore.prototype.removeMedia = function (mediaItem) {
        for (var i = 0; i < this.state.addedMedia.length; i++) {
            var thisItem = this.state.addedMedia[i];
            if (mediaItem.id === thisItem.id) {
                this.state.addedMedia.splice(i, 1);
                return i;
            }
        }
        return -1;
    };
    Object.defineProperty(SubmissionStore.prototype, "addedMedia", {
        get: function () {
            return this.state.addedMedia;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "catItem", {
        get: function () {
            return this.state.catItem;
        },
        set: function (catItem) {
            this.state.catItem = catItem;
            this.state.sku = catItem.sku;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "currentPage", {
        get: function () {
            return this.state.currentPage;
        },
        set: function (page) {
            // put previous page into history if there was one.  Not adding 'add-video' since it is not
            // a page the user can go back to.  Should be going back to the one before that.
            if (this.state.currentPage && this.state.currentPage.page !== 'add-video') {
                var newLength = this.state.pageHistory.unshift(this.state.currentPage);
                // only keep history up to previous 3 pages.  Shouldn't need but 2 or 3
                if (newLength > 3) {
                    this.state.pageHistory.splice(3);
                }
            }
            // Remove any 'back' listener from the eventBus to make sure they are cleaned up before going
            // to the next page
            this.eventBus.$off('back');
            this.state.currentPage = page;
        },
        enumerable: true,
        configurable: true
    });
    // a way for the submission modal to communicate to the screen widget that a "close" event has
    // taken place, which may mean "go back" to the previous modal screen.  The inidividual widget
    // can determine where to go back to or fire a close event back up to the submission modal.
    SubmissionStore.prototype.fireBackEvent = function () {
        // this is using the internal Vue api, which could change, but not likely -
        // https://forum.vuejs.org/t/detect-whether-there-are-event-listeners/10754
        // using to detect if the 'back' event is registered, if not, we can just close
        var events = this.eventBus._events;
        if (events && events.back) {
            this.eventBus.$emit('back');
            return;
        }
        this.close();
    };
    SubmissionStore.prototype.getLaunchToken = function () {
        return this.state.launchData.rseToken || this.state.qaLaunchData.emailToken ||
            this.state.sellerRatingLaunchData.emailToken || this.state.launchData.ssoToken ||
            this.state.prevLaunchToken;
    };
    Object.defineProperty(SubmissionStore.prototype, "isLaunchingWriteReview", {
        get: function () {
            return this.state.isLaunchingWriteReview;
        },
        set: function (isLaunching) {
            this.state.isLaunchingWriteReview = isLaunching;
        },
        enumerable: true,
        configurable: true
    });
    SubmissionStore.prototype.isVisualFirstFlow = function () {
        return this.state.launchData.startAction === 'visual';
    };
    Object.defineProperty(SubmissionStore.prototype, "launchData", {
        get: function () {
            return this.state.launchData;
        },
        set: function (launchData) {
            this.state.launchData = launchData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "qaLaunchData", {
        get: function () {
            return this.state.qaLaunchData;
        },
        set: function (launchData) {
            this.state.qaLaunchData = launchData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "sellerRatingLaunchData", {
        get: function () {
            return this.state.sellerRatingLaunchData;
        },
        set: function (launchData) {
            this.state.sellerRatingLaunchData = launchData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "isOpen", {
        get: function () {
            return this.state.isOpen;
        },
        set: function (isOpen) {
            this.state.isOpen = isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "pageHistory", {
        get: function () {
            return this.state.pageHistory;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "poweredByText", {
        get: function () {
            var page = this.state.currentPage ? this.state.currentPage.page : null;
            if (page === 'do-more') {
                return Object(__WEBPACK_IMPORTED_MODULE_3_services_msg__["a" /* default */])('doMore.poweredBy');
            }
            else if (page === 'review-form' && !this.isVisualFirstFlow()) {
                return Object(__WEBPACK_IMPORTED_MODULE_3_services_msg__["a" /* default */])('submission.reviewsPoweredBy');
            }
            return Object(__WEBPACK_IMPORTED_MODULE_3_services_msg__["a" /* default */])('submission.visualPoweredBy');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "previousPage", {
        get: function () {
            return this.state.pageHistory.length > 0 ? this.state.pageHistory[0] : null;
        },
        enumerable: true,
        configurable: true
    });
    // This sets to all default values including isOpen false which will close the submission modal.
    // So only use when not staying in the modal
    SubmissionStore.prototype.resetStore = function () {
        this.state = JSON.parse(DEFAULT_STATE);
        // make sure all registered events ($on) are removed from the eventBus
        this.eventBus.$off();
    };
    // Resets to default values except:
    // - isOpen true so the modal does not close
    // - the catItem and siteKey
    // - launchingElem if present
    // - currentPage and pageHistory if present
    SubmissionStore.prototype.resetStoreWithCatItem = function (siteKey, catItem) {
        var prevLaunchToken = this.getLaunchToken();
        var launchingElem = this.state.launchingElem;
        var history = this.state.pageHistory;
        var currentPage = this.state.currentPage;
        var defaultState = JSON.parse(DEFAULT_STATE);
        defaultState.isOpen = true;
        defaultState.siteKey = siteKey;
        defaultState.launchingElem = launchingElem;
        defaultState.currentPage = currentPage;
        defaultState.pageHistory = history;
        defaultState.prevLaunchToken = prevLaunchToken;
        this.state = defaultState;
        this.catItem = catItem;
    };
    Object.defineProperty(SubmissionStore.prototype, "sku", {
        // setting sku is done through one of the startFlow functions
        get: function () {
            return this.state.sku;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "siblingSiteKey", {
        get: function () {
            return this.state.siteKey !== __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey ? this.state.siteKey : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SubmissionStore.prototype, "siteKey", {
        // setting siteKey is done through one of the startFlow functions
        get: function () {
            return this.state.siteKey;
        },
        enumerable: true,
        configurable: true
    });
    // start a flow with Do More or for use by other start flow functions
    SubmissionStore.prototype.startFlow = function (sku, siteKey, page) {
        this.state.sku = sku;
        this.state.siteKey = siteKey;
        this.currentPage = page;
    };
    // start a flow with QA Solo View
    SubmissionStore.prototype.startQaFlow = function (sku, siteKey, page, launchData) {
        this.state.qaLaunchData = launchData;
        this.startFlow(sku, siteKey, page);
    };
    // start a flow with review form or vc share
    SubmissionStore.prototype.startRevFlow = function (sku, siteKey, page, launchData, launchingElem) {
        if (launchingElem === void 0) { launchingElem = undefined; }
        this.state.launchData = launchData;
        // don't want body to be the launching element
        if (launchingElem && launchingElem.tagName.toLowerCase() !== 'body') {
            this.state.launchingElem = launchingElem;
        }
        this.startFlow(sku, siteKey, page);
    };
    SubmissionStore.prototype.startSellerRatingFlow = function (siteKey, page, launchData) {
        this.state.sellerRatingLaunchData = launchData;
        this.startFlow(null, siteKey, page);
    };
    // start a flow with Do More using catItem instead of sku
    SubmissionStore.prototype.startFlowWithCatItem = function (catItem, siteKey, page) {
        this.state.catItem = catItem;
        this.startFlow(catItem.sku, siteKey, page);
    };
    return SubmissionStore;
}());
/* harmony default export */ __webpack_exports__["b"] = (new SubmissionStore());


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* unused harmony export ApiService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_client__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);
/* tslint:disable */


function createRestError(xhr) {
    /* beautify ignore:start */
    var restError = {
        status: xhr.status,
        fieldErrors: []
    };
    /* beautify ignore:end */
    var errorsStr = xhr.getResponseHeader('turnto-error-msg');
    if (xhr.getResponseHeader('turnto-error') && errorsStr) {
        try {
            JSON.parse(errorsStr).forEach(function (error) {
                if (error.path) {
                    restError.fieldErrors.push(error);
                }
                else {
                    restError.errorCode = error.code;
                }
            });
        }
        catch (e) {
            restError.errorCode = 'unexpected-error';
        }
    }
    else {
        restError.errorCode = 'unexpected-error';
    }
    return restError;
}
function createOfflineRestError(xhr) {
    /* beautify ignore:start */
    return {
        status: xhr.status,
        fieldErrors: [],
        errorCode: "turnto-offline"
    };
    /* beautify ignore:end */
}
function populatePathValues(path, params) {
    if (params === void 0) { params = {}; }
    var fieldsInPathRegEx = /{(.*?)}/g;
    // globally replacing siteKey and locale without needing to pass in calls
    var replaceMap = {
        '{siteKey}': __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey,
        '{locale}': __WEBPACK_IMPORTED_MODULE_1_init_config__["b" /* turnToConfig */].locale
    };
    // this loop finds each path variable and adds to the replaceMap.
    // a path variable is surrounded by curly braces.
    // Example with siteKey and id: /{siteKey}/review/{id}
    var match;
    while (match = fieldsInPathRegEx.exec(path)) {
        var fieldName = match[1];
        if (fieldName !== 'siteKey' && fieldName !== 'locale') {
            replaceMap["{" + fieldName + "}"] = params[fieldName];
        }
    }
    // this regex and replace, replaces each path variable with its value
    var replaceRegEx = new RegExp(Object.keys(replaceMap).join("|"), "gi");
    return path.replace(replaceRegEx, (function (matched) { return replaceMap[matched]; }));
}
function call(method, path, parameters, requiredFields, queryFields, headerFields, body) {
    if (parameters === void 0) { parameters = {}; }
    if (body === void 0) { body = {}; }
    var queryParameters = {};
    var headers = {};
    requiredFields.forEach(function (fieldName) {
        if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
            throw new Error("Missing required  parameter: " + fieldName);
        }
    });
    queryFields.forEach(function (fieldName) {
        if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
            queryParameters[fieldName] = parameters[fieldName];
        }
    });
    headerFields.forEach(function (fieldName) {
        if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
            headers[fieldName] = parameters[fieldName];
        }
    });
    var populatedPath = populatePathValues(path, parameters);
    return new Promise(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_0__http_client__["c" /* executeRequest */])(method, populatedPath, {
            body: body,
            headers: headers,
            params: queryParameters
        }).then(function (xhr) {
            var offline = xhr.getResponseHeader('turnto-offline');
            if (offline === 'true') {
                reject(createOfflineRestError(xhr));
            }
            else if (xhr.status === 200 || xhr.status === 201) {
                resolve(xhr.data);
            }
            else {
                reject((createRestError(xhr)));
            }
        }).catch(function (xhr) {
            reject(createRestError(xhr));
        });
    });
}
function callStatic(path, parameters, requiredFields) {
    if (parameters === void 0) { parameters = {}; }
    requiredFields.forEach(function (fieldName) {
        if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
            throw new Error("Missing required  parameter: " + fieldName);
        }
    });
    var populatedPath = populatePathValues(path, parameters);
    return new Promise(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_0__http_client__["d" /* executeStaticRequest */])(populatedPath).then(function (xhr) {
            var offline = xhr.getResponseHeader('turnto-offline');
            if (offline === 'true') {
                reject(createOfflineRestError(xhr));
            }
            else if (xhr.status === 200) {
                resolve(xhr.data);
            }
            else {
                reject((createRestError(xhr)));
            }
        }).catch(function (xhr) {
            reject(createRestError(xhr));
        });
    });
}
/**
 * v5 Widget API
 * @class ApiService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
var ApiService = /** @class */ (function () {
    function ApiService() {
    }
    ApiService.prototype.uploadFile = function (path, formData, progressCallback) {
        return new Promise(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_0__http_client__["c" /* executeRequest */])('POST', path, 
            // progressCallback function updates the progress as it's being uploaded
            {
                formData: formData,
                progressCallback: progressCallback
            }).then(function (xhr) {
                if (xhr.status === 200 || xhr.status === 201) {
                    resolve(xhr.data);
                }
                else {
                    reject((createRestError(xhr)));
                }
            }).catch(function (xhr) {
                reject(createRestError(xhr));
            });
        });
    };
    /**
     * Get article by id
     *
     * @method
     * @name ApiService#getArticleById
     * @param {integer} id -
     */
    ApiService.prototype.getArticleById = function (parameters) {
        return call('GET', '/{siteKey}/article/{id}/{locale}', parameters, ['id'], [], []);
    };
    /**
     * Retrieve catalog items
     *
     * @method
     * @name ApiService#getCatalogItems
     * @param {object} body -
     * {
     *   searchTerm:string
     *   excludeCatItemIds:array
     *   currentSku:string
     * }
     */
    ApiService.prototype.getCatalogItems = function (body) {
        return call('POST', '/{siteKey}/catalogItem/search', {}, [], [], [], body);
    };
    /**
     * Retrieve catalog items containing comments for the comments pinboard
     *
     * @method
     * @name ApiService#getCatalogItemsForCommentsPinboard
     * @param {string} skus -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {boolean} activeOnly -
     * @param {string} brands -
     * @param {string} tags -
     * @param {boolean} includeCommentsCount -
     * @param {boolean} includeReviewData -
     * @param {integer} maxDaysOld - Specify -1 to include all, regardless of age
     * @param {boolean} includeSyndicated -
     * @param {integer} minComments -
     * @param {integer} maxCommentsReturned -
     */
    ApiService.prototype.getCatalogItemsForCommentsPinboard = function (parameters) {
        return callStatic('/sitedata/{siteKey}/commentsPinboard/{skus}/{locale}/{offset}/{limit}/{activeOnly}/{brands}/{tags}/{includeCommentsCount}/{includeReviewData}/{maxDaysOld}/{includeSyndicated}/{minComments}/{maxCommentsReturned}', parameters, ['skus', 'offset', 'limit', 'activeOnly', 'brands', 'tags', 'includeCommentsCount', 'includeReviewData', 'maxDaysOld', 'includeSyndicated', 'minComments', 'maxCommentsReturned']);
    };
    /**
     * Save a new comment
     *
     * @method
     * @name ApiService#createComment
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {CreateCommentBody} body -
     */
    ApiService.prototype.createComment = function (parameters, body) {
        return call('POST', '/{siteKey}/comment', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Comments for chatter
     *
     * @method
     * @name ApiService#chatterComments
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Possible values are:
     * 0 (default) - by id, descending
     * 1 - by length of comment text, descending
    
     * @param {integer} minCharCount -
     * @param {integer} minWordCount -
     * @param {boolean} includeSyndicated -
     * @param {boolean} includeRelated -
     */
    ApiService.prototype.chatterComments = function (parameters) {
        return callStatic('/sitedata/{siteKey}/chatter/{sku}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}/{includeRelated}', parameters, ['sku', 'offset', 'limit', 'sort', 'minCharCount', 'minWordCount', 'includeSyndicated', 'includeRelated']);
    };
    /**
     * This is only intended to be done right after comment creation
     *
     * @method
     * @name ApiService#updateComment
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {UpdateCommentBody} body -
     */
    ApiService.prototype.updateComment = function (parameters, body) {
        return call('PUT', '/{siteKey}/comment/{id}', parameters, ['context-token', 'id', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * This is only intended to be done right after comment creation
     *
     * @method
     * @name ApiService#deleteComment
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     */
    ApiService.prototype.deleteComment = function (parameters) {
        return call('DELETE', '/{siteKey}/comment/{id}', parameters, ['context-token', 'id', 'sku',], ['sku', 'checkoutSiteKey'], ['context-token',]);
    };
    /**
     * Top comments
     *
     * @method
     * @name ApiService#topComments
     * @param {string} skus - Comma separated list of skus
     * @param {integer} minCharCount -
     * @param {integer} minWordCount -
     * @param {string} tags - Comma separated list of tags
     * @param {boolean} includeSyndicated -
     */
    ApiService.prototype.topComments = function (parameters) {
        return callStatic('/sitedata/{siteKey}/topcomment/{skus}/{locale}/{minCharCount}/{minWordCount}/{tags}/{includeSyndicated}', parameters, ['skus', 'minCharCount', 'minWordCount', 'tags', 'includeSyndicated']);
    };
    /**
     * List of media
     *
     * @method
     * @name ApiService#mediaList
     * @param {string} skus -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Possible values are: MOST_VOTES, MOST_RECENT, and LONGEST
     * @param {boolean} includeProductSiblings -
     * @param {string} tags -
     * @param {integer} minCharCount -
     * @param {integer} minWordCount -
     * @param {boolean} includeSyndicated -
     */
    ApiService.prototype.mediaList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/gallery/{skus}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}/{includeProductSiblings}/{tags}', parameters, ['skus', 'offset', 'limit', 'sort', 'includeProductSiblings', 'tags', 'minCharCount', 'minWordCount', 'includeSyndicated']);
    };
    /**
     * Vote for a media item
     *
     * @method
     * @name ApiService#voteForMedia
     * @param {integer} id -
     */
    ApiService.prototype.voteForMedia = function (parameters) {
        return call('POST', '/{siteKey}/media/{id}/vote', parameters, ['id'], [], []);
    };
    /**
     * Flag a media item as inappropriate
     *
     * @method
     * @name ApiService#flagMedia
     * @param {integer} id -
     * @param {string} reason - Possible values:
    *   ipViolation
    *   offensive
    *   offTopic
    *   spam
    
     */
    ApiService.prototype.flagMedia = function (parameters) {
        return call('POST', '/{siteKey}/media/{id}/flag', parameters, ['id', 'reason'], ['reason'], []);
    };
    /**
     * Save a batch of media items
     *
     * @method
     * @name ApiService#saveMedia
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {CreateMediaItemsBody} body -
     */
    ApiService.prototype.saveMedia = function (parameters, body) {
        return call('POST', '/{siteKey}/media/batch', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for the share media flow (coming from rse)
     *
     * @method
     * @name ApiService#shareMediaInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.shareMediaInitData = function (parameters) {
        return call('GET', '/{siteKey}/media/initData', parameters, ['sku',], ['sku', 'checkoutSiteKey', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * TODO - need to make this work or remove.  Currently using hard-coded call set in api-service called uploadFile
     *
     * @method
     * @name ApiService#uploadMedia
     * @param {file} file -
     * @param {string} uploadId -
     */
    ApiService.prototype.uploadMedia = function (parameters) {
        return call('POST', '/{siteKey}/media/upload', parameters, ['file', 'uploadId'], [], []);
    };
    /**
     * Post a video link for validation and return details
     *
     * @method
     * @name ApiService#addVideoLink
     * @param {string} url -
     */
    ApiService.prototype.addVideoLink = function (parameters) {
        return call('POST', '/{siteKey}/media/videoLink', parameters, ['url'], ['url'], []);
    };
    /**
     * Retrieve media for vc pinboard
     *
     * @method
     * @name ApiService#getMediaForVcPinboard
     * @param {string} skus -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {boolean} activeOnly -
     * @param {string} brands -
     * @param {string} tags -
     * @param {integer} sortOrder - Possible values are: MOST_VOTES, MOST_RECENT, and LONGEST
     * @param {boolean} includeReviewData -
     * @param {integer} minCaptionCharCount -
     * @param {integer} minCaptionWordCount -
     */
    ApiService.prototype.getMediaForVcPinboard = function (parameters) {
        return callStatic('/sitedata/{siteKey}/vcPinboard/{skus}/{locale}/{offset}/{limit}/{activeOnly}/{brands}/{tags}/{sortOrder}/{includeReviewData}/{minCaptionCharCount}/{minCaptionWordCount}', parameters, ['skus', 'offset', 'limit', 'activeOnly', 'brands', 'tags', 'sortOrder', 'includeReviewData', 'minCaptionCharCount', 'minCaptionWordCount']);
    };
    /**
     * List of questions
     *
     * @method
     * @name ApiService#questionsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Default value depends on site settings:
     * RECENT
     * OLDEST
     * BEST
     * MOST_ANSWERS
     * LEAST_ANSWERS
     * MOST_RECENT_ANSWER
     * OLDEST_ANSWER
    
     * @param {boolean} includeRelated -
     */
    ApiService.prototype.questionsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/question/{locale}/{offset}/{limit}/{sort}/{includeRelated}', parameters, ['sku', 'offset', 'limit', 'sort',]);
    };
    /**
     * List of related questions
     *
     * @method
     * @name ApiService#relatedQuestionsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Default value depends on site settings:
     * RECENT
     * OLDEST
     * BEST
     * MOST_ANSWERS
     * LEAST_ANSWERS
     * MOST_RECENT_ANSWER
     * OLDEST_ANSWER
    
     */
    ApiService.prototype.relatedQuestionsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/r/relatedquestion/{locale}/{offset}/{limit}/{sort}', parameters, ['sku', 'offset', 'limit', 'sort']);
    };
    /**
     * Create a question (anonymous or unconfirmed user)
     *
     * @method
     * @name ApiService#createQuestionAnonOrUnconfirmedUser
     * @param {string} qualifier -
     * @param {string} sku -
     * @param {CreateQuestionBody} body -
     */
    ApiService.prototype.createQuestionAnonOrUnconfirmedUser = function (parameters, body) {
        return call('POST', '/{siteKey}/question/inline/{qualifier}', parameters, ['qualifier', 'sku',], ['sku',], [], body);
    };
    /**
     * Create a question (confirmed user)
     *
     * @method
     * @name ApiService#createQuestionConfirmedUser
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {CreateQuestionBody} body -
     */
    ApiService.prototype.createQuestionConfirmedUser = function (parameters, body) {
        return call('POST', '/{siteKey}/question/inline/confirmed', parameters, ['context-token', 'sku',], ['sku',], ['context-token',], body);
    };
    /**
     * Create an answer
     *
     * @method
     * @name ApiService#createAnswer
     * @param {string} contextToken -
     * @param {string} qualifier - confirmed or unconfirmed
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateAnswerBody} body -
     */
    ApiService.prototype.createAnswer = function (parameters, body) {
        return call('POST', '/{siteKey}/answer/inline/{qualifier}', parameters, ['sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Create an answer from an email
     *
     * @method
     * @name ApiService#createEmailAnswer
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateAnswerBody} body -
     */
    ApiService.prototype.createEmailAnswer = function (parameters, body) {
        return call('POST', '/{siteKey}/answer/email', parameters, ['sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for coming from question email to answer the question
     *
     * @method
     * @name ApiService#answerInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.answerInitData = function (parameters) {
        return call('GET', '/{siteKey}/answer/initData', parameters, ['context-token', 'sku',], ['sku', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Vote for a question
     *
     * @method
     * @name ApiService#voteQuestion
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {integer} id -
     * @param {object} body -
     * {
     *   up:number
     * }
     */
    ApiService.prototype.voteQuestion = function (parameters, body) {
        return call('POST', '/{siteKey}/question/{id}/vote', parameters, ['sku', 'id',], ['sku', 'originSiteKey',], [], body);
    };
    /**
     * Get question data by id
     *
     * @method
     * @name ApiService#getQuestionData
     * @param {string} originSiteKey -
     * @param {integer} id -
     */
    ApiService.prototype.getQuestionData = function (parameters) {
        return call('GET', '/{siteKey}/question/{id}/{locale}', parameters, ['id'], ['originSiteKey',], []);
    };
    /**
     * Flag an answer as inappropriate
     *
     * @method
     * @name ApiService#flagAnswer
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {integer} id -
     */
    ApiService.prototype.flagAnswer = function (parameters) {
        return call('POST', '/{siteKey}/answer/{id}/flag', parameters, ['sku', 'id'], ['sku', 'originSiteKey',], []);
    };
    /**
     * Vote for an answer
     *
     * @method
     * @name ApiService#voteAnswer
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {integer} id -
     * @param {object} body -
     * {
     *   up:number
     * }
     */
    ApiService.prototype.voteAnswer = function (parameters, body) {
        return call('POST', '/{siteKey}/answer/{id}/vote', parameters, ['sku', 'id',], ['sku', 'originSiteKey',], [], body);
    };
    /**
     * Create a reply to an answer
     *
     * @method
     * @name ApiService#createReply
     * @param {string} contextToken -
     * @param {string} qualifier - confirmed or unconfirmed
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateReplyBody} body -
     */
    ApiService.prototype.createReply = function (parameters, body) {
        return call('POST', '/{siteKey}/reply/inline/{qualifier}', parameters, ['qualifier', 'sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Create a reply from an email
     *
     * @method
     * @name ApiService#createEmailReply
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} originSiteKey -
     * @param {CreateReplyBody} body -
     */
    ApiService.prototype.createEmailReply = function (parameters, body) {
        return call('POST', '/{siteKey}/reply/email', parameters, ['sku',], ['sku', 'originSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for coming from answer or reply email to reply
     *
     * @method
     * @name ApiService#replyInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.replyInitData = function (parameters) {
        return call('GET', '/{siteKey}/reply/initData', parameters, ['context-token', 'sku',], ['sku', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Save a new review by an unconfirmed user
     *
     * @method
     * @name ApiService#saveReviewUnconfirmed
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {ReviewForm} body -
     */
    ApiService.prototype.saveReviewUnconfirmed = function (parameters, body) {
        return call('POST', '/{siteKey}/review/inline/unconfirmed', parameters, ['sku',], ['sku', 'checkoutSiteKey',], [], body);
    };
    /**
     * Save a new review by a confirmed (logged-in) user
     *
     * @method
     * @name ApiService#saveReviewConfirmed
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {ReviewForm} body -
     */
    ApiService.prototype.saveReviewConfirmed = function (parameters, body) {
        return call('POST', '/{siteKey}/review/inline/confirmed', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Save a new review from an RSE
     *
     * @method
     * @name ApiService#saveReviewRse
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {ReviewForm} body -
     */
    ApiService.prototype.saveReviewRse = function (parameters, body) {
        return call('POST', '/{siteKey}/review/email', parameters, ['context-token', 'sku',], ['sku', 'checkoutSiteKey',], ['context-token',], body);
    };
    /**
     * Initialization data for the review form
     *
     * @method
     * @name ApiService#reviewInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.reviewInitData = function (parameters) {
        return call('GET', '/{siteKey}/review/initData', parameters, ['sku',], ['sku', 'checkoutSiteKey', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Initialization data for the review form coming from RSE
     *
     * @method
     * @name ApiService#rseReviewInitData
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {string} ssoProfileToken -
     * @param {number} lastSeenSrDate - Last seen seller rating date in milliseconds UTC
     * @param {string} checkoutSiteKey -
     */
    ApiService.prototype.rseReviewInitData = function (parameters) {
        return call('GET', '/{siteKey}/review/rseInitData', parameters, ['sku',], ['sku', 'ssoProfileToken', 'lastSeenSrDate', 'checkoutSiteKey'], ['context-token',]);
    };
    /**
     * List of reviews
     *
     * @method
     * @name ApiService#reviewsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} filters - Encoded JSON of filters.  Example before being encoded: {"md":true,"rt":[1,2,3],"sp":[{"7":[2,3]},{"14":[1]}],"dm":[{"5":[1,4]},{"3":[2,3,4]}],"att":[{"2":[1]},{"3":[1,2]}]}
     * @param {string} sort - Default value and which options are available depends on site settings:
     * mostRecent
     * mostHelpful (formerly bestR)
     * expert (expert reviews first)
     * staff (staff reviews first)
     * topContributors (reviews first)
     * highestRated
     * lowestRated
     * mostRelevant
     * photosVideos
     * oldest
    
     * @param {boolean} includeRelated -
     * @param {boolean} includeFilters -
     * @param {string} searchText -
     */
    ApiService.prototype.reviewsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/review/{locale}/{offset}/{limit}/{filters}/{sort}/{includeRelated}/{includeFilters}/{searchText}', parameters, ['sku', 'offset', 'limit', 'filters', 'sort', 'includeRelated', 'includeFilters',]);
    };
    /**
     * List of related reviews
     *
     * @method
     * @name ApiService#relatedReviewsList
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {string} sort - Default value and which options are available depends on site settings:
     * mostRecent
     * mostHelpful (formerly bestR)
     * expert (expert reviews first)
     * staff (staff reviews first)
     * topContributors (reviews first)
     * highestRated
     * lowestRated
     * mostRelevant
     * photosVideos
     * oldest
    
     */
    ApiService.prototype.relatedReviewsList = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/r/relatedReview/{locale}/{offset}/{limit}/{sort}', parameters, ['sku', 'offset', 'limit', 'sort']);
    };
    /**
     * Spectrum of reviews
     *
     * @method
     * @name ApiService#spectrum
     * @param {string} sku -
     */
    ApiService.prototype.spectrum = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/review/spectrum/{locale}', parameters, ['sku']);
    };
    /**
     * Send deviceFingerprint to be stored on the review
     *
     * @method
     * @name ApiService#saveReviewFingerprint
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {object} body -
     * {
     *   deviceFingerprint:string
     * }
     */
    ApiService.prototype.saveReviewFingerprint = function (parameters, body) {
        return call('PUT', '/{siteKey}/review/{id}/fingerprint', parameters, ['id',], [], ['context-token',], body);
    };
    /**
     * Flag a review as inappropriate
     *
     * @method
     * @name ApiService#flagReview
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     */
    ApiService.prototype.flagReview = function (parameters) {
        return call('POST', '/{siteKey}/review/{id}/flag', parameters, ['id', 'sku',], ['sku', 'checkoutSiteKey'], []);
    };
    /**
     * Registers a down vote for a review
     *
     * @method
     * @name ApiService#voteForReview
     * @param {integer} id -
     * @param {string} sku -
     * @param {string} checkoutSiteKey -
     * @param {object} body -
     * {
     *   up:number
     *   down:number
     * }
     */
    ApiService.prototype.voteForReview = function (parameters, body) {
        return call('POST', '/{siteKey}/review/{id}/vote', parameters, ['id', 'sku',], ['sku', 'checkoutSiteKey',], [], body);
    };
    /**
     * Get review data by id
     *
     * @method
     * @name ApiService#getReviewData
     * @param {string} originSiteKey -
     * @param {integer} id -
     */
    ApiService.prototype.getReviewData = function (parameters) {
        return call('GET', '/{siteKey}/review/{id}/{locale}', parameters, ['id'], ['originSiteKey',], []);
    };
    /**
     *
     *
     * @method
     * @name ApiService#reviewsSummary
     * @param {string} sku -
     */
    ApiService.prototype.reviewsSummary = function (parameters) {
        return callStatic('/sitedata/{siteKey}/{sku}/d/review/summary/{locale}', parameters, ['sku']);
    };
    /**
     * This is called when coming from a successful inbox submission
     *
     * @method
     * @name ApiService#checkSellerRatingEligibile
     * @param {string} contextToken -
     * @param {number} lastSeenSrDate - Last seen seller rating date in milliseconds UTC
     */
    ApiService.prototype.checkSellerRatingEligibile = function (parameters) {
        return call('GET', '/{siteKey}/sellerRating/checkEligible', parameters, ['context-token',], ['lastSeenSrDate'], ['context-token',]);
    };
    /**
     * Save a new seller rating coming from solicitation email
     *
     * @method
     * @name ApiService#saveSellerRating
     * @param {string} contextToken -
     * @param {string} submitType -
     * @param {SellerRatingForm} body -
     */
    ApiService.prototype.saveSellerRating = function (parameters, body) {
        return call('POST', '/{siteKey}/sellerRating/{submitType}', parameters, ['context-token', 'submitType',], [], ['context-token',], body);
    };
    /**
     * Initialization data for the seller rating form
     *
     * @method
     * @name ApiService#srInitData
     * @param {string} contextToken -
     * @param {string} initType -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.srInitData = function (parameters) {
        return call('GET', '/{siteKey}/sellerRating/{initType}', parameters, ['initType',], ['ssoProfileToken'], ['context-token',]);
    };
    /**
     * Post a transaction (js feed)
     *
     * @method
     * @name ApiService#createTransaction
     * @param {CreateTransactionBody} body -
     */
    ApiService.prototype.createTransaction = function (body) {
        return call('POST', '/{siteKey}/transaction/{locale}', {}, [], [], [], body);
    };
    /**
     * Post a transaction (js feed) and get items for user to comment on
     *
     * @method
     * @name ApiService#createTransactionAndGetItemsForComment
     * @param {CreateTransactionBody} body -
     */
    ApiService.prototype.createTransactionAndGetItemsForComment = function (body) {
        return call('POST', '/{siteKey}/transaction/itemsForComment/{locale}', {}, [], [], [], body);
    };
    /**
     * Submits user registration information
     *
     * @method
     * @name ApiService#registerUser
     * @param {string} qualifier -
     * @param {string} registerFor -
     * @param {RegisterUserBody} body -
     */
    ApiService.prototype.registerUser = function (parameters, body) {
        return call('POST', '/{siteKey}/user/register/{qualifier}/{registerFor}', parameters, ['qualifier', 'registerFor',], [], [], body);
    };
    /**
     * Call to resend the confirmation email just sent
     *
     * @method
     * @name ApiService#resendConfirmation
     * @param {string} qualifier -
     * @param {string} registerFor -
     * @param {object} body -
     * {
     *   token:string
     * }
     */
    ApiService.prototype.resendConfirmation = function (parameters, body) {
        return call('POST', '/{siteKey}/user/register/{qualifier}/resend/{registerFor}', parameters, ['qualifier', 'registerFor',], [], [], body);
    };
    /**
     * Get user's reviews
     *
     * @method
     * @name ApiService#getUserReviews
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserReviews = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/review/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's questions
     *
     * @method
     * @name ApiService#getUserQuestions
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserQuestions = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/question/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's answers
     *
     * @method
     * @name ApiService#getUserAnswers
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserAnswers = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/answer/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's media
     *
     * @method
     * @name ApiService#getUserMedia
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserMedia = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/media/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get user's comments
     *
     * @method
     * @name ApiService#getUserComments
     * @param {integer} id -
     * @param {integer} offset -
     * @param {integer} limit -
     */
    ApiService.prototype.getUserComments = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/comment/{locale}', parameters, ['id',], ['offset', 'limit'], []);
    };
    /**
     * Get statistics for user submitted ugc
     *
     * @method
     * @name ApiService#getUserUgcStats
     * @param {integer} id -
     */
    ApiService.prototype.getUserUgcStats = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/ugcStats/{locale}', parameters, ['id'], [], []);
    };
    /**
     * Get user profile
     *
     * @method
     * @name ApiService#getUserProfile
     * @param {string} contextToken -
     * @param {integer} id -
     */
    ApiService.prototype.getUserProfile = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/profile/{locale}', parameters, ['context-token', 'id'], [], ['context-token',]);
    };
    /**
     * This can only be done by the logged in user.
     *
     * @method
     * @name ApiService#updateUserProfile
     * @param {string} contextToken -
     * @param {integer} id -
     * @param {UserProfile} body -
     */
    ApiService.prototype.updateUserProfile = function (parameters, body) {
        return call('PUT', '/{siteKey}/user/{id}/profile/{locale}', parameters, ['context-token', 'id',], [], ['context-token',], body);
    };
    /**
     * Get user identities by user id
     *
     * @method
     * @name ApiService#getUserIdentities
     * @param {integer} id - User id
     */
    ApiService.prototype.getUserIdentities = function (parameters) {
        return call('GET', '/{siteKey}/user/{id}/identity', parameters, ['id'], [], []);
    };
    /**
     * This can only be done by the logged in user.
     *
     * @method
     * @name ApiService#createUserIdentity
     * @param {integer} id - User id
     * @param {CreateUserIdentityBody} body -
     */
    ApiService.prototype.createUserIdentity = function (parameters, body) {
        return call('POST', '/{siteKey}/user/{id}/identity', parameters, ['id',], [], [], body);
    };
    /**
     * This really only updates the isPrimary property
     *
     * @method
     * @name ApiService#updateUserIdentity
     * @param {integer} id - User id
     * @param {integer} identityId - User identity id
     * @param {UpdateUserIdentityBody} body -
     */
    ApiService.prototype.updateUserIdentity = function (parameters, body) {
        return call('PUT', '/{siteKey}/user/{id}/identity/{identityId}', parameters, ['id', 'identityId',], [], [], body);
    };
    /**
     * Delete a user identity
     *
     * @method
     * @name ApiService#deleteUserIdentity
     * @param {integer} id - User id
     * @param {integer} identityId - User identity id
     */
    ApiService.prototype.deleteUserIdentity = function (parameters) {
        return call('DELETE', '/{siteKey}/user/{id}/identity/{identityId}', parameters, ['id', 'identityId'], [], []);
    };
    /**
     * Get do more content by user id
     *
     * @method
     * @name ApiService#getDoMoreContent
     * @param {string} contextToken -
     * @param {string} sku -
     * @param {integer} offset -
     * @param {integer} limit -
     * @param {integer} questionId -
     * @param {string} ssoProfileToken -
     */
    ApiService.prototype.getDoMoreContent = function (parameters) {
        return call('GET', '/{siteKey}/user/doMore/{locale}', parameters, ['context-token', 'sku',], ['sku', 'offset', 'limit', 'questionId', 'ssoProfileToken'], ['context-token',]);
    };
    /**
     * Instant answers search.
     *
     * @method
     * @name ApiService#instantAnswerSearch
     * @param {SearchBody} body -
     */
    ApiService.prototype.instantAnswerSearch = function (body) {
        return call('POST', '/{siteKey}/answer/search', {}, [], [], [], body);
    };
    /**
     * Counts for each ugc type, formally itemjs
     *
     * @method
     * @name ApiService#ugcCounts
     * @param {string} sku -
     */
    ApiService.prototype.ugcCounts = function (parameters) {
        return call('GET', '/sitedata/{siteKey}/{sku}/d/ugc/counts/{locale}', parameters, ['sku'], ['sku'], []);
    };
    /**
     * Complete action in 'ssoRegDone' js callback by partner site after sso
     *
     * @method
     * @name ApiService#completeSsoAction
     * @param {string} sku -
     * @param {SsoRequest} body -
     */
    ApiService.prototype.completeSsoAction = function (parameters, body) {
        return call('POST', '/{siteKey}/user/sso', parameters, ['sku',], ['sku',], [], body);
    };
    return ApiService;
}());

/* harmony default export */ __webpack_exports__["a"] = (new ApiService());

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODERATION_URL; });
/* harmony export (immutable) */ __webpack_exports__["d"] = encodeArray;
/* harmony export (immutable) */ __webpack_exports__["f"] = getProductImageUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = callTurnToConfigFn;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TTDAT_PARAM_NAME; });
/* harmony export (immutable) */ __webpack_exports__["i"] = parseTTdat;
/* harmony export (immutable) */ __webpack_exports__["k"] = setLastSeenSellerRatingDate;
/* harmony export (immutable) */ __webpack_exports__["e"] = getLastSeenSellerRatingDate;
/* harmony export (immutable) */ __webpack_exports__["h"] = getSessionVarInt;
/* harmony export (immutable) */ __webpack_exports__["g"] = getSessionVar;
/* harmony export (immutable) */ __webpack_exports__["j"] = removeSessionVar;
/* harmony export (immutable) */ __webpack_exports__["l"] = setSessionVar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_browser_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);


var ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
var SR_LAST_SEEN_DATE_COOKIE_NAME = 'TT_SRLSD'; // SR: Seller Rating
var MODERATION_URL = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].moderationHost;
/**
 * Used for service calls that are passing an array on the path
 * @param arr
 */
function encodeArray(arr) {
    return Array.isArray(arr) && arr.length > 0 ? encodeURIComponent(arr.join(',')) : '_ALL_';
}
function getProductImageUrl(catItem, size, siblingSiteKey) {
    if (size === void 0) { size = 'L'; }
    var imgSiteKey = siblingSiteKey || __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey;
    return __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].imageStoreBase + "/item/" + imgSiteKey + "/" +
        ("" + catItem.imageId + size + ".png");
}
function callTurnToConfigFn(objName, fnName) {
    var objConfig = window.turnToConfig[objName] || {};
    // if client provided the function
    if (objConfig[fnName]) {
        objConfig[fnName]();
    }
}
var TTDAT_PARAM_NAME = 'ttdat';
function parseTTdat(ttdat) {
    var data = {};
    if (ttdat) {
        // Base64 encoded JSON data (user, catItemId, etc)
        var parsedTTdat = JSON.parse(atob(ttdat));
        data = {
            user: !parsedTTdat.u ? null : {
                id: parsedTTdat.u,
                firstName: parsedTTdat.f,
                lastName: parsedTTdat.l,
                nickName: parsedTTdat.n,
                isModerator: parsedTTdat.m || false
            },
            catItemId: parsedTTdat.c
        };
    }
    return data;
}
function setLastSeenSellerRatingDate() {
    // setting to now in milliseconds UTC, expiring in a year
    Object(__WEBPACK_IMPORTED_MODULE_0_util_browser_utils__["i" /* setCookie */])(SR_LAST_SEEN_DATE_COOKIE_NAME, Date.now(), ONE_YEAR_SECONDS);
}
function getLastSeenSellerRatingDate() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_util_browser_utils__["c" /* getCookie */])(SR_LAST_SEEN_DATE_COOKIE_NAME);
}
/**
 * Utility to retrieve int value from sessionStorage
 * @param type
 * @param id
 */
function getSessionVarInt(type, id) {
    if (window.sessionStorage.getItem(type + "_" + id)) {
        return parseInt(window.sessionStorage.getItem(type + "_" + id));
    }
    return null;
}
function getSessionVar(type, id) {
    return window.sessionStorage.getItem(type + "_" + id);
}
function removeSessionVar(type, id) {
    window.sessionStorage.removeItem(type + "_" + id);
}
function setSessionVar(type, id, value) {
    window.sessionStorage.setItem(type + "_" + id, value);
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__submission_modal__ = __webpack_require__(42);




var SUBMISSION_MODAL_ID = 'tt-submission-modal';
var wasLoaded = false;
/* harmony default export */ __webpack_exports__["a"] = ({
    // If it does not already exist, this creates a div as a descendant of body with
    // an id used for submission-modal. It then mounts the submission-modal component
    // if not already mounted.
    load: function () {
        return new Promise(function (resolve) {
            if (wasLoaded) {
                __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */].isOpen = true;
                resolve();
            }
            else if (!document.getElementById(SUBMISSION_MODAL_ID)) {
                __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].appendDivToBody(SUBMISSION_MODAL_ID);
                new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
                    el: "#" + SUBMISSION_MODAL_ID,
                    render: function (h) { return h(__WEBPACK_IMPORTED_MODULE_3__submission_modal__["a" /* default */], {
                        attrs: { id: SUBMISSION_MODAL_ID }
                    }); },
                    created: function () {
                        __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */].isOpen = true;
                    }
                });
                wasLoaded = true;
                resolve();
            }
            else {
                resolve();
            }
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = processSsoRegDone;
/* harmony export (immutable) */ __webpack_exports__["g"] = ssoCreateReview;
/* harmony export (immutable) */ __webpack_exports__["e"] = ssoCreateQuestion;
/* harmony export (immutable) */ __webpack_exports__["d"] = ssoCreateAnswer;
/* harmony export (immutable) */ __webpack_exports__["f"] = ssoCreateReply;
/* harmony export (immutable) */ __webpack_exports__["h"] = ssoGetLoggedInData;
/* harmony export (immutable) */ __webpack_exports__["i"] = ssoGetLoggedInDataForReview;
/* harmony export (immutable) */ __webpack_exports__["b"] = processLoggedInDataDone;
/* harmony export (immutable) */ __webpack_exports__["a"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__msg__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_init_global_config__ = __webpack_require__(6);







function encodeSsoContext(ssoContext) {
    return btoa(JSON.stringify(ssoContext));
}
function processSsoRegDone(params) {
    var ssoContextData = parseSsoContext(params.context);
    if (params.userDataToken === null || params.userDataToken === '') {
        if (ssoContextData.action === 'QUESTION_CREATE' && __WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].isAllowAnon()) {
            __WEBPACK_IMPORTED_MODULE_4_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({ message: Object(__WEBPACK_IMPORTED_MODULE_5__msg__["a" /* default */])('ia.reg.skipped'), autoClose: true });
        }
        return;
    }
    __WEBPACK_IMPORTED_MODULE_0__api_service__["a" /* default */].completeSsoAction({
        sku: ssoContextData.sku
    }, {
        submissionToken: ssoContextData.submissionToken,
        action: ssoContextData.action,
        userDataToken: params.userDataToken
    }).then(function (ssoResponse) {
        // Review submission - purchase required case
        if (ssoContextData.action === 'REVIEW_CREATE' && __WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].isPurchaseReq()) {
            var launchData = {
                startAction: 'review',
                fromSso: true,
                source: ssoContextData.source,
                ssoToken: ssoResponse.token,
                starSelected: typeof ssoContextData.rating === 'number' ? ssoContextData.rating : undefined
            };
            __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startRevFlow(ssoContextData.sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, { page: 'review-form', props: {} }, launchData);
            __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
        }
        else {
            var messageType = 'review';
            switch (ssoContextData.action) {
                case 'QUESTION_CREATE':
                    messageType = __WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].isAllowAnon() ? 'questionAnonSso' : 'question';
                    break;
                case 'ANSWER_CREATE':
                    messageType = 'answer';
                    break;
                case 'REPLY_CREATE': messageType = 'reply';
            }
            __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].launchData = { ssoToken: ssoResponse.token };
            __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].currentPage = {
                page: 'do-more',
                props: {
                    msgType: messageType,
                    questionId: ssoContextData.questionId || null
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
        }
        // stops spinner on write review button(s)
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].isLaunchingWriteReview = false;
    }).catch(function (e) {
        var errorMsgKey = e.errorCode === 'item-already-reviewed'
            ? 'revForm.alreadyReviewed.message'
            : e.errorCode === 'turnto-offline' ? 'offline.error' : 'unexpected.error';
        __WEBPACK_IMPORTED_MODULE_4_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
            message: Object(__WEBPACK_IMPORTED_MODULE_5__msg__["a" /* default */])(errorMsgKey), type: 'error', autoClose: true
        });
    });
}
function ssoCreateReview(sku, source, submissionToken, rating) {
    if (submissionToken === void 0) { submissionToken = null; }
    if (rating === void 0) { rating = null; }
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.review) {
        case 1:
            ssoUserData(sku, 'REVIEW_CREATE', 'REGISTRATION_REQUIRED', submissionToken, source, rating);
            break;
        case 3:
            ssoUserData(sku, 'REVIEW_CREATE', 'CONFIRMATION_REQUIRED', submissionToken, source, rating);
            break;
        case 4:
            ssoUserData(sku, 'REVIEW_CREATE', 'PURCHASE_REQUIRED', submissionToken, source, rating);
    }
}
function ssoCreateQuestion(sku, submissionToken) {
    if (submissionToken === void 0) { submissionToken = null; }
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.question) {
        case 1:
            ssoUserData(sku, 'QUESTION_CREATE', 'ANONYMOUS', submissionToken);
            break;
        case 2:
            ssoUserData(sku, 'QUESTION_CREATE', 'REGISTRATION_REQUIRED', submissionToken);
            break;
        case 3:
            ssoUserData(sku, 'QUESTION_CREATE', 'CONFIRMATION_REQUIRED', submissionToken);
    }
}
function ssoCreateAnswer(sku, submissionToken, questionId) {
    if (questionId === void 0) { questionId = null; }
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.answerReply) {
        case 1:
            ssoUserData(sku, 'ANSWER_CREATE', 'REGISTRATION_REQUIRED', submissionToken, null, null, questionId);
            break;
        case 2:
            ssoUserData(sku, 'ANSWER_CREATE', 'CONFIRMATION_REQUIRED', submissionToken, null, null, questionId);
    }
}
function ssoCreateReply(sku, submissionToken) {
    switch (__WEBPACK_IMPORTED_MODULE_6_init_global_config__["a" /* default */].authSettings.answerReply) {
        case 1:
            ssoUserData(sku, 'REPLY_CREATE', 'REGISTRATION_REQUIRED', submissionToken);
            break;
        case 2:
            ssoUserData(sku, 'REPLY_CREATE', 'CONFIRMATION_REQUIRED', submissionToken);
    }
}
function ssoGetLoggedInData(sku, page, launchData, launchType) {
    var ssoContext = {};
    ssoContext.sku = sku;
    ssoContext.page = page;
    ssoContext.launchData = launchData;
    ssoContext.launchType = launchType;
    var encodedSsoContext = encodeSsoContext(ssoContext);
    __WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.loggedInDataFn(encodedSsoContext);
}
function ssoGetLoggedInDataForReview(sku, source, rating) {
    if (rating === void 0) { rating = null; }
    ssoGetLoggedInData(sku, { page: 'review-form', props: {} }, {
        startAction: 'review',
        source: typeof source === 'number' ? source : undefined,
        starSelected: typeof rating === 'number' ? rating : undefined
    }, 'rev');
}
function processLoggedInDataDone(params) {
    var ssoContextData = parseSsoContext(params.context);
    if (!!params.loggedInData) {
        ssoContextData.launchData.ssoProfileToken = params.loggedInData;
    }
    if (ssoContextData.launchType === 'qa') {
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startQaFlow(ssoContextData.sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, ssoContextData.page, ssoContextData.launchData);
    }
    else if (ssoContextData.launchType === 'sr') {
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startSellerRatingFlow(__WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, ssoContextData.page, ssoContextData.launchData);
    }
    else {
        __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].startRevFlow(ssoContextData.sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, ssoContextData.page, ssoContextData.launchData);
    }
    __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
    // stops spinner on write review button(s)
    __WEBPACK_IMPORTED_MODULE_1_store_submission_store__["b" /* default */].isLaunchingWriteReview = false;
}
function logout() {
    if (__WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.logout) {
        __WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.logout();
    }
}
function ssoUserData(sku, action, authSetting, submissionToken, source, rating, questionId) {
    if (submissionToken === void 0) { submissionToken = null; }
    if (source === void 0) { source = null; }
    if (rating === void 0) { rating = null; }
    if (questionId === void 0) { questionId = null; }
    var ssoContext = {};
    ssoContext.action = action;
    ssoContext.authSetting = authSetting;
    ssoContext.sku = sku;
    ssoContext.submissionToken = submissionToken;
    if (typeof source === 'number') {
        ssoContext.source = source;
    }
    if (typeof rating === 'number') {
        ssoContext.rating = rating;
    }
    if (typeof questionId === 'number') {
        ssoContext.questionId = questionId;
    }
    var encodedSsoContext = encodeSsoContext(ssoContext);
    __WEBPACK_IMPORTED_MODULE_2_init_config__["b" /* turnToConfig */].sso.userDataFn(encodedSsoContext);
}
function parseSsoContext(ssoContext) {
    var data = {};
    if (ssoContext) {
        // Base64 encoded JSON data (submissionToken, action)
        data = JSON.parse(atob(ssoContext));
    }
    return data;
}


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objects_popover_popover__ = __webpack_require__(21);



var POPOVER_CONTAINER_ID = 'tt-standalone-popover';
/**
 * This is intended to be used for when a user first comes to the page.  If the popover shows
 * at a later time, then should be shown as part of the widget it applies to instead of as a
 * standalone.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    // If it does not already exist, this creates a div as a descendant of body with
    // an id used for a standalone popover message. It then mounts the popover component
    // if not already mounted.
    load: function (data) {
        return new Promise(function (resolve) {
            __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].appendDivToBody(POPOVER_CONTAINER_ID);
            new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
                el: "#" + POPOVER_CONTAINER_ID,
                data: function () { return { showPopover: true }; },
                render: function (h) {
                    var _this = this;
                    if (this.showPopover) {
                        return h(__WEBPACK_IMPORTED_MODULE_2_objects_popover_popover__["a" /* default */], {
                            attrs: { id: POPOVER_CONTAINER_ID },
                            on: {
                                close: function () {
                                    _this.showPopover = false;
                                    __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].removeFromBody(POPOVER_CONTAINER_ID);
                                }
                            },
                            props: {
                                ariaLabel: data.label || '',
                                message: data.message,
                                type: data.type || 'success',
                                autoClose: data.autoClose || false
                            },
                            style: {
                                top: '25%'
                            }
                        });
                    }
                }
            });
            resolve();
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loadLoggedInUser;
/* harmony export (immutable) */ __webpack_exports__["c"] = loginUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = logoutUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = getUserToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_browser_utils__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_turnto_utils__ = __webpack_require__(11);



var USER_TOKEN_COOKIE_NAME = 'TT_USER_TOKEN';
var COOKIE_DELIMITER = '|';
function getUserAndToken() {
    var cookieValue = Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["c" /* getCookie */])(USER_TOKEN_COOKIE_NAME);
    if (cookieValue) {
        var cookieParts = cookieValue.split(COOKIE_DELIMITER);
        return { userToken: cookieParts[0], user: Object(__WEBPACK_IMPORTED_MODULE_2_util_turnto_utils__["i" /* parseTTdat */])(cookieParts[1]).user };
    }
    return { userToken: null, user: null };
}
// to be called when first coming to the page to load logged-in user info if logged-in.
// Can also be used to revalidate.  In other words, log out user if token expired.
function loadLoggedInUser() {
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = getUserAndToken().user;
}
/**
 * Logs in a user by setting the token in a cookie and sets the user with the passed in user.
 * Also need ttdat, which contains user data. Storing in cookie for the case where the user
 * refreshes or goes to another page.  Can then parse out the user info in "loadLoggedInUser".
 * @param token
 * @param ttdat
 */
function loginUser(token, ttdat) {
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = Object(__WEBPACK_IMPORTED_MODULE_2_util_turnto_utils__["i" /* parseTTdat */])(ttdat).user;
    var currentCookieValue = Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["c" /* getCookie */])(USER_TOKEN_COOKIE_NAME);
    var cookieTokenValue = currentCookieValue ? currentCookieValue.split(COOKIE_DELIMITER)[0] : '';
    // only want to set cookie if it doesn't exist or not the same.  Don't want to reset due to
    // expiration period
    if (cookieTokenValue !== token) {
        // setting to expire in 24 hours (86400 seconds)
        Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["i" /* setCookie */])(USER_TOKEN_COOKIE_NAME, "" + token + COOKIE_DELIMITER + ttdat, 86400);
    }
}
// Clears the user data and removes the user token
function logoutUser() {
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = null;
    Object(__WEBPACK_IMPORTED_MODULE_1_util_browser_utils__["b" /* dropCookie */])(USER_TOKEN_COOKIE_NAME);
}
function getUserToken() {
    var _a = getUserAndToken(), user = _a.user, userToken = _a.userToken;
    __WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].user = user;
    return userToken || '';
}


/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var global_commands_namespaceObject = {};
__webpack_require__.d(global_commands_namespaceObject, "set", function() { return set; });
__webpack_require__.d(global_commands_namespaceObject, "initialize", function() { return initialize; });
__webpack_require__.d(global_commands_namespaceObject, "setLogLevel", function() { return setLogLevel; });
__webpack_require__.d(global_commands_namespaceObject, "setLogTrace", function() { return setLogTrace; });
__webpack_require__.d(global_commands_namespaceObject, "ssoRegDone", function() { return ssoRegDone; });
__webpack_require__.d(global_commands_namespaceObject, "loggedInDataFnDone", function() { return loggedInDataFnDone; });

// EXTERNAL MODULE: ./src/util/logger.ts
var logger = __webpack_require__(9);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(4);

// EXTERNAL MODULE: ./src/services/sso-service.ts
var sso_service = __webpack_require__(13);

// CONCATENATED MODULE: ./src/init/global-commands.ts



// widgets affected by a change in sku
var SET_TYPES = ['chatter', 'instant-answers', 'qa', 'reviews-summary', 'reviews-list'];
function set(params) {
    if (!params || !params.sku) {
        logger["a" /* default */].error('Must specify sku for "set" (e.g. {sku: "abc"})');
        return;
    }
    var previousSku = global_store["a" /* default */].sku;
    global_store["a" /* default */].sku = params.sku;
    // if the sku changed, check to make sure the affected widgets are loaded, if not load them
    if (previousSku !== global_store["a" /* default */].sku) {
        global_store["a" /* default */].loaders.forEach(function (loader) {
            if (SET_TYPES.indexOf(loader.type) > -1 && !loader.getInstance()) {
                loader.initialize();
            }
        });
    }
}
// Used to load widgets after the page has loaded.  Covers case where divs do not exist on the
// page by the time dom is ready.  Can also be used in SPA situation where the html holding the
// widgets is removed and replaced with a new dom.
function initialize(widgetType) {
    global_store["a" /* default */].loaders.forEach(function (loader) {
        // not all widgets have an initialize functiion (e.g. top-comments, feed-comment-capture)
        if (typeof loader.initialize === 'function' && (!widgetType || widgetType === loader.type)) {
            loader.initialize();
        }
    });
}
function setLogLevel(level) {
    logger["b" /* setLogLevel */](level);
}
function setLogTrace(logTrace) {
    logger["c" /* setLogTrace */](logTrace);
}
// context is a base64 encoded json containing submissionToken, action, sku and optionally rating
function ssoRegDone(params) {
    if (!params || !params.context) {
        logger["a" /* default */].error('Must specify context for "ssoRegDone" (e.g. {context: "abc"})');
        return;
    }
    Object(sso_service["c" /* processSsoRegDone */])(params);
}
// context is a base64 encoded json containing sku and optionally rating
function loggedInDataFnDone(params) {
    if (!params || !params.context) {
        logger["a" /* default */].error('Must specify context for "loggedInDataFnDone" (e.g. {context: "abc"})');
        return;
    }
    Object(sso_service["b" /* processLoggedInDataDone */])(params);
}

// CONCATENATED MODULE: ./src/init/command-queue.ts
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return widgetLibraries; });


// An array of commands submitted by the client
var queue;
// Help make sure commands are not executed twice
var isProcessingQueue = false;
/**
 * Called by the page entry js once the widgets have been initialized, but not necessarily mounted
 */
function init() {
    // determine the name of the command function the client is using
    var cmdObjName = window.TurnToCmdObjectName || 'TurnToCmd';
    // get the commands that already queued up
    queue = window[cmdObjName] ? (window[cmdObjName].q || []) : [];
    // reassign the command object to point to internal function
    window[cmdObjName] = queueAndRunCommands;
    // call to run commands in case any are already in the queue
    runCommands();
}
/**
 * Widget loaders assign the function calls that can be made
 */
var widgetLibraries = {
    chatter: {},
    commentsPinboard: {},
    commentsPinboardTeaser: {},
    feed: {},
    gallery: {},
    global: global_commands_namespaceObject,
    instantAnswers: {},
    qa: {},
    reviewsList: {},
    reviewsSummary: {},
    spectrum: {},
    topComments: {},
    userToolbar: {},
    vcPinboard: {}
};
// Function that the command object is assigned to when initialized
function queueAndRunCommands() {
    queue.push(arguments);
    runCommands();
}
// Run any commands that are in the queue
function runCommands() {
    if (!isProcessingQueue) {
        isProcessingQueue = true;
        while (queue.length) {
            // removes the first item from the queue and converts the Arguments object to an array
            var args = Array.prototype.slice.call(queue.shift());
            // called without args
            if (args.length === 0) {
                logger["a" /* default */].error('TurnToCmd called without any arguments');
                continue;
            }
            // If the command contains a dot, then it's a specific widget command.
            // If no dot, it should be a global command.
            var cmd = args[0];
            var libraryName = 'global';
            var fnName = cmd;
            if (~cmd.indexOf('.')) {
                var cmdParts = cmd.split('.');
                libraryName = cmdParts[0];
                fnName = cmdParts[1];
            }
            var fn = widgetLibraries[libraryName] ? widgetLibraries[libraryName][fnName] : undefined;
            if (!isFunction(fn)) {
                logger["a" /* default */].error("\"" + cmd + "\" is not a valid command.");
                continue;
            }
            // finally verified, we can call the function.  Doesn't mean it won't fail if the arguments
            // for the function are incorrect
            var functionArgs = args.length > 1 ? args.slice(1) : [];
            fn.apply(null, functionArgs);
        }
        isProcessingQueue = false;
    }
}
function isFunction(fn) {
    return typeof fn === 'function';
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(1);

// CONCATENATED MODULE: ./src/mixins/modal-tab-control-mixin.ts
/**
 * This mixin is meant to be used by modal and popover components.
 * It keeps the tabbing within the modal/popover until the user exits
 * the popover/modal.
 * The top element in the component should have a tab event that calls
 * handleTab: @keydown.tab="handleTab"
 * It is the responsibility of the component inside the modal to set the first element to focus on.
 */

/* harmony default export */ var modal_tab_control_mixin = ({
    methods: {
        getFirstTabbableElement: function (tabbableElements) {
            var firstElement = tabbableElements[0];
            if (firstElement.type === 'radio') {
                firstElement = this.getTabToRadioBtn(firstElement.name, true);
            }
            return firstElement;
        },
        getLastTabbableElement: function (tabbableElements) {
            var lastElement = tabbableElements[tabbableElements.length - 1];
            if (lastElement.type === 'radio') {
                lastElement = this.getTabToRadioBtn(lastElement.name, false);
            }
            return lastElement;
        },
        getTabToRadioBtn: function (radioGroupName, forward) {
            var radioBtns = this.$el.querySelectorAll("[name=" + radioGroupName + "]");
            // if one is checked, that trumps all
            for (var i = 0; i < radioBtns.length; i++) {
                if (radioBtns[i].checked) {
                    return radioBtns[i];
                }
            }
            // if tabbing forward, it's the first button we select, if backwards its the last
            return forward ? radioBtns[0] : radioBtns[radioBtns.length - 1];
        },
        isFirstTabbableElement: function (elem, tabbableElements) {
            return elem === tabbableElements[0] || (elem.type === 'radio' &&
                tabbableElements[0].type === 'radio' && elem.name === tabbableElements[0].name);
        },
        isLastTabbableElement: function (elem, tabbableElements) {
            var trueLast = tabbableElements[tabbableElements.length - 1];
            return elem === trueLast || (elem.type === 'radio' && trueLast.type === 'radio' &&
                elem.name === trueLast.name);
        },
        handleTab: function (e) {
            var tabbableElements = dom_utils["a" /* default */].getTabbableElements(this.$el);
            if (e.shiftKey && this.isFirstTabbableElement(e.target, tabbableElements)) {
                // is on the first element, since this is shift+tab, need to now focus on last element
                e.preventDefault();
                this.getLastTabbableElement(tabbableElements).focus();
            }
            else if (!e.shiftKey && this.isLastTabbableElement(e.target, tabbableElements)) {
                e.preventDefault();
                this.getFirstTabbableElement(tabbableElements).focus();
            }
        }
    }
});

// EXTERNAL MODULE: ./src/services/msg.ts
var msg = __webpack_require__(5);

// EXTERNAL MODULE: ./src/util/browser-utils.ts
var browser_utils = __webpack_require__(16);

// CONCATENATED MODULE: ./src/util/body-scroll-lock.ts
// This ism eant for use by the modal.  Can only be applied to one element on the page.
// Helps hold the underlying page in position, while allowing the modal to scroll smoothly.
// Most of this code is due to the odd behavior of iOS.
//
// This is a trimmed down version of https://github.com/willmcpo/body-scroll-lock
// Notes from that library:
// Adopted and modified solution from Bohdan Didukh (2017)
// tslint:disable-next-line:max-line-length
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var targetElement;
var scrollY;
var initialClientY = -1;
var previousBodyOverflowSetting;
function allowMove(e) {
    return e.target && e.target.className.indexOf('tt-scoll-lock-ignore') > -1;
}
var preventDefault = function (rawEvent) {
    var e = rawEvent || window.event;
    if (allowMove(e)) {
        return true;
    }
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch
    // gesture like pinch to zoom)
    if (e.touches.length > 1)
        return true;
    if (e.preventDefault)
        e.preventDefault();
    return false;
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function (targetElement) {
    return targetElement ?
        targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight
        : false;
};
var handleScroll = function (e, targetElement) {
    var clientY = e.targetTouches[0].clientY - initialClientY;
    if (allowMove(e)) {
        return true;
    }
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        return preventDefault(e);
    }
    if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
        // element is at the top of its scroll
        return preventDefault(e);
    }
    e.stopPropagation();
    return true;
};
var disableBodyScroll = function (el) {
    // already disabled by something else
    if (targetElement) {
        return;
    }
    targetElement = el;
    if (browser_utils["e" /* isIOS */]) {
        targetElement.style['-webkit-overflow-scrolling'] = 'touch';
        targetElement.ontouchstart = function (e) {
            if (e.targetTouches.length === 1) {
                // detect single touch
                initialClientY = e.targetTouches[0].clientY;
            }
        };
        targetElement.ontouchmove = function (e) {
            if (e.targetTouches.length === 1) {
                // detect single touch
                handleScroll(e, targetElement);
            }
        };
        document.addEventListener('touchmove', preventDefault);
    }
    else {
        // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
        // the responsiveness for some reason. Setting within a setTimeout fixes this.
        setTimeout(function () {
            // TT-11611 - form scrolling fix
            if (browser_utils["d" /* isAndroid */]) {
                scrollY = window.scrollY;
                window.scrollTo(window.scrollX, 0);
            }
            // If previousBodyOverflowSetting is already set, don't set it again.
            if (previousBodyOverflowSetting === undefined) {
                previousBodyOverflowSetting = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
            }
        });
    }
};
var enableBodyScroll = function () {
    if (browser_utils["e" /* isIOS */]) {
        if (targetElement) {
            targetElement.ontouchstart = null;
            targetElement.ontouchmove = null;
        }
        document.removeEventListener('touchmove', preventDefault);
    }
    else {
        // Setting overflow on body/documentElement synchronously in Desktop Safari slows down
        // the responsiveness for some reason. Setting within a setTimeout fixes this.
        setTimeout(function () {
            if (browser_utils["d" /* isAndroid */] && scrollY) {
                window.scrollTo(window.scrollX, scrollY);
            }
            if (previousBodyOverflowSetting !== undefined) {
                document.body.style.overflow = previousBodyOverflowSetting;
                // Restore previousBodyOverflowSetting to undefined
                // so setOverflowHidden knows it can be set again.
                previousBodyOverflowSetting = undefined;
            }
        });
    }
    targetElement = undefined;
};

// EXTERNAL MODULE: ./src/objects/popover/popover.ts
var popover = __webpack_require__(21);

// EXTERNAL MODULE: ./src/objects/modal/modal.html
var modal = __webpack_require__(45);
var modal_default = /*#__PURE__*/__webpack_require__.n(modal);

// EXTERNAL MODULE: ./src/objects/modal/modal.scss
var modal_modal = __webpack_require__(46);
var modal_modal_default = /*#__PURE__*/__webpack_require__.n(modal_modal);

// CONCATENATED MODULE: ./src/objects/modal/modal.ts








// NOTE: MUST USE v-if TO SHOW/HIDE THE MODAL. This is due to logic that adds an overflow style to
// the body of the page and removes that same style before the component is destroyed.
/* harmony default export */ var objects_modal_modal = __webpack_exports__["a"] = (modal_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () { return { scrollPosition: 0 }; },
    mixins: [modal_tab_control_mixin],
    props: {
        ariaLabel: String,
        ariaLabeledById: String,
        centered: {
            type: Boolean,
            default: false
        },
        closeLabel: {
            type: String,
            // had to import msg as this.$msg does not work here
            default: function () { return Object(msg["a" /* default */])('modal.close'); }
        },
        ariaDescribedById: String,
        // whether or not this modal is inside yet another modal. Important to set to true so
        // that the overflow set on body is not removed when the child modal is closed
        isLoading: Boolean,
        notifyOutsideClick: Boolean,
        popoverMessage: String,
        popoverType: {
            type: String,
            default: 'success'
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },
    provide: {
        // this is made available for all child components to know whether they are inside of a modal
        // or not.  This is used by this modal as well as menu-list so they know how to close when not
        // directly in the body
        isInModal: true
    },
    inject: {
        // This is set by the "provide" above if this modal is inside another modal.  Otherwise, false
        isInModal: { default: false }
    },
    components: { 'tt-popover': popover["a" /* default */] },
    methods: {
        close: function () {
            this.$emit('close');
        },
        closePopover: function () {
            this.$emit('closePopover');
        },
        handleClick: function (e) {
            // if clicking outside of the container, then close it
            if (!this.$refs.container.contains(e.target) && !this.isExternalButtonClick(e) &&
                !this.isPopoverClick(e)) {
                this.notifyOutsideClick ? this.$emit('outsideClick') : this.close();
            }
        },
        isExternalButtonClick: function (e) {
            var externalBtns = this.$slots.externalButtons;
            if (externalBtns) {
                for (var i = 0; i < externalBtns.length; i++) {
                    var elem = externalBtns[i].elm;
                    if (elem && elem.nodeType === 1 && elem.contains(e.target)) {
                        return true;
                    }
                }
            }
            return false;
        },
        isPopoverClick: function (e) {
            var popover = this.$refs.popover;
            return popover && popover.$el.contains(e.target);
        }
    },
    created: function () {
        if (!this.ariaLabel && !this.ariaLabeledById && "production" === 'development') {
            // tslint:disable:next-line no-console
            console.error('Must provide ariaLabel or ariaLabeledById');
        }
    },
    mounted: function () {
        // prevent scrollbars from showing up for underlying body and allow for smooth scrolling on iOS
        if (!this.isInModal) {
            disableBodyScroll(this.$el);
        }
        this.$refs.container.focus();
    },
    beforeDestroy: function () {
        // re-enable body scrolling that was disabled when the modal was opened
        if (!this.isInModal) {
            enableBodyScroll();
        }
    },
    watch: {
        popoverMessage: function () {
            var _this = this;
            if (this.popoverMessage) {
                dom_utils["a" /* default */].whenRefIsVisible(this.$refs, 'popover').then(function () {
                    _this.$refs.popover.$el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
                });
            }
        }
    }
})));


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RelatedReviewsDisplayTypes; });
/* unused harmony export ReviewsListConfig */
/* harmony export (immutable) */ __webpack_exports__["c"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultConfig; });
var RelatedReviewsDisplayTypes;
(function (RelatedReviewsDisplayTypes) {
    RelatedReviewsDisplayTypes["NONE"] = "NONE";
    RelatedReviewsDisplayTypes["INCLUDED"] = "INCLUDED";
    RelatedReviewsDisplayTypes["SEPARATE"] = "SEPARATE";
})(RelatedReviewsDisplayTypes || (RelatedReviewsDisplayTypes = {}));
var ReviewsListConfig = /** @class */ (function () {
    function ReviewsListConfig(config) {
        this.breakpoints = config.breakpoints;
        this.defaultSortOption = config.defaultSortOption;
        this.displayUserToolbar = config.displayUserToolbar;
        this.hideWriteReview = config.hideWriteReview;
        this.initialPageSize = config.initialPageSize;
        this.pageSize = config.pageSize;
        this.relatedReviewsDisplay = config.relatedReviewsDisplay;
        this.relatedInitialPageSize = config.relatedInitialPageSize;
        this.relatedPageSize = config.relatedPageSize;
        this.showPurchaserBadge = config.showPurchaserBadge;
        this.sortOptions = config.sortOptions;
        this.toggleFiltersDesktop = config.toggleFiltersDesktop;
        this.toggleFiltersMobile = config.toggleFiltersMobile;
        this.useShowMore = config.useShowMore;
        this.widgetDivId = config.widgetDivId;
    }
    return ReviewsListConfig;
}());

var defaultConfig = {};
function loadConfig(config) {
    defaultConfig = new ReviewsListConfig(config);
}



/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_html__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popover_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__popover_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover_scss__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popover_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__popover_scss__);



var TYPES = ['success', 'error'];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__popover_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        ariaLabel: String,
        asAlertDialog: Boolean,
        autoClose: Boolean,
        closeLabel: String,
        // specify message or provide slot
        message: String,
        showClose: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'success',
            validator: function (v) { return TYPES.indexOf(v) > -1; }
        }
    },
    computed: {
        iconName: function () {
            return this.type === 'error' ? 'error' : 'check';
        },
        typeClass: function () {
            return this.type ? "tt-o-popover--" + this.type : '';
        },
        role: function () {
            return this.asAlertDialog ? 'alertdialog' : 'alert';
        }
    },
    methods: {
        close: function () {
            this.$emit('close');
        }
    },
    created: function () {
        if (this.asAlertDialog && !this.ariaLabel && "production" === 'development') {
            // tslint:disable:next-line no-console
            console.error('Must provide ariaLabel');
        }
    },
    mounted: function () {
        var _this = this;
        if (this.autoClose) {
            // will close after a period of time.  Must use a v-if on the popover for mounted to be
            // called each time it is shown.
            setTimeout(function () {
                _this.close();
            }, (this.type === 'error' ? 10000 : 6000));
        }
    }
})));


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/util/ts-utils.ts
var ts_utils = __webpack_require__(10);

// EXTERNAL MODULE: ./src/services/msg.ts
var msg = __webpack_require__(5);

// CONCATENATED MODULE: ./src/store/filter-store.ts



// when initializing the filterValues for each filter, setting to one of these values based on
// filter type
function getDefaultValForType(type) {
    return type === 'array' ? new Array() : null;
}
var filter_store_FilterStore = /** @class */ (function () {
    function FilterStore() {
        this.state = {
            appliedFilters: [],
            filterValues: {},
            filters: [],
            // an encoded, ordered json obj for sending in query path
            encodedFiltersUrl: encodeURIComponent('{}'),
            ratingsFilter: undefined
        };
    }
    Object.defineProperty(FilterStore.prototype, "filterValues", {
        get: function () {
            return this.state.filterValues;
        },
        enumerable: true,
        configurable: true
    });
    FilterStore.prototype.clearFilters = function () {
        var _this = this;
        this.state.filters.forEach(function (filter) {
            if (_this.state.filterValues[filter.group]) {
                _this.state.filterValues[filter.group][filter.name] = getDefaultValForType(filter.type);
            }
        });
        this.state.appliedFilters = [];
        this.state.encodedFiltersUrl = encodeURIComponent('{}');
    };
    Object.defineProperty(FilterStore.prototype, "appliedFilters", {
        get: function () {
            return this.state.appliedFilters;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterStore.prototype, "encodedFiltersUrl", {
        get: function () {
            return this.state.encodedFiltersUrl;
        },
        enumerable: true,
        configurable: true
    });
    FilterStore.prototype.setFilterValue = function (filter, value) {
        this.state.filterValues[filter.group][filter.name] = value;
        this.updateAppliedFilters();
    };
    // only to be called internally
    FilterStore.prototype.updateAppliedFilters = function () {
        var filterValues = this.state.filterValues;
        var appliedFilters = [];
        var appliedFiltersMap = {};
        // Need to alphabetize the output (JSON.stringify) below so that the filter is consistent
        // for CDN caching. Idea for how:
        // https://stackoverflow.com/questions/16167581/sort-object-properties-and-json-stringify
        var replacer = [];
        this.state.filters.forEach(function (filter) {
            var group = filter.group;
            var filterName = filter.name;
            var filterValue = filterValues[group][filterName];
            if ((filter.type === 'array' && filterValue.length > 0) ||
                (filter.type !== 'array' && (!!filterValue || filterValue === 0))) {
                if (replacer.indexOf(group) === -1) {
                    replacer.push(group);
                }
                replacer.push(filterName);
                if (!appliedFiltersMap[group]) {
                    appliedFiltersMap[group] = {};
                }
                appliedFiltersMap[group][filterName] = filterValue;
                var optionValues = filter.type === 'array' ? filterValue : [filterValue];
                var filterLabel_1 = filter.group === 'cm' ? '' :
                    (filter.labelKey ? Object(msg["a" /* default */])(filter.labelKey) : filter.label) + ": ";
                optionValues.forEach(function (optionValue) {
                    var option = Object(ts_utils["a" /* arrayFind */])(filter.options, function (opt) { return opt.value === optionValue; });
                    appliedFilters.push({
                        filter: filter,
                        value: option.value,
                        label: "" + filterLabel_1 + (option.labelKey ? Object(msg["a" /* default */])(option.labelKey) : option.label)
                    });
                });
            }
        });
        this.state.appliedFilters = appliedFilters;
        this.state.encodedFiltersUrl =
            encodeURIComponent(JSON.stringify(appliedFiltersMap, replacer.sort()));
    };
    FilterStore.prototype.removeFilterValue = function (filter, value) {
        if (filter.type === 'array') {
            // setFilterValue needs the full array with this given value removed
            this.setFilterValue(filter, this.state.filterValues[filter.group][filter.name].filter(function (v) { return v !== value; }));
            return;
        }
        this.setFilterValue(filter, getDefaultValForType(filter.type));
    };
    Object.defineProperty(FilterStore.prototype, "filters", {
        get: function () {
            return this.state.filters;
        },
        /**
         * Set the filters to be used.  This also initializes the filterValues for each filter
         */
        set: function (filters) {
            var _this = this;
            // in case being reset, clear state values
            this.state.filters = filters;
            this.clearFilters();
            // organize filters and filterValues by group / filter name
            filters.forEach(function (filter) {
                if (!_this.state.filters[filter.group]) {
                    vue_runtime_esm["a" /* default */].set(_this.state.filters, filter.group, {});
                    vue_runtime_esm["a" /* default */].set(_this.state.filterValues, filter.group, {});
                }
                vue_runtime_esm["a" /* default */].set(_this.state.filters[filter.group], filter.name, filter);
                vue_runtime_esm["a" /* default */].set(_this.state.filterValues[filter.group], filter.name, getDefaultValForType(filter.type));
                // setting ratings filter specifically for easy access in ratings-breakdown and spectrum
                if (filter.group === 'cm' && filter.name === 'rt') {
                    _this.state.ratingsFilter = filter;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    FilterStore.prototype.getRatingsFilter = function () {
        return this.state.ratingsFilter;
    };
    return FilterStore;
}());


// CONCATENATED MODULE: ./src/store/reviews-store.ts
/* unused harmony export ReviewsStore */

var reviews_store_ReviewsStore = /** @class */ (function () {
    function ReviewsStore() {
        this.state = {
            filterStore: undefined,
            sort: undefined,
            searchTerm: '',
            trimmedSearchTerm: ''
        };
        this.state.filterStore = new filter_store_FilterStore();
    }
    Object.defineProperty(ReviewsStore.prototype, "filterStore", {
        get: function () {
            return this.state.filterStore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewsStore.prototype, "sort", {
        get: function () {
            return this.state.sort;
        },
        set: function (sort) {
            this.state.sort = sort;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewsStore.prototype, "searchTerm", {
        get: function () {
            return this.state.searchTerm;
        },
        set: function (searchTerm) {
            this.state.searchTerm = searchTerm;
            this.state.trimmedSearchTerm = searchTerm.trim();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReviewsStore.prototype, "trimmedSearchTerm", {
        get: function () {
            return this.state.trimmedSearchTerm;
        },
        enumerable: true,
        configurable: true
    });
    return ReviewsStore;
}());

/* harmony default export */ var reviews_store = __webpack_exports__["a"] = (new reviews_store_ReviewsStore());


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RelatedQuestionsDisplayTypes; });
/* unused harmony export QaConfig */
/* harmony export (immutable) */ __webpack_exports__["c"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultConfig; });
var RelatedQuestionsDisplayTypes;
(function (RelatedQuestionsDisplayTypes) {
    RelatedQuestionsDisplayTypes["NONE"] = "NONE";
    RelatedQuestionsDisplayTypes["INCLUDED"] = "INCLUDED";
    RelatedQuestionsDisplayTypes["SEPARATE"] = "SEPARATE";
})(RelatedQuestionsDisplayTypes || (RelatedQuestionsDisplayTypes = {}));
var QaCommentsConfig = /** @class */ (function () {
    function QaCommentsConfig(config) {
        this.initialPageSize = config.initialPageSize;
        this.includeSyndicated = config.includeSyndicated;
        this.limit = config.limit;
        this.minCharacterCount = config.minCharacterCount;
        this.minWordCount = config.minWordCount;
        this.sortOrder = config.sortOrder;
        this.truncateLength = config.truncateLength;
        this.truncateAllowance = config.truncateAllowance;
    }
    return QaCommentsConfig;
}());
var QaConfig = /** @class */ (function () {
    function QaConfig(config) {
        this.defaultSortOption = config.defaultSortOption;
        this.defaultSortOptionName = config.defaultSortOptionName;
        this.displayUserToolbar = config.displayUserToolbar;
        this.hideBestAnswer = config.hideBestAnswer;
        this.initialPageSize = config.initialPageSize;
        this.pageSize = config.pageSize;
        this.relatedInitialPageSize = config.relatedInitialPageSize;
        this.relatedPageSize = config.relatedPageSize;
        if (config.comments) {
            this.comments = new QaCommentsConfig(config.comments);
        }
        else {
            this.comments = {};
        }
        this.showCheckoutChatterOnQAWidget = config.showCheckoutChatterOnQAWidget;
        this.sortOptions = config.sortOptions;
        this.widgetDivId = config.widgetDivId;
        this.relatedQuestionsDisplay = config.relatedQuestionsDisplay;
    }
    return QaConfig;
}());

var defaultConfig = {};
function loadConfig(config) {
    defaultConfig = new QaConfig(config);
}



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_html__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menu_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__menu_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_scss__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__menu_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__menu_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () { return { isMenuExpanded: false }; },
    methods: {
        // this method can be used by the parent to force the menu to close (clicking outside of the
        // menu for example)
        close: function () {
            this.setExpanded(false);
        },
        getMenuTrigger: function () {
            var triggerNodes = this.$slots.menuTrigger;
            if (!triggerNodes) {
                // tslint:disable:next-line no-console
                console.error('Could not find "menuTrigger" slot in Menu');
                return null;
            }
            return triggerNodes[0];
        },
        menuTriggerSelected: function (e) {
            if (e.type === 'click' || e.keyCode === 13) {
                this.setExpanded(true);
            }
        },
        setExpanded: function (expanded, setFocus) {
            if (setFocus === void 0) { setFocus = true; }
            this.isMenuExpanded = expanded;
            var menuTriggerElem = this.getMenuTrigger().elm;
            if (menuTriggerElem) {
                this.getMenuTrigger().elm.setAttribute('aria-expanded', expanded);
                if (!this.isMenuExpanded && setFocus) {
                    menuTriggerElem.focus();
                }
            }
        }
    },
    mounted: function () {
        // make sure these are on menu-trigger
        var menuTrigger = this.getMenuTrigger();
        menuTrigger.elm.setAttribute('aria-haspopup', 'menu');
        this.setExpanded(false, false);
        menuTrigger.elm.addEventListener('click', this.menuTriggerSelected);
        if (menuTrigger.elm.tagName !== 'BUTTON') {
            // if a button, it already fires 'click' event when hitting enter key
            // if not a button, need to add this keydown event
            menuTrigger.elm.addEventListener('keydown', this.menuTriggerSelected);
            // also need to make sure it has a role of 'button' then
            menuTrigger.elm.setAttribute('role', 'button');
        }
    },
    beforeDestroy: function () {
        var menuTrigger = this.getMenuTrigger();
        if (menuTrigger) {
            menuTrigger.elm.removeEventListener('click', this.menuTriggerSelected, false);
            menuTrigger.elm.removeEventListener('keydown', this.menuTriggerSelected, false);
        }
    }
})));


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_list_html__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu_list_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__menu_list_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_scss__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__menu_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__menu_scss__);




var VALID_ALIGNMENTS = ['left', 'center', 'right'];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__menu_list_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: 'MenuList',
    data: function () {
        return {
            listenerElem: undefined,
            selectedItemIndex: -1
        };
    },
    props: {
        alignMenu: {
            type: String,
            default: 'center',
            validator: function (value) { return VALID_ALIGNMENTS.indexOf(value) > -1; }
        },
        menuItems: Array,
        type: {
            type: String,
            default: 'action'
        }
    },
    inject: {
        // The modal.ts "provides" this value if this menu list is inside a modal, otherwise false.
        // Need to know when inside of a modal to be able to properly close when clicking outside of
        // this menu-list
        isInModal: { default: false }
    },
    computed: {
        alignClass: function () {
            return ["tt-o-menu__list--align-" + this.alignMenu];
        },
        isMenuExpanded: function () {
            return this.$parent.isMenuExpanded;
        },
        menuItemTypeClass: function () {
            return "tt-o-menu__item--" + this.type;
        }
    },
    methods: {
        close: function () {
            this.$parent.close();
        },
        getMenuItems: function () {
            return this.$slots.default.filter(function (v) {
                var inst = v.componentInstance;
                return inst && inst.$options.name === 'MenuItem';
            });
        },
        handleTab: function (e) {
            e.shiftKey ? this.moveUp() : this.moveDown();
        },
        menuItemSelected: function (index) {
            var item = this.menuItems[index];
            if (!item.disabled) {
                this.$emit('menuItemSelected', item);
                this.close();
            }
        },
        moveDown: function () {
            if (this.selectedItemIndex > -1 && this.selectedItemIndex < this.menuItems.length - 1) {
                this.selectedItemIndex += 1;
            }
            else {
                this.selectedItemIndex = 0;
            }
        },
        moveUp: function () {
            if (this.selectedItemIndex <= 0) {
                this.selectedItemIndex = this.menuItems.length - 1;
            }
            else {
                this.selectedItemIndex -= 1;
            }
        },
        outsideClick: function (e) {
            if (!this.$el.contains(e.target)) {
                this.close();
            }
        },
        setItemFocus: function () {
            if (this.selectedItemIndex > -1 && this.selectedItemIndex < this.menuItems.length) {
                this.$el.querySelectorAll('.tt-o-menu__item')[this.selectedItemIndex].focus();
            }
        },
        setSelectedMenuItem: function () {
            var _this = this;
            this.getMenuItems().forEach(function (item, i) {
                if (_this.selectedItemIndex === i) {
                    item.componentInstance.setSelected(true);
                }
                else {
                    item.componentInstance.setSelected(false);
                }
            });
        }
    },
    watch: {
        isMenuExpanded: function () {
            var _this = this;
            this.selectedItemIndex = -1;
            this.listenerElem = this.isInModal ? document.querySelector('.tt-o-modal') : document.body;
            if (!this.listenerElem) {
                return;
            }
            if (this.isMenuExpanded) {
                // due to a timing issue, if not rendered yet, need to wait by using safeFocus
                __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].safeFocus(this.$el).then(function () {
                    _this.listenerElem.addEventListener('click', _this.outsideClick, false);
                });
            }
            else {
                this.listenerElem.removeEventListener('click', this.outsideClick, false);
            }
        },
        selectedItemIndex: function () {
            this.setItemFocus();
        }
    },
    beforeDestroy: function () {
        // just to be sure we don't leave the event around
        if (this.listenerElem) {
            this.listenerElem.removeEventListener('click', this.outsideClick, false);
        }
    }
})));


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ORIGIN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CDN_URL; });
/* harmony export (immutable) */ __webpack_exports__["c"] = executeRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = executeStaticRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_ts_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);


var ORIGIN_URL = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].originHost + "/v5";
var CDN_URL = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].cdnHost + "/v5";
function createRequest(method, url, options, resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.addEventListener('load', function () {
        if (xhr.responseText) {
            // assume json
            try {
                xhr.data = JSON.parse(xhr.responseText);
            }
            catch (e) {
                xhr.data = {};
                reject(xhr);
                return;
            }
        }
        resolve(xhr);
    });
    var onError = function () {
        if (xhr.responseText) {
            // assume json
            try {
                xhr.data = JSON.parse(xhr.responseText);
            }
            catch (e) {
                xhr.data = {};
            }
        }
        reject(xhr);
    };
    xhr.addEventListener('error', onError);
    xhr.addEventListener('abort', onError);
    var params = options.params || {};
    // open needs to be called before setting content-type header for IE10-11
    xhr.open(method, url + "?" + Object(__WEBPACK_IMPORTED_MODULE_0_util_ts_utils__["c" /* buildQryString */])(params));
    var headers = options.headers;
    if (headers) {
        Object.keys(headers).forEach(function (h) { return xhr.setRequestHeader(h, headers[h]); });
    }
    // when true, allow CORS to send cookies
    xhr.withCredentials = options.withCredentials || false;
    return xhr;
}
function executeRequest(method, uri, options) {
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        options.params = options.params || {};
        // set locale on all calls that doesn't already have that value in the path.
        if (!options.params.locale && uri.indexOf("" + __WEBPACK_IMPORTED_MODULE_1_init_config__["b" /* turnToConfig */].locale) === -1) {
            options.params.locale = __WEBPACK_IMPORTED_MODULE_1_init_config__["b" /* turnToConfig */].locale;
        }
        var url = "" + ORIGIN_URL + uri;
        if (!options.headers) {
            options.headers = {};
        }
        // all but static (CDN) calls need to have this header for CORS allow origin
        options.headers['X-Turnto-Sitekey'] = __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey;
        if (options.body && !options.headers['Content-Type']) {
            options.headers['Content-Type'] = 'application/json';
        }
        else if (options.formData && options.headers['Content-Type']) {
            // making sure to let xhr/formData set Content-Type. Needed for multi-part boundary
            delete options.headers['Content-Type'];
        }
        var xhr = createRequest(method, url, options, resolve, reject);
        // if a callback is provided for file upload progress
        if (options.progressCallback && xhr.upload) {
            xhr.upload.addEventListener('progress', options.progressCallback, false);
        }
        if (options.body) {
            xhr.send(JSON.stringify(options.body));
        }
        else if (options.formData) {
            xhr.send(options.formData);
        }
        else {
            xhr.send();
        }
    });
}
function executeStaticRequest(uri, options) {
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        var url = "" + CDN_URL + uri;
        var xhr = createRequest('GET', url, options, resolve, reject);
        xhr.send();
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = createAndMountInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_logger__ = __webpack_require__(9);



function createAndMountInstance(existingInstance, widget, divId) {
    return new Promise(function (resolve) {
        if (existingInstance) {
            existingInstance.$destroy();
        }
        // if the dom element already exists, no need to wait for dom ready
        if (document.getElementById(divId)) {
            resolve(createInstance(widget, divId));
            return;
        }
        __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].onDomReady().then(function () {
            if (document.getElementById(divId)) {
                resolve(createInstance(widget, divId));
                return;
            }
            resolve();
            __WEBPACK_IMPORTED_MODULE_2_util_logger__["a" /* default */].warn("Widget not loaded at dom ready. Could not find div with id " + divId + ".");
        });
    });
}
function createInstance(widget, divId) {
    return new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
        el: "#" + divId,
        render: function (h) { return h(widget, {
            attrs: { id: divId }
        }); }
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_filters_format_name__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_global_config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_init_global_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_token_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_msg__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_profile_profile_store__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_objects_menu_menu__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_objects_menu_menu_list__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_toolbar_m1_html__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_toolbar_m1_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__user_toolbar_m1_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_toolbar_scss__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_toolbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__user_toolbar_scss__);











/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9__user_toolbar_m1_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    components: {
        // tslint:disable-next-line
        'tt-profile': function () { return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 292)); },
        'tt-menu-list': __WEBPACK_IMPORTED_MODULE_8_objects_menu_menu_list__["a" /* default */],
        'tt-menu': __WEBPACK_IMPORTED_MODULE_7_objects_menu_menu__["a" /* default */]
    },
    data: function () {
        return {
            globalStore: __WEBPACK_IMPORTED_MODULE_3_init_global_store__["a" /* default */],
            state: __WEBPACK_IMPORTED_MODULE_6_components_profile_profile_store__["a" /* default */].state
        };
    },
    computed: {
        isLoggedIn: function () {
            return this.globalStore.user.id;
        },
        formattedUsername: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_filters_format_name__["a" /* default */])(this.globalStore.user);
        },
        menuItems: function () {
            return [
                // TODO: include when functionality added
                // { name: 'do-more', iconName: 'bell', title: msg('userToolbar.menu.doMore') },
                // { name: 'posts', iconName: 'helpful-off', title: msg('userToolbar.menu.posts') },
                // { name: 'profile', iconName: 'profile', title: msg('userToolbar.menu.profile') },
                // { name: 'settings', iconName: 'settings', title: msg('userToolbar.menu.settings') },
                { name: 'logout', iconName: 'close',
                    title: Object(__WEBPACK_IMPORTED_MODULE_5_services_msg__["a" /* default */])('userToolbar.menu.logout', [this.formattedUsername]) }
            ];
        },
        showToolbar: function () {
            return !__WEBPACK_IMPORTED_MODULE_2_init_global_config__["a" /* default */].ssoEnabled;
        }
    },
    methods: {
        menuItemSelected: function (item) {
            if (item.name === 'logout') {
                Object(__WEBPACK_IMPORTED_MODULE_4_services_token_service__["d" /* logoutUser */])();
            }
            else {
                this.state.currentProfilePage = item.name;
                this.state.dashboardIsOpen = true;
            }
        },
        openMyPosts: function () {
            if (this.isLoggedIn) {
                this.state.currentProfilePage = 'posts';
                this.state.dashboardIsOpen = true;
            }
            else {
                // tslint:disable-next-line
                __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 410)).then(function (registrationModalLoader) {
                    registrationModalLoader.default.load({ registerFor: 'profile' });
                });
            }
        }
    }
})));


/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TYPE_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TYPE_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MAX_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MAX_FILE_SIZE_MB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_FILE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPTED_MIME_TYPES; });
/* unused harmony export ACCEPTED_FILE_TYPES */
/* unused harmony export getFileTypeFromName */
/* harmony export (immutable) */ __webpack_exports__["g"] = getImageUrl;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOrientation;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOrientationTransform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_config__ = __webpack_require__(3);

var TYPE_PHOTO = 0;
var TYPE_VIDEO = 1;
var MAX_MEDIA = 5;
var MAX_FILE_SIZE_MB = 10;
var MAX_FILE_SIZE = (MAX_FILE_SIZE_MB * 1024 * 1024);
var ACCEPTED_MIME_TYPES = [
    'image/gif',
    'image/jpeg',
    'image/jpg',
    'image/pjpeg',
    'image/png',
    'image/x-png'
];
// assumption here is that the mime types represent actual file types
var ACCEPTED_FILE_TYPES = ACCEPTED_MIME_TYPES.map(function (mimeType) {
    return mimeType.substring(mimeType.indexOf('/') + 1);
});
function getFileTypeFromName(fileName) {
    return fileName.toLowerCase().substring(fileName.lastIndexOf('.') + 1);
}
// media - the media object
// sizeSuffix - (_PZ320, _L1000, etc).  Miust include the underscore.  Can set empty string to
//              get the original image
function getImageUrl(media, sizeSuffix) {
    if (sizeSuffix === void 0) { sizeSuffix = ''; }
    var baseUrl = __WEBPACK_IMPORTED_MODULE_0_init_config__["a" /* hostsConfig */].protocol + "://" + __WEBPACK_IMPORTED_MODULE_0_init_config__["a" /* hostsConfig */].imageStoreBase;
    var fileName = "" + media.imageId + (sizeSuffix ? '_' + sizeSuffix : '') + "." + media.imageType;
    return baseUrl + "/media/" + __WEBPACK_IMPORTED_MODULE_0_init_config__["a" /* hostsConfig */].siteKey + "/" + fileName;
}
/**
 * Get the orientation of an image file (jpeg).
 * The promise return value is the orientation.
 * If no orientation then
 * -1: not defined
 * -2: not a jpeg
 *
 * Function taken from:
 * https://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript
 * -on-the-client-side
 * Orientations: https://i.stack.imgur.com/VGsAj.gif
 *
 * @param file: File
 */
function getOrientation(file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
            var view = new DataView(reader.result);
            if (view.getUint16(0, false) !== 0xFFD8) {
                resolve(-2);
                return;
            }
            var length = view.byteLength;
            var offset = 2;
            while (offset < length) {
                if (view.getUint16(offset + 2, false) <= 8) {
                    resolve(-1);
                    return;
                }
                var marker = view.getUint16(offset, false);
                offset += 2;
                if (marker === 0xFFE1) {
                    if (view.getUint32(offset += 2, false) !== 0x45786966) {
                        resolve(-1);
                        return;
                    }
                    var little = view.getUint16(offset += 6, false) === 0x4949;
                    offset += view.getUint32(offset + 4, little);
                    var tags = view.getUint16(offset, little);
                    offset += 2;
                    for (var i = 0; i < tags; i++) {
                        if (view.getUint16(offset + (i * 12), little) === 0x0112) {
                            resolve(view.getUint16(offset + (i * 12) + 8, little));
                            return;
                        }
                    }
                }
                else if ((marker & 0xFF00) !== 0xFF00) {
                    break;
                }
                else {
                    offset += view.getUint16(offset, false);
                }
            }
            return resolve(-1);
        };
        reader.readAsArrayBuffer(file);
    });
}
function getOrientationTransform(orientation) {
    switch (orientation) {
        case 2:
            return 'transform: scaleX(-1);';
        case 3:
            return 'transform: rotate(180deg);';
        case 4:
            return 'transform: rotate(180deg) scaleX(-1);';
        case 5:
            return 'transform: rotate(270deg) scaleX(-1);';
        case 6:
            return 'transform: rotate(90deg);';
        case 7:
            return 'transform: rotate(90deg) scaleX(-1);';
        case 8:
            return 'transform: rotate(270deg);';
        default:
            return '';
    }
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        catItem: {
            type: Object,
            required: true
        },
        includeAlt: {
            type: Boolean,
            default: true
        },
        isLinkable: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'L'
        },
        siblingSiteKey: { type: String }
    },
    computed: {
        imageUrl: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__["f" /* getProductImageUrl */])(this.catItem, this.size, this.siblingSiteKey);
        }
    },
    render: function (h) {
        // Ugly using render instead of a normal <template>, but we don't have a difinitive root
        // element for the <template>, which Vue requires.  If linkable, then the root is <a>,
        // otherwise, the root is <img>
        // A way around this would be to wrap in a div, which product image usually is, would
        // just need to be able to apply the necessary classes.
        var img = h('img', {
            attrs: {
                src: this.imageUrl,
                alt: this.includeAlt ? this.catItem.title : '',
                class: 'tt-o-product__image'
            }
        });
        if (!this.isLinkable) {
            return img;
        }
        return h('a', {
            attrs: {
                href: this.catItem.url,
                target: '_blank',
                rel: 'nofollow',
                class: 'tt-o-product__image-link'
            }
        }, [img]);
    }
}));


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_html__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__header_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_scss__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__header_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__header_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        description: String,
        heading: String,
        withBorder: {
            type: Boolean,
            default: true
        }
    }
})));


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_objects_pagination_pagination__ = __webpack_require__(63);

/**
 * NOTE: It is EXPECTED that a component using this mixin has a "fetchData" method that makes a
 * call to update the data based on currentPage or query parameters changing. It is RECOMMENDED
 * that the "fetchData" method uses debounce for cases where more than one thing can trigger a
 * query change.
 * Components using this mixin can optionally include "sortBy" and/or "filtersQueryString"
 * properties that will be watched for to trigger a "fetchData" call.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'tt-pagination': __WEBPACK_IMPORTED_MODULE_0_objects_pagination_pagination__["a" /* default */]
    },
    data: function () {
        return {
            initialPageSize: 10,
            isLoading: false,
            loadError: null,
            pageSize: 20,
            currentPage: 1,
            total: 0,
            offset: 0
        };
    },
    computed: {
        hasMore: function () {
            if (this.offset === 0) {
                return this.initialPageSize < this.total;
            }
            return this.offset + this.pageSize < this.total;
        }
    },
    methods: {
        onQueryChange: function () {
            this.offset = 0;
            this.currentPage = 1;
            this.fetchData();
        },
        pageChange: function (pageNum) {
            if (pageNum === 1) {
                this.offset = 0;
            }
            else {
                this.offset = this.initialPageSize + ((pageNum - 2) * this.pageSize);
            }
            this.currentPage = pageNum;
            this.fetchData(true);
        },
        showMore: function () {
            // this is used when a "show more" button is being used instead of normal pagination
            this.offset = this.offset === 0 ? this.initialPageSize : (this.offset + this.pageSize);
            this.fetchData();
        }
    },
    watch: {
        sortBy: function (newValue, oldValue) {
            if (oldValue !== '') {
                this.onQueryChange();
            }
        },
        filtersQueryString: function () { this.onQueryChange(); }
    }
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rating_stars_html__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rating_stars_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__rating_stars_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_stars_scss__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_stars_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rating_stars_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__rating_stars_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () { return {}; },
    props: {
        // text that is hidden from view, but accessible to screen readers.  Case where NOT to include
        // is reviews summary, where the info is redundant
        includeAccessibleText: {
            type: Boolean,
            default: true
        },
        rating: {
            type: Number,
            default: 0
        },
        starSize: {
            type: String,
            default: 'md'
        }
    },
    computed: {
        adjustedRating: function () {
            var floorValue = Math.floor(this.rating);
            var rounded = Math.round(this.rating * 100) / 100;
            var decimalValue = parseFloat((rounded - floorValue).toFixed(2));
            if (decimalValue < 0.25) {
                return floorValue;
            }
            else if (decimalValue < 0.75) {
                return floorValue + 0.5;
            }
            return floorValue + 1;
        }
    },
    methods: {
        starIcon: function (starNum) {
            if (starNum > this.adjustedRating && starNum - this.adjustedRating >= 1) {
                return 'star--empty';
            }
            else if (starNum <= this.adjustedRating) {
                return 'star--full';
            }
            return 'star--half';
        }
    }
})));


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_objects_product_image_product_image__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_about_html__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__product_about_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__product_about_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_about_scss__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__product_about_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__product_about_scss__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__product_about_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        catItem: Object,
        showAbout: { type: Boolean, default: true },
        imageSize: { type: String, default: 'L' }
    },
    components: {
        'tt-product-image': __WEBPACK_IMPORTED_MODULE_1_objects_product_image_product_image__["a" /* default */]
    }
})));


/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_objects_header_header__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objects_modal_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__warn_close_modal_scss__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__warn_close_modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__warn_close_modal_scss__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__warn_close_modal_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: 'WarnCloseModal',
    components: {
        'tt-header': __WEBPACK_IMPORTED_MODULE_1_objects_header_header__["a" /* default */],
        'tt-modal': __WEBPACK_IMPORTED_MODULE_2_objects_modal_modal__["a" /* default */]
    },
    methods: {
        close: function () {
            this.$emit('close');
        },
        closeParentModal: function () {
            this.$emit('closeParentModal');
        }
    },
    mounted: function () {
        var _this = this;
        this.$nextTick(function () { return _this.$refs.returnBtn.$el.focus(); });
    }
})));


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

/**
 *  A place to store data that is used across
 */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {
            allLayouts: { type: Array },
            currentLayoutIndex: 0,
            mediaQueryListeners: []
        };
    },
    computed: {
        allItemsInLayout: function () {
            if (this.currentLayout) {
                var columnItems = this.currentLayout.columns.reduce(function (acc, cur) {
                    return acc.concat(cur.items);
                }, []);
                return this.currentLayout.headerItems
                    .concat(this.currentLayout.footerItems)
                    .concat(columnItems);
            }
            return [];
        },
        currentBreakpointConfig: function () {
            return this.allLayouts.length > 0 ? this.allLayouts[this.currentLayoutIndex] : null;
        },
        currentBreakpoint: function () {
            return this.currentBreakpointConfig ? this.currentBreakpointConfig.breakpoint : null;
        },
        currentLayout: function () {
            return this.currentBreakpointConfig ? this.currentBreakpointConfig.layout : null;
        },
        // in mobile layout, if 'showDetails' item is added, everything below it is initially hidden
        // from view. This provides an array of the layout items that are below 'showDetails'
        slotNamesAfterShowDetails: function () {
            if (this.currentLayout) {
                var items = this.currentLayout.columns.length === 1 ? this.currentLayout.columns[0].items : [];
                if (items.length > 0 && items.indexOf('showDetails') > 0) {
                    return items.slice(items.indexOf('showDetails') + 1);
                }
            }
            return [];
        }
    },
    methods: {
        removeListeners: function () {
            this.mediaQueryListeners.forEach(function (item) {
                if (item['mediaQueryList']) {
                    item['mediaQueryList'].removeListener(item['mediaQueryListener']);
                }
            });
            this.mediaQueryListeners = [];
        },
        setLayoutsConfig: function (layoutsConfig) {
            this.allLayouts = layoutsConfig;
            this.setupLayout();
        },
        setupLayout: function () {
            var _this = this;
            // make sure any existing are cleared out
            this.removeListeners();
            this.currentLayoutIndex = 0;
            var _loop_1 = function (i) {
                var breakpointLayout = this_1.allLayouts[i];
                var mediaQueryList = window.matchMedia("(min-width: " + breakpointLayout.breakpoint + "px)");
                var mediaQueryListener = function (e) {
                    var layoutIndex = e.matches ? i : i - 1;
                    _this.currentLayoutIndex = layoutIndex;
                };
                mediaQueryList.addListener(mediaQueryListener);
                this_1.mediaQueryListeners.push({ mediaQueryList: mediaQueryList, mediaQueryListener: mediaQueryListener });
                if (mediaQueryList.matches) {
                    this_1.currentLayoutIndex = i;
                }
            };
            var this_1 = this;
            for (var i = 1; i < this.allLayouts.length; i++) {
                _loop_1(i);
            }
        }
    },
    beforeDestroy: function () {
        this.removeListeners();
    }
}));


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_objects_modal_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_warn_close_modal_warn_close_modal__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__submission_modal_html__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__submission_modal_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__submission_modal_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__submission_modal_scss__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__submission_modal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__submission_modal_scss__);








/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6__submission_modal_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    name: 'SubmissionModal',
    data: function () {
        return {
            isConfirmOpen: false,
            isFormLoaded: false,
            popoverMessage: '',
            popoverType: '',
            preventClickOutside: false,
            submissionStore: __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */]
        };
    },
    components: {
        'tt-modal': __WEBPACK_IMPORTED_MODULE_4_objects_modal_modal__["a" /* default */],
        // tslint:disable-next-line
        'tt-submission-mediator': function () { return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 115)); },
        'tt-warn-close-modal': __WEBPACK_IMPORTED_MODULE_5_components_warn_close_modal_warn_close_modal__["a" /* default */]
    },
    computed: {
        isOpen: function () {
            return this.submissionStore.isOpen;
        },
        poweredByText: function () {
            return this.submissionStore.poweredByText;
        }
    },
    methods: {
        closeConfirm: function () {
            var _this = this;
            this.isConfirmOpen = false;
            this.$nextTick(function () { return _this.$el.focus(); });
        },
        closePopover: function () {
            this.popoverMessage = '';
        },
        closeSubmissionModal: function () {
            this.isConfirmOpen = false;
            __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */].fireBackEvent();
        },
        pageLoaded: function (preventClickOutside) {
            if (preventClickOutside === void 0) { preventClickOutside = false; }
            this.isFormLoaded = true;
            this.preventClickOutside = preventClickOutside;
        },
        pageLoading: function () {
            var _this = this;
            this.isFormLoaded = false;
            // while loading, focus on modal container.  The component being loaded will decide if focus
            // should go elsewhere
            // hard-coded/tightly coupled modal ref name. not great, but unlikely to change
            __WEBPACK_IMPORTED_MODULE_1_util_dom_utils__["a" /* default */].safeFocus(function () { return _this.$refs.modal ? _this.$refs.modal.$refs.container : undefined; });
        },
        onShowError: function (providedMessage, closeModal, autoClosePopup) {
            if (closeModal === void 0) { closeModal = false; }
            if (autoClosePopup === void 0) { autoClosePopup = true; }
            if (closeModal) {
                var message = providedMessage || this.$msg('flowError.2000');
                __WEBPACK_IMPORTED_MODULE_3_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({ message: message, type: 'error', autoClose: autoClosePopup });
                this.closeSubmissionModal();
                return;
            }
            this.popoverMessage = providedMessage;
            this.popoverType = 'error';
        },
        onShowPopoverMessage: function (message, closeModal) {
            if (closeModal === void 0) { closeModal = false; }
            if (closeModal) {
                __WEBPACK_IMPORTED_MODULE_3_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({ message: message });
                this.closeSubmissionModal();
                return;
            }
            this.popoverMessage = message;
            this.popoverType = 'success';
        },
        outsideClick: function () {
            if (this.preventClickOutside) {
                this.isConfirmOpen = true;
                return;
            }
            this.closeSubmissionModal();
        }
    }
})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "tt-o-popover-" } }, [
    _c(
      "div",
      {
        staticClass: "tt-o-popover",
        class: _vm.typeClass,
        attrs: {
          role: _vm.role,
          "aria-label": _vm.ariaLabel,
          "aria-modal": "false",
          tabindex: "-1",
          "aria-live": "polite"
        },
        on: {
          keydown: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
            ) {
              return null
            }
            $event.stopPropagation()
            return _vm.close($event)
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "tt-o-popover__icon" },
          [_c("tt-icon", { attrs: { name: _vm.iconName, size: "sm" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tt-o-popover__body" },
          [
            _vm.message
              ? _c("p", {
                  staticClass: "tt-o-popover__text",
                  domProps: { innerHTML: _vm._s(_vm.message) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        ),
        _vm._v(" "),
        _vm.showClose
          ? _c(
              "div",
              { staticClass: "tt-o-popover__close" },
              [
                _c(
                  "tt-button",
                  {
                    ref: "closeBtn",
                    staticClass: "tt-o-popover__close-btn",
                    attrs: {
                      type: "icon",
                      "aria-label": _vm.closeLabel,
                      title: _vm.closeLabel
                    },
                    on: { click: _vm.close }
                  },
                  [_c("tt-icon", { attrs: { name: "close", size: "xxs" } })],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("534a7da4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("534a7da4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "tt-o-modal",
        class: { "tt-o-modal--centered": _vm.centered },
        attrs: {
          role: "dialog",
          "aria-label":
            _vm.ariaLabel && !_vm.ariaLabeledById ? _vm.ariaLabel : undefined,
          "aria-labelledby": _vm.ariaLabeledById,
          "aria-describedby": _vm.ariaDescribedById,
          "aria-modal": "true"
        },
        on: {
          keydown: [
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.handleTab($event)
            },
            function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.close($event)
            }
          ],
          click: function($event) {
            $event.stopPropagation()
            _vm.handleClick($event)
          }
        }
      },
      _vm.$listeners
    ),
    [
      _vm.popoverMessage
        ? _c("tt-popover", {
            ref: "popover",
            staticClass: "tt-o-modal__popover",
            attrs: {
              autoClose: true,
              message: _vm.popoverMessage,
              type: _vm.popoverType
            },
            on: { close: _vm.closePopover }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "container",
          staticClass: "tt-o-modal__container",
          attrs: { tabindex: "-1" }
        },
        [
          _vm.showClose
            ? _c(
                "div",
                { staticClass: "tt-o-modal__close" },
                [
                  _c(
                    "tt-button",
                    {
                      ref: "closeBtn",
                      staticClass: "tt-o-modal__close-btn",
                      attrs: {
                        type: "icon",
                        "aria-label": _vm.closeLabel,
                        title: _vm.closeLabel
                      },
                      on: { click: _vm.close }
                    },
                    [_c("tt-icon", { attrs: { name: "close", size: "xs" } })],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tt-o-modal__body" },
            [
              _vm.isLoading
                ? _c("div", { staticClass: "tt-o-modal__loading" }, [
                    _c("div", { staticClass: "tt-o-spinner" })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm._t("externalButtons"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-o-modal__poweredby-footer" },
        [_vm._t("poweredByText")],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("5057139e", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("5057139e", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tt-o-header",
      class: { "tt-o-header--with-border": _vm.withBorder }
    },
    [
      _c("div", {
        staticClass: "tt-o-header__heading",
        attrs: { role: "heading", "aria-level": "2" },
        domProps: { innerHTML: _vm._s(_vm.heading) }
      }),
      _vm._v(" "),
      _vm.description
        ? _c("p", {
            staticClass: "tt-o-header__text",
            domProps: { innerHTML: _vm._s(_vm.description) }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("721f269a", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("721f269a", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tt-modal",
    {
      staticClass: "tt-c-warn-close-modal",
      attrs: {
        ariaLabel: _vm.$msg("warnCloseModal.label"),
        centered: true,
        showClose: false
      },
      on: { close: _vm.close }
    },
    [
      _c("tt-header", {
        staticClass: "tt-c-warn-close-modal__header",
        attrs: { heading: _vm.$msg("warnCloseModal.title") }
      }),
      _vm._v(" "),
      _c("p", {
        staticClass: "tt-c-warn-close-modal__message",
        domProps: { innerHTML: _vm._s(_vm.$msg("warnCloseModal.message")) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-warn-close-modal__actions tt-o-button-group" },
        [
          _c("tt-button", {
            ref: "returnBtn",
            staticClass: "tt-c-warn-close-modal__return",
            attrs: { type: "primary" },
            domProps: { innerHTML: _vm._s(_vm.$msg("warnCloseModal.return")) },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.close($event)
              }
            }
          }),
          _vm._v(" "),
          _c("tt-button", {
            staticClass: "tt-c-warn-close-modal__leave",
            attrs: { type: "secondary" },
            domProps: { innerHTML: _vm._s(_vm.$msg("warnCloseModal.leave")) },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.closeParentModal($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3ca8798e", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3ca8798e", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "tt-modal",
        {
          ref: "modal",
          staticClass: "tt-w-submission-modal",
          attrs: {
            ariaLabel: _vm.$msg("submission.title"),
            closeLabel: _vm.$msg("submission.close"),
            isLoading: !_vm.isFormLoaded,
            popoverMessage: _vm.popoverMessage,
            popoverType: _vm.popoverType,
            notifyOutsideClick: true
          },
          on: {
            showError: _vm.onShowError,
            close: _vm.closeSubmissionModal,
            closePopover: _vm.closePopover,
            outsideClick: _vm.outsideClick
          }
        },
        [
          _c("tt-submission-mediator", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isFormLoaded,
                expression: "isFormLoaded"
              }
            ],
            on: {
              pageLoading: _vm.pageLoading,
              pageLoaded: _vm.pageLoaded,
              showPopoverMessage: _vm.onShowPopoverMessage,
              showError: _vm.onShowError
            }
          }),
          _vm._v(" "),
          _vm.isConfirmOpen
            ? _c("tt-warn-close-modal", {
                on: {
                  close: _vm.closeConfirm,
                  closeParentModal: _vm.closeSubmissionModal
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", {
            attrs: { slot: "poweredByText" },
            domProps: { innerHTML: _vm._s(_vm.poweredByText) },
            slot: "poweredByText"
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("4a45375f", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("4a45375f", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkTurntoflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_msg__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util_ts_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util_turnto_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__confirmation_message_flows__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__review_flows__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__qa_flows__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__seller_rating_flows__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_token_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(14);




 // dp
 // dp
 // dp
 // dp


// This checks to see if the user reloaded the page.  The interpretation of "reload" is different
// depending on the browser. All will treat the reload/refresh icon click as a realod as well as
// the key command for reload.  What is treated differently is the user clicking in the address
// bar and hitting the enter key.  Chrome treats it as a reload, but most other browsers do not.
function isReload() {
    // for old iOS 7.  Can't support because window.performance is not present.
    if (!window.performance) {
        return false;
    }
    if (typeof window.performance['getEntriesByType'] === 'function') {
        // pnt - PerformanceNavigationTiming interface
        var pnt = Object(__WEBPACK_IMPORTED_MODULE_2_util_ts_utils__["a" /* arrayFind */])(window.performance.getEntriesByType('navigation'), function (entry) { return entry.type; });
        if (pnt) {
            return pnt.type !== 'navigate';
        }
    }
    // for the case where the PerformanceNavigationTiming interface is not present, try the
    // deprecated PerformanceNavigation interface
    var pn = window.performance['navigation'];
    return !pn || pn.type === undefined ? false : pn.type !== 0;
}
function checkTurntoflow() {
    var params = Object(__WEBPACK_IMPORTED_MODULE_2_util_ts_utils__["e" /* getParameters */])();
    var turntoflow = null;
    if (params.turntoflow) {
        turntoflow = params.turntoflow;
        if (isReload()) {
            return;
        }
        var ttdat = params[__WEBPACK_IMPORTED_MODULE_3_util_turnto_utils__["b" /* TTDAT_PARAM_NAME */]];
        // if confirmation token is passed, login the user
        if (params.tttok && ttdat) {
            Object(__WEBPACK_IMPORTED_MODULE_8_services_token_service__["c" /* loginUser */])(params.tttok, ttdat);
        }
        __WEBPACK_IMPORTED_MODULE_0_util_dom_utils__["a" /* default */].onDomReady().then(function () {
            if (params.tterr && params.tterr !== '1101') {
                __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
                    message: Object(__WEBPACK_IMPORTED_MODULE_1_services_msg__["a" /* default */])("flowError." + params.tterr),
                    type: 'error'
                });
                // no need to proceed to any other flows
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_4__confirmation_message_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
            Object(__WEBPACK_IMPORTED_MODULE_5__review_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
            Object(__WEBPACK_IMPORTED_MODULE_6__qa_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
            Object(__WEBPACK_IMPORTED_MODULE_7__seller_rating_flows__["a" /* checkForFlow */])(turntoflow, params); // dp
        });
    }
}


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widgets_submission_submission_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store_submission_store__ = __webpack_require__(7);



var FLOW_DATA = {
    qco: { rf: 'question', rq: 'optional' },
    qcr: { rf: 'question', rq: 'required' },
    aco: { rf: 'answer', rq: 'optional' },
    acr: { rf: 'answer', rq: 'required' },
    repco: { rf: 'reply', rq: 'optional' },
    repcr: { rf: 'reply', rq: 'required' },
    revco: { rf: 'review', rq: 'optional' },
    revcr: { rf: 'review', rq: 'required' }
};
var CONFIRMATION_FLOW_KEYS = Object.keys(FLOW_DATA);
/**
 * These flows are confirmation message flows.  In other words, there is no action to be taken,
 * only display a popover message to the user.
 *
 * @param flow
 * @param params
 * @param data
 */
function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (CONFIRMATION_FLOW_KEYS.indexOf(flow) > -1) {
            if (params.tterr === '1101') {
                // expired confirmation token
                // tslint:disable-next-line
                __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 117)).then(function (expiredConfirmationLoader) {
                    expiredConfirmationLoader.default.load({
                        registerFor: FLOW_DATA[flow].rf,
                        registrationQualifier: FLOW_DATA[flow].rq,
                        token: params.ttrtok
                    });
                });
                resolve(true);
                return;
            }
            // open Do More with appropriate message
            var messageType = FLOW_DATA[flow].rf;
            if (messageType === 'question' && __WEBPACK_IMPORTED_MODULE_0_init_global_config__["a" /* default */].isAllowAnon()) {
                messageType = 'questionAnon';
            }
            __WEBPACK_IMPORTED_MODULE_2_store_submission_store__["b" /* default */].currentPage = {
                page: 'do-more',
                props: { msgType: messageType }
            };
            __WEBPACK_IMPORTED_MODULE_1_widgets_submission_submission_loader__["a" /* default */].load();
            resolve(true);
        }
        else {
            resolve(false);
        }
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_api_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_init_global_config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_init_global_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_util_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_token_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_services_msg__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_services_sso_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widgets_submission_submission_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_util_ts_utils__ = __webpack_require__(10);













function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (!isReviewFlow(flow, params)) {
            resolve(false);
            return;
        }
        if (flow === 'optout') {
            __WEBPACK_IMPORTED_MODULE_9_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
                message: Object(__WEBPACK_IMPORTED_MODULE_7_services_msg__["a" /* default */])('flowMsg.optout.rse')
            });
            resolve(true);
            return;
        }
        var page = 'review-form';
        var launchData = {};
        var props = {};
        if (flow === 'review') {
            launchData = getRseLaunchData(params);
            if (launchData.startAction === 'visual') {
                page = 'share-media';
            }
        }
        else if (flow === 'rebelmail') {
            launchData = getRebelmailLaunchData(params);
            if (launchData.reviewId) {
                page = 'do-more';
                props = { msgType: 'review' };
            }
            else if (launchData.alreadyReviewed) {
                page = 'do-more';
                props = { msgType: 'alreadyReviewed' };
            }
        }
        else if (flow === 'revpr') {
            // coming from a purchase required confirmation email and should already be logged in from
            // email-flow-entry. now place the user on the review page
            launchData.startAction = 'review';
        }
        // if we have a RSE token, need to remove currently logged in user (if any)
        if (launchData.rseToken) {
            Object(__WEBPACK_IMPORTED_MODULE_6_services_token_service__["d" /* logoutUser */])();
        }
        // for successful inbox submission flow, need to check for seller rating eligibility.  Since
        // need to make server call, needs to be async and wait before proceeding.
        // Ideally would do with await/async, but not available in all browsers, so we have this nested
        // promises situation
        checkSellerRatingEligibile(launchData, params).then(function (transactionId) {
            if (transactionId) {
                // because we are coming from an RSE, the token needs to be stored in review launch data
                // so the seller rating form knows which initData method to call
                __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["b" /* default */].launchData = { rseToken: launchData.rseToken };
                __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["b" /* default */].startSellerRatingFlow(__WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, { page: 'seller-rating-form', props: { msgType: 'reviewed' } }, { transactionId: transactionId });
                __WEBPACK_IMPORTED_MODULE_11_widgets_submission_submission_loader__["a" /* default */].load().then(function () { return resolve(true); });
                return;
            }
            startRevFlow(flow, launchData, params, { page: page, props: props }).then(function () { return resolve(true); });
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_5_util_logger__["a" /* default */].error(e);
            startRevFlow(flow, launchData, params, { page: page, props: props }).then(function () { return resolve(true); });
        });
    });
}
function startRevFlow(flow, launchData, params, page) {
    return new Promise(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_12_util_ts_utils__["h" /* waitForValue */])(function () { return params.turntosku || __WEBPACK_IMPORTED_MODULE_4_init_global_store__["a" /* default */].sku; }).then(function (sku) {
            if (__WEBPACK_IMPORTED_MODULE_3_init_global_config__["a" /* default */].ssoEnabled && ['review', 'rebelmail', 'share-media'].indexOf(flow) > -1) {
                Object(__WEBPACK_IMPORTED_MODULE_8_services_sso_service__["h" /* ssoGetLoggedInData */])(sku, page, launchData, 'rev');
                resolve();
                return;
            }
            __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["b" /* default */].startRevFlow(sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, page, launchData);
            __WEBPACK_IMPORTED_MODULE_11_widgets_submission_submission_loader__["a" /* default */].load().then(function () { return resolve(); });
        });
    });
}
// if yes, then resolves with transaction id, otherwise resolves to no
function checkSellerRatingEligibile(launchData, params) {
    return new Promise(function (resolve, reject) {
        if (launchData.reviewId && params.turntoCheckSrEligibility === '1') {
            __WEBPACK_IMPORTED_MODULE_0_services_api_service__["a" /* default */].checkSellerRatingEligibile({ 'context-token': launchData.rseToken, lastSeenSrDate: Object(__WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__["e" /* getLastSeenSellerRatingDate */])() }).then(function (data) {
                resolve(data.transactionId);
            }).catch(function (e) {
                __WEBPACK_IMPORTED_MODULE_5_util_logger__["a" /* default */].error(e);
                resolve(null);
            });
        }
        else {
            resolve(null);
        }
    });
}
function getRseLaunchData(params) {
    var launchData = {
        rseToken: params.tttok || params.token,
        source: __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["a" /* Source */].RSE
    };
    if (params.reviewStartAction) {
        launchData.startAction = params.reviewStartAction === 'shareAPhoto' ? 'visual' : 'review';
    }
    if (params.starSelected) {
        launchData.starSelected = parseInt(params.starSelected) || 0;
        if (launchData.starSelected < 0 || launchData.starSelected > 5) {
            launchData.starSelected = 0;
        }
    }
    return launchData;
}
function getRebelmailLaunchData(params) {
    return {
        alreadyReviewed: params.turntotoAlreadyReviewed === '1',
        hasErrors: params.turntoReviewHasErrors ? true : false,
        showGuidelines: params.turntoShowGuidelines === '1' ? true : false,
        startAction: 'review',
        rseToken: params.tttok || params.token,
        reviewId: params.turntoReviewId ? parseInt(params.turntoReviewId) : null,
        source: __WEBPACK_IMPORTED_MODULE_10_store_submission_store__["a" /* Source */].RSE
    };
}
function isReviewFlow(flow, params) {
    // If flow is 'optout', need to make sure it's from an RSE. Could be from question email.
    return (flow === 'optout' && (params.turntoEmailType === 'reviewSolicitation' ||
        params.turntoEmailType === 'rseFollowUp')) ||
        ['review', 'rebelmail', 'revpr'].indexOf(flow) > -1;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_global_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_services_token_service__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_msg__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_services_sso_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widgets_submission_submission_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widgets_standalone_popover_standalone_popover_loader__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util_ts_utils__ = __webpack_require__(10);










function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (!isQaFlow(flow, params)) {
            resolve(false);
            return;
        }
        if (flow === 'irrelevantq' || flow === 'optout') {
            __WEBPACK_IMPORTED_MODULE_8_widgets_standalone_popover_standalone_popover_loader__["a" /* default */].load({
                message: Object(__WEBPACK_IMPORTED_MODULE_4_services_msg__["a" /* default */])("flowMsg." + (flow === 'optout' ? flow + ".question" : flow))
            });
            resolve(true);
            return;
        }
        // All content solicitation cases should have a token. The "question approval email" sent to
        // moderators is posing as a content soliciation email with turntoflow=answerview (TT-11589).
        // This will skip it as it doesn't have a token.
        if (!params.tttok) {
            resolve(false);
            return;
        }
        var qaLaunchData = {};
        var page = 'solo-question';
        var props = {};
        qaLaunchData.emailToken = params.tttok;
        // coming from content solicitation email, need to remove currently logged in user (if any)
        Object(__WEBPACK_IMPORTED_MODULE_3_services_token_service__["d" /* logoutUser */])();
        if (flow === 'answer') {
            qaLaunchData.view = 'answer';
            qaLaunchData.answerText = params.ttAnswer;
            // itemQuestionRecipientLogId
            qaLaunchData.iqrlId = params.iqrlId ? parseInt(params.iqrlId) : null;
        }
        else if (flow === 'thankanswer') {
            qaLaunchData.view = 'replyToAnswer';
        }
        else if (flow === 'answerreply') {
            qaLaunchData.view = 'replyToReply';
        }
        else if (flow === 'answerview' || flow === 'replyview') {
            qaLaunchData.view = 'seeAll';
        }
        else if (flow === 'thanka') {
            page = 'do-more';
            props = { msgType: 'thank' };
        }
        Object(__WEBPACK_IMPORTED_MODULE_9_util_ts_utils__["h" /* waitForValue */])(function () { return params.turntosku || __WEBPACK_IMPORTED_MODULE_1_init_global_store__["a" /* default */].sku; }).then(function (sku) {
            if (__WEBPACK_IMPORTED_MODULE_0_init_global_config__["a" /* default */].ssoEnabled) {
                Object(__WEBPACK_IMPORTED_MODULE_5_services_sso_service__["h" /* ssoGetLoggedInData */])(sku, { page: page, props: props }, qaLaunchData, 'qa');
                resolve(true);
                return;
            }
            __WEBPACK_IMPORTED_MODULE_7_store_submission_store__["b" /* default */].startQaFlow(sku, __WEBPACK_IMPORTED_MODULE_2_init_config__["a" /* hostsConfig */].siteKey, { page: page, props: props }, qaLaunchData);
            __WEBPACK_IMPORTED_MODULE_6_widgets_submission_submission_loader__["a" /* default */].load().then(function () { return resolve(true); });
        });
    });
}
function isQaFlow(flow, params) {
    // If flow is 'optout', need to make sure it is from a question email, not an RSE
    return (flow === 'optout' && params.turntoEmailType === 'question') ||
        [
            'answer',
            'irrelevantq',
            'thankanswer',
            'thanka',
            'answerview',
            'answerreply',
            'replyview' // clicking on "see all answers" from reply email
        ].indexOf(flow) > -1;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = checkForFlow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_sso_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_store_submission_store__ = __webpack_require__(7);





var SELLER_RATING_FLOW_KEYS = ['sellerrating'];
/**
 * These flows are seller rating flows.  Currently, there is only one flow.
 *
 * @param flow
 * @param params
 * @param data
 */
function checkForFlow(flow, params) {
    return new Promise(function (resolve) {
        if (SELLER_RATING_FLOW_KEYS.indexOf(flow) > -1) {
            var launchData = { emailToken: params.tttok || params.token };
            if (params.starSelected) {
                launchData.starSelected = parseInt(params.starSelected) || 0;
                if (launchData.starSelected < 0 || launchData.starSelected > 5) {
                    launchData.starSelected = undefined;
                }
            }
            var submissionPage = { page: 'seller-rating-form', props: {} };
            if (__WEBPACK_IMPORTED_MODULE_0_init_global_config__["a" /* default */].ssoEnabled) {
                // for soft-login
                Object(__WEBPACK_IMPORTED_MODULE_2_services_sso_service__["h" /* ssoGetLoggedInData */])(null, submissionPage, launchData, 'sr');
                resolve(true);
                return;
            }
            __WEBPACK_IMPORTED_MODULE_4_store_submission_store__["b" /* default */].startSellerRatingFlow(__WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey, submissionPage, launchData);
            __WEBPACK_IMPORTED_MODULE_3_widgets_submission_submission_loader__["a" /* default */].load();
            resolve(true);
        }
        else {
            resolve(false);
        }
    });
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InstantAnswersConfig */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
var InstantAnswersConfig = /** @class */ (function () {
    function InstantAnswersConfig(config) {
        this.initialPageSize = config.initialPageSize;
        this.pageSize = config.pageSize;
        this.learnMoreEnabled = config.learnMoreEnabled;
        this.multiItemQuestionEnabled = config.multiItemQuestionEnabled;
        this.widgetDivId = config.widgetDivId;
    }
    return InstantAnswersConfig;
}());

var defaultConfig = {};
function loadConfig(config) {
    defaultConfig = new InstantAnswersConfig(config);
}



/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = localizedPercentage;
/* harmony export (immutable) */ __webpack_exports__["a"] = localizedNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_config__ = __webpack_require__(3);

function localizedPercentage(num, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 1; }
    if (isNaN(num)) {
        return '';
    }
    var options = {
        style: 'percent',
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits
    };
    return num.toLocaleString(__WEBPACK_IMPORTED_MODULE_0_init_config__["b" /* turnToConfig */].locale.replace('_', '-'), options);
}
function localizedNumber(num, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 1; }
    if (isNaN(num)) {
        return '';
    }
    var options = {
        maximumFractionDigits: fractionDigits,
        minimumFractionDigits: fractionDigits
    };
    return num.toLocaleString(__WEBPACK_IMPORTED_MODULE_0_init_config__["b" /* turnToConfig */].locale.replace('_', '-'), options);
}


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

/**
 * This mixin is just for props that are used for field-group fields.  This helps them
 * be consistent with the props of it's parents (text-field selectbox, etc)
 */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        asFieldset: { type: Boolean, default: false },
        errorText: String,
        hintText: String,
        label: String,
        labelId: String,
        id: String,
        describedbyId: String,
        required: { type: Boolean, default: false }
    }
}));


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hint_text_scss__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hint_text_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__hint_text_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hint_text_html__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hint_text_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__hint_text_html__);



var TYPES = ['alert', 'error', 'info'];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__hint_text_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        type: {
            type: String,
            default: 'info',
            validator: function (v) { return TYPES.indexOf(v) > -1; }
        },
        text: { type: String }
    },
    computed: {
        iconName: function () {
            return this.type === 'alert' ? 'question' : this.type;
        },
        hasValidType: function () {
            return TYPES.indexOf(this.type) > -1;
        }
    }
})));


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = truncateText;
/* harmony export (immutable) */ __webpack_exports__["a"] = addHighlightClass;
var OPEN_HIGHLIGHT_TAG = '<mark>';
var CLOSE_HIGHLIGHT_TAG = '</mark>';
var HIGHLIGHT_CLASS = 'tt-highlight';
var OPEN_HIGHLIGHT_TAG_WITH_CLASS = "<mark class=\"" + HIGHLIGHT_CLASS + "\">";
var OPEN_CNTRL_CHAR = '\x02';
var CLOSE_CNTRL_CHAR = '\x03';
/**
 * Truncates the provided text given the truncateLength and truncateAllowance.
 * If the text does not need to be truncated, null string is returned.
 * Line breaks <br> and a space for opening and closing highlight tag (<mark>) are included in the
 * count. Count will be slightly off in these cases, but minimizes the code needed to handle.
 *
 * TODO: does this work for Chinese? Do we bother with Arabic?
 *
 * @param text - text to truncate (should already be trimmed, otherwise spaces count)
 * @param truncateLength - how long the truncated text should be
 * @param truncateAllowance - allows the text to go over a little without truncation. Helps avoid
 *                            a case where the expanded text is only a few more characters.
 */
function truncateText(content, truncateLength, truncateAllowance) {
    if (truncateAllowance === void 0) { truncateAllowance = 0; }
    if (!content) {
        return null;
    }
    var text = content;
    // if it has highlight tags, change them to be control characters so they take up less
    // space for truncation
    if (text.indexOf(OPEN_HIGHLIGHT_TAG) > -1) {
        text = text.replace(new RegExp(OPEN_HIGHLIGHT_TAG, 'g'), '\x02')
            .replace(new RegExp(CLOSE_HIGHLIGHT_TAG, 'g'), '\x03');
    }
    var shouldTruncate = text && text.length > (truncateLength + truncateAllowance);
    if (!shouldTruncate) {
        return null;
    }
    // replacing <br /> with <br> so it doesn't truncate in the middle of the tag.
    // br should only count for one character, but going to let it slide.
    text = text.replace(/<br \/>/g, '<br>');
    // doing +1 to determine if last character is the end of a word or not
    var truncatedTextPlus1 = text.substring(0, truncateLength + 1);
    var lastSpaceIndex = truncatedTextPlus1.lastIndexOf(' ');
    var truncatedText;
    if (lastSpaceIndex < 0) {
        // need to do a hard truncate because there is no space
        truncatedText = text.substring(0, truncateLength + truncateAllowance);
    }
    else if (lastSpaceIndex === truncatedTextPlus1.length - 1) {
        // last character is a space, just trim
        truncatedText = truncatedTextPlus1.trim();
    }
    else {
        truncatedText = text.substring(0, lastSpaceIndex).trim();
    }
    var lastOpenMarkupIndex = truncatedText.lastIndexOf(OPEN_CNTRL_CHAR);
    if (lastOpenMarkupIndex > -1) {
        if (truncatedText.substring(lastOpenMarkupIndex).indexOf(CLOSE_CNTRL_CHAR) === -1) {
            // add closing markup tag that will be hidden by truncation
            truncatedText = truncatedText + CLOSE_HIGHLIGHT_TAG;
        }
        // put the highlight tags back in
        truncatedText = truncatedText.replace(new RegExp(OPEN_CNTRL_CHAR, 'g'), OPEN_HIGHLIGHT_TAG)
            .replace(new RegExp(CLOSE_CNTRL_CHAR, 'g'), CLOSE_HIGHLIGHT_TAG);
    }
    return truncatedText;
}
function addHighlightClass(text) {
    if (!text) {
        return text;
    }
    return text.replace(new RegExp(OPEN_HIGHLIGHT_TAG, 'g'), OPEN_HIGHLIGHT_TAG_WITH_CLASS);
}


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_msg__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination_html__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pagination_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pagination_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination_scss__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pagination_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pagination_scss__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2__pagination_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {};
    },
    props: {
        currentPage: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
            default: 0
        },
        isButtonStyle: Boolean,
        initialPageSize: {
            type: Number,
            default: 0
        },
        pageSize: {
            type: Number,
            default: 10
        },
        hideBackNext: {
            type: Boolean,
            default: false
        },
        hidePageList: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            // had to import msg as this.$msg does not work here
            default: function () { return Object(__WEBPACK_IMPORTED_MODULE_1_services_msg__["a" /* default */])('pagination.title'); }
        }
    },
    directives: { focus: { inserted: function (el) { return el.focus(); } } },
    computed: {
        buttonType: function () {
            return this.isButtonStyle ? 'primary' : 'icon';
        },
        numberOfPages: function () {
            if (this.pageSize === 0 || this.total === 0) {
                return 0;
            }
            if (this.total <= this.initialPageSize) {
                return 1;
            }
            var totalLessInitialPageSize = this.total - this.initialPageSize;
            return Math.ceil(totalLessInitialPageSize / this.pageSize) + (this.initialPageSize ? 1 : 0);
        },
        hasMore: function () {
            return this.currentPage < this.numberOfPages;
        },
        hasPrevious: function () {
            return this.currentPage > 1;
        },
        pageList: function () {
            var _this = this;
            var delta = 1;
            var range = [];
            var rangeData = [];
            var l;
            // first gather all the page numbers that will be shown
            range.push(1);
            var insideStartPage = Math.min(this.currentPage - delta, this.numberOfPages - 4);
            var insideEndPage = Math.max(5, this.currentPage + delta);
            for (var i = insideStartPage; i <= insideEndPage; i++) {
                if (i < this.numberOfPages && i > 1) {
                    range.push(i);
                }
            }
            range.push(this.numberOfPages);
            // now add each to the rangeData, adding any needed filled in page (for 2 page gaps) and
            // ellipsis spot if needed as well
            range.forEach(function (v) {
                if (l) {
                    if (v - l === 2) {
                        rangeData.push(_this.getDataForPage(l + 1));
                    }
                    else if (v - l !== 1) {
                        rangeData.push(_this.getDataForPage((l + 1), true));
                    }
                }
                rangeData.push(_this.getDataForPage(v));
                l = v;
            });
            return rangeData;
        }
    },
    methods: {
        getDataForPage: function (page, isEllipsis) {
            if (isEllipsis === void 0) { isEllipsis = false; }
            var isCurrentPage = page === this.currentPage;
            var msgKey = isCurrentPage ? 'pagination.currentPage' : 'pagination.goToPage';
            return { page: page, isCurrentPage: isCurrentPage, label: this.$msg(msgKey, [page]), isEllipsis: isEllipsis };
        },
        next: function () {
            this.$emit('updatePage', this.currentPage + 1);
        },
        back: function () {
            this.$emit('updatePage', this.currentPage - 1);
        },
        focusOnCurrentPage: function () {
            var _this = this;
            this.$nextTick(function () {
                _this.$el.querySelector('.tt-o-page-list__number.tt-is-active a').focus();
            });
        },
        goToPage: function (pageNum) {
            this.$emit('updatePage', pageNum);
            this.focusOnCurrentPage();
        }
    }
})));


/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/services/api-service.ts
var api_service = __webpack_require__(8);

// EXTERNAL MODULE: ./src/services/msg.ts
var msg = __webpack_require__(5);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(4);

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/objects/badge/badge.ts
var badge = __webpack_require__(67);

// EXTERNAL MODULE: ./src/init/config.ts
var config = __webpack_require__(3);

// EXTERNAL MODULE: ./src/util/logger.ts
var logger = __webpack_require__(9);

// EXTERNAL MODULE: ./src/objects/menu/menu.ts
var menu = __webpack_require__(24);

// EXTERNAL MODULE: ./src/objects/menu/menu-list.ts
var menu_list = __webpack_require__(25);

// EXTERNAL MODULE: ./src/objects/byline/byline.html
var byline = __webpack_require__(101);
var byline_default = /*#__PURE__*/__webpack_require__.n(byline);

// EXTERNAL MODULE: ./src/objects/byline/byline.scss
var byline_byline = __webpack_require__(36);
var byline_byline_default = /*#__PURE__*/__webpack_require__.n(byline_byline);

// CONCATENATED MODULE: ./src/objects/byline/byline.ts








// from TranslinkService.
// TODO: still using same TransLinkController/service
var VALID_UGC_TYPES = [
    'sq',
    'sa',
    'sr',
    'sc' // comment
];
/* harmony default export */ var objects_byline_byline = (byline_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () { return { hasMenuItems: false }; },
    props: {
        item: { type: Object },
        menuItems: { type: Array },
        ugcType: {
            type: String,
            validator: function (value) { return VALID_UGC_TYPES.indexOf(value) > -1; }
        }
    },
    components: {
        'tt-badge': badge["a" /* default */],
        'tt-menu': menu["a" /* default */],
        'tt-menu-list': menu_list["a" /* default */]
    },
    computed: {
        purchasedText: function () {
            if (!this.item.purchaseDateMillis) {
                return null;
            }
            return this.$msg('byline.purchased', [this.item.purchaseDateFormatted]);
        },
        purchasedDatetime: function () {
            return (new Date(this.item.purchaseDateMillis)).toISOString();
        },
        // TODO: Make syndication link it's own component?  Trick is how it fits into message,
        // it needs to be a string.  We could just "hope" translations can be done for all
        // languages where the syndication link comes last.  Another possibility is to put
        // the full message inside the anchor tag.
        // TODO: are we still going to be using TransLinkController, etc.?
        syndicationText: function () {
            if (this.item.syndicationSourceSiteId) {
                var siteName = this.item.syndicationSourceSiteName;
                var url = config["a" /* hostsConfig */].protocol + "://" + config["a" /* hostsConfig */].originHost + "/transLink/13/" +
                    (this.ugcType + "/" + this.item.id + "/" + config["b" /* turnToConfig */].locale + "?") +
                    ("siteId=" + this.item.syndicationSourceSiteId);
                var anchor = "<a target=\"_blank\" href=\"" + url + "\" rel=\"nofollow\">" + siteName + "</a>";
                return this.$msg('byline.originallyPosted', [anchor]);
            }
            return '';
        }
    },
    methods: {
        menuItemSelected: function (menuItem) {
            this.$emit('menuItemSelected', menuItem);
        },
        selectedAuthor: function () {
            // TODO...
            logger["a" /* default */].debug('author selected...');
        }
    }
})));

// EXTERNAL MODULE: ./src/services/token-service.ts
var token_service = __webpack_require__(15);

// EXTERNAL MODULE: ./src/init/global.config.ts
var global_config = __webpack_require__(6);

// EXTERNAL MODULE: ./src/util/validation-utils.ts
var validation_utils = __webpack_require__(68);

// EXTERNAL MODULE: ./src/objects/form/textarea.ts
var form_textarea = __webpack_require__(83);

// EXTERNAL MODULE: ./src/components/question/multi-items.ts
var multi_items = __webpack_require__(69);

// EXTERNAL MODULE: ./src/services/sso-service.ts
var sso_service = __webpack_require__(13);

// EXTERNAL MODULE: ./src/components/answers/answer-reply-form.html
var answer_reply_form = __webpack_require__(106);
var answer_reply_form_default = /*#__PURE__*/__webpack_require__.n(answer_reply_form);

// EXTERNAL MODULE: ./src/components/answers/answer-reply-form.scss
var answers_answer_reply_form = __webpack_require__(107);
var answers_answer_reply_form_default = /*#__PURE__*/__webpack_require__.n(answers_answer_reply_form);

// CONCATENATED MODULE: ./src/components/answers/answer-reply-form.ts














var ANSWER = 'answer';
var QUESTION = 'question';
var REPLY = 'reply';
var MAX_CHARACTERS = 2000;
/* harmony default export */ var components_answers_answer_reply_form = (answer_reply_form_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            errorMsg: '',
            globalStore: global_store["a" /* default */],
            isSubmitting: false,
            multiItems: [],
            text: ''
        };
    },
    props: {
        answerId: Number,
        hideCancel: Boolean,
        originSiteKey: String,
        parentType: {
            type: String,
            validator: function (value) { return value === REPLY || value === ANSWER || value === QUESTION; }
        },
        parent: {
            type: Object,
            required: true
        },
        questionId: Number,
        submissionCtx: Object // ISubmissionContext
    },
    components: {
        'tt-textarea': form_textarea["a" /* default */],
        'tt-multi-items': multi_items["a" /* default */]
    },
    computed: {
        charactersLeft: function () {
            return MAX_CHARACTERS - this.text.length;
        },
        forType: function () {
            return this.parentType === QUESTION ? 'answer' : 'reply';
        },
        label: function () {
            return this.$msg("answerReplyForm.enter" + (this.parentType === QUESTION ? 'Answer' : 'Reply'));
        },
        fieldId: function () {
            return "tt-" + this.forType + "-form-field-" + this.parent.id;
        },
        maxCharacters: function () {
            return MAX_CHARACTERS;
        },
        multiItemsPromptText: function () {
            return this.$msg("multiItem.answer.prompt" + (this.multiItems.length > 0 ? '.withAdded' : ''));
        },
        showMultiItems: function () {
            return global_config["a" /* default */].multiItemAnswerEnabled && this.parentType === QUESTION;
        }
    },
    methods: {
        addMultiItems: function (items) {
            var _this = this;
            items.forEach(function (item) {
                if (_this.multiItems.filter(function (mi) { return mi.id === item.id; }).length === 0) {
                    _this.multiItems.push(item);
                }
            });
        },
        cancel: function () {
            this.$emit('close');
        },
        confirmedSubmitComplete: function (ugcType) {
            this.submissionCtx.confirmedSubmitComplete({
                siteKey: this.originSiteKey || config["a" /* hostsConfig */].siteKey,
                catItem: this.parent.catItem,
                questionId: this.questionId,
                ugcType: ugcType
            });
        },
        focusOnField: function () {
            return dom_utils["a" /* default */].safeFocus(this.$el.querySelector('textarea'));
        },
        removeMultiItem: function (item) {
            for (var i = 0; i < this.multiItems.length; i++) {
                if (this.multiItems[i].id === item.id) {
                    this.multiItems.splice(i, 1);
                    break;
                }
            }
        },
        showError: function (e) {
            if (e.fieldErrors.length > 0 && e.fieldErrors[0].code === 'ext-site-link') {
                this.errorMsg = this.$msg('answerReplyForm.err.containsLink');
            }
            else {
                this.submissionCtx.showError(Object(msg["b" /* getOfflineOrUnexpectedMsg */])(e), false, true);
            }
            this.focusOnField();
            this.isSubmitting = false;
        },
        showRegistration: function (stagedContentToken, registerFor) {
            this.submissionCtx.showRegistration({
                stagedContentToken: stagedContentToken, registerFor: registerFor
            });
        },
        submitAnswerReply: function () {
            this.isSubmitting = true;
            if (!this.validate()) {
                this.focusOnField();
                this.isSubmitting = false;
                return;
            }
            // Coming from an email, the parent will have an answerToken (if question) or a
            // replyToken (if answer or reply)
            var emailToken = this.parent.answerToken || this.parent.replyToken;
            if (emailToken) {
                if (this.parentType === QUESTION) {
                    this.submitEmailAnswer(emailToken);
                    return;
                }
                this.submitEmailReply(emailToken);
                return;
            }
            var confirmedToken = Object(token_service["a" /* getUserToken */])();
            var qualifier = confirmedToken ? 'confirmed' : 'unconfirmed';
            if (this.parentType === QUESTION) {
                this.submitInlineAnswer(qualifier, confirmedToken);
                return;
            }
            this.submitInlineReply(qualifier, confirmedToken);
        },
        submitEmailAnswer: function (token) {
            var _this = this;
            api_service["a" /* default */].createEmailAnswer({
                'context-token': token,
                originSiteKey: this.originSiteKey || '',
                sku: this.parent.catItem.sku
            }, {
                catItemId: this.parent.catItem.id,
                itemQuestionRecipientLogId: this.submissionCtx.iqrlId || null,
                multiItemIds: this.multiItems.map(function (item) { return item.id; }),
                questionId: this.parent.id,
                sourceId: 1,
                text: this.text
            }).then(function (data) {
                _this.submissionCtx.emailSubmitComplete('answer');
                _this.onAnswerSubmit(data.answerId);
            }).catch(function (e) {
                _this.showError(e);
            });
        },
        submitEmailReply: function (token) {
            var _this = this;
            api_service["a" /* default */].createEmailReply({
                'context-token': token,
                originSiteKey: this.originSiteKey || '',
                sku: this.parent.catItem.sku
            }, {
                answerId: this.answerId,
                catItemId: this.parent.catItem.id,
                parentReplyId: this.parentType === REPLY ? this.parent.id : null,
                text: this.text
            }).then(function () {
                _this.submissionCtx.emailSubmitComplete('reply');
                _this.isSubmitting = false;
            }).catch(function (e) {
                _this.showError(e);
            });
        },
        submitInlineAnswer: function (qualifier, token) {
            var _this = this;
            api_service["a" /* default */].createAnswer({
                'context-token': token,
                qualifier: qualifier,
                originSiteKey: this.originSiteKey || '',
                sku: this.parent.catItem.sku
            }, {
                catItemId: this.parent.catItem.id,
                multiItemIds: this.multiItems.map(function (item) { return item.id; }),
                questionId: this.parent.id,
                sourceId: 2,
                text: this.text
            }).then(function (data) {
                if (token) {
                    _this.confirmedSubmitComplete('answer');
                    _this.onAnswerSubmit(data.answerId);
                }
                else {
                    if (global_config["a" /* default */].ssoEnabled) {
                        Object(sso_service["d" /* ssoCreateAnswer */])(_this.parent.catItem.sku, data.stagedAnswerToken, _this.questionId);
                    }
                    else {
                        _this.showRegistration(data.stagedAnswerToken, 'answer');
                    }
                }
                _this.$emit('close');
                _this.isSubmitting = false;
            }).catch(function (e) {
                _this.showError(e);
            });
        },
        submitInlineReply: function (qualifier, token) {
            var _this = this;
            api_service["a" /* default */].createReply({
                'context-token': token,
                qualifier: qualifier,
                originSiteKey: this.originSiteKey || '',
                sku: this.parent.catItem.sku
            }, {
                answerId: this.answerId,
                catItemId: this.parent.catItem.id,
                parentReplyId: this.parentType === REPLY ? this.parent.id : null,
                text: this.text
            }).then(function (data) {
                if (token) {
                    _this.confirmedSubmitComplete('reply');
                }
                else {
                    if (global_config["a" /* default */].ssoEnabled) {
                        Object(sso_service["f" /* ssoCreateReply */])(_this.parent.catItem.sku, data.stagedReplyToken);
                    }
                    else {
                        _this.showRegistration(data.stagedReplyToken, 'reply');
                    }
                }
                _this.$emit('close', data);
                _this.isSubmitting = false;
            }).catch(function (e) {
                _this.showError(e);
            });
        },
        validate: function () {
            this.errorMsg = ''; // clear any existing message
            if (this.text.trim().length > MAX_CHARACTERS) {
                return false;
            }
            if (this.text.trim().length === 0) {
                this.errorMsg =
                    this.$msg("answerReplyForm.enter" + (this.parentType === QUESTION ? 'Answer' : 'Reply'));
                return false;
            }
            if (validation_utils["a" /* default */].containsEmail(this.text)) {
                this.errorMsg = this.$msg('answerReplyForm.err.dontIncludeEmail');
                return false;
            }
            if (validation_utils["a" /* default */].containsPhoneNumber(this.text)) {
                this.errorMsg = this.$msg('answerReplyForm.err.dontIncludePhone');
                return false;
            }
            return true;
        },
        onAnswerSubmit: function (answerId) {
            // if client provided an onAnswerSubmit function
            var eventHandlers = window.turnToConfig.eventHandlers || {};
            if (eventHandlers.onAnswerSubmit) {
                eventHandlers.onAnswerSubmit({ id: answerId });
            }
        }
    },
    mounted: function () {
        var _this = this;
        this.focusOnField().then(function () {
            // if we have text from inbox submission, set it and submit
            if (_this.submissionCtx && _this.submissionCtx.answerText) {
                _this.text = _this.submissionCtx.answerText;
                _this.submitAnswerReply();
            }
        });
    }
})));

// EXTERNAL MODULE: ./src/components/product-about/product-about.ts
var product_about = __webpack_require__(35);

// EXTERNAL MODULE: ./src/components/reply/reply.html
var reply = __webpack_require__(110);
var reply_default = /*#__PURE__*/__webpack_require__.n(reply);

// EXTERNAL MODULE: ./src/components/reply/reply.scss
var reply_reply = __webpack_require__(111);
var reply_reply_default = /*#__PURE__*/__webpack_require__.n(reply_reply);

// CONCATENATED MODULE: ./src/components/reply/reply.ts






// tslint:disable-next-line:variable-name
var Reply = reply_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            showReplyForm: false
        };
    },
    props: {
        answerId: Number,
        depth: {
            type: Number,
            default: 1
        },
        openReplyForReplyId: Number,
        originSiteKey: String,
        questionId: Number,
        reply: Object,
        submissionCtx: Object // passed down to answer-reply-form
    },
    components: {
        'tt-reply-form': components_answers_answer_reply_form,
        'tt-byline': objects_byline_byline
    },
    computed: {
        controlsId: function () {
            // id for aria-controls on reply button.  id is on reply form
            return "tt-reply-form-" + this.reply.id;
        },
        menuItems: function () {
            return [{
                    name: 'reply',
                    title: this.$msg('answer.reply'),
                    iconName: 'reply',
                    cntrlsId: this.controlsId,
                    expanded: this.showReplyForm.toString()
                }];
        }
    },
    methods: {
        closeForm: function () {
            this.showReplyForm = false;
            // TT-11853 - should focus back on "Relpy", but complicated by mobile.
            // tries to focus on desktop first, then on mobile if not found
            var bylineEl = this.$refs.byline.$el;
            dom_utils["a" /* default */].safeFocus(function () { return bylineEl.querySelector('.tt-o-byline__options-item--reply'); })
                .catch(function () { return dom_utils["a" /* default */].safeFocus(function () { return bylineEl.querySelector('.tt-o-byline__menu-trigger'); }); });
        },
        menuItemSelected: function (menuItem) {
            if (menuItem.name === 'reply') {
                this.showReplyForm = true;
            }
        }
    },
    beforeCreate: function () {
        // eslint-disable-next-line global-require
        this.$options.components.Reply = Reply;
    },
    created: function () {
        if (this.openReplyForReplyId === this.reply.id) {
            this.showReplyForm = true;
        }
    }
}));
/* harmony default export */ var components_reply_reply = (Reply);

// EXTERNAL MODULE: ./src/util/turnto-utils.ts
var turnto_utils = __webpack_require__(11);

// EXTERNAL MODULE: ./src/components/answers/answer.html
var answer = __webpack_require__(112);
var answer_default = /*#__PURE__*/__webpack_require__.n(answer);

// EXTERNAL MODULE: ./src/components/answers/answer.scss
var answers_answer = __webpack_require__(113);
var answers_answer_default = /*#__PURE__*/__webpack_require__.n(answers_answer);

// CONCATENATED MODULE: ./src/components/answers/answer.ts












var VOTED_SESSION_TYPE = 'aWasVotedOn';
/* harmony default export */ var components_answers_answer = (answer_default()(vue_runtime_esm["a" /* default */].extend({
    name: 'Answer',
    data: function () {
        return {
            globalStore: global_store["a" /* default */],
            showReplyForm: false,
            showAllReplies: false,
            wasFlagged: false,
            wasVotedOn: false,
            voteBeingProcessed: false
        };
    },
    props: {
        answer: Object,
        isBestAnswer: Boolean,
        isOnlyAnswer: Boolean,
        openReplyForAnswerId: Number,
        openReplyForReplyId: Number,
        questionId: Number,
        originSiteKey: String,
        submissionCtx: Object // passed down to answer-reply-form
    },
    components: {
        'tt-byline': objects_byline_byline,
        'tt-product-about': product_about["a" /* default */],
        'tt-reply': components_reply_reply,
        'tt-reply-form': components_answers_answer_reply_form
    },
    computed: {
        canVote: function () {
            // can't vote if vote submission is in progress or the current user wrote this answer
            var loggedInUser = this.globalStore.user;
            return !this.voteBeingProcessed &&
                !(loggedInUser && loggedInUser.id && this.answer.user && this.answer.user.id &&
                    loggedInUser.id === this.answer.user.id);
        },
        controlsId: function () {
            // id for aria-controls on reply button.  id is on reply form
            return "tt-ansreply-form-" + this.answer.id;
        },
        menuItems: function () {
            var flagIcon = this.wasFlagged ? 'flag-on' : 'flag-off';
            var flagText = this.$msg('answer.inaccurate');
            if (this.wasFlagged) {
                flagText = this.$msg('answer.flagged');
            }
            return [
                { name: 'reply', title: this.$msg('answer.reply'), iconName: 'reply',
                    cntrlsId: this.controlsId, expanded: this.showReplyForm.toString() },
                { name: 'flag', title: flagText, iconName: flagIcon, disabled: this.wasFlagged }
            ];
        },
        nestedReplies: function () {
            if (this.isBestAnswer && !this.isOnlyAnswer) {
                return [];
            }
            if (this.showAllReplies || this.answer.replies.length <= 3) {
                return this.answer.replies;
            }
            return this.answer.replies.slice(0, 3);
        },
        showActions: function () {
            return !this.isBestAnswer && this.answer.replies.length > 3;
        },
        voteIconName: function () {
            return this.wasVotedOn ? 'helpful-on' : 'helpful-off';
        }
    },
    methods: {
        closeForm: function () {
            this.showReplyForm = false;
            // TT-11853 - should focus back on "Reply", but complicated by mobile.
            this.focusOnBylineItem('reply');
        },
        menuItemSelected: function (menuItem) {
            if (menuItem.name === 'flag') {
                this.flag();
            }
            else if (menuItem.name === 'reply') {
                this.showReplyForm = true;
            }
        },
        flag: function () {
            var _this = this;
            if (!this.wasFlagged) {
                this.wasFlagged = true;
                api_service["a" /* default */].flagAnswer({
                    id: this.answer.id,
                    originSiteKey: this.originSiteKey || '',
                    sku: this.answer.catItem.sku
                }).catch(function (e) {
                    _this.showError(e);
                });
                this.$nextTick(function () { return _this.focusOnBylineItem('flag'); });
            }
        },
        focusOnBylineItem: function (name) {
            var bylineEl = this.$refs.byline.$el;
            // tries to focus on desktop first, then on mobile if not found
            dom_utils["a" /* default */].safeFocus(function () { return bylineEl.querySelector(".tt-o-byline__options-item--" + name); })
                .catch(function () { return dom_utils["a" /* default */].safeFocus(function () { return bylineEl.querySelector('.tt-o-byline__menu-trigger'); }); });
        },
        showError: function (e) {
            this.submissionCtx.showError(Object(msg["b" /* getOfflineOrUnexpectedMsg */])(e), false, true);
            this.isSubmitting = false;
        },
        vote: function () {
            var _this = this;
            if (this.voteBeingProcessed) {
                return;
            }
            this.voteBeingProcessed = true;
            var up = this.wasVotedOn ? -1 : 1;
            api_service["a" /* default */].voteAnswer({
                id: this.answer.id,
                originSiteKey: this.originSiteKey || '',
                sku: this.answer.catItem.sku
            }, {
                up: up
            }).then(function () {
                _this.wasVotedOn = !_this.wasVotedOn;
                if (_this.wasVotedOn) {
                    Object(turnto_utils["l" /* setSessionVar */])(VOTED_SESSION_TYPE, _this.answer.id, _this.wasVotedOn);
                }
                else {
                    Object(turnto_utils["j" /* removeSessionVar */])(VOTED_SESSION_TYPE, _this.answer.id);
                }
                _this.voteBeingProcessed = false;
            }).catch(function (e) {
                _this.showError(e);
                _this.voteBeingProcessed = false;
            });
        }
    },
    created: function () {
        if (this.openReplyForAnswerId === this.answer.id) {
            this.showReplyForm = true;
        }
        this.wasVotedOn = Object(turnto_utils["g" /* getSessionVar */])(VOTED_SESSION_TYPE, this.answer.id) ? true : false;
    }
})));

// EXTERNAL MODULE: ./src/objects/product-image/product-image.ts
var product_image = __webpack_require__(31);

// EXTERNAL MODULE: ./src/transitions/slide-transition.ts
var slide_transition = __webpack_require__(94);

// EXTERNAL MODULE: ./src/components/question/question.html
var question = __webpack_require__(114);
var question_default = /*#__PURE__*/__webpack_require__.n(question);

// EXTERNAL MODULE: ./src/components/question/question.scss
var question_question = __webpack_require__(71);
var question_question_default = /*#__PURE__*/__webpack_require__.n(question_question);

// CONCATENATED MODULE: ./src/components/question/question.ts
/* unused harmony export VOTED_SESSION_TYPE */














var question_VOTED_SESSION_TYPE = 'qWasVotedOn';
/* harmony default export */ var components_question_question = __webpack_exports__["a"] = (question_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            globalStore: global_store["a" /* default */],
            showAnswerForm: false,
            showAnswers: false,
            wasFlagged: false,
            wasVotedOn: false,
            // userSessionVote is used to track when a vote, up or down has been cast by the user
            userSessionVote: this.question.upVotes,
            voteBeingProcessed: false
        };
    },
    components: {
        'tt-answer': components_answers_answer,
        'tt-answer-form': components_answers_answer_reply_form,
        'tt-byline': objects_byline_byline,
        'tt-product-about': product_about["a" /* default */],
        'tt-product-image': product_image["a" /* default */],
        'tt-slide-transition': slide_transition["a" /* default */]
    },
    props: {
        // to originally display as open
        displayExpanded: Boolean,
        hideAddAnswer: Boolean,
        isRelated: Boolean,
        isSoloView: Boolean,
        openAnswerForm: Boolean,
        openReplyForAnswerId: Number,
        openReplyForReplyId: Number,
        originSiteKey: String,
        question: { type: Object },
        showActions: {
            type: Boolean,
            default: true
        },
        showBestAnswer: Boolean,
        soloTitle: String,
        submissionCtx: Object // passed down to answer-reply-form, directly and through answer
    },
    computed: {
        aboutText: function () {
            return this.question ? this.$msg('soloQ.about', [this.question.catItem.title]) : '';
        },
        addAnswerDisabled: function () {
            return this.userAskedThisQuestion;
        },
        bestAnswer: function () {
            var answers = this.question.answers;
            return this.showBestAnswer && !this.showAnswers && answers.length > 0 ? answers[0] : null;
        },
        canVote: function () {
            return !this.userAskedThisQuestion && !this.voteBeingProcessed;
        },
        controlsId: function () {
            // id for aria-controls on add answer button.  id is on answer form
            return "tt-answer-form-" + this.question.id;
        },
        expanderData: function () {
            var numAnswers = this.question.answers.length;
            if (numAnswers === 0 || (numAnswers === 1 && this.showBestAnswer)) {
                return null;
            }
            if (this.showAnswers) {
                return {
                    expanded: 'true',
                    icon: 'options-collapse',
                    text: this.$msg('question.hideAnswers', [], this.question.answers.length)
                };
            }
            return {
                expanded: 'false',
                icon: 'options-expand',
                text: this.$msg('question.showAnswers', [this.question.answers.length], this.question.answers.length)
            };
        },
        hideAnswerFormCancel: function () {
            return this.isSoloView && this.question.answers.length === 0;
        },
        isModerator: function () {
            return global_store["a" /* default */].user.isModerator;
        },
        moderationUrl: function () {
            return turnto_utils["a" /* MODERATION_URL */] + "/moderation/qsolo?id=" + this.question.id;
        },
        userAskedThisQuestion: function () {
            // check for question.user, may be anonymous
            return this.globalStore.user && this.globalStore.user.id && this.question.user &&
                this.question.user.id && this.globalStore.user.id === this.question.user.id;
        },
        voteCount: function () {
            return this.userSessionVote;
        },
        voteIconName: function () {
            return this.wasVotedOn ? 'vote-on' : 'vote-off';
        }
    },
    methods: {
        closeForm: function () {
            this.showAnswerForm = false;
            // TT-11853 - should focus back on "Add Answer" after closing form
            dom_utils["a" /* default */].safeFocusRef(this.$refs, 'addAnswer');
        },
        toggleShowHideAnswers: function () {
            this.showAnswers = !this.showAnswers;
        },
        vote: function (e) {
            var _this = this;
            // have to get reference to currentTarget right away as it ends up null later on
            var voteBtn = e.currentTarget;
            this.voteBeingProcessed = true;
            var up = this.wasVotedOn ? -1 : 1;
            return api_service["a" /* default */].voteQuestion({
                id: this.question.id,
                originSiteKey: this.originSiteKey || '',
                sku: this.question.catItem.sku
            }, {
                up: up
            }).then(function () {
                _this.wasVotedOn = up === 1 ? true : false;
                _this.userSessionVote += (_this.wasVotedOn ? 1 : -1);
                if (_this.wasVotedOn) {
                    Object(turnto_utils["l" /* setSessionVar */])(question_VOTED_SESSION_TYPE, _this.question.id, _this.userSessionVote);
                }
                else {
                    Object(turnto_utils["j" /* removeSessionVar */])(question_VOTED_SESSION_TYPE, _this.question.id);
                }
                _this.voteBeingProcessed = false;
                _this.$nextTick(function () { return voteBtn.focus(); });
            }).catch(function (e) {
                _this.voteBeingProcessed = false;
                _this.$emit('showError', Object(msg["b" /* getOfflineOrUnexpectedMsg */])(e));
            });
        }
    },
    created: function () {
        if (this.displayExpanded && this.question.answers.length > 0) {
            this.showAnswers = true;
        }
        if (this.openAnswerForm) {
            this.showAnswerForm = true;
        }
        var storedSessionValue = Object(turnto_utils["h" /* getSessionVarInt */])(question_VOTED_SESSION_TYPE, this.question.id);
        if (storedSessionValue) {
            this.wasVotedOn = true;
            this.userSessionVote = storedSessionValue;
        }
    }
})));


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__badge_html__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__badge_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__badge_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__badge_scss__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__badge_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__badge_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__badge_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: { type: String },
    computed: {
        typeClass: function () {
            return this.type ? "tt-o-badge--" + this.type : '';
        }
    }
})));


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EMAIL_REGEX = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/im;
var PHONE_REGEX = /1?\W*([2-9][0-8][0-9])\W*([2-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?/;
/* harmony default export */ __webpack_exports__["a"] = ({
    /**
     * Users regexp to check if there is email-like text in the string
     * @param content
     */
    containsEmail: function (content) { return content.search(EMAIL_REGEX) !== -1; },
    /**
     * Users regexp to check if there is a phone number in the string
     * @param content
     */
    containsPhoneNumber: function (content) { return content.search(PHONE_REGEX) !== -1; }
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_objects_modal_modal__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objects_product_image_product_image__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multi_items_html__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__multi_items_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__multi_items_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__multi_items_scss__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__multi_items_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__multi_items_scss__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__multi_items_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return { showMultiItemSearch: false };
    },
    props: {
        multiItems: { type: Array },
        promptText: { type: String },
        sku: { type: String }
    },
    components: {
        // tslint:disable-next-line
        'tt-multi-item-search': function () { return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 290)); },
        'tt-modal': __WEBPACK_IMPORTED_MODULE_1_objects_modal_modal__["a" /* default */],
        'tt-product-image': __WEBPACK_IMPORTED_MODULE_2_objects_product_image_product_image__["a" /* default */]
    },
    computed: {
        searchExcludedCatItemIds: function () {
            return this.multiItems.map(function (item) { return item.id; });
        }
    },
    methods: {
        addItemsAndClose: function (items) {
            this.$emit('addItems', items);
            this.closeSearch();
        },
        openSearch: function () {
            this.showMultiItemSearch = true;
        },
        closeSearch: function () {
            this.showMultiItemSearch = false;
            this.$refs.openSearchBtn.$el.focus();
        },
        removeItem: function (item) {
            this.$emit('removeItem', item);
        }
    }
})));


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_field_html__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__search_field_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__search_field_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_field_scss__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search_field_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__search_field_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__search_field_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        describedBy: { type: String },
        fieldId: { type: String },
        labelId: { type: String },
        multiline: Boolean,
        placeholder: String,
        showSearchIcon: Boolean,
        value: String
    },
    methods: {
        clearText: function () {
            var _this = this;
            this.$emit('input', '');
            this.$nextTick(function () { return _this.$refs.field.focus(); });
        },
        update: function (e) {
            this.$emit('input', this.multiline ? e.target.innerText : e.target.value);
        }
    },
    watch: {
        value: function () {
            if (this.multiline && this.value.length === 0) {
                this.$refs.field.innerText = '';
            }
        }
    }
})));


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/filters/format-name.ts
var format_name = __webpack_require__(20);

// EXTERNAL MODULE: ./src/util/text-utils.ts
var text_utils = __webpack_require__(62);

// EXTERNAL MODULE: ./src/layouts/grid/grid-layout.ts
var grid_layout = __webpack_require__(75);

// EXTERNAL MODULE: ./src/objects/media/media-thumb.ts
var media_thumb = __webpack_require__(89);

// EXTERNAL MODULE: ./src/components/rating/rating-stars.ts
var rating_stars = __webpack_require__(34);

// EXTERNAL MODULE: ./src/components/review/previous-ratings.html
var previous_ratings = __webpack_require__(194);
var previous_ratings_default = /*#__PURE__*/__webpack_require__.n(previous_ratings);

// EXTERNAL MODULE: ./src/components/review/previous-ratings.scss
var review_previous_ratings = __webpack_require__(195);
var review_previous_ratings_default = /*#__PURE__*/__webpack_require__.n(review_previous_ratings);

// CONCATENATED MODULE: ./src/components/review/previous-ratings.ts




/* harmony default export */ var components_review_previous_ratings = (previous_ratings_default()(vue_runtime_esm["a" /* default */].extend({
    props: {
        /* Example structure:
          [
            {"rating": 3, "updateDateFormatted": "Dec 12 2017"},
            {"rating": 4, "updateDateFormatted": "Feb 02 2018"}
          ]
        */
        previousRatings: { type: Array }
    },
    components: {
        'tt-rating-stars': rating_stars["a" /* default */]
    }
})));

// EXTERNAL MODULE: ./src/components/product-about/product-about.ts
var product_about = __webpack_require__(35);

// EXTERNAL MODULE: ./src/util/logger.ts
var logger = __webpack_require__(9);

// EXTERNAL MODULE: ./src/objects/badge/badge.ts
var badge = __webpack_require__(67);

// EXTERNAL MODULE: ./src/objects/byline/review-byline.html
var review_byline = __webpack_require__(196);
var review_byline_default = /*#__PURE__*/__webpack_require__.n(review_byline);

// EXTERNAL MODULE: ./src/objects/byline/byline.scss
var byline = __webpack_require__(36);
var byline_default = /*#__PURE__*/__webpack_require__.n(byline);

// CONCATENATED MODULE: ./src/objects/byline/review-byline.ts





var VALID_UGC_TYPES = [
    'r',
    'rr' // review response
];
/* harmony default export */ var byline_review_byline = (review_byline_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () { return { hasMenuItems: false }; },
    props: {
        item: Object,
        showPurchaserBadge: Boolean,
        ugcType: {
            type: String,
            validator: function (value) { return VALID_UGC_TYPES.indexOf(value) > -1; }
        }
    },
    components: {
        'tt-badge': badge["a" /* default */]
    },
    computed: {
        badges: function () {
            var badges = [];
            if (this.item.isIndependent) {
                badges.push({ type: 'expert', label: this.$msg('badge.expert') });
            }
            else if (this.item.isStaff) {
                badges.push({ type: 'staff', label: this.$msg('badge.staff') });
            }
            if (this.item.expertLabel) {
                badges.push({ type: 'expert', label: this.item.expertLabel });
            }
            if (this.item.purchaseDateFormatted && this.showPurchaserBadge) {
                badges.push({ type: 'verified-purchaser', label: this.$msg('badge.verifiedPurchaser') });
            }
            return badges;
        },
        dateCreatedFormatted: function () {
            return this.ugcType === 'rr' ? this.item.dateCreatedFormatted : '';
        },
        dateTime: function () {
            return this.item.dateCreatedMillis ? new Date(this.item.dateCreatedMillis).toISOString() :
                this.item.dateCreatedFormatted;
        }
    },
    methods: {
        selectedAuthor: function () {
            // TODO...
            logger["a" /* default */].debug('author selected...');
        }
    }
})));

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/init/config.ts
var config = __webpack_require__(3);

// EXTERNAL MODULE: ./src/util/localization-utils.ts
var localization_utils = __webpack_require__(59);

// EXTERNAL MODULE: ./src/components/review/dimension.html
var dimension = __webpack_require__(197);
var dimension_default = /*#__PURE__*/__webpack_require__.n(dimension);

// EXTERNAL MODULE: ./src/components/review/dimension.scss
var review_dimension = __webpack_require__(198);
var review_dimension_default = /*#__PURE__*/__webpack_require__.n(review_dimension);

// CONCATENATED MODULE: ./src/components/review/dimension.ts






/* harmony default export */ var components_review_dimension = (dimension_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () { return { dotSize: 0 }; },
    props: {
        type: { type: Number },
        label: { type: String },
        value: { type: Number },
        valueLabels: {
            type: Array,
            default: function () { return []; }
        }
    },
    computed: {
        imageUrls: function () {
            // TODO: just use value labels?  Or separate prop?
            if (this.isSelectImage) {
                return this.valueLabels.map(function (imageId) {
                    // tslint:disable-next-line:max-line-length
                    return config["a" /* hostsConfig */].protocol + "://" + config["a" /* hostsConfig */].imageStoreBase + "/custom-dim/" + config["a" /* hostsConfig */].siteKey + "/" + imageId + ".png";
                });
            }
            return [];
        },
        isRange: function () {
            return this.type === 2;
        },
        isRating: function () {
            return this.type === 1;
        },
        isSelectImage: function () {
            return this.type === 5;
        },
        valueLabel: function () {
            if (this.isRating) {
                return Object(localization_utils["a" /* localizedNumber */])(this.value) + " / " + Object(localization_utils["a" /* localizedNumber */])(5.0);
            }
            else if (this.isRange) {
                // for range, 'value' is the sort order which is actually the index of one of the
                // value labels
                return this.valueLabels[this.value];
            }
            else if (!this.isSelectImage) {
                return this.valueLabels.length > 0 ? this.valueLabels.join(', ') : '';
            }
            return '';
        },
        valuePercentage: function () {
            if (this.isRange) {
                var percentage = this.value / (this.valueLabels.length - 1);
                var dotAdjustment = Math.round(this.dotSize * percentage);
                return "calc(" + (percentage * 100).toFixed(1) + "% - " + dotAdjustment + "px)";
            }
            else if (this.isRating) {
                return (this.value / 5.0 * 100).toFixed(1) + "%";
            }
            return '';
        }
    },
    mounted: function () {
        var _this = this;
        if (this.isRange) {
            dom_utils["a" /* default */].whenRefIsVisible(this.$refs, 'dot').then(function () {
                _this.dotSize = _this.$refs.dot.offsetWidth;
            }).catch(function () {
                // when initially hidden on page (e.g. under a tab), offsetWidth is 0.  This is a fallback
                // to the px equivalent to the rem(10) it is set to in css
                _this.dotSize = 10;
            });
        }
    }
})));

// EXTERNAL MODULE: ./src/components/review/review-responses.html
var review_responses = __webpack_require__(199);
var review_responses_default = /*#__PURE__*/__webpack_require__.n(review_responses);

// EXTERNAL MODULE: ./src/components/review/review-responses.scss
var review_review_responses = __webpack_require__(200);
var review_review_responses_default = /*#__PURE__*/__webpack_require__.n(review_review_responses);

// CONCATENATED MODULE: ./src/components/review/review-responses.ts




/* harmony default export */ var components_review_review_responses = (review_responses_default()(vue_runtime_esm["a" /* default */].extend({
    props: {
        /* Example structure with 1 source. If source was a brand, 'isStaff' would be false,
           and 'expertLabel' would be populated.
          [{
            "source": "Nike",
            "responses": [
              {
                  "id": 111,
                  "text": "We're sorry that you had this experience.",
                  "dateCreatedFormatted": "2016-09-03",
                  "isStaff": true,
                  "user": {
                      "firstName": "Clarice",
                      "lastName": "Starling"
                  }
              },
              {
                  "id": 112,
                  "text": "PS, the new model will be out next month.",
                  "dateCreatedFormatted": "2016-09-04",
                  "isStaff": true,
                  "user": {
                      "firstName": "Clarice",
                      "lastName": "Starling"
                  }
              }
            ]
          }]
        */
        responsesBySource: { type: Array }
    },
    components: {
        'tt-review-byline': byline_review_byline
    }
})));

// EXTERNAL MODULE: ./src/services/api-service.ts
var api_service = __webpack_require__(8);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(4);

// EXTERNAL MODULE: ./src/objects/menu/menu.ts
var menu = __webpack_require__(24);

// EXTERNAL MODULE: ./src/objects/menu/menu-list.ts
var menu_list = __webpack_require__(25);

// EXTERNAL MODULE: ./src/widgets/standalone-popover/standalone-popover-loader.ts
var standalone_popover_loader = __webpack_require__(14);

// EXTERNAL MODULE: ./src/util/turnto-utils.ts
var turnto_utils = __webpack_require__(11);

// EXTERNAL MODULE: ./src/components/review/review-toolbar.html
var review_toolbar = __webpack_require__(201);
var review_toolbar_default = /*#__PURE__*/__webpack_require__.n(review_toolbar);

// EXTERNAL MODULE: ./src/components/review/review-toolbar.scss
var review_review_toolbar = __webpack_require__(202);
var review_review_toolbar_default = /*#__PURE__*/__webpack_require__.n(review_review_toolbar);

// CONCATENATED MODULE: ./src/components/review/review-toolbar.ts












var UPVOTED_SESSION_TYPE = 'rWasUpVoted';
var DOWNVOTED_SESSION_TYPE = 'rWasDownVoted';
/* harmony default export */ var components_review_review_toolbar = (review_toolbar_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            wasDownVoted: false,
            wasFlagged: false,
            wasUpVoted: false,
            store: global_store["a" /* default */],
            userSessionDownVote: this.downVotes,
            userSessionUpVote: this.upVotes,
            voteBeingProcessed: false
        };
    },
    props: {
        checkoutSiteKey: String,
        downVotes: { type: Number, required: true },
        review: { type: Object, required: true },
        upVotes: { type: Number, required: true }
    },
    components: {
        'tt-menu': menu["a" /* default */],
        'tt-menu-list': menu_list["a" /* default */]
    },
    computed: {
        downVoteCount: function () {
            return this.userSessionDownVote;
        },
        downVoteIconName: function () {
            return this.wasDownVoted ? 'unhelpful-on' : 'unhelpful-off';
        },
        flagAriaLabel: function () {
            return this.$msg(this.wasFlagged ?
                'review.flagged.aria' : 'review.flag.aria', [this.username]);
        },
        flagIconName: function () {
            return this.wasFlagged ? 'flag-on' : 'flag-off';
        },
        flagText: function () {
            return this.$msg(this.wasFlagged ? 'review.flagged' : 'review.flag');
        },
        isModerator: function () {
            return this.store.user && this.store.user.isModerator;
        },
        moderationUrl: function () {
            // tslint:disable-next-line:max-line-length
            return turnto_utils["a" /* MODERATION_URL */] + "/reviews/rsolo?siteKey=" + config["a" /* hostsConfig */].siteKey + "&id=" + this.review.id;
        },
        menuItems: function () {
            var flagText = this.$msg(this.wasFlagged ? 'review.flagged' : 'review.flag');
            var items = [
                { name: 'flag', iconName: this.flagIconName, title: flagText, disabled: this.wasFlagged }
            ];
            // TODO: check to see if is moderator
            if (this.isModerator) {
                items.push({ name: 'moderate', iconName: 'write', title: this.$msg('mediaModal.moderate') });
            }
            return items;
        },
        upVoteCount: function () {
            return this.userSessionUpVote;
        },
        upVoteIconName: function () {
            return this.wasUpVoted ? 'helpful-on' : 'helpful-off';
        },
        username: function () {
            return Object(format_name["a" /* default */])(this.review.user);
        },
        wasVotedOn: function () {
            return this.wasDownVoted || this.wasUpVoted;
        }
    },
    methods: {
        downVote: function (e) {
            var voteBtn = e.currentTarget;
            if (this.wasDownVoted) {
                // was down voted, now the user is retracting that vote
                this.sendVote(0, -1, voteBtn);
            }
            else {
                // actual down vote
                // need to check if up vote already given by this user.  If so, need to retract
                var up = this.wasUpVoted ? -1 : 0;
                this.sendVote(up, 1, voteBtn);
            }
        },
        flag: function () {
            var _this = this;
            if (this.wasFlagged) {
                return;
            }
            this.wasFlagged = true;
            api_service["a" /* default */].flagReview({
                id: this.review.id,
                checkoutSiteKey: this.checkoutSiteKey || '',
                sku: this.review.catItem.sku
            }).catch(function (e) {
                _this.wasFlagged = false;
                var msgKey = 'unexpected.error';
                if (e.errorCode === 'turnto-offline') {
                    msgKey = 'offline.error';
                }
                else {
                    logger["a" /* default */].error('Error sending review flag when not offline', e);
                }
                standalone_popover_loader["a" /* default */].load({ message: _this.$msg(msgKey), type: 'error' });
            });
        },
        menuItemSelected: function (item) {
            if (item.name === 'flag' && !this.wasFlagged) {
                this.flag();
            }
            else if (item.name === 'moderate') {
                this.moderate();
            }
        },
        removeUserDownVote: function () {
            if (Object(turnto_utils["h" /* getSessionVarInt */])(DOWNVOTED_SESSION_TYPE, this.review.id)) {
                this.userSessionDownVote -= 1;
            }
            Object(turnto_utils["j" /* removeSessionVar */])(DOWNVOTED_SESSION_TYPE, this.review.id);
        },
        removeUserUpVote: function () {
            if (Object(turnto_utils["h" /* getSessionVarInt */])(UPVOTED_SESSION_TYPE, this.review.id)) {
                this.userSessionUpVote -= 1;
            }
            Object(turnto_utils["j" /* removeSessionVar */])(UPVOTED_SESSION_TYPE, this.review.id);
        },
        sendVote: function (up, down, voteBtn) {
            var _this = this;
            this.voteBeingProcessed = true;
            return api_service["a" /* default */].voteForReview({
                id: this.review.id,
                checkoutSiteKey: this.checkoutSiteKey || '',
                sku: this.review.catItem.sku
            }, {
                down: down,
                up: up
            }).then(function () {
                _this.voteBeingProcessed = false;
                _this.wasUpVoted = up === 1 || (_this.wasUpVoted && !(up === -1));
                if (_this.wasUpVoted) {
                    _this.userSessionUpVote += 1;
                    Object(turnto_utils["l" /* setSessionVar */])(UPVOTED_SESSION_TYPE, _this.review.id, _this.userSessionUpVote);
                    _this.removeUserDownVote();
                }
                else {
                    _this.removeUserUpVote();
                }
                _this.wasDownVoted = down === 1 || (_this.wasDownVoted && !(down === -1));
                if (_this.wasDownVoted) {
                    _this.userSessionDownVote += 1;
                    Object(turnto_utils["l" /* setSessionVar */])(DOWNVOTED_SESSION_TYPE, _this.review.id, _this.userSessionDownVote);
                    _this.removeUserUpVote();
                }
                else {
                    _this.removeUserDownVote();
                }
                _this.$nextTick(function () { return voteBtn.focus(); });
            }).catch(function (e) {
                _this.voteBeingProcessed = false;
                var msgKey = 'unexpected.error';
                if (e.errorCode === 'turnto-offline') {
                    msgKey = 'offline.error';
                }
                else {
                    logger["a" /* default */].error('Error sending vote when not offline', e);
                }
                standalone_popover_loader["a" /* default */].load({ message: _this.$msg(msgKey), type: 'error' });
            });
        },
        upVote: function (e) {
            var voteBtn = e.currentTarget;
            if (this.wasUpVoted) {
                // was up voted, now the user is retracting that vote
                this.sendVote(-1, 0, voteBtn);
            }
            else {
                // actual up vote
                // need to check if down vote already given by this user.  If so, need to retract
                var down = this.wasDownVoted ? -1 : 0;
                this.sendVote(1, down, voteBtn);
            }
        }
    },
    created: function () {
        var rWasDownVoted = Object(turnto_utils["h" /* getSessionVarInt */])(DOWNVOTED_SESSION_TYPE, this.review.id);
        if (rWasDownVoted !== null) {
            this.wasDownVoted = true;
            this.userSessionDownVote = rWasDownVoted;
        }
        var rWasUpVoted = Object(turnto_utils["h" /* getSessionVarInt */])(UPVOTED_SESSION_TYPE, this.review.id);
        if (rWasUpVoted !== null) {
            this.wasUpVoted = true;
            this.userSessionUpVote = rWasUpVoted;
        }
    }
})));

// EXTERNAL MODULE: ./src/util/media-utils.ts
var media_utils = __webpack_require__(30);

// EXTERNAL MODULE: ./src/components/review/review.html
var review = __webpack_require__(203);
var review_default = /*#__PURE__*/__webpack_require__.n(review);

// EXTERNAL MODULE: ./src/components/review/review.scss
var review_review = __webpack_require__(204);
var review_review_default = /*#__PURE__*/__webpack_require__.n(review_review);

// CONCATENATED MODULE: ./src/components/review/review.ts















/* harmony default export */ var components_review_review = __webpack_exports__["a"] = (review_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            // TODO: not sure how this is determined yet. May not be a data value
            areProfileAttributesStacked: false,
            // Just a single index (0) for review.text for now.  If ans when review updates are added,
            // a review may have more.
            // The index will be in the this list if the user clicked on the "Read More" for the text.
            expandedTextIndexes: [],
            showDetailsClicked: false
        };
    },
    props: {
        allItemsInLayout: { type: Array },
        currentLayout: { type: Object },
        isRelatedReview: { type: Boolean, default: false },
        mediaSize: { type: Number, default: 60 },
        review: { type: Object },
        showPurchaserBadge: Boolean,
        slotNamesAfterShowDetails: { type: Array },
        truncateAllowance: { type: Number, default: 99 },
        truncateLength: { type: Number, default: 500 }
    },
    components: {
        'tt-grid-layout': grid_layout["a" /* default */],
        'tt-media-thumb': media_thumb["a" /* default */],
        'tt-previous-ratings': components_review_previous_ratings,
        'tt-product-about': product_about["a" /* default */],
        'tt-review-byline': byline_review_byline,
        'tt-dimension': components_review_dimension,
        'tt-review-responses': components_review_review_responses,
        'tt-rating-stars': rating_stars["a" /* default */],
        'tt-review-toolbar': components_review_review_toolbar
    },
    computed: {
        displayShowDetails: function () {
            return !this.showDetailsClicked && ~this.allItemsInLayout.indexOf('showDetails') &&
                this.hiddenSlotNames.length > 0;
        },
        hasUpdates: function () {
            return this.review.updates && this.review.updates.length > 0;
        },
        // in mobile layout, if 'showDetails' item is added, everything below it is initially hidden
        // from view.  When 'showDetails' is clicked, the items below it are shown
        hiddenSlotNames: function () {
            var _this = this;
            if (!this.showDetailsClicked) {
                return this.slotNamesAfterShowDetails.filter(function (slotName) {
                    // we only want to include items that have data to be presented.  For example,
                    // customDim-5 should not be included if there are only 4 custom dims.
                    if (slotName.indexOf('customDim') === 0) {
                        var dimNum = parseInt(slotName.split('-')[1], 10);
                        return _this.review.dimensions.length >= dimNum;
                    }
                    else if (_this.slotHasData.hasOwnProperty(slotName)) {
                        return _this.slotHasData[slotName];
                    }
                    // all other slots will always have data for display
                    return true;
                });
            }
            return [];
        },
        previousRatings: function () {
            if (this.hasUpdates) {
                // only want the udpates that have a rating and they need to be in order of most recent
                // which is the reverse order in which review.updates are listed
                return this.review.updates.filter(function (update) { return update.rating; }).reverse();
            }
            return [];
        },
        productAttributes: function () {
            // TODO: how these attributes display is still being spec'd. This is just a guess on how
            // it may work
            if (this.review.catItem.attributes) {
                return this.review.catItem.attributes.map(function (attribute) {
                    return attribute.label + ": " + attribute.value;
                }).join(', ');
            }
            return '';
        },
        profileAttributes: function () {
            var attributesForDisplay = [];
            var attributes = this.review.profileAttributes;
            if (!attributes) {
                return attributesForDisplay;
            }
            if (attributes.ageRange) {
                var label = this.$msg('review.attribute.age');
                attributesForDisplay.push({ label: label, value: attributes.ageRange });
            }
            if (attributes.location) {
                var label = this.$msg('review.attribute.location');
                attributesForDisplay.push({ label: label, value: attributes.location });
            }
            if (attributes.custom) {
                attributes.custom.forEach(function (item, i) {
                    attributesForDisplay.push({ label: item.label, value: item.value });
                });
            }
            return attributesForDisplay;
        },
        recommendIcon: function () {
            return this.review.recommend ? 'check' : 'close';
        },
        recommendText: function () {
            return this.review.recommend === undefined ? '' :
                this.$msg(this.review.recommend ? 'review.recommend' : 'review.notRecommend');
        },
        reviewDate: function () {
            if (this.hasUpdates) {
                return this.review.updates[this.review.updates.length - 1].updateDateFormatted;
            }
            return this.review.dateCreatedFormatted;
        },
        reviewTexts: function () {
            var reviewTexts = [];
            if (this.review.text) {
                var truncated = this.expandedTextIndexes.indexOf(0) > -1 ? null :
                    Object(text_utils["b" /* truncateText */])(this.review.text, this.truncateLength, this.truncateAllowance);
                reviewTexts.push({
                    text: Object(text_utils["a" /* addHighlightClass */])(truncated || this.review.text),
                    updateDateFormatted: this.review.dateCreatedFormatted,
                    isTruncated: truncated
                });
            }
            for (var i = 0; i < this.textUpdates.length; i++) {
                var textUpdate = this.textUpdates[i];
                var truncatedUpdate = this.expandedTextIndexes.indexOf((i + 1)) > -1 ? null :
                    Object(text_utils["b" /* truncateText */])(textUpdate.text, this.truncateLength, this.truncateAllowance);
                reviewTexts.push({
                    text: Object(text_utils["a" /* addHighlightClass */])(truncatedUpdate || textUpdate.text),
                    updateDateFormatted: textUpdate.dateCreatedFormatted,
                    isTruncated: truncatedUpdate
                });
            }
            return reviewTexts;
        },
        slotHasData: function () {
            return {
                relatedProduct: this.isRelatedReview,
                reviewTitle: this.review.title,
                productAttributes: this.productAttributes,
                recommend: this.recommendText,
                previousRatings: this.previousRatings.length > 0,
                media: this.review.media && this.review.media.length > 0,
                reviewText: this.reviewTexts.length > 0,
                profileAttributes: this.profileAttributes.length > 0,
                reviewResponses: this.review.responsesBySource.length > 0,
                purchasedOn: this.review.purchaseDateFormatted,
                syndication: this.syndicationAttribution,
                incentivized: this.review.incentivized
            };
        },
        syndicationAttribution: function () {
            var syndication = this.review.syndication;
            if (syndication) {
                var source = void 0;
                if (syndication.logoUrl) {
                    source = "<img src=\"" + syndication.logoUrl + "\" alt=\"" + syndication.sourceName + "\" " +
                        'class="tt-c-review__syndication-logo">';
                }
                else {
                    source = syndication.sourceName;
                }
                if (syndication.siteUrl) {
                    source = "<a href=\"" + syndication.siteUrl + "\" class=\"tt-c-review__syndication-link\" " +
                        ("target=\"_blank\" rel=\"nofollow\">" + source + "</a>");
                }
                return this.$msg('review.syndicationAttribution', [source]);
            }
            return '';
        },
        textUpdates: function () {
            if (this.hasUpdates) {
                return this.review.updates.filter(function (update) { return update.text !== '' && update.text !== undefined; });
            }
            return [];
        },
        title: function () {
            return Object(text_utils["a" /* addHighlightClass */])(this.review.title);
        },
        updateButtonId: function () {
            return "tt-review-update-" + this.review.id;
        },
        updateReviewText: function () {
            var text = this.$msg('review.updateReview');
            return text.replace('<button>', "<button id=\"" + this.updateButtonId + "\" type=\"button\" class=\"tt-o-button tt-o-button--flat\">");
        }
    },
    methods: {
        expandText: function (index) {
            this.expandedTextIndexes.push(index);
        },
        isSlotHidden: function (slotName) {
            return ~this.hiddenSlotNames.indexOf(slotName);
        },
        mediaLinkTitle: function (mediaItem) {
            var username = Object(format_name["a" /* default */])(mediaItem.user);
            var type = mediaItem.type === media_utils["e" /* TYPE_PHOTO */] ? 'photo' : 'video';
            return this.$msg("review.opensMediaModal." + type, [username]);
        },
        openMediaModal: function (mediaIndex) {
            var _this = this;
            this.review.media.forEach(function (mediaItem) {
                // media do not have catItem populated.  Need to make sure they do before opening in modal
                if (!mediaItem.catItem) {
                    mediaItem.catItem = _this.review.catItem;
                }
                // also need to populate basic review data for the modal
                if (!mediaItem.review) {
                    mediaItem.review = {
                        rating: _this.review.rating,
                        text: _this.review.text,
                        title: _this.review.title
                    };
                }
            });
            this.$emit('openMediaModal', this.review.media, mediaIndex);
        },
        onShowDetailsClick: function () {
            this.showDetailsClicked = true;
        }
    },
    watch: {
        currentLayout: function (newLayout, oldLayout) {
            // something is causing this to be called when the layout hasn't changed
            // so checking just in case
            if (newLayout !== oldLayout) {
                this.showDetails = false;
                this.expandedTextIndexes = [];
            }
        }
    }
})));


/***/ }),
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_ts_utils__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_layout_scss__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__grid_layout_scss__);



var VERTICAL_SPACING_CLASS = '';
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        layout: { type: Object },
        classPrefix: { type: String }
    },
    methods: {
        createSection: function (h, slotNames, classes, width, rightMargin) {
            var _this = this;
            if (rightMargin === void 0) { rightMargin = 0; }
            var childNodes = [];
            slotNames.forEach(function (name) {
                if (_this.$slots[name]) {
                    childNodes.push(_this.$slots[name]);
                }
            });
            var sectionStyle = width ? "flex: 0 0 auto;width: " + width + "%;" : '';
            sectionStyle += rightMargin ? "margin-right: " + rightMargin + "%" : '';
            return this.createElement(h, childNodes, classes, sectionStyle);
        },
        createElement: function (createElement, childNodes, elementClass, elementStyle) {
            if (elementStyle === void 0) { elementStyle = ''; }
            var attrs = { class: elementClass };
            if (elementStyle) {
                attrs.style = elementStyle;
            }
            return createElement('div', attrs, childNodes);
        },
        classesForSuffix: function (classSuffix) {
            var sectionClasses = {};
            sectionClasses["tt-l-grid__" + classSuffix] = true;
            sectionClasses[this.classPrefix + "__grid-" + classSuffix] = this.classPrefix;
            return sectionClasses;
        }
    },
    render: function (h) {
        var _this = this;
        var headerNodes = [];
        if (this.layout.headerItems.length) {
            var classes = this.classesForSuffix('header');
            classes[VERTICAL_SPACING_CLASS] = true;
            var header = this.createSection(h, this.layout.headerItems, classes);
            headerNodes.push(header);
        }
        var middleRowNodes = [];
        this.layout.columns.forEach(function (column, i) {
            if (column.items.length) {
                var classes = Object(__WEBPACK_IMPORTED_MODULE_1_util_ts_utils__["f" /* mergeProps */])(_this.classesForSuffix('col'), _this.classesForSuffix("col--" + (i + 1)));
                classes[VERTICAL_SPACING_CLASS] = true;
                var columnSection = _this.createSection(h, column.items, classes, column.width, column.rightMargin);
                middleRowNodes.push(columnSection);
            }
        });
        var footerNodes = [];
        if (this.layout.footerItems.length) {
            var classes = this.classesForSuffix('footer');
            classes[VERTICAL_SPACING_CLASS] = true;
            var footer = this.createSection(h, this.layout.footerItems, classes);
            footerNodes.push(footer);
        }
        var rowClasses = this.classesForSuffix('row');
        var rows = [];
        if (headerNodes) {
            rows.push(this.createElement(h, headerNodes, rowClasses));
        }
        if (middleRowNodes) {
            rows.push(this.createElement(h, middleRowNodes, rowClasses));
        }
        if (footerNodes) {
            rows.push(this.createElement(h, footerNodes, rowClasses));
        }
        return this.createElement(h, rows, "tt-l-grid " + VERTICAL_SPACING_CLASS);
    }
}));


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
var Store = /** @class */ (function () {
    function Store() {
        this.state = {
            schemaOrgEntityType: undefined
        };
        this.state.schemaOrgEntityType = window.turnToConfig.schemaOrgEntityType || '';
    }
    Object.defineProperty(Store.prototype, "schemaOrgEntityType", {
        get: function () {
            return this.state.schemaOrgEntityType;
        },
        set: function (schemaOrgEntityType) {
            this.state.schemaOrgEntityType = schemaOrgEntityType;
        },
        enumerable: true,
        configurable: true
    });
    return Store;
}());

/* harmony default export */ __webpack_exports__["a"] = (new Store());


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReviewsSummaryConfig */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
var ReviewsSummaryConfig = /** @class */ (function () {
    function ReviewsSummaryConfig(config) {
        this.aggregateMetaOn = config.aggregateMetaOn;
        this.aggregateJsonLdMetaOn = config.aggregateJsonLdMetaOn;
        this.breakpoints = config.breakpoints;
        this.childWidgets = config.childWidgets || {};
        this.layouts = config.layouts;
        this.showRangeMiddle = config.showRangeMiddle;
        this.widgetDivId = config.widgetDivId;
    }
    return ReviewsSummaryConfig;
}());

var defaultConfig = {};
function loadConfig(config) {
    defaultConfig = new ReviewsSummaryConfig(config);
}



/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__field_group_props_mixin__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_objects_hint_hint_text__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_group_scss__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_group_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__field_group_scss__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__field_group_props_mixin__["a" /* default */]],
    components: { 'tt-hint-text': __WEBPACK_IMPORTED_MODULE_2_objects_hint_hint_text__["a" /* default */] },
    computed: {
        hint: function () {
            return {
                text: this.errorText || this.hintText,
                type: this.errorText ? 'error' : 'info'
            };
        }
    },
    methods: {
        getHintTextElement: function (createElement) {
            return createElement(__WEBPACK_IMPORTED_MODULE_2_objects_hint_hint_text__["a" /* default */], {
                attrs: { id: this.describedbyId },
                props: {
                    type: this.hint.type,
                    text: this.hint.text
                }
            });
        },
        getLabelElement: function (createElement) {
            var labelChildren = [];
            labelChildren.push(createElement('span', {
                class: 'tt-o-field-group__label-text',
                domProps: {
                    // adding a space to the label in case the required indicator follows
                    innerHTML: this.label
                }
            }));
            if (this.required) {
                labelChildren.push(createElement('span', {
                    class: 'tt-o-field-group__required',
                    domProps: {
                        innerHTML: " " + this.$msg('fieldGroup.requiredIndicator')
                    }
                }));
            }
            return createElement(this.asFieldset ? 'legend' : 'label', {
                attrs: { id: this.labelId, for: this.id },
                class: 'tt-o-field-group__label'
            }, labelChildren);
        }
    },
    /* This is what the html template would look like.  Converted to a render function so this
     * component could also be used for fields like checkbox groups that should use a root element
     * of "fieldset" with "legend" as a label instead of the default root element of a "div" with
     * "label".
     *
     * <div class="tt-o-field-group tt-u-spacing--xs">
     *   <label class="tt-o-field-group__label" :for="id">
     *     <span class="tt-o-field-group__label-text>{{ label }}</span>
     *     <span v-if="required" class="tt-o-field-group__required"
     *           v-html="$msg('fieldGroup.requiredIndicator')"></span>
     *   </label>
     *   <slot></slot>
     *   <tt-hint-text v-if="hint.text" :type="hint.type" :text="hint.text"></tt-hint-text>
     * </div>
     */
    render: function (createElement) {
        var rootChildren = [];
        if (this.label) {
            rootChildren.push(this.getLabelElement(createElement));
        }
        rootChildren.push(this.$slots.default);
        if (this.hint.text) {
            rootChildren.push(this.getHintTextElement(createElement));
        }
        return createElement(this.asFieldset ? 'fieldset' : 'div', {
            attrs: {
                'aria-required': this.asFieldset && this.required ? 'true' : false,
                'aria-invalid': this.asFieldset && this.errorText ? 'true' : false
            },
            class: 'tt-o-field-group tt-u-spacing--xs'
        }, rootChildren);
    }
}));


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasValidType
    ? _c(
        "div",
        { class: ["tt-o-hint", "tt-o-hint--" + _vm.type] },
        [
          _c("tt-icon", {
            staticClass: "tt-o-hint__icon",
            attrs: { name: _vm.iconName, size: "xs" }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "tt-o-hint__text",
            domProps: { innerHTML: _vm._s(_vm.text) }
          }),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("d1d26c44", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("d1d26c44", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReviewSubmissionConfig */
/* harmony export (immutable) */ __webpack_exports__["b"] = loadConfig;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
var ReviewSubmissionConfig = /** @class */ (function () {
    function ReviewSubmissionConfig(config) {
        this.termsUrl = config.termsUrl;
        this.acceptTermsRequired = config.acceptTermsRequired;
        this.deviceFingerprintOn = config.deviceFingerprintOn;
        this.mediaSizes = config.mediaSizes;
        this.recommendRequired = config.recommendRequired;
        this.showRangeMiddle = config.showRangeMiddle;
        this.showRecommend = config.showRecommend;
        this.showSweepstakes = config.showSweepstakes;
        this.textMinLength = config.textMinLength;
        this.textMaxLength = config.textMaxLength;
        this.textRequired = config.textRequired;
        this.titleMaxLength = config.titleMaxLength;
        this.titleRequired = config.titleRequired;
    }
    return ReviewSubmissionConfig;
}());

var defaultConfig = {};
function loadConfig(config) {
    defaultConfig = new ReviewSubmissionConfig(config);
}



/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_MAX_CHARACTERS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__field_group_props_mixin__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__field_group__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__textarea_html__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__textarea_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__textarea_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__textarea_scss__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__textarea_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__textarea_scss__);





var DEFAULT_MAX_CHARACTERS = 500;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__textarea_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    // data() {
    //   return {
    //     hasFocus: false
    //   }
    // },
    props: {
        describedbyId: {
            type: String,
            default: function () { return "tt-hint-" + Math.random().toString(16).slice(5); }
        },
        disabled: Boolean,
        focusOnMount: Boolean,
        id: {
            type: String,
            default: function () { return "tt-textarea-" + Math.random().toString(16).slice(5); }
        },
        characterThreshold: {
            type: Number,
            default: DEFAULT_MAX_CHARACTERS
        },
        maxCharacters: {
            type: Number,
            default: DEFAULT_MAX_CHARACTERS
        },
        name: {
            type: String,
            required: true
        },
        rows: String,
        success: Boolean,
        value: {
            type: String,
            default: ''
        }
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__field_group_props_mixin__["a" /* default */]],
    components: { 'tt-field-group': __WEBPACK_IMPORTED_MODULE_2__field_group__["a" /* default */] },
    computed: {
        charactersLeft: function () {
            return this.maxCharacters - this.value.length;
        },
        error: function () {
            var error = this.charactersLeft < 0 ?
                this.$msg('cc.charactersOver', [Math.abs(this.charactersLeft)]) : '';
            if (this.errorText) {
                // tslint:disable-next-line:max-line-length
                error += (this.charactersLeft < 0 ? ' <span class="tt-o-hint__dot">' + this.$msg('hint.error.separator') + '</span> ' : '') + this.errorText;
            }
            return error;
        },
        hint: function () {
            return this.charactersLeft >= 0
                && this.charactersLeft <= this.characterThreshold ?
                this.$msg('cc.charactersLeft', [this.charactersLeft]) : this.hintText;
        }
    },
    methods: {
        blurTextarea: function (e) {
            this.$emit('blurTextArea', e.target);
        },
        // Input event fired when the user clicks into the field.
        focusTextarea: function (e) {
            this.$emit('focusTextArea', e.target);
        },
        // Event fired when the input changes in the textarea
        updateValue: function (e) {
            this.$emit('input', e.target.value);
        }
    },
    mounted: function () {
        var _this = this;
        if (this.focusOnMount) {
            // delay so that the modal doesn't take the focus back on it's mount.
            // This will fire the focus event, causing focusTextarea to be called.
            setTimeout(function () { return _this.$refs.field.focus(); }, 100);
        }
    }
})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tt-field-group",
    _vm._b(
      { attrs: { errorText: _vm.error, hintText: _vm.hint } },
      "tt-field-group",
      {
        id: _vm.id,
        describedbyId: _vm.describedbyId,
        label: _vm.label,
        required: _vm.required
      },
      false
    ),
    [
      _c(
        "textarea",
        _vm._b(
          {
            ref: "field",
            staticClass: "tt-o-textarea",
            class: {
              "tt-o-textarea__success": _vm.success,
              "tt-o-textarea--active": _vm.focusOnMount
            },
            attrs: {
              "aria-describedby": _vm.describedbyId,
              "aria-required": _vm.required ? "true" : "false",
              "aria-invalid": _vm.errorText ? "true" : "false"
            },
            on: {
              input: _vm.updateValue,
              focus: _vm.focusTextarea,
              blur: _vm.blurTextarea
            }
          },
          "textarea",
          {
            id: _vm.id,
            name: _vm.name,
            rows: _vm.rows,
            disabled: _vm.disabled,
            value: _vm.value
          },
          false
        )
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3aa1cc84", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3aa1cc84", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_media_utils__ = __webpack_require__(30);


// the standard for the largest thumbnail size. standard meaning 'not customized'
var STANDARD_LARGE_SIZE = 160;
/**
 *  Methods used by media.ts, media-thumb.ts, and media-submission-thumb.ts
 */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    props: {
        media: {
            type: Object,
            required: true
        },
        size: Number
    },
    computed: {
        durationScaling: function () {
            if (!this.size || this.size >= STANDARD_LARGE_SIZE) {
                return '';
            }
            // this equation makes an image at 80px (half of large size) to have a timestamp that is
            // 80% if the normal size.  1-to-1 scaling made it get to small (or large)
            var scaledValue = (100 - ((STANDARD_LARGE_SIZE * .25) - (this.size * .25))) / 100;
            // scale the size of the duration display so not too big for smaller images (video thumbnails)
            return "transform: scale(" + scaledValue + ")";
        },
        isImage: function () {
            return this.media.type === __WEBPACK_IMPORTED_MODULE_1_util_media_utils__["e" /* TYPE_PHOTO */];
        }
    },
    methods: {
        getPanAndZoomDimensions: function (w, h, maxW, maxH) {
            var newW = maxW;
            var newH = maxH;
            if (w > h && h >= maxH) {
                newW = Math.floor((w / h) * maxW);
            }
            else if (h > w && w > maxW) {
                newH = Math.floor((h / w) * maxH);
            }
            else if (w < maxW || h < maxH) {
                newW = w;
                newH = h;
            }
            return { width: newW, height: newH };
        },
        getStyleString: function (cssProps) {
            var pixelProps = ['width', 'height', 'top', 'left'];
            var styles = '';
            Object.keys(cssProps).forEach(function (p) {
                var suffix = pixelProps.indexOf(p) > -1 ? 'px' : '';
                styles += p + ":" + cssProps[p] + suffix + ";";
            });
            return styles;
        },
        getImagePositioning: function (w, h, maxW, maxH) {
            return {
                top: this.getPosition(h, maxH),
                left: this.getPosition(w, maxW)
            };
        },
        getPosition: function (value, maxValue) {
            if (value > maxValue) {
                return -Math.floor((value - maxValue) / 2);
            }
            return Math.floor((maxValue - value) / 2);
        },
        isOrientation90or270: function (orientation) {
            return [5, 6, 7, 8].indexOf(orientation) !== -1;
        }
    }
}));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tt-o-media-thumb", style: _vm.itemStyles }, [
    !_vm.isImageLoaded
      ? _c("div", { staticClass: "tt-o-spinner tt-o-media-thumb__spinner" })
      : _vm._e(),
    _vm._v(" "),
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isImageLoaded,
          expression: "isImageLoaded"
        }
      ],
      staticClass: "tt-o-media-thumb__image",
      style: _vm.imageStyles,
      attrs: { src: _vm.imageSrc, alt: _vm.altText },
      on: { load: _vm.onImageLoad }
    }),
    _vm._v(" "),
    this.media.durationFormatted
      ? _c(
          "time",
          {
            staticClass: "tt-o-media-thumb__video-timestamp",
            style: _vm.durationScaling
          },
          [_vm._v(_vm._s(this.media.durationFormatted))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("52c94dc7", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("52c94dc7", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_media_utils__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_mixin__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_thumb_html__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_thumb_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__media_thumb_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_thumb_scss__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_thumb_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__media_thumb_scss__);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__media_thumb_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return { isImageLoaded: false };
    },
    props: {
        altText: String
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_2__media_mixin__["a" /* default */]],
    computed: {
        imageStyles: function () {
            if (this.isImage) {
                // even though thumbnails are square, need to explicitly set width and height due to
                // differences in how IE interprets max-width 100% compared to other browsers.
                return this.itemStyles;
            }
            var dims = this.getPanAndZoomDimensions(this.media.thumbnailWidth, this.media.thumbnailHeight, this.size, this.size);
            var newWidth = dims.width;
            var newHeight = dims.height;
            // we need to adjust the top or left to fit in the square
            var _a = this.getImagePositioning(newWidth, newHeight, this.size, this.size), top = _a.top, left = _a.left;
            var allStyles = {
                position: 'absolute',
                'max-width': 'none',
                width: newWidth,
                height: newHeight,
                top: top,
                left: left
            };
            return this.getStyleString(allStyles);
        },
        itemStyles: function () {
            return this.getStyleString({ width: this.size, height: this.size });
        },
        imageSrc: function () {
            if (this.isImage) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_util_media_utils__["g" /* getImageUrl */])(this.media, 'PZ320');
            }
            return this.media.thumbnailUrl; // video
        }
    },
    methods: {
        onImageLoad: function () {
            this.isImageLoaded = true;
        }
    }
})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.numberOfPages > 1
    ? _c(
        "nav",
        {
          staticClass: "tt-o-pagination",
          attrs: { role: "navigation", "aria-label": _vm.title }
        },
        [
          !_vm.hideBackNext
            ? _c(
                "tt-button",
                {
                  staticClass: "tt-o-pagination__back",
                  attrs: {
                    type: _vm.buttonType,
                    "aria-label": _vm.$msg("pagination.goBack"),
                    disabled: !_vm.hasPrevious
                  },
                  on: { click: _vm.back }
                },
                [_c("tt-icon", { attrs: { name: "caret-left" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.hidePageList
            ? _c(
                "ul",
                { staticClass: "tt-o-page-list" },
                _vm._l(_vm.pageList, function(p) {
                  return _c(
                    "li",
                    {
                      key: p.page,
                      staticClass: "tt-o-page-list__number",
                      class: {
                        "tt-is-active": p.isCurrentPage,
                        "tt-o-page-list__number-jump": p.jumpTo
                      }
                    },
                    [
                      p.isEllipsis
                        ? _c("span", { staticClass: "tt-o-page-list__gap" }, [
                            _vm._v("…")
                          ])
                        : _c(
                            "a",
                            {
                              staticClass:
                                "tt-o-page-list__link tt-u-ignore-default",
                              attrs: {
                                href: "",
                                "aria-label": p.label,
                                "aria-current": p.isCurrentPage,
                                rel: "nofollow"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.goToPage(p.page)
                                },
                                keydown: function($event) {
                                  if (
                                    !("button" in $event) &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  _vm.goToPage(p.page)
                                }
                              }
                            },
                            [_vm._v(_vm._s(p.page))]
                          )
                    ]
                  )
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          !_vm.hideBackNext
            ? _c(
                "tt-button",
                {
                  staticClass: "tt-o-pagination__next",
                  attrs: {
                    type: _vm.buttonType,
                    "aria-label": _vm.$msg("pagination.goNext"),
                    disabled: !_vm.hasMore
                  },
                  on: { click: _vm.next }
                },
                [_c("tt-icon", { attrs: { name: "caret-right" } })],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("7770248c", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("7770248c", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProfileStore = /** @class */ (function () {
    function ProfileStore() {
        this.state = {
            currentProfilePage: 'posts',
            profileStats: {},
            currentProfilePostTab: 'reviews',
            dashboardIsOpen: false
        };
    }
    return ProfileStore;
}());
/* harmony default export */ __webpack_exports__["a"] = (new ProfileStore());


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionable_rating_stars_html__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionable_rating_stars_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__actionable_rating_stars_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_stars_scss__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rating_stars_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__rating_stars_scss__);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__actionable_rating_stars_html___default()(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return { hoverRating: 0 };
    },
    props: {
        starSize: {
            type: String,
            default: 'xxl'
        },
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        rating: function () {
            return this.hoverRating || this.value;
        }
    },
    methods: {
        ratingSelected: function (rating) {
            this.$emit('input', rating);
        },
        ratingEnter: function (rating) {
            this.hoverRating = rating;
        },
        ratingLeave: function () {
            this.hoverRating = 0;
        }
    }
})));


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
    data: function () {
        return {
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: 0,
            marginBottom: 0
        };
    },
    props: {
        duration: {
            type: Number,
            default: 0.5
        }
    },
    methods: {
        clearValues: function (el) {
            el.style.height = '';
            this.setBox(el, '');
            el.style.transition = '';
            el.style.overflow = '';
        },
        calcAndSetPaddingMargin: function () {
            if (this.$slots.default && this.$slots.default[0].elm) {
                var el = this.$slots.default[0].elm;
                var css = window.getComputedStyle(el, null);
                this.paddingTop = css.paddingTop;
                this.paddingBottom = css.paddingBottom;
                this.marginTop = css.marginTop;
                this.marginBottom = css.marginBottom;
            }
        },
        setBox: function (el, boxValues) {
            var isObj = typeof boxValues === 'object';
            el.style.paddingTop = isObj ? boxValues.paddingTop : boxValues;
            el.style.paddingBottom = isObj ? boxValues.paddingBottom : boxValues;
            el.style.marginTop = isObj ? boxValues.marginTop : boxValues;
            el.style.marginBottom = isObj ? boxValues.marginBottom : boxValues;
        },
        setValues: function (el, height, boxValues) {
            el.style.transition = "all " + this.duration + "s linear";
            el.style.overflow = 'hidden';
            el.style.height = height + "px";
            if (boxValues !== undefined) {
                this.setBox(el, boxValues);
            }
        }
    },
    render: function (createElement) {
        var vm = this;
        var data = {
            props: { name: 'slide-transition' },
            on: {
                beforeEnter: function (el) {
                    vm.setValues(el, 0);
                },
                enter: function (el, done) {
                    // should just need the beforeEnter call to setValues, but for some reason it is not
                    // working that way.  Only seems to work if set in both places.
                    var height = el.scrollHeight;
                    vm.setValues(el, 0, 0);
                    // TODO: still have issue with padding and/or margin not transitioning on enter
                    vm.setValues(el, height, {
                        paddingTop: vm.paddingTop,
                        paddingBottom: vm.paddingBottom,
                        marginTop: vm.marginTop,
                        marginBottom: vm.marginBottom
                    });
                    done();
                },
                afterEnter: function (el) {
                    setTimeout(function () {
                        vm.clearValues(el);
                        vm.calcAndSetPaddingMargin();
                    }, (vm.duration * 1000));
                },
                beforeLeave: function (el) {
                    vm.setValues(el, el.offsetHeight);
                },
                leave: function (el) {
                    // should just need the beforeLeave call to setValues, but for some reason it is not
                    // working that way.  Only seems to work if set in both places.
                    vm.setValues(el, el.offsetHeight);
                    // now set to 0
                    vm.setValues(el, 0, 0);
                },
                afterLeave: function (el) {
                    vm.clearValues(el);
                }
            },
            bind: { css: false }
        };
        return createElement('transition', data, this.$slots.default);
    },
    mounted: function () {
        this.calcAndSetPaddingMargin();
    }
}));


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubmissionContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

var SubmissionContext = /** @class */ (function () {
    function SubmissionContext() {
        this.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
    }
    SubmissionContext.prototype.confirmedSubmitComplete = function (info) {
        this.eventBus.$emit('confirmedSubmitComplete', info);
    };
    SubmissionContext.prototype.emailSubmitComplete = function (ugcType) {
        this.eventBus.$emit('emailSubmitComplete', ugcType);
    };
    SubmissionContext.prototype.showRegistration = function (registrationInfo) {
        this.eventBus.$emit('showRegistration', registrationInfo);
    };
    SubmissionContext.prototype.showError = function (message, endFlow, autoClose) {
        if (endFlow === void 0) { endFlow = false; }
        if (autoClose === void 0) { autoClose = true; }
        this.eventBus.$emit('showError', message, endFlow, autoClose);
    };
    return SubmissionContext;
}());



/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-rating tt-c-rating--actionable" },
    _vm._l(5, function(n) {
      return _c(
        "tt-button",
        {
          key: n,
          staticClass: "tt-c-rating__star",
          attrs: {
            type: "icon",
            "aria-label": _vm.$msg("ratingStars.selectToRate", [n], n)
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              _vm.ratingSelected(n)
            },
            mouseenter: function($event) {
              _vm.ratingEnter(n)
            },
            mouseleave: function($event) {
              _vm.ratingLeave()
            }
          }
        },
        [
          _vm.rating < n
            ? _c("tt-icon", {
                staticClass: "tt-c-rating__icon",
                attrs: { name: "star--empty", size: _vm.starSize }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.rating >= n
            ? _c("tt-icon", {
                staticClass: "tt-c-rating__icon",
                attrs: { name: "star--full", size: _vm.starSize }
              })
            : _vm._e()
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("774c6359", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("774c6359", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "tt-o-badge", class: _vm.typeClass },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("a652349c", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("a652349c", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-o-menu" },
    [_vm._t("menuTrigger"), _vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("ddd64a4c", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("ddd64a4c", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isMenuExpanded,
          expression: "isMenuExpanded"
        }
      ],
      staticClass: "tt-o-menu__list",
      class: _vm.alignClass,
      attrs: { role: "menu", tabindex: "-1" },
      on: {
        keydown: [
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
            ) {
              return null
            }
            $event.stopPropagation()
            _vm.close()
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            $event.preventDefault()
            _vm.moveUp()
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown"
              ])
            ) {
              return null
            }
            $event.preventDefault()
            _vm.moveDown()
          },
          function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
            ) {
              return null
            }
            $event.stopPropagation()
            _vm.handleTab($event)
          }
        ]
      }
    },
    _vm._l(_vm.menuItems, function(item, index) {
      return _c(
        "div",
        {
          key: item.name,
          staticClass: "tt-o-menu__item",
          class: [
            { "tt-o-menu__item--active": index === _vm.selectedItemIndex },
            _vm.menuItemTypeClass
          ],
          attrs: {
            tabindex: "0",
            role: "menuitem",
            "aria-controls": item.cntrlsId,
            "aria-expanded": item.expanded,
            "aria-disabled": item.disabled
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.menuItemSelected(index)
            },
            keydown: [
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.menuItemSelected(index)
              },
              function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "space", 32, $event.key, " ")
                ) {
                  return null
                }
                $event.preventDefault()
                _vm.menuItemSelected(index)
              }
            ]
          }
        },
        [
          item.iconName
            ? _c("tt-icon", {
                staticClass: "tt-o-menu__icon",
                attrs: { name: item.iconName, size: "md" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", {
            staticClass: "tt-o-menu__item-title",
            domProps: { innerHTML: _vm._s(item.title) }
          })
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("b876b7e6", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("b876b7e6", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c(
        "div",
        { staticClass: "tt-o-byline tt-u-spacing--left--xs" },
        [
          _vm.item.user
            ? _c(
                "span",
                { staticClass: "tt-o-byline__item tt-o-byline__author" },
                [_vm._v(_vm._s(_vm._f("formatName")(_vm.item.user)))]
              )
            : _c("span", {
                staticClass: "tt-o-byline__item",
                domProps: { innerHTML: _vm._s(_vm.$msg("byline.anon")) }
              }),
          _vm._v(" "),
          _vm.item.expertLabel
            ? _c("tt-badge", {
                attrs: { type: "expert" },
                domProps: { innerHTML: _vm._s(_vm.item.expertLabel) }
              })
            : _vm.item.isIndependentExpert
              ? _c("tt-badge", {
                  attrs: { type: "expert" },
                  domProps: { innerHTML: _vm._s(_vm.$msg("badge.expert")) }
                })
              : _vm.item.isStaff
                ? _c("tt-badge", {
                    attrs: { type: "staff" },
                    domProps: { innerHTML: _vm._s(_vm.$msg("badge.staff")) }
                  })
                : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "tt-o-byline__dot" }),
          _vm._v(" "),
          _c(
            "time",
            {
              staticClass: "tt-o-byline__item tt-o-byline__on-date",
              attrs: { datetime: _vm.item.dateCreated }
            },
            [_vm._v(_vm._s(_vm.item.dateCreatedFormatted))]
          ),
          _vm._v(" "),
          _vm.purchasedText
            ? _c("span", { staticClass: "tt-o-byline__dot" })
            : _vm._e(),
          _vm._v(" "),
          _vm.purchasedText
            ? _c("time", {
                staticClass: "tt-o-byline__item tt-o-byline__purchased",
                attrs: { datetime: _vm.purchasedDatetime },
                domProps: { innerHTML: _vm._s(_vm.purchasedText) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.syndicationText
            ? _c("span", { staticClass: "tt-o-byline__dot" })
            : _vm._e(),
          _vm._v(" "),
          _vm.syndicationText
            ? _c("span", {
                staticClass:
                  "tt-o-byline__item tt-o-byline__syndication-source",
                domProps: { innerHTML: _vm._s(_vm.syndicationText) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.menuItems, function(menuItem) {
            return [
              _c("span", {
                key: menuItem.name + "-byline",
                staticClass: "tt-o-byline__dot"
              }),
              _vm._v(" "),
              _c("tt-button", {
                key: menuItem.name + "-link",
                staticClass:
                  "tt-o-byline__item tt-o-byline__action tt-o-byline__options-item",
                class: ["tt-o-byline__options-item--" + menuItem.name],
                attrs: {
                  type: "link",
                  "aria-controls": menuItem.cntrlsId,
                  "aria-expanded": menuItem.expanded,
                  "aria-disabled": menuItem.disabled ? "true" : null,
                  disabledClassOnly: menuItem.disabled
                },
                domProps: { innerHTML: _vm._s(menuItem.title) },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.menuItemSelected(menuItem)
                  }
                }
              })
            ]
          }),
          _vm._v(" "),
          _vm.menuItems
            ? _c(
                "tt-menu",
                [
                  _c(
                    "tt-button",
                    {
                      staticClass: "tt-o-byline__menu-trigger",
                      attrs: {
                        slot: "menuTrigger",
                        type: "icon",
                        "aria-label": _vm.$msg("byline.optionsMenu")
                      },
                      slot: "menuTrigger"
                    },
                    [_c("tt-icon", { attrs: { name: "more-h", size: "sm" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("tt-menu-list", {
                    staticClass: "tt-o-byline__menu-list",
                    attrs: { menuItems: _vm.menuItems },
                    on: { menuItemSelected: _vm.menuItemSelected }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("2f4bf05a", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("2f4bf05a", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-multi-items" },
    [
      _c(
        "p",
        {
          staticClass: "tt-c-multi-items__text",
          attrs: { id: "tt-multi-items-text" }
        },
        [_vm._v(_vm._s(_vm.promptText))]
      ),
      _vm._v(" "),
      _c("tt-button", {
        ref: "openSearchBtn",
        staticClass: "tt-c-multi-items__add-items",
        attrs: {
          type: "compact-text",
          "aria-describedby": "tt-multi-items-text",
          "aria-haspopup": "true"
        },
        domProps: { innerHTML: _vm._s(_vm.$msg("multiItem.addItems")) },
        on: {
          click: function($event) {
            _vm.openSearch()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-multi-items__container" },
        _vm._l(_vm.multiItems, function(item) {
          return _c(
            "div",
            { key: item.id, staticClass: "tt-c-multi-items__item" },
            [
              _c(
                "button",
                {
                  staticClass:
                    "tt-c-multi-items__remove tt-o-button--action-icon-chip",
                  attrs: {
                    type: "button",
                    "aria-label": _vm.$msg("multiItem.removeItem", [item.title])
                  },
                  on: {
                    click: function($event) {
                      _vm.removeItem(item)
                    }
                  }
                },
                [_c("tt-icon", { attrs: { name: "close" } })],
                1
              ),
              _vm._v(" "),
              _c("tt-product-image", { attrs: { catItem: item } })
            ],
            1
          )
        })
      ),
      _vm._v(" "),
      _vm.showMultiItemSearch
        ? _c(
            "tt-modal",
            {
              staticClass: "tt-o-multi-items-popover",
              attrs: {
                closeLabel: _vm.$msg("multiItemSearch.popoverCloseLabel"),
                "aria-label": _vm.$msg("multiItemSearch.popoverLabel")
              },
              on: { close: _vm.closeSearch }
            },
            [
              _c("tt-multi-item-search", {
                attrs: {
                  excludedCatItemIds: _vm.searchExcludedCatItemIds,
                  sku: _vm.sku
                },
                on: { addItems: _vm.addItemsAndClose }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("d46cdddc", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("d46cdddc", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tt-o-search-field",
      class: { "tt-o-search-field--with-search-icon": _vm.showSearchIcon }
    },
    [
      _vm.showSearchIcon
        ? _c("tt-icon", { attrs: { name: "search", size: "sm" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.multiline
        ? _c("input", {
            ref: "field",
            staticClass: "tt-o-search-field__input",
            attrs: {
              type: "text",
              id: _vm.fieldId,
              "aria-describedby": _vm.describedBy,
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.value },
            on: { input: _vm.update }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.multiline
        ? _c("div", {
            ref: "field",
            staticClass: "tt-o-search-field__input",
            attrs: {
              contenteditable: "true",
              id: _vm.fieldId,
              role: "textbox",
              "aria-labelledby": _vm.labelId,
              "aria-describedby": _vm.describedBy,
              "aria-multiline": "true",
              tabindex: "0"
            },
            on: { keyup: _vm.update }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.value
        ? _c(
            "tt-button",
            {
              staticClass: "tt-o-search-field__clear",
              attrs: {
                type: "icon",
                "aria-label": _vm.$msg("searchField.clearText")
              },
              on: { click: _vm.clearText }
            },
            [_c("tt-icon", { attrs: { name: "close", size: "xxs" } })],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("1add8d89", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("1add8d89", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-answer-form" },
    [
      _c("label", {
        staticClass: "tt-u-clip-hide",
        attrs: { for: _vm.fieldId },
        domProps: { innerHTML: _vm._s(_vm.label) }
      }),
      _vm._v(" "),
      _c("tt-textarea", {
        ref: "textArea",
        staticClass: "tt-c-answer-form__textarea",
        attrs: {
          id: _vm.fieldId,
          name: "tt-c-answer-form-field",
          focusOnMount: true,
          describedbyId: "tt-c-answer-form-hint",
          maxCharacters: _vm.maxCharacters,
          errorText: _vm.errorMsg,
          characterThreshold: 200,
          hintText: _vm.$msg("answerReplyForm.instruction")
        },
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _vm._v(" "),
      _vm.showMultiItems
        ? _c("tt-multi-items", {
            attrs: {
              multiItems: _vm.multiItems,
              promptText: _vm.multiItemsPromptText,
              sku: _vm.parent.catItem.sku
            },
            on: { addItems: _vm.addMultiItems, removeItem: _vm.removeMultiItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-answer-form__action-buttons" },
        [
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isSubmitting,
                expression: "isSubmitting"
              }
            ],
            staticClass: "tt-o-spinner tt-o-spinner--submit"
          }),
          _vm._v(" "),
          _c("tt-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isSubmitting,
                expression: "!isSubmitting"
              }
            ],
            staticClass: "tt-c-answer-form__submit",
            domProps: { innerHTML: _vm._s(_vm.$msg("answerReplyForm.submit")) },
            on: { click: _vm.submitAnswerReply }
          }),
          _vm._v(" "),
          _c("tt-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isSubmitting && !_vm.hideCancel,
                expression: "!isSubmitting && !hideCancel"
              }
            ],
            staticClass: "tt-c-answer-form__cancel",
            attrs: { type: "secondary" },
            domProps: { innerHTML: _vm._s(_vm.$msg("answerReplyForm.cancel")) },
            on: { click: _vm.cancel }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("7faca3e1", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("7faca3e1", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-product-about" },
    [
      _c("tt-product-image", {
        staticClass: "tt-c-product-about__image",
        attrs: { catItem: _vm.catItem, isLinkable: true, size: _vm.imageSize }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "tt-c-product-about__info" }, [
        _vm.showAbout
          ? _c("div", {
              staticClass: "tt-c-product-about__about",
              domProps: { innerHTML: _vm._s(_vm.$msg("productAbout.about")) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("a", {
          staticClass: "tt-c-product-about__link",
          attrs: { href: _vm.catItem.url, target: "_blank", rel: "nofollow" },
          domProps: { innerHTML: _vm._s(_vm.catItem.title) }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("bb375ae4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("bb375ae4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-reply" },
    [
      _c("p", {
        staticClass: "tt-c-reply__text",
        domProps: { innerHTML: _vm._s(_vm.reply.text) }
      }),
      _vm._v(" "),
      _c("tt-byline", {
        ref: "byline",
        staticClass: "tt-c-reply__byline",
        attrs: { item: _vm.reply, ugcType: "sr", menuItems: _vm.menuItems },
        on: { menuItemSelected: _vm.menuItemSelected }
      }),
      _vm._v(" "),
      _vm.showReplyForm
        ? _c("tt-reply-form", {
            attrs: {
              id: _vm.controlsId,
              answerId: _vm.answerId,
              originSiteKey: _vm.originSiteKey,
              parentType: "reply",
              parent: _vm.reply,
              questionId: _vm.questionId,
              submissionCtx: _vm.submissionCtx
            },
            on: { close: _vm.closeForm }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "tt-c-reply__list",
            { "tt-c-reply__list--nested": _vm.depth < 4 }
          ]
        },
        _vm._l(_vm.reply.replies, function(nestedReply) {
          return _c("reply", {
            key: nestedReply.id,
            attrs: {
              answerId: _vm.answerId,
              openReplyForReplyId: _vm.openReplyForReplyId,
              originSiteKey: _vm.originSiteKey,
              questionId: _vm.questionId,
              reply: nestedReply,
              depth: _vm.depth + 1,
              submissionCtx: _vm.submissionCtx
            }
          })
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3368edd0", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3368edd0", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tt-c-answer",
      class: { "tt-c-answer--best": _vm.isBestAnswer }
    },
    [
      !_vm.isBestAnswer
        ? _c(
            "div",
            { staticClass: "tt-c-answer__votes" },
            [
              _c(
                "tt-button",
                {
                  staticClass: "tt-c-answer__upvote",
                  attrs: {
                    type: "icon",
                    disabled: !_vm.canVote,
                    "aria-label": _vm.$msg("answer.voteUp"),
                    "aria-pressed": _vm.wasVotedOn.toString()
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.vote($event)
                    }
                  }
                },
                [
                  _c("tt-icon", {
                    attrs: { name: _vm.voteIconName, size: "sm" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-answer__body" },
        [
          _c("p", { staticClass: "tt-c-answer__text" }, [
            _vm.isBestAnswer
              ? _c("span", {
                  staticClass: "tt-c-answer__best-answer-label",
                  domProps: { innerHTML: _vm._s(_vm.$msg("answer.bestAnswer")) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", {
              staticClass: "tt-c-answer__best-answer-text",
              domProps: { innerHTML: _vm._s(_vm.answer.text) }
            })
          ]),
          _vm._v(" "),
          _c("tt-byline", {
            ref: "byline",
            staticClass: "tt-c-answer__byline",
            attrs: {
              item: _vm.answer,
              ugcType: "sa",
              menuItems: _vm.menuItems
            },
            on: { menuItemSelected: _vm.menuItemSelected }
          }),
          _vm._v(" "),
          _vm.answer.multiItems.length > 0
            ? _c(
                "div",
                { staticClass: "tt-c-answer__multi-items" },
                _vm._l(_vm.answer.multiItems, function(multiItem) {
                  return _c("tt-product-about", {
                    attrs: { catItem: multiItem, showAbout: false }
                  })
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showReplyForm
            ? _c("tt-reply-form", {
                attrs: {
                  id: _vm.controlsId,
                  answerId: _vm.answer.id,
                  originSiteKey: _vm.originSiteKey,
                  parentType: "answer",
                  parent: _vm.answer,
                  questionId: _vm.questionId,
                  submissionCtx: _vm.submissionCtx
                },
                on: { close: _vm.closeForm }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tt-c-answer__reply-list" },
            _vm._l(_vm.nestedReplies, function(reply) {
              return _c("tt-reply", {
                key: reply.id,
                attrs: {
                  answerId: _vm.answer.id,
                  openReplyForReplyId: _vm.openReplyForReplyId,
                  originSiteKey: _vm.originSiteKey,
                  reply: reply,
                  questionId: _vm.questionId,
                  submissionCtx: _vm.submissionCtx
                }
              })
            })
          ),
          _vm._v(" "),
          _vm.showActions
            ? _c(
                "div",
                { staticClass: "tt-c-answer__actions" },
                [
                  !_vm.showAllReplies
                    ? _c(
                        "tt-button",
                        {
                          staticClass: "tt-c-answer__actions-view-all",
                          attrs: { type: "toolbar", "aria-expanded": "false" },
                          on: {
                            click: function($event) {
                              _vm.showAllReplies = true
                            }
                          }
                        },
                        [
                          _c("tt-icon", {
                            attrs: { name: "options-expand", size: "sm" }
                          }),
                          _c("span", {
                            staticClass: "tt-o-expander__text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$msg("answer.showAllReplies", [
                                  _vm.answer.replies.length
                                ])
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showAllReplies
                    ? _c(
                        "tt-button",
                        {
                          staticClass: "tt-c-answer__actions-hide-replies",
                          attrs: { type: "toolbar", "aria-expanded": "true" },
                          on: {
                            click: function($event) {
                              _vm.showAllReplies = false
                            }
                          }
                        },
                        [
                          _c("tt-icon", {
                            attrs: { name: "options-collapse", size: "sm" }
                          }),
                          _c("span", {
                            staticClass: "tt-o-expander__text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$msg("answer.hideAllReplies")
                              )
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("ab435bc6", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("ab435bc6", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tt-c-question-container",
      class: { "tt-c-question-container--is-solo": _vm.isSoloView }
    },
    [
      _vm.isSoloView
        ? _c(
            "div",
            { staticClass: "tt-c-question__header" },
            [
              _c("div", {
                staticClass: "tt-c-question__heading",
                attrs: { role: "heading", "aria-level": "2" },
                domProps: { innerHTML: _vm._s(_vm.soloTitle) }
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "tt-c-question__about",
                domProps: { innerHTML: _vm._s(_vm.aboutText) }
              }),
              _vm._v(" "),
              _vm.isSoloView
                ? _c("tt-product-image", {
                    staticClass: "tt-c-question__item-image",
                    attrs: { catItem: _vm.question.catItem, includeAlt: false }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "tt-c-question" }, [
        _c(
          "div",
          { staticClass: "tt-c-question__votes" },
          [
            _c(
              "tt-button",
              {
                staticClass: "tt-c-question__upvote",
                class: { "tt-o-button--selected": _vm.wasVotedOn },
                attrs: {
                  type: "toolbar",
                  disabled: !_vm.canVote,
                  "aria-label": _vm.$msg(
                    "question.voteUp",
                    [_vm.voteCount],
                    _vm.voteCount
                  ),
                  "aria-pressed": _vm.wasVotedOn.toString()
                },
                on: { click: _vm.vote }
              },
              [
                _c("tt-icon", {
                  attrs: { name: _vm.voteIconName, size: "md" }
                }),
                _c("span", { staticClass: "tt-c-question__upvote-count" }, [
                  _vm._v(_vm._s(_vm.voteCount))
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tt-c-question__body tt-u-spacing--xs" },
          [
            _c("div", {
              staticClass: "tt-c-question__title",
              domProps: { innerHTML: _vm._s(_vm.question.text) }
            }),
            _vm._v(" "),
            _vm.isRelated
              ? _c("tt-product-about", {
                  staticClass: "tt-c-question__related tt-u-mb--md",
                  attrs: { catItem: _vm.question.catItem }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("tt-byline", { attrs: { item: _vm.question, ugcType: "sq" } }),
            _vm._v(" "),
            _vm.question.multiItems.length > 0
              ? _c(
                  "div",
                  { staticClass: "tt-c-question__multi-items" },
                  _vm._l(_vm.question.multiItems, function(multiItem) {
                    return _c("tt-product-about", {
                      attrs: { catItem: multiItem, showAbout: false }
                    })
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "tt-slide-transition",
              [
                _vm.bestAnswer
                  ? _c("tt-answer", {
                      key: _vm.bestAnswer.id,
                      attrs: {
                        answer: _vm.bestAnswer,
                        isBestAnswer: true,
                        isOnlyAnswer: _vm.question.answers.length === 1,
                        originSiteKey: _vm.originSiteKey,
                        questionId: _vm.question.id,
                        submissionCtx: _vm.submissionCtx
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-question__answers" },
        [
          _vm.showActions
            ? _c(
                "div",
                { staticClass: "tt-c-question__actions" },
                [
                  _vm.expanderData
                    ? _c(
                        "tt-button",
                        {
                          staticClass: "tt-c-question__actions-show",
                          attrs: {
                            type: "toolbar",
                            "aria-expanded": _vm.expanderData.expanded,
                            "aria-controls": "tt-answer-list-" + _vm.question.id
                          },
                          on: { click: _vm.toggleShowHideAnswers }
                        },
                        [
                          _c("tt-icon", {
                            attrs: { name: _vm.expanderData.icon, size: "sm" }
                          }),
                          _c("span", {
                            staticClass: "tt-o-expander__text",
                            domProps: {
                              innerHTML: _vm._s(_vm.expanderData.text)
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideAddAnswer
                    ? _c(
                        "tt-button",
                        {
                          ref: "addAnswer",
                          staticClass: "tt-c-question__actions-answer",
                          attrs: {
                            type: "toolbar",
                            "aria-controls": _vm.controlsId,
                            "aria-expanded": _vm.showAnswerForm.toString(),
                            disabled: _vm.addAnswerDisabled
                          },
                          on: {
                            click: function($event) {
                              _vm.showAnswerForm = true
                            }
                          }
                        },
                        [
                          _c("tt-icon", {
                            attrs: { name: "write", size: "sm" }
                          }),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$msg("question.answer"))
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isModerator
                    ? _c(
                        "a",
                        {
                          staticClass: "tt-c-question__actions-moderate",
                          attrs: {
                            href: _vm.moderationUrl,
                            target: "_blank",
                            rel: "nofollow"
                          }
                        },
                        [
                          _c("tt-icon", {
                            attrs: { name: "moderate", size: "sm" }
                          }),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$msg("question.moderate"))
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showAnswerForm
            ? _c("tt-answer-form", {
                attrs: {
                  id: _vm.controlsId,
                  hideCancel: _vm.hideAnswerFormCancel,
                  originSiteKey: _vm.originSiteKey,
                  parentType: "question",
                  parent: _vm.question,
                  questionId: _vm.question.id,
                  submissionCtx: _vm.submissionCtx
                },
                on: { close: _vm.closeForm }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAnswers,
                  expression: "showAnswers"
                }
              ],
              staticClass: "tt-c-question__answer-list",
              attrs: { id: "tt-answer-list-" + _vm.question.id }
            },
            [
              _vm.showAnswers
                ? [
                    _vm._l(_vm.question.answers, function(answer) {
                      return _c("tt-answer", {
                        key: answer.id,
                        attrs: {
                          answer: answer,
                          isOnlyAnswer: _vm.question.answers.length === 1,
                          openReplyForAnswerId: _vm.openReplyForAnswerId,
                          openReplyForReplyId: _vm.openReplyForReplyId,
                          originSiteKey: _vm.originSiteKey,
                          questionId: _vm.question.id,
                          submissionCtx: _vm.submissionCtx
                        }
                      })
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "tt-c-answer__help" }, [
                      _c(
                        "div",
                        { staticClass: "tt-c-answer__votes" },
                        [
                          _c("tt-icon", {
                            attrs: { name: "helpful-on", size: "sm" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "tt-c-answer__body" }, [
                        _c("p", {
                          staticClass: "tt-c-answer__help-text",
                          domProps: {
                            innerHTML: _vm._s(_vm.$msg("question.voteForAbove"))
                          }
                        })
                      ])
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3a175fee", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3a175fee", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/services/msg.ts
var msg = __webpack_require__(5);

// CONCATENATED MODULE: ./src/util/time-utils.ts

var intervals = [
    { ms: 31536000, i: 'year' },
    { ms: 2592000, i: 'month' },
    { ms: 604800, i: 'week' },
    { ms: 86400, i: 'day' },
    { ms: 3600, i: 'hour' },
    { ms: 60, i: 'minute' }
];
function getElapsedTime(dateMillis) {
    if (!dateMillis) {
        return '';
    }
    var nowMillis = new Date().getTime();
    var diff = Math.floor((nowMillis - dateMillis) / 1000);
    var interval;
    var num = 0;
    for (var i = 0; i < intervals.length; i++) {
        if (diff >= intervals[i].ms) {
            interval = intervals[i].i;
            num = Math.floor(diff / intervals[i].ms);
            break;
        }
    }
    if (!interval) {
        return Object(msg["a" /* default */])('time.lessThanMinuteAgo');
    }
    return Object(msg["a" /* default */])("time." + interval + "sAgo", [num], num);
}

// EXTERNAL MODULE: ./src/util/text-utils.ts
var text_utils = __webpack_require__(62);

// CONCATENATED MODULE: ./src/components/comment/comment-mixin.ts



/* harmony default export */ var comment_mixin = (vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            commentText: '',
            commentTextOnExpand: '',
            isTruncated: false
        };
    },
    props: {
        comment: {
            type: Object,
            required: true
        },
        truncateLength: {
            type: Number,
            default: 200
        },
        truncateAllowance: {
            type: Number,
            default: 9
        }
    },
    computed: {
        datetime: function () {
            return (new Date(this.comment.dateCreatedMillis)).toISOString();
        },
        elapsedTime: function () {
            return getElapsedTime(this.comment.dateCreatedMillis);
        }
    },
    methods: {
        expandComment: function () {
            this.commentText = this.commentTextOnExpand;
            this.isTruncated = false;
            // Call to tileMixin notifying the layout container that this comment is expanding.
            if (this.isTile) {
                this.tileHeightChanged();
            }
        },
        setupText: function () {
            var text = this.comment.text.trim();
            var truncatedText = Object(text_utils["b" /* truncateText */])(text, this.truncateLength, this.truncateAllowance);
            if (truncatedText) {
                this.isTruncated = true;
                this.commentText = truncatedText;
                this.commentTextOnExpand = text;
            }
            else {
                this.commentText = text;
            }
        }
    },
    created: function () {
        this.setupText();
    }
}));

// EXTERNAL MODULE: ./src/components/comment/comment.html
var comment = __webpack_require__(189);
var comment_default = /*#__PURE__*/__webpack_require__.n(comment);

// EXTERNAL MODULE: ./src/objects/byline/byline.scss
var byline = __webpack_require__(36);
var byline_default = /*#__PURE__*/__webpack_require__.n(byline);

// EXTERNAL MODULE: ./src/components/comment/comment.scss
var comment_comment = __webpack_require__(190);
var comment_comment_default = /*#__PURE__*/__webpack_require__.n(comment_comment);

// CONCATENATED MODULE: ./src/components/comment/comment.ts





var ELAPSED_DATE_TYPE = 'ed';
var FORMATTED_DATE_TYPE = 'fd';
var CAT_ITEM_TYPE = 'ci';
var META_TYPES = [ELAPSED_DATE_TYPE, FORMATTED_DATE_TYPE, CAT_ITEM_TYPE];
/**
 * Used for top-comments (ed), comments-question (fd), profile comment (ci)
 */
/* harmony default export */ var components_comment_comment = __webpack_exports__["a"] = (comment_default()(vue_runtime_esm["a" /* default */].extend({
    props: {
        metaType: {
            type: String,
            validator: function (value) { return META_TYPES.indexOf(value) > -1; }
        },
        prefixText: String // for top comment
    },
    mixins: [comment_mixin],
    computed: {
        dateText: function () {
            return this.metaType === FORMATTED_DATE_TYPE ? this.comment.dateCreatedFormatted :
                this.$msg('comment.purchased', [this.elapsedTime]);
        },
        linkUsername: function () {
            // TODO: when my posts is released, this can be uncommented instead of using false
            return false; // this.metaType === FORMATTED_DATE_TYPE
        },
        showCatItem: function () {
            return this.metaType === CAT_ITEM_TYPE;
        }
    },
    methods: {
        showProfile: function () {
            // TODO
        }
    }
})));


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GALLERY_FETCH_LIMIT; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getMediaList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_service__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__ = __webpack_require__(11);


var GALLERY_FETCH_LIMIT = 25;
function getMediaList(skus, tags, offset, galleryConfig) {
    return __WEBPACK_IMPORTED_MODULE_0__api_service__["a" /* default */].mediaList({
        skus: Object(__WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__["d" /* encodeArray */])(skus),
        offset: offset,
        limit: GALLERY_FETCH_LIMIT,
        sort: galleryConfig.sortOrder,
        tags: Object(__WEBPACK_IMPORTED_MODULE_1_util_turnto_utils__["d" /* encodeArray */])(tags),
        minCharCount: galleryConfig.minTextContentCharacterCount,
        minWordCount: galleryConfig.minTextContentWordCount,
        includeProductSiblings: galleryConfig.includeProductSiblings,
        includeSyndicated: galleryConfig.includeSyndicated
    });
}


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadConfig", function() { return loadConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_entry_base__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_command_queue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_global_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_email_flows_email_flow_entry__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_init_global_config__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_init_resource_loader__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_services_msg__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widgets_instant_answers_instant_answers_loader__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widgets_qa_qa_loader__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widgets_reviews_summary_reviews_summary_loader__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widgets_reviews_list_reviews_list_loader__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widgets_submission_review_submission_config__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_services_token_service__ = __webpack_require__(15);
/* tslint:disable */
// (AUTO-GENERATED PAGE BUNDLE)
// PAGE NAME: pdp-page
// ==============================













function loadConfig(config) {
    Object(__WEBPACK_IMPORTED_MODULE_5_init_resource_loader__["c" /* loadIcons */])(__webpack_require__(242));
    Object(__WEBPACK_IMPORTED_MODULE_6_services_msg__["c" /* loadMessages */])(config.messages, config.pluralRuleFn);
    Object(__WEBPACK_IMPORTED_MODULE_4_init_global_config__["b" /* loadConfig */])(config.globalConfig);
    Promise.all([
        __WEBPACK_IMPORTED_MODULE_7_widgets_instant_answers_instant_answers_loader__["loadWidget"](config.instantAnswers),
        __WEBPACK_IMPORTED_MODULE_8_widgets_qa_qa_loader__["loadWidget"](config.qa),
        __WEBPACK_IMPORTED_MODULE_9_widgets_reviews_summary_reviews_summary_loader__["loadWidget"](config.reviewsSummary),
        __WEBPACK_IMPORTED_MODULE_10_widgets_reviews_list_reviews_list_loader__["loadWidget"](config.reviewsList)
    ]).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_init_global_store__["a" /* default */].loaders = [
            __WEBPACK_IMPORTED_MODULE_7_widgets_instant_answers_instant_answers_loader__,
            __WEBPACK_IMPORTED_MODULE_8_widgets_qa_qa_loader__,
            __WEBPACK_IMPORTED_MODULE_9_widgets_reviews_summary_reviews_summary_loader__,
            __WEBPACK_IMPORTED_MODULE_10_widgets_reviews_list_reviews_list_loader__
        ];
        __WEBPACK_IMPORTED_MODULE_1_init_command_queue__["a" /* init */]();
    });
    Object(__WEBPACK_IMPORTED_MODULE_12_services_token_service__["b" /* loadLoggedInUser */])();
    Object(__WEBPACK_IMPORTED_MODULE_11_widgets_submission_review_submission_config__["b" /* loadConfig */])(config.reviewSubmission);
    Object(__WEBPACK_IMPORTED_MODULE_3_email_flows_email_flow_entry__["a" /* checkTurntoflow */])();
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["loadWidget"] = loadWidget;
/* harmony export (immutable) */ __webpack_exports__["getInstance"] = getInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_util_loader_helper__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_init_command_queue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instant_answers_config__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__instant_answers__ = __webpack_require__(181);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
var root;
var type = 'instant-answers';
function initialize() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_util_loader_helper__["a" /* createAndMountInstance */])(root, __WEBPACK_IMPORTED_MODULE_4__instant_answers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__instant_answers_config__["a" /* default */].widgetDivId)
        .then(function (instance) { return root = instance; });
}
function loadWidget(widgetConfig) {
    return new Promise(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_3__instant_answers_config__["b" /* loadConfig */])(widgetConfig);
        // no commands for instant answers yet
        __WEBPACK_IMPORTED_MODULE_2_init_command_queue__["b" /* widgetLibraries */].instantAnswers = {};
        initialize().then(function () { return resolve(); });
    });
}
function getInstance() {
    return root;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/services/api-service.ts
var api_service = __webpack_require__(8);

// EXTERNAL MODULE: ./src/util/ts-utils.ts
var ts_utils = __webpack_require__(10);

// EXTERNAL MODULE: ./src/widgets/instant-answers/instant-answers.config.ts
var instant_answers_config = __webpack_require__(58);

// EXTERNAL MODULE: ./src/components/ask/ask-tips.html
var ask_tips = __webpack_require__(182);
var ask_tips_default = /*#__PURE__*/__webpack_require__.n(ask_tips);

// EXTERNAL MODULE: ./src/components/ask/ask-tips.scss
var ask_ask_tips = __webpack_require__(183);
var ask_ask_tips_default = /*#__PURE__*/__webpack_require__.n(ask_ask_tips);

// CONCATENATED MODULE: ./src/components/ask/ask-tips.ts



/* harmony default export */ var components_ask_ask_tips = (ask_tips_default()(vue_runtime_esm["a" /* default */].extend({
    computed: {
        columns: function () {
            return [
                this.getCol('askTips.how', 'ol'),
                this.getCol('askTips.topics', 'ul'),
                this.getCol('askTips.support', 'p')
            ].filter(function (col) { return col; }); // filters out null columns
        }
    },
    methods: {
        getCol: function (msgPrefix, tag) {
            var title = this.$msg(msgPrefix + ".title");
            if (!title) {
                return null;
            }
            return {
                title: title,
                tag: tag,
                items: this.getListItems(msgPrefix)
            };
        },
        getListItems: function (msgPrefix) {
            var listItems = [];
            for (var i = 1; i <= 10; i++) {
                var text = this.$msg(msgPrefix + "." + i);
                if (!text || text.indexOf('<?') === 0) {
                    continue;
                }
                listItems.push(text);
            }
            return listItems;
        }
    }
})));

// EXTERNAL MODULE: ./src/objects/hint/hint-text.ts
var hint_text = __webpack_require__(61);

// EXTERNAL MODULE: ./src/objects/form/search-field.ts
var search_field = __webpack_require__(70);

// EXTERNAL MODULE: ./src/components/ask/ask.html
var ask = __webpack_require__(184);
var ask_default = /*#__PURE__*/__webpack_require__.n(ask);

// EXTERNAL MODULE: ./src/components/ask/ask.scss
var ask_ask = __webpack_require__(185);
var ask_ask_default = /*#__PURE__*/__webpack_require__.n(ask_ask);

// CONCATENATED MODULE: ./src/components/ask/ask.ts







/* harmony default export */ var components_ask_ask = (ask_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return { showLearnMore: false };
    },
    components: {
        'tt-ask-tips': components_ask_ask_tips,
        'tt-hint-text': hint_text["a" /* default */],
        'tt-search-field': search_field["a" /* default */]
    },
    props: {
        alertText: { type: String },
        countText: { type: String },
        errorText: { type: String },
        inAskMode: {
            type: Boolean,
            default: false
        },
        questionText: String
    },
    model: {
        prop: 'questionText',
        event: 'input'
    },
    computed: {
        askLabel: function () {
            return this.$msg(this.inAskMode ? 'ia.askLabel' : 'ia.promptLabel');
        },
        askLabelMobile: function () {
            return this.$msg(this.inAskMode ? 'ia.askLabel.mobile' : 'ia.promptLabel.mobile');
        },
        hintSeparator: function () {
            return ' <span class="tt-o-hint__dot">' + this.$msg('hint.error.separator') + '</span> ';
        },
        hintText: function () {
            if (this.errorText) {
                return this.errorText;
            }
            if (this.alertText) {
                return this.alertText;
            }
            if (this.inAskMode) {
                return (this.countText ?
                    this.countText + this.hintSeparator : '') + this.$msg('ia.askHint');
            }
            return this.value ? '' :
                (this.countText ? this.countText + this.hintSeparator : '') + this.$msg('ia.promptHint');
        },
        hintType: function () {
            return this.errorText ? 'error' : (this.alertText ? 'alert' : 'info');
        },
        learnMoreText: function () {
            return this.showLearnMore ? this.$msg('ia.hideTipsLink') : this.$msg('ia.learnMoreLink');
        },
        showLearnMoreLink: function () {
            return instant_answers_config["a" /* default */].learnMoreEnabled && !this.alertText && !this.inAskMode && !this.value;
        }
    },
    methods: {
        toggleLearnMore: function () {
            this.showLearnMore = !this.showLearnMore;
        },
        updateText: function (text) {
            this.$emit('input', text);
        }
    },
    watch: {
        questionText: function () {
            if (this.questionText && this.showLearnMore) {
                this.showLearnMore = false;
            }
        }
    }
})));

// EXTERNAL MODULE: ./src/services/msg.ts
var msg = __webpack_require__(5);

// EXTERNAL MODULE: ./src/services/token-service.ts
var token_service = __webpack_require__(15);

// EXTERNAL MODULE: ./src/init/global.config.ts
var global_config = __webpack_require__(6);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(4);

// EXTERNAL MODULE: ./src/init/config.ts
var config = __webpack_require__(3);

// EXTERNAL MODULE: ./src/components/question/multi-items.ts
var multi_items = __webpack_require__(69);

// EXTERNAL MODULE: ./src/widgets/qa/qa.config.ts
var qa_config = __webpack_require__(23);

// EXTERNAL MODULE: ./src/widgets/reviews-list/reviews-list-widget.config.ts
var reviews_list_widget_config = __webpack_require__(19);

// EXTERNAL MODULE: ./src/services/sso-service.ts
var sso_service = __webpack_require__(13);

// EXTERNAL MODULE: ./src/widgets/standalone-popover/standalone-popover-loader.ts
var standalone_popover_loader = __webpack_require__(14);

// EXTERNAL MODULE: ./src/widgets/submission/submission-loader.ts
var submission_loader = __webpack_require__(12);

// EXTERNAL MODULE: ./src/store/submission-store.ts
var submission_store = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/user-toolbar/user-toolbar.ts
var user_toolbar = __webpack_require__(28);

// EXTERNAL MODULE: ./src/util/validation-utils.ts
var validation_utils = __webpack_require__(68);

// EXTERNAL MODULE: ./src/widgets/instant-answers/instant-answers.html
var instant_answers = __webpack_require__(191);
var instant_answers_default = /*#__PURE__*/__webpack_require__.n(instant_answers);

// EXTERNAL MODULE: ./src/widgets/instant-answers/instant-answers.scss
var instant_answers_instant_answers = __webpack_require__(192);
var instant_answers_instant_answers_default = /*#__PURE__*/__webpack_require__.n(instant_answers_instant_answers);

// CONCATENATED MODULE: ./src/widgets/instant-answers/instant-answers.ts






















var MAX_CHARACTERS = 2000;
var CHARACTER_THRESHOLD = 200;
/* harmony default export */ var widgets_instant_answers_instant_answers = __webpack_exports__["a"] = (instant_answers_default()(vue_runtime_esm["a" /* default */].extend({
    name: 'InstantAnswers',
    data: function () {
        return {
            globalStore: global_store["a" /* default */],
            inAskMode: false,
            isOffline: false,
            isSearching: false,
            isSubmitting: false,
            errorText: null,
            multiItems: [],
            previousQuestionText: '',
            questionText: '',
            searchResults: []
        };
    },
    components: {
        'tt-ask': components_ask_ask,
        'tt-multi-items': multi_items["a" /* default */],
        // tslint:disable-next-line
        'tt-ask-results': function () { return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 432)); },
        'tt-user-toolbar': user_toolbar["a" /* default */]
    },
    computed: {
        charactersLeft: function () {
            return MAX_CHARACTERS - this.trimmedQuestionText.length;
        },
        countText: function () {
            return (this.charactersLeft <= CHARACTER_THRESHOLD) ?
                this.$msg('cc.charactersLeft', [this.charactersLeft]) : '';
        },
        currentSku: function () {
            return this.globalStore.sku;
        },
        iaConfig: function () {
            return instant_answers_config["a" /* default */];
        },
        multiItemsPromptText: function () {
            return this.$msg("multiItem.question.prompt" + (this.multiItems.length > 0 ? '.withAdded' : ''));
        },
        resultsPromptText: function () {
            return this.searchResults.length > 0 ? this.$msg('ia.results.notWhatLookingFor') :
                this.$msg('ia.results.reviseSearch');
        },
        showMultiItems: function () {
            return instant_answers_config["a" /* default */].multiItemQuestionEnabled && this.inAskMode;
        },
        showResults: function () {
            return this.trimmedQuestionText && !this.inAskMode;
        },
        trimmedQuestionText: function () {
            return this.questionText.trim();
        }
    },
    methods: {
        addMultiItems: function (items) {
            var _this = this;
            items.forEach(function (item) {
                if (_this.multiItems.filter(function (mi) { return mi.id === item.id; }).length === 0) {
                    _this.multiItems.push(item);
                }
            });
        },
        askUpdate: function () {
            var trimmedText = this.trimmedQuestionText;
            // don't want to trigger unnecessary searces
            if (trimmedText === this.previousQuestionText) {
                return;
            }
            this.previousQuestionText = trimmedText;
            if (this.charactersLeft < 0) {
                this.errorText = this.$msg('cc.charactersOver', [Math.abs(this.charactersLeft)]);
                return;
            }
            this.clearErrors();
            if (trimmedText.length === 0) {
                this.inAskMode = false;
                this.searchResults = [];
            }
            else if (!this.inAskMode) {
                this.instantAnswerSearch();
            }
        },
        cancelAskMode: function () {
            this.inAskMode = false;
            this.questionText = '';
            this.clearErrors();
        },
        clearErrors: function () {
            this.errorText = '';
        },
        enterAskMode: function () {
            this.inAskMode = true;
            dom_utils["a" /* default */].safeFocusRef(this.$refs, 'submitBtn');
        },
        instantAnswerSearch: Object(ts_utils["d" /* debounce */])(function () {
            var _this = this;
            this.isSearching = true;
            this.isOffline = false;
            api_service["a" /* default */].instantAnswerSearch({
                catalogItemId: global_store["a" /* default */].catItemId,
                categoryIds: global_store["a" /* default */].parentCategoryIds,
                brand: global_store["a" /* default */].brand,
                includeRelatedQuestions: qa_config["b" /* default */].relatedQuestionsDisplay === qa_config["a" /* RelatedQuestionsDisplayTypes */].INCLUDED,
                includeRelatedReviews: reviews_list_widget_config["b" /* default */].relatedReviewsDisplay === reviews_list_widget_config["a" /* RelatedReviewsDisplayTypes */].INCLUDED,
                searchTerm: this.trimmedQuestionText
            }).then(function (data) {
                _this.searchResults = data.items;
                _this.isSearching = false;
            }).catch(function (e) {
                if (e.errorCode === 'turnto-offline') {
                    _this.isOffline = true;
                }
                _this.isSearching = false;
            });
        }, 300),
        onShowError: function (e) {
            if (e.fieldErrors.length > 0 && e.fieldErrors[0].code === 'ext-site-link') {
                this.errorText = this.$msg('ia.err.containsLink');
                this.isSubmitting = false;
            }
            else {
                // used for error like question submission where modal not open
                standalone_popover_loader["a" /* default */].load({ message: Object(msg["b" /* getOfflineOrUnexpectedMsg */])(e),
                    type: 'error', autoClose: true });
                this.resetAfterError();
            }
        },
        removeMultiItem: function (item) {
            for (var i = 0; i < this.multiItems.length; i++) {
                if (this.multiItems[i].id === item.id) {
                    this.multiItems.splice(i, 1);
                    break;
                }
            }
        },
        resetAfterError: function () {
            // so we don't wipe out question giving them option of trying again
            // which may only be practical for offline error case
            this.inAskMode = false;
            this.isSearching = false;
            this.isSubmitting = false;
            this.isOffline = false;
        },
        resetAfterSubmit: function () {
            this.cancelAskMode();
            this.isSearching = false;
            this.isSubmitting = false;
            this.isOffline = false;
            this.searchResults = [];
            this.multiItems = [];
        },
        validateQuestion: function (text) {
            this.clearErrors();
            if (this.charactersLeft < 0) {
                this.errorText = this.$msg('cc.charactersOver', [Math.abs(this.charactersLeft)]);
                return false;
            }
            if (text.search(/[?]/im) === -1) {
                this.errorText = this.$msg('ia.error.isThisAQuestion');
                return false;
            }
            if (validation_utils["a" /* default */].containsEmail(text)) {
                this.errorText = this.$msg('ia.err.dontIncludeEmail');
                return false;
            }
            if (validation_utils["a" /* default */].containsPhoneNumber(text)) {
                this.errorText = this.$msg('ia.err.dontIncludePhone');
                return false;
            }
            return true;
        },
        submitQuestion: function () {
            var _this = this;
            this.isSubmitting = true;
            if (!this.validateQuestion(this.trimmedQuestionText)) {
                var field_1 = this.$el.querySelector('.tt-o-search-field__input');
                dom_utils["a" /* default */].safeFocus(field_1).then(function () {
                    // Safari was having an issue focusing at end of content in textarea.
                    // Most likely because it's a contenteditable div instead of an actual textarea.
                    dom_utils["a" /* default */].setCursorAtEndOfText(field_1);
                });
                this.isSubmitting = false;
                return;
            }
            var userToken = Object(token_service["a" /* getUserToken */])();
            if (userToken) {
                // This is a logged in, and therefore confirmed user.
                api_service["a" /* default */].createQuestionConfirmedUser({
                    'context-token': userToken,
                    sku: this.currentSku
                }, {
                    questionType: 0,
                    text: this.trimmedQuestionText,
                    multiItemIds: this.multiItems.map(function (item) { return item.id; })
                }).then(function (data) {
                    // go to do more where question submission message will display
                    submission_store["b" /* default */].startFlow(_this.currentSku, config["a" /* hostsConfig */].siteKey, { page: 'do-more', props: { msgType: 'question' } });
                    submission_loader["a" /* default */].load();
                    _this.onQuestionSubmit(data.questionId);
                    _this.resetAfterSubmit();
                }).catch(function (e) {
                    _this.onShowError(e);
                });
            }
            else {
                var qualifier = global_config["a" /* default */].isAllowAnon() ? 'anonymous' : 'unconfirmed';
                api_service["a" /* default */].createQuestionAnonOrUnconfirmedUser({
                    sku: this.currentSku,
                    qualifier: qualifier
                }, {
                    questionType: 0,
                    text: this.trimmedQuestionText,
                    multiItemIds: this.multiItems.map(function (item) { return item.id; })
                }).then(function (resp) {
                    if (resp.questionId) {
                        _this.onQuestionSubmit(resp.questionId);
                    }
                    _this.resetAfterSubmit();
                    if (global_config["a" /* default */].ssoEnabled) {
                        Object(sso_service["e" /* ssoCreateQuestion */])(_this.currentSku, resp.savedQuestionToken || resp.stagedQuestionToken);
                    }
                    else {
                        // tslint:disable-next-line
                        __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 410)).then(function (registrationModalLoader) {
                            registrationModalLoader.default.load({
                                // for anonymous, will be null for other qualifier types
                                savedContentToken: resp.savedQuestionToken,
                                // for emailRequired and emailConfirmRequired, will be null if for anonymous
                                stagedContentToken: resp.stagedQuestionToken,
                                registerFor: 'question'
                            });
                        });
                    }
                }).catch(function (e) {
                    _this.onShowError(e);
                });
            }
        },
        onInstantAnswerClick: function () {
            // if client provided an onInstantAnswerClick function
            var eventHandlers = window.turnToConfig.eventHandlers || {};
            if (eventHandlers.onInstantAnswerClick) {
                this.$nextTick(function () {
                    eventHandlers.onInstantAnswerClick();
                });
            }
        },
        onQuestionSubmit: function (questionId) {
            // if client provided an onQuestionSubmit function
            var eventHandlers = window.turnToConfig.eventHandlers || {};
            if (eventHandlers.onQuestionSubmit) {
                eventHandlers.onQuestionSubmit({ id: questionId });
            }
        }
    },
    watch: {
        questionText: function () {
            this.askUpdate();
        }
    }
})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-ask-tips" },
    _vm._l(_vm.columns, function(col) {
      return _c(
        "div",
        { staticClass: "tt-c-ask-tips__col" },
        [
          col.title
            ? _c("div", {
                staticClass: "tt-c-ask-tips__heading",
                domProps: { innerHTML: _vm._s(col.title) }
              })
            : _vm._e(),
          _vm._v(" "),
          col.tag === "ol"
            ? _c(
                "ol",
                { staticClass: "tt-c-ask-tips__list" },
                _vm._l(col.items, function(item) {
                  return _c("li", {
                    staticClass: "tt-c-ask-tips__list-item",
                    domProps: { innerHTML: _vm._s(item) }
                  })
                })
              )
            : _vm._e(),
          _vm._v(" "),
          col.tag === "ul"
            ? _c(
                "ul",
                { staticClass: "tt-c-ask-tips__list" },
                _vm._l(col.items, function(item) {
                  return _c("li", {
                    staticClass: "tt-c-ask-tips__list-item",
                    domProps: { innerHTML: _vm._s(item) }
                  })
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(col.items, function(item) {
            return col.tag === "p"
              ? _c("p", {
                  staticClass: "tt-c-ask-tips__text",
                  domProps: { innerHTML: _vm._s(item) }
                })
              : _vm._e()
          })
        ],
        2
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("27296513", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("27296513", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-ask" },
    [
      _c(
        "div",
        { staticClass: "tt-c-ask__label", attrs: { id: "tt-c-ask-label" } },
        [
          _c("span", {
            staticClass: "tt-c-ask__label-text tt-u-show-until--md",
            domProps: { innerHTML: _vm._s(_vm.askLabelMobile) }
          }),
          _vm._v(" "),
          _c("span", {
            staticClass: "tt-c-ask__label-text tt-u-hide-until--md",
            domProps: { innerHTML: _vm._s(_vm.askLabel) }
          })
        ]
      ),
      _vm._v(" "),
      _c("tt-search-field", {
        staticClass: "tt-c-ask__field",
        attrs: {
          value: _vm.questionText,
          multiline: true,
          labelId: "tt-c-ask-label",
          describedBy: "tt-c-ask-hint"
        },
        on: { input: _vm.updateText }
      }),
      _vm._v(" "),
      _vm.hintText
        ? _c(
            "tt-hint-text",
            {
              staticClass: "tt-c-ask__hint",
              attrs: {
                id: "tt-c-ask-hint",
                type: _vm.hintType,
                text: _vm.hintText
              }
            },
            [
              _vm.showLearnMoreLink
                ? _c("a", {
                    staticClass: "tt-c-ask__learn-more",
                    attrs: {
                      href: "#tt-c-ask-tips",
                      "aria-controls": "tt-c-ask-tips",
                      "aria-expanded": _vm.showLearnMore.toString(),
                      rel: "nofollow"
                    },
                    domProps: { innerHTML: _vm._s(_vm.learnMoreText) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.toggleLearnMore()
                      },
                      keydown: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        _vm.toggleLearnMore()
                      }
                    }
                  })
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("tt-ask-tips", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showLearnMore,
            expression: "showLearnMore"
          }
        ],
        attrs: { id: "tt-c-ask-tips" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("8565290c", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("8565290c", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn && _vm.showToolbar
    ? _c(
        "div",
        { staticClass: "tt-c-user-toolbar tt-u-spacing--left--sm" },
        [
          _vm.isLoggedIn
            ? _c("div", { staticClass: "tt-c-user-toolbar__name" }, [
                _vm._v(_vm._s(_vm.formattedUsername))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoggedIn && _vm.menuItems
            ? _c(
                "tt-menu",
                [
                  _c(
                    "tt-button",
                    {
                      staticClass: "tt-c-user-toolbar__menu-trigger",
                      attrs: {
                        slot: "menuTrigger",
                        type: "icon",
                        "aria-label": _vm.$msg("userToolbar.optionsMenuLabel")
                      },
                      slot: "menuTrigger"
                    },
                    [_c("tt-icon", { attrs: { name: "more-h", size: "sm" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("tt-menu-list", {
                    staticClass: "tt-c-user-toolbar__menu-list",
                    attrs: { menuItems: _vm.menuItems },
                    on: { menuItemSelected: _vm.menuItemSelected }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("a1973f5a", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("a1973f5a", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-rating" },
    [
      _vm.includeAccessibleText
        ? _c("div", {
            staticClass: "tt-u-clip-hide",
            domProps: {
              innerHTML: _vm._s(_vm.$msg("ratingStars.rating", [_vm.rating]))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(5, function(n) {
        return _c(
          "div",
          { key: n, staticClass: "tt-c-rating__star" },
          [
            _c("tt-icon", {
              staticClass: "tt-c-rating__icon",
              attrs: { name: _vm.starIcon(n), size: _vm.starSize }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("41260bfa", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("41260bfa", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tt-c-comment" }, [
    _c(
      "div",
      { staticClass: "tt-c-comment__quote-col" },
      [
        _c("tt-icon", {
          staticClass: "tt-c-comment__quote",
          attrs: { name: "quote" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tt-c-comment__body tt-u-spacing--xs" }, [
      _c(
        "p",
        { staticClass: "tt-c-comment__text" },
        [
          _vm.prefixText
            ? _c("span", {
                staticClass: "tt-c-comment__comment-prefix",
                domProps: { innerHTML: _vm._s(_vm.prefixText) }
              })
            : _vm._e(),
          _vm._v(" " + _vm._s(_vm.commentText)),
          _vm.isTruncated ? [_vm._v("…")] : _vm._e(),
          _vm._v(" "),
          _vm.isTruncated
            ? _c("tt-button", {
                staticClass: "tt-c-comment__expand",
                attrs: { type: "link" },
                domProps: { innerHTML: _vm._s(_vm.$msg("comment.readMore")) },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.expandComment($event)
                  }
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.showCatItem
        ? _c("span", {
            staticClass: "tt-c-comment__item",
            domProps: {
              innerHTML: _vm._s(
                _vm.$msg("comment.aboutItem", [_vm.comment.catItem.title])
              )
            }
          })
        : _c(
            "div",
            {
              staticClass:
                "tt-o-byline tt-c-comment__byline tt-u-spacing--left--xs"
            },
            [
              _vm.linkUsername
                ? _c(
                    "tt-button",
                    {
                      staticClass: "tt-o-byline__author tt-o-byline__item",
                      attrs: { type: "link" },
                      on: { click: _vm.showProfile }
                    },
                    [_vm._v(_vm._s(_vm._f("formatName")(_vm.comment.user)))]
                  )
                : _c(
                    "span",
                    { staticClass: "tt-o-byline__author tt-o-byline__item" },
                    [_vm._v(_vm._s(_vm._f("formatName")(_vm.comment.user)))]
                  ),
              _vm._v(" "),
              _c("span", { staticClass: "tt-o-byline__dot" }),
              _vm._v(" "),
              _c("time", {
                staticClass: "tt-o-byline__on-date tt-o-byline__item",
                attrs: { datetime: _vm.datetime },
                domProps: { innerHTML: _vm._s(_vm.dateText) }
              })
            ],
            1
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("917a6ba4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("917a6ba4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-w-instant-answers" },
    [
      _c("tt-user-toolbar"),
      _vm._v(" "),
      _c("tt-ask", {
        attrs: {
          inAskMode: _vm.inAskMode,
          errorText: _vm.errorText,
          countText: _vm.countText
        },
        model: {
          value: _vm.questionText,
          callback: function($$v) {
            _vm.questionText = $$v
          },
          expression: "questionText"
        }
      }),
      _vm._v(" "),
      _vm.showResults
        ? _c(
            "tt-ask-results",
            {
              attrs: {
                initialPageSize: _vm.iaConfig.initialPageSize,
                pageSize: _vm.iaConfig.pageSize,
                searchResults: _vm.searchResults,
                isSearching: _vm.isSearching,
                isOffline: _vm.isOffline,
                searchTerm: _vm.questionText
              },
              on: {
                showError: _vm.onShowError,
                itemClick: _vm.onInstantAnswerClick
              }
            },
            [
              _c(
                "div",
                { staticClass: "tt-c-instant-answers__submit-wrap" },
                [
                  _c("span", {
                    staticClass:
                      "tt-c-instant-answers__results-prompt tt-u-hide-until--md",
                    domProps: { innerHTML: _vm._s(_vm.resultsPromptText) }
                  }),
                  _vm._v(" "),
                  _c(
                    "tt-button",
                    {
                      staticClass: "tt-c-instant-answers__submit-question",
                      attrs: { type: "primary" },
                      on: { click: _vm.enterAskMode }
                    },
                    [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$msg("ia.results.submitNew"))
                        }
                      }),
                      _c("tt-icon", {
                        attrs: { name: "caret-right", size: "sm" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showMultiItems
        ? _c("tt-multi-items", {
            attrs: {
              multiItems: _vm.multiItems,
              promptText: _vm.multiItemsPromptText,
              sku: _vm.globalStore.sku
            },
            on: { addItems: _vm.addMultiItems, removeItem: _vm.removeMultiItem }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.inAskMode
        ? _c(
            "div",
            { staticClass: "tt-c-instant-answers__action-buttons" },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isSubmitting,
                    expression: "isSubmitting"
                  }
                ],
                staticClass: "tt-o-spinner tt-o-spinner--submit"
              }),
              _vm._v(" "),
              !_vm.isSubmitting
                ? _c("tt-button", {
                    ref: "submitBtn",
                    staticClass: "tt-c-instant-answers__submit",
                    attrs: { type: "primary" },
                    domProps: { innerHTML: _vm._s(_vm.$msg("ia.submit")) },
                    on: { click: _vm.submitQuestion }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("tt-button", {
                staticClass: "tt-c-instant-answers__cancel",
                attrs: { type: "secondary", disabled: _vm.isSubmitting },
                domProps: { innerHTML: _vm._s(_vm.$msg("ia.cancel")) },
                on: { click: _vm.cancelAskMode }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("1bad63ab", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("1bad63ab", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-previous-ratings tt-u-spacing--sm" },
    [
      _c("div", {
        staticClass: "tt-c-previous-ratings__heading",
        domProps: {
          innerHTML: _vm._s(
            _vm.$msg("review.previousRatings", [], _vm.previousRatings.length)
          )
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.previousRatings, function(previous) {
        return _c(
          "div",
          { staticClass: "tt-c-previous-ratings__wrap" },
          [
            _c("tt-rating-stars", {
              staticClass: "tt-c-previous-ratings__rating",
              attrs: { rating: previous.rating, size: "sm" }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "tt-c-previous-ratings__date" }, [
              _vm._v(_vm._s(previous.updateDateFormatted))
            ])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("266b6334", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("266b6334", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c(
        "div",
        { staticClass: "tt-o-byline tt-u-spacing--left--xs" },
        [
          _vm.item.user
            ? _c(
                "span",
                { staticClass: "tt-o-byline__item tt-o-byline__author" },
                [_vm._v(_vm._s(_vm._f("formatName")(_vm.item.user)))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.badges, function(badge) {
            return _c("tt-badge", {
              key: badge.type,
              attrs: { type: badge.type },
              domProps: { innerHTML: _vm._s(badge.label) }
            })
          }),
          _vm._v(" "),
          _vm.dateCreatedFormatted
            ? _c(
                "time",
                {
                  staticClass: "tt-o-byline__item tt-o-byline__on-date",
                  attrs: { datetime: _vm.dateTime }
                },
                [_vm._v(_vm._s(_vm.dateCreatedFormatted))]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("33ff410d", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("33ff410d", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tt-c-dimension tt-u-mb--xl",
      class: ["tt-c-dimension--" + _vm.type]
    },
    [
      _c(
        "div",
        { staticClass: "tt-c-dimension__heading tt-u-mb--sm" },
        [
          _c(
            "span",
            { staticClass: "tt-c-dimension__label" },
            [
              _vm._v(_vm._s(_vm.label)),
              _vm.valueLabel || _vm.isSelectImage ? [_vm._v(":")] : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.valueLabel
            ? _c("span", { staticClass: "tt-c-dimension__value-label" }, [
                _vm._v(_vm._s(_vm.valueLabel))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.imageUrls, function(url) {
            return _c("img", {
              staticClass: "tt-c-dimension__image",
              attrs: { src: url }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.isRating || _vm.isRange
        ? _c(
            "div",
            {
              staticClass: "tt-c-dimension__bar-wrap",
              class: [
                "tt-c-dimension__bar-wrap--" +
                  (_vm.isRange ? "range" : "rating")
              ]
            },
            [
              _c("div", { staticClass: "tt-c-dimension__bar" }, [
                _vm.isRating
                  ? _c("span", {
                      staticClass: "tt-c-dimension__progress",
                      style: { width: _vm.valuePercentage }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isRange
                  ? _c("span", {
                      ref: "dot",
                      staticClass: "tt-c-dimension__dot",
                      style: { left: _vm.valuePercentage }
                    })
                  : _vm._e()
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("63f8eeb4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("63f8eeb4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-review-responses tt-u-mb--lg" },
    _vm._l(_vm.responsesBySource, function(sourceResponses) {
      return _c(
        "div",
        { staticClass: "tt-c-review-responses__source-wrap tt-u-mb--lg" },
        [
          _c("div", {
            staticClass: "tt-c-review-responses__source tt-u-mb--sm",
            domProps: {
              innerHTML: _vm._s(
                _vm.$msg("review.response.from", [sourceResponses.source])
              )
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tt-c-review-responses__responses tt-u-mb--md" },
            _vm._l(sourceResponses.responses, function(response) {
              return _c(
                "div",
                { staticClass: "tt-c-review-responses__item tt-u-mb--lg" },
                [
                  _c("div", {
                    staticClass: "tt-c-review-responses__text tt-u-mb--md",
                    domProps: { innerHTML: _vm._s(response.text) }
                  }),
                  _vm._v(" "),
                  _c("tt-review-byline", {
                    staticClass: "tt-c-review-responses__byline",
                    attrs: { item: response, ugcType: "rr" }
                  })
                ],
                1
              )
            })
          )
        ]
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3d420e09", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3d420e09", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tt-c-review-toolbar" }, [
    _c(
      "div",
      {
        staticClass: "tt-c-review-toolbar__content--left tt-u-spacing--left--md"
      },
      [
        _c("span", {
          staticClass: "tt-c-review-toolbar__text",
          domProps: { innerHTML: _vm._s(_vm.$msg("review.wasHelpful")) }
        }),
        _vm._v(" "),
        _c(
          "tt-button",
          {
            staticClass: "tt-c-review-toolbar__vote",
            attrs: {
              type: "toolbar",
              disabled: _vm.voteBeingProcessed,
              "aria-label": _vm.$msg(
                "review.voteUp",
                [_vm.username, _vm.upVoteCount],
                _vm.upVoteCount
              ),
              "aria-pressed": _vm.wasUpVoted.toString()
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.upVote($event)
              }
            }
          },
          [
            _c("tt-icon", {
              staticClass: "tt-c-review-toolbar__icon",
              attrs: { name: _vm.upVoteIconName, size: "sm" }
            }),
            _c("span", { staticClass: "tt-c-review-toolbar__likes-number" }, [
              _vm._v(_vm._s(_vm.upVoteCount))
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "tt-button",
          {
            staticClass: "tt-c-review-toolbar__vote",
            attrs: {
              type: "toolbar",
              disabled: _vm.voteBeingProcessed,
              "aria-label": _vm.$msg(
                "review.voteDown",
                [_vm.username, _vm.downVoteCount],
                _vm.downVoteCount
              ),
              "aria-pressed": _vm.wasDownVoted.toString()
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.downVote($event)
              }
            }
          },
          [
            _c("tt-icon", {
              staticClass: "tt-c-review-toolbar__icon",
              attrs: {
                name: _vm.downVoteIconName,
                "aria-hidden": true,
                size: "sm"
              }
            }),
            _c(
              "span",
              { staticClass: "tt-c-review-toolbar__dislikes-number" },
              [_vm._v(_vm._s(_vm.downVoteCount))]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tt-c-review-toolbar__content--right" }, [
      _c(
        "div",
        { staticClass: "tt-c-review-toolbar__actions tt-u-spacing--left--lg" },
        [
          _c(
            "tt-button",
            {
              staticClass:
                "tt-c-review-toolbar__action tt-c-review-toolbar__action--flag",
              attrs: {
                type: "toolbar",
                disabledClassOnly: _vm.wasFlagged,
                "aria-disabled": _vm.wasFlagged,
                "aria-label": _vm.flagAriaLabel
              },
              on: { click: _vm.flag }
            },
            [
              _c("tt-icon", { attrs: { name: _vm.flagIconName } }),
              _c("span", { domProps: { innerHTML: _vm._s(_vm.flagText) } })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isModerator
            ? _c(
                "a",
                {
                  staticClass:
                    "tt-c-review-toolbar__action tt-c-review-toolbar__action--moderate",
                  attrs: {
                    href: _vm.moderationUrl,
                    target: "_blank",
                    rel: "nofollow"
                  }
                },
                [
                  _c("tt-icon", { attrs: { name: "moderate" } }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$msg("mediaModal.moderate"))
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "tt-menu",
            { staticClass: "tt-c-review-toolbar__menu" },
            [
              _c(
                "tt-button",
                {
                  ref: "menuTrigger",
                  staticClass: "tt-c-review-toolbar__menu-trigger",
                  attrs: { slot: "menuTrigger", type: "icon" },
                  slot: "menuTrigger"
                },
                [
                  _c("tt-icon", {
                    attrs: {
                      name: "more-h",
                      size: "sm",
                      title: _vm.$msg("review.optionsMenu")
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("tt-menu-list", {
                attrs: { alignMenu: "right", menuItems: _vm.menuItems },
                on: { menuItemSelected: _vm.menuItemSelected }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("02f5b100", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("02f5b100", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-review" },
    [
      _c(
        "tt-grid-layout",
        {
          staticClass: "tt-c-review__content",
          attrs: { layout: _vm.currentLayout, classPrefix: "tt-c-review" }
        },
        [
          _vm.isRelatedReview && !_vm.isSlotHidden("relatedProduct")
            ? _c("tt-product-about", {
                staticClass: "tt-c-review__product tt-u-mb--md",
                attrs: { slot: "relatedProduct", catItem: _vm.review.catItem },
                slot: "relatedProduct"
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSlotHidden("stars")
            ? _c("tt-rating-stars", {
                staticClass: "tt-c-review__rating tt-u-mb--sm",
                attrs: {
                  slot: "stars",
                  rating: _vm.review.rating,
                  starSize: "lg"
                },
                slot: "stars"
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSlotHidden("reviewDate")
            ? _c(
                "div",
                {
                  staticClass: "tt-c-review__date tt-u-mb--sm",
                  attrs: { slot: "reviewDate" },
                  slot: "reviewDate"
                },
                [_vm._v(_vm._s(_vm.reviewDate))]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSlotHidden("reviewTitle") && _vm.review.title
            ? _c(
                "div",
                {
                  staticClass: "tt-c-review__heading tt-u-mb--sm",
                  attrs: { slot: "reviewTitle" },
                  slot: "reviewTitle"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "tt-c-review__heading-text",
                      domProps: { innerHTML: _vm._s(_vm.title) }
                    },
                    [
                      _vm.hasUpdates
                        ? _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$msg("review.updated"))
                            }
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.productAttributes && !_vm.isSlotHidden("productAttributes")
            ? _c(
                "div",
                {
                  staticClass: "tt-c-review__product-attributes tt-u-mb--md",
                  attrs: { slot: "productAttributes" },
                  slot: "productAttributes"
                },
                [_vm._v(_vm._s(_vm.productAttributes))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.recommendText && !_vm.isSlotHidden("recommend")
            ? _c(
                "div",
                {
                  staticClass: "tt-c-review__recommend tt-u-mb--md",
                  attrs: { slot: "recommend" },
                  slot: "recommend"
                },
                [
                  _c("tt-icon", {
                    attrs: { name: _vm.recommendIcon, size: "xs" }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "tt-c-review__recommend-text",
                    domProps: { innerHTML: _vm._s(_vm.recommendText) }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSlotHidden("updateReview")
            ? _c("div", {
                staticClass: "tt-c-review__update",
                attrs: { slot: "updateReview" },
                domProps: { innerHTML: _vm._s(_vm.updateReviewText) },
                slot: "updateReview"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.previousRatings.length > 0 && !_vm.isSlotHidden("previousRatings")
            ? _c("tt-previous-ratings", {
                attrs: {
                  slot: "previousRatings",
                  previousRatings: _vm.previousRatings
                },
                slot: "previousRatings"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.review.media &&
          _vm.review.media.length > 0 &&
          !_vm.isSlotHidden("media")
            ? _c(
                "div",
                {
                  staticClass: "tt-c-review__media tt-u-mb--md",
                  attrs: { slot: "media" },
                  slot: "media"
                },
                _vm._l(_vm.review.media, function(mediaItem, index) {
                  return _c(
                    "a",
                    {
                      key: mediaItem.id,
                      staticClass: "tt-c-review__media-link",
                      attrs: {
                        href: "",
                        title: _vm.mediaLinkTitle(mediaItem),
                        "aria-haspopup": "true",
                        rel: "nofollow"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.openMediaModal(index)
                        }
                      }
                    },
                    [
                      _c("tt-media-thumb", {
                        staticClass: "tt-c-review__media-item",
                        attrs: {
                          altText: _vm.$msg("media.submittedBy", [
                            _vm.$options.filters.formatName(mediaItem.user)
                          ]),
                          media: mediaItem,
                          size: _vm.mediaSize
                        }
                      })
                    ],
                    1
                  )
                })
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSlotHidden("reviewText")
            ? _c(
                "div",
                {
                  staticClass: "tt-c-review__text",
                  attrs: { slot: "reviewText" },
                  slot: "reviewText"
                },
                _vm._l(_vm.reviewTexts, function(update, i) {
                  return _c("div", { staticClass: "tt-c-review__text-wrap" }, [
                    _vm.reviewTexts.length > 1
                      ? _c(
                          "div",
                          {
                            staticClass: "tt-c-review__text-header tt-u-mb--sm"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "tt-c-review__text-type" },
                              [
                                _c("span", {
                                  staticClass: "tt-c-review__text-type-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$msg(
                                        i === 0
                                          ? "review.original"
                                          : "review.textUpdate"
                                      )
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "tt-c-review__text-date" },
                              [_vm._v(_vm._s(update.updateDateFormatted))]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "tt-c-review__text-content-wrapper tt-u-mb--md"
                      },
                      [
                        _c("span", {
                          staticClass: "tt-c-review__text-content",
                          domProps: { innerHTML: _vm._s(update.text) }
                        }),
                        update.isTruncated ? [_vm._v("…")] : _vm._e(),
                        _vm._v(" "),
                        update.isTruncated
                          ? _c("tt-button", {
                              staticClass: "tt-c-review__text-expand",
                              attrs: { type: "link" },
                              domProps: {
                                innerHTML: _vm._s(_vm.$msg("review.readMore"))
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.expandText(i)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                })
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSlotHidden("byline")
            ? _c("tt-review-byline", {
                staticClass: "tt-c-review__byline tt-u-mb--lg",
                attrs: {
                  slot: "byline",
                  item: _vm.review,
                  showPurchaserBadge: _vm.showPurchaserBadge,
                  ugcType: "r"
                },
                slot: "byline"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.profileAttributes &&
          _vm.profileAttributes.length > 0 &&
          !_vm.isSlotHidden("profileAttributes")
            ? _c(
                "div",
                {
                  staticClass:
                    "tt-c-review__profile-attributes tt-c-profile-attributes tt-u-mb--lg",
                  class: {
                    "tt-c-profile-attributes--stacked":
                      _vm.areProfileAttributesStacked
                  },
                  attrs: { slot: "profileAttributes" },
                  slot: "profileAttributes"
                },
                _vm._l(_vm.profileAttributes, function(attribute) {
                  return _c(
                    "div",
                    { staticClass: "tt-c-profile-attributes__item" },
                    [
                      _c("div", {
                        staticClass:
                          "tt-c-profile-attributes__property tt-u-mb--xs",
                        domProps: { innerHTML: _vm._s(attribute.label) }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tt-c-profile-attributes__value" },
                        [_vm._v(_vm._s(attribute.value))]
                      )
                    ]
                  )
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.review.responsesBySource.length > 0 &&
          !_vm.isSlotHidden("reviewResponses")
            ? _c("tt-review-responses", {
                attrs: {
                  slot: "reviewResponses",
                  responsesBySource: _vm.review.responsesBySource
                },
                slot: "reviewResponses"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.review.dimensions, function(dim, i) {
            return !_vm.isSlotHidden("customDim-" + (i + 1))
              ? _c("tt-dimension", {
                  key: dim.label,
                  attrs: {
                    slot: "customDim-" + (i + 1),
                    type: dim.type,
                    label: dim.dimensionLabel,
                    value: dim.value,
                    valueLabels: dim.valueLabels
                  },
                  slot: "customDim-" + (i + 1)
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.review.purchaseDateFormatted && !_vm.isSlotHidden("purchasedOn")
            ? _c("div", {
                staticClass: "tt-c-review__purchased tt-u-mb--sm",
                attrs: { slot: "purchasedOn" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$msg("review.purchasedOn", [
                      _vm.review.purchaseDateFormatted
                    ])
                  )
                },
                slot: "purchasedOn"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.syndicationAttribution && !_vm.isSlotHidden("syndication")
            ? _c("div", {
                staticClass: "tt-c-review__syndication tt-u-mb--xl",
                attrs: { slot: "syndication" },
                domProps: { innerHTML: _vm._s(_vm.syndicationAttribution) },
                slot: "syndication"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.review.incentivized && !_vm.isSlotHidden("incentivized")
            ? _c("div", {
                staticClass: "tt-c-review__incentivized tt-u-mb--sm",
                attrs: { slot: "incentivized" },
                domProps: {
                  innerHTML: _vm._s(_vm.$msg("review.incentivized"))
                },
                slot: "incentivized"
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isSlotHidden("toolbar")
            ? _c("tt-review-toolbar", {
                staticClass: "tt-u-mb--xs",
                attrs: {
                  slot: "toolbar",
                  review: _vm.review,
                  downVotes: _vm.review.downVotes,
                  upVotes: _vm.review.upVotes
                },
                slot: "toolbar"
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayShowDetails
            ? _c(
                "div",
                {
                  staticClass:
                    "tt-c-review__expander tt-o-expander tt-o-expander--with-dashed-border",
                  attrs: { slot: "showDetails" },
                  slot: "showDetails"
                },
                [
                  _c(
                    "tt-button",
                    {
                      staticClass: "tt-o-expander__button",
                      attrs: { type: "toolbar" },
                      on: { click: _vm.onShowDetailsClick }
                    },
                    [
                      _c("tt-icon", {
                        staticClass: "tt-c-reviews-summary__expander-icon",
                        attrs: { name: "options-expand", size: "sm" }
                      }),
                      _c("span", {
                        staticClass: "tt-o-expander__text",
                        domProps: {
                          innerHTML: _vm._s(_vm.$msg("review.showDetails"))
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("0c9ff024", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("0c9ff024", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["loadWidget"] = loadWidget;
/* harmony export (immutable) */ __webpack_exports__["getInstance"] = getInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_loader_helper__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_command_queue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__qa_config__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__qa__ = __webpack_require__(206);




var root;
var type = 'qa';
function initialize() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_util_loader_helper__["a" /* createAndMountInstance */])(root, __WEBPACK_IMPORTED_MODULE_3__qa__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__qa_config__["b" /* default */].widgetDivId)
        .then(function (instance) { return root = instance; });
}
function loadWidget(widgetConfig) {
    return new Promise(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_2__qa_config__["c" /* loadConfig */])(widgetConfig);
        // no commands for qa yet
        __WEBPACK_IMPORTED_MODULE_1_init_command_queue__["b" /* widgetLibraries */].qa = {};
        initialize().then(function () { return resolve(); });
    });
}
function getInstance() {
    return root;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/services/api-service.ts
var api_service = __webpack_require__(8);

// EXTERNAL MODULE: ./src/util/turnto-utils.ts
var turnto_utils = __webpack_require__(11);

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(4);

// EXTERNAL MODULE: ./src/init/global.config.ts
var global_config = __webpack_require__(6);

// EXTERNAL MODULE: ./src/components/comment/comment.ts + 2 modules
var comment = __webpack_require__(118);

// EXTERNAL MODULE: ./src/widgets/qa/qa.config.ts
var qa_config = __webpack_require__(23);

// EXTERNAL MODULE: ./src/components/question/comments-question.html
var comments_question = __webpack_require__(207);
var comments_question_default = /*#__PURE__*/__webpack_require__.n(comments_question);

// EXTERNAL MODULE: ./src/components/question/question.scss
var question = __webpack_require__(71);
var question_default = /*#__PURE__*/__webpack_require__.n(question);

// CONCATENATED MODULE: ./src/components/question/comments-question.ts









/*
 * As of initial v5 development, all the qaConfig.comments settings are actually
 * not configurable by users, though we have coded this to get values from the
 * qaConfig object. V4 did not have any of these configurable and in fact was not
 * truncating comments but because of the way Comment is used in this and others
 * we thought it better to let it do so in v5.
 */
/* harmony default export */ var question_comments_question = (comments_question_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            comments: [],
            globalStore: global_store["a" /* default */],
            showComments: false
        };
    },
    components: {
        'tt-qa-comment': comment["a" /* default */]
    },
    computed: {
        currentSku: function () {
            return this.globalStore.sku;
        },
        siteName: function () {
            return global_config["a" /* default */].siteName;
        },
        showActions: function () {
            return this.comments.length > qa_config["b" /* default */].comments.initialPageSize;
        },
        showExpand: function () {
            return this.comments.length > qa_config["b" /* default */].comments.initialPageSize && !this.showComments;
        },
        showHide: function () {
            return this.comments.length > 1 && this.showComments;
        },
        commentsForDisplay: function () {
            if (!this.showComments) {
                return this.comments.slice(0, qa_config["b" /* default */].comments.initialPageSize);
            }
            return this.comments;
        },
        truncateLength: function () {
            return qa_config["b" /* default */].comments.truncateLength;
        },
        truncateAllowance: function () {
            return qa_config["b" /* default */].comments.truncateAllowance;
        }
    },
    methods: {
        expandComments: function () {
            this.showComments = true;
            dom_utils["a" /* default */].safeFocusRef(this.$refs, 'hideComments');
        },
        hideComments: function () {
            this.showComments = false;
            dom_utils["a" /* default */].safeFocusRef(this.$refs, 'expandComments');
        },
        fetchData: function () {
            var _this = this;
            if (this.currentSku) {
                api_service["a" /* default */].chatterComments({
                    sku: this.currentSku,
                    offset: 0,
                    limit: qa_config["b" /* default */].comments.limit,
                    sort: qa_config["b" /* default */].comments.sortOrder,
                    minCharCount: 0,
                    minWordCount: 0,
                    includeSyndicated: qa_config["b" /* default */].comments.includeSyndicated,
                    includeRelated: qa_config["b" /* default */].relatedQuestionsDisplay === qa_config["a" /* RelatedQuestionsDisplayTypes */].INCLUDED
                }).then(function (data) {
                    _this.comments = data.comments;
                    _this.$emit('commentsLoaded', (_this.comments.length > 0 ? true : false));
                }).catch(function () {
                    _this.$emit('commentsLoaded', false);
                });
            }
        }
    },
    created: function () {
        this.fetchData();
    },
    watch: {
        currentSku: function () {
            this.fetchData();
        }
    }
})));

// EXTERNAL MODULE: ./src/objects/menu/menu.ts
var menu = __webpack_require__(24);

// EXTERNAL MODULE: ./src/util/logger.ts
var logger = __webpack_require__(9);

// EXTERNAL MODULE: ./src/objects/menu/menu-list.ts
var menu_list = __webpack_require__(25);

// EXTERNAL MODULE: ./src/components/question/question.ts + 4 modules
var question_question = __webpack_require__(65);

// EXTERNAL MODULE: ./src/mixins/paginate-mixin.ts
var paginate_mixin = __webpack_require__(33);

// EXTERNAL MODULE: ./src/components/related-questions-list/related-questions-list.html
var related_questions_list = __webpack_require__(208);
var related_questions_list_default = /*#__PURE__*/__webpack_require__.n(related_questions_list);

// EXTERNAL MODULE: ./src/components/related-questions-list/related-questions-list.scss
var related_questions_list_related_questions_list = __webpack_require__(209);
var related_questions_list_related_questions_list_default = /*#__PURE__*/__webpack_require__.n(related_questions_list_related_questions_list);

// CONCATENATED MODULE: ./src/components/related-questions-list/related-questions-list.ts











/* harmony default export */ var components_related_questions_list_related_questions_list = (related_questions_list_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            relatedQuestions: [],
            store: global_store["a" /* default */]
        };
    },
    components: {
        'tt-question': question_question["a" /* default */]
    },
    mixins: [paginate_mixin["a" /* default */]],
    props: {
        submissionCtx: Object
    },
    computed: {
        currentSku: function () {
            return this.store.sku;
        },
        qaConfig: function () {
            return qa_config["b" /* default */];
        }
    },
    methods: {
        fetchData: function (isPageChange) {
            var _this = this;
            if (this.currentSku && (this.offset === 0 || this.offset <= this.total)) {
                var limit = this.offset === 0 ? qa_config["b" /* default */].relatedInitialPageSize : qa_config["b" /* default */].relatedPageSize;
                api_service["a" /* default */].relatedQuestionsList({
                    sku: this.currentSku,
                    offset: this.offset,
                    limit: limit,
                    sort: qa_config["b" /* default */].defaultSortOption
                }).then(function (data) {
                    _this.relatedQuestions = data.relatedQuestions;
                    _this.total = data.total;
                    if (isPageChange) {
                        // not first time, so most likely paginated.  Will only scroll up, not down
                        _this.$nextTick(function () {
                            // TT-11837 - focus header after scroll. safeFocus in case client hides the header
                            var focusFn = function () { return dom_utils["a" /* default */].safeFocus(function () { return _this.$refs.heading; }); };
                            dom_utils["a" /* default */]
                                .scrollUpToRef(_this.$refs, 'relQList', global_config["a" /* default */].additionalPagingScroll)
                                .then(focusFn)
                                .catch(focusFn);
                        });
                    }
                }).catch(function (e) {
                    if (e.errorCode === 'turnto-offline') {
                        logger["a" /* default */].info('TurnTo is in offline mode - related questions not loaded', e);
                    }
                    else {
                        logger["a" /* default */].info('Error loading related question data for the Q&A widget', e);
                    }
                });
            }
        }
    },
    created: function () {
        // initialPageSize and pageSize are in paginateMixin
        this.initialPageSize = qa_config["b" /* default */].relatedInitialPageSize;
        this.pageSize = qa_config["b" /* default */].relatedPageSize;
        this.fetchData();
    },
    watch: {
        currentSku: function () {
            // onQueryChange method in paginateMixin
            this.onQueryChange();
        }
    }
})));

// EXTERNAL MODULE: ./src/objects/pagination/pagination.ts
var pagination = __webpack_require__(63);

// EXTERNAL MODULE: ./src/components/answers/answer-reply-submission-context.ts
var answer_reply_submission_context = __webpack_require__(95);

// EXTERNAL MODULE: ./src/widgets/standalone-popover/standalone-popover-loader.ts
var standalone_popover_loader = __webpack_require__(14);

// EXTERNAL MODULE: ./src/store/submission-store.ts
var submission_store = __webpack_require__(7);

// EXTERNAL MODULE: ./src/widgets/submission/submission-loader.ts
var submission_loader = __webpack_require__(12);

// EXTERNAL MODULE: ./src/components/user-toolbar/user-toolbar.ts
var user_toolbar = __webpack_require__(28);

// EXTERNAL MODULE: ./src/widgets/qa/qa.html
var qa = __webpack_require__(210);
var qa_default = /*#__PURE__*/__webpack_require__.n(qa);

// EXTERNAL MODULE: ./src/widgets/qa/qa.scss
var qa_qa = __webpack_require__(211);
var qa_qa_default = /*#__PURE__*/__webpack_require__.n(qa_qa);

// CONCATENATED MODULE: ./src/widgets/qa/qa.ts





















var MIN_QUESTIONS_FOR_SORT = 3;
/* harmony default export */ var widgets_qa_qa = __webpack_exports__["a"] = (qa_default()(vue_runtime_esm["a" /* default */].extend({
    name: 'QA',
    data: function () {
        return {
            currentPage: 1,
            forType: '',
            offset: 0,
            previousSku: '',
            questions: [],
            sortBy: '',
            store: global_store["a" /* default */],
            submissionCtx: null,
            directQuestionTotal: 0,
            hasOneOrMoreComments: false
        };
    },
    components: {
        'tt-comments-question': question_comments_question,
        'tt-menu': menu["a" /* default */],
        'tt-menu-list': menu_list["a" /* default */],
        'tt-pagination': pagination["a" /* default */],
        'tt-question': question_question["a" /* default */],
        'tt-user-toolbar': user_toolbar["a" /* default */],
        'tt-related-questions-list': components_related_questions_list_related_questions_list
    },
    computed: {
        currentSku: function () {
            return this.store.sku;
        },
        defaultSortOption: function () {
            return qa_config["b" /* default */].defaultSortOption;
        },
        initialPageSize: function () {
            return qa_config["b" /* default */].initialPageSize || qa_config["b" /* default */].pageSize;
        },
        qaConfig: function () {
            return qa_config["b" /* default */];
        },
        showSort: function () {
            return this.questions.length >= MIN_QUESTIONS_FOR_SORT;
        },
        sortByTitle: function () {
            return this.$msg("qa.sortBy." + this.sortBy);
        },
        sortOptions: function () {
            var _this = this;
            return qa_config["b" /* default */].sortOptions.map(function (option) {
                return { name: option, title: _this.$msg("qa.sortBy." + option) };
            });
        },
        total: function () {
            return (this.hasOneOrMoreComments ? 1 : 0) + this.directQuestionTotal;
        },
        showRelatedList: function () {
            return qa_config["b" /* default */].relatedQuestionsDisplay === qa_config["a" /* RelatedQuestionsDisplayTypes */].SEPARATE;
        }
    },
    methods: {
        fetchData: function (isPageChange) {
            var _this = this;
            if (this.currentSku && (this.offset === 0 || this.offset <= this.directQuestionTotal)) {
                var limit = this.offset === 0 ? this.initialPageSize : qa_config["b" /* default */].pageSize;
                var isFirstCall_1 = this.currentSku !== this.previousSku;
                api_service["a" /* default */].questionsList({
                    sku: this.currentSku,
                    offset: this.offset,
                    limit: limit,
                    sort: this.sortBy,
                    includeRelated: qa_config["b" /* default */].relatedQuestionsDisplay === qa_config["a" /* RelatedQuestionsDisplayTypes */].INCLUDED
                }).then(function (data) {
                    _this.previousSku = _this.currentSku;
                    global_store["a" /* default */].catItemId = data.catalogItemId;
                    global_store["a" /* default */].parentCategoryIds = data.parentCategoryIds;
                    global_store["a" /* default */].brand = data.brand;
                    _this.questions = data.questions;
                    _this.directQuestionTotal = data.total;
                    if (isPageChange) {
                        // not first time, so may have paginated.  Will only scroll up, not down
                        _this.$nextTick(function () {
                            // TT-11837 - focus header after scroll. safeFocus in case client hides the header
                            var focusFn = function () { return dom_utils["a" /* default */].safeFocus(function () { return _this.$refs.total; }); };
                            dom_utils["a" /* default */]
                                .scrollUpToRef(_this.$refs, 'qList', global_config["a" /* default */].additionalPagingScroll)
                                .then(focusFn)
                                .catch(focusFn);
                        });
                    }
                    if (isFirstCall_1) {
                        _this.$nextTick(function () { Object(turnto_utils["c" /* callTurnToConfigFn */])('qa', 'onFinish'); });
                    }
                }).catch(function (e) {
                    if (e.errorCode === 'turnto-offline') {
                        logger["a" /* default */].info('TurnTo is in offline mode - Q&A widget not loaded', e);
                    }
                    else {
                        logger["a" /* default */].error('Error loading data for the Q&A widget', e);
                    }
                });
            }
        },
        onShowError: function (providedMessage) {
            var message = providedMessage || this.$msg('flowError.2000');
            standalone_popover_loader["a" /* default */].load({ message: message, type: 'error', autoClose: true });
        },
        openRegistration: function (registrationInfo) {
            // tslint:disable-next-line
            __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 410)).then(function (registrationModalLoader) {
                registrationModalLoader.default.load({
                    stagedContentToken: registrationInfo.stagedContentToken,
                    registerFor: registrationInfo.registerFor
                });
            });
        },
        pageChange: function (pageNum) {
            if (pageNum === 1) {
                this.offset = 0;
            }
            else {
                this.offset = this.initialPageSize + ((pageNum - 2) * qa_config["b" /* default */].pageSize);
            }
            this.currentPage = pageNum;
            this.fetchData(true);
        },
        setSortOrder: function (sortBy) {
            this.offset = 0;
            this.currentPage = 1;
            this.sortBy = sortBy;
            this.fetchData();
        },
        sortOrderSelected: function (sort) {
            this.setSortOrder(sort.name);
        },
        commentsLoaded: function (hasOneOrMoreComments) {
            this.hasOneOrMoreComments = hasOneOrMoreComments;
        }
    },
    watch: {
        //  whenever the currentSku changes, we need to reload the questions
        currentSku: function () {
            this.setSortOrder(this.defaultSortOption);
        }
    },
    created: function () {
        this.setSortOrder(this.defaultSortOption);
        var submissionCtx = new answer_reply_submission_context["a" /* SubmissionContext */]();
        submissionCtx.eventBus.$on('confirmedSubmitComplete', function (info) {
            submission_store["b" /* default */].startFlowWithCatItem(info.catItem, info.siteKey, {
                page: 'do-more',
                props: { msgType: info.ugcType, questionId: info.questionId }
            });
            submission_loader["a" /* default */].load();
        });
        submissionCtx.eventBus.$on('showRegistration', this.openRegistration);
        submissionCtx.eventBus.$on('showError', this.onShowError);
        this.submissionCtx = submissionCtx;
    }
})));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.comments.length > 0
    ? _c("div", { staticClass: "tt-c-question__comments" }, [
        _c("div", { staticClass: "tt-c-question" }, [
          _c(
            "div",
            { staticClass: "tt-c-question__icon-col" },
            [
              _c("tt-icon", {
                staticClass: "tt-c-question__icon",
                attrs: { name: "question", size: "md" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tt-c-question__body tt-u-spacing--md" }, [
            _c("div", {
              staticClass: "tt-c-question__title",
              domProps: {
                innerHTML: _vm._s(_vm.$msg("commentsQuestion.whyDidYouChoose"))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "tt-c-question__byline tt-u-no-space" }, [
              _c("span", { staticClass: "tt-c-question__byline-name" }, [
                _vm._v(_vm._s(_vm.siteName) + " ")
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "tt-c-question__badge tt-o-badge",
                domProps: {
                  innerHTML: _vm._s(_vm.$msg("commentsQuestion.storeBadge"))
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tt-c-question__answers" }, [
          _c(
            "div",
            { staticClass: "tt-c-question__comment-list" },
            _vm._l(_vm.commentsForDisplay, function(comment, index) {
              return _c("tt-qa-comment", {
                key: comment.id,
                staticClass: "tt-c-question__comment",
                attrs: {
                  comment: comment,
                  metaType: "fd",
                  truncateLength: _vm.truncateLength,
                  truncateAllowance: _vm.truncateAllowance,
                  order: index
                }
              })
            })
          ),
          _vm._v(" "),
          _vm.showActions
            ? _c(
                "div",
                { staticClass: "tt-c-question__actions" },
                [
                  _c(
                    "tt-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showExpand,
                          expression: "showExpand"
                        }
                      ],
                      ref: "expandComments",
                      staticClass: "tt-c-question__actions-show",
                      attrs: { type: "toolbar", "aria-expanded": "false" },
                      on: { click: _vm.expandComments }
                    },
                    [
                      _c("tt-icon", {
                        attrs: { name: "options-expand", size: "sm" }
                      }),
                      _c("span", {
                        staticClass: "tt-o-expander__text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$msg("commentsQuestion.showComments", [
                              _vm.comments.length
                            ])
                          )
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "tt-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showHide,
                          expression: "showHide"
                        }
                      ],
                      ref: "hideComments",
                      staticClass: "tt-c-question__actions-hide",
                      attrs: { type: "toolbar", "aria-expanded": "true" },
                      on: { click: _vm.hideComments }
                    },
                    [
                      _c("tt-icon", {
                        attrs: { name: "options-collapse", size: "sm" }
                      }),
                      _c("span", {
                        staticClass: "tt-o-expander__text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$msg("commentsQuestion.hideComments")
                          )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("ddf02082", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("ddf02082", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.total > 0
    ? _c(
        "div",
        { ref: "relQList", staticClass: "tt-c-related-questions-list" },
        [
          _c(
            "div",
            { staticClass: "tt-c-related-questions-list__header tt-u-mb--md" },
            [
              _c("div", {
                ref: "heading",
                staticClass: "tt-c-related-questions-list__heading",
                attrs: { tabindex: "-1" },
                domProps: {
                  innerHTML: _vm._s(_vm.$msg("relatedQuestions.title"))
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tt-c-related-questions-list__content" },
            _vm._l(_vm.relatedQuestions, function(item) {
              return _c("tt-question", {
                key: item.relatedQuestion.id,
                attrs: {
                  isRelated: true,
                  question: item.relatedQuestion,
                  submissionCtx: _vm.submissionCtx,
                  showBestAnswer: false
                }
              })
            })
          ),
          _vm._v(" "),
          _c("tt-pagination", {
            attrs: {
              currentPage: _vm.currentPage,
              total: _vm.total,
              initialPageSize: _vm.initialPageSize,
              pageSize: _vm.pageSize
            },
            on: { updatePage: _vm.pageChange }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("4987c2ee", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("4987c2ee", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "qList", staticClass: "tt-c-questions" },
    [
      _vm.qaConfig.displayUserToolbar ? _c("tt-user-toolbar") : _vm._e(),
      _vm._v(" "),
      _vm.total > 0
        ? _c("div", { staticClass: "tt-c-questions__toolbar tt-c-toolbar" }, [
            _c(
              "div",
              { staticClass: "tt-c-toolbar__content-left" },
              [
                _c("span", {
                  ref: "total",
                  staticClass: "tt-c-questions__total",
                  attrs: { tabindex: "-1" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$msg("qa.questionCount", [_vm.total], _vm.total)
                    )
                  }
                }),
                _vm._v(" "),
                _vm.showSort
                  ? _c(
                      "tt-menu",
                      { ref: "sortByMenu" },
                      [
                        _c(
                          "tt-button",
                          {
                            ref: "menuTrigger",
                            staticClass: "tt-c-questions__sort",
                            attrs: {
                              slot: "menuTrigger",
                              type: "toolbar",
                              "aria-label": _vm.$msg("qa.sortQuestions")
                            },
                            slot: "menuTrigger"
                          },
                          [
                            _c("span", {
                              staticClass: "tt-c-questions__sort-text",
                              domProps: { innerHTML: _vm._s(_vm.sortByTitle) }
                            }),
                            _vm._v(" "),
                            _c("tt-icon", {
                              attrs: { size: "xxs", name: "arrow-fill" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("tt-menu-list", {
                          ref: "sortByMenuList",
                          attrs: {
                            menuItems: _vm.sortOptions,
                            type: "dropdown"
                          },
                          on: { menuItemSelected: _vm.sortOrderSelected }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-questions__list" },
        [
          _vm.qaConfig.showCheckoutChatterOnQAWidget
            ? _c("tt-comments-question", {
                on: { commentsLoaded: _vm.commentsLoaded }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.questions, function(question) {
            return _c("tt-question", {
              key: question.id,
              attrs: {
                isRelated: question.catItem.sku !== _vm.currentSku,
                question: question,
                submissionCtx: _vm.submissionCtx,
                showBestAnswer: !_vm.qaConfig.hideBestAnswer
              },
              on: { showError: _vm.onShowError }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("tt-pagination", {
        attrs: {
          currentPage: _vm.currentPage,
          total: _vm.directQuestionTotal,
          initialPageSize: _vm.qaConfig.initialPageSize,
          pageSize: _vm.qaConfig.pageSize
        },
        on: { updatePage: _vm.pageChange }
      }),
      _vm._v(" "),
      _vm.showRelatedList
        ? _c("tt-related-questions-list", {
            attrs: { submissionCtx: _vm.submissionCtx }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("579b23ff", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("579b23ff", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["loadWidget"] = loadWidget;
/* harmony export (immutable) */ __webpack_exports__["getInstance"] = getInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_loader_helper__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reviews_summary_commands__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reviews_summary_config__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reviews_summary__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_init_command_queue__ = __webpack_require__(17);





var root;
var type = 'reviews-summary';
function initialize() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_util_loader_helper__["a" /* createAndMountInstance */])(root, __WEBPACK_IMPORTED_MODULE_3__reviews_summary__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__reviews_summary_config__["a" /* default */].widgetDivId)
        .then(function (instance) { return root = instance; });
}
function loadWidget(widgetConfig) {
    return new Promise(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_2__reviews_summary_config__["b" /* loadConfig */])(widgetConfig);
        __WEBPACK_IMPORTED_MODULE_4_init_command_queue__["b" /* widgetLibraries */].reviewsSummary = __WEBPACK_IMPORTED_MODULE_1__reviews_summary_commands__;
        initialize().then(function () { return resolve(); });
    });
}
function getInstance() {
    return root;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["schemaOrgEntityType"] = schemaOrgEntityType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_store_reviews_summary_store__ = __webpack_require__(76);

function schemaOrgEntityType(schemaOrgEntityType) {
    if (schemaOrgEntityType) {
        __WEBPACK_IMPORTED_MODULE_0_store_reviews_summary_store__["a" /* default */].schemaOrgEntityType = schemaOrgEntityType;
    }
}


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/promiscuous/promiscuous.js
var promiscuous = __webpack_require__(2);
var promiscuous_default = /*#__PURE__*/__webpack_require__.n(promiscuous);

// EXTERNAL MODULE: ./src/services/api-service.ts
var api_service = __webpack_require__(8);

// EXTERNAL MODULE: ./src/util/ts-utils.ts
var ts_utils = __webpack_require__(10);

// EXTERNAL MODULE: ./src/util/turnto-utils.ts
var turnto_utils = __webpack_require__(11);

// EXTERNAL MODULE: ./src/services/http-client.ts
var http_client = __webpack_require__(26);

// EXTERNAL MODULE: ./src/init/config.ts
var config = __webpack_require__(3);

// EXTERNAL MODULE: ./src/init/global.config.ts
var global_config = __webpack_require__(6);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(4);

// EXTERNAL MODULE: ./src/layouts/grid/grid-layout-data-mixin.ts
var grid_layout_data_mixin = __webpack_require__(38);

// EXTERNAL MODULE: ./src/util/browser-utils.ts
var browser_utils = __webpack_require__(16);

// EXTERNAL MODULE: ./src/util/logger.ts
var logger = __webpack_require__(9);

// EXTERNAL MODULE: ./src/services/media-service.ts
var media_service = __webpack_require__(119);

// EXTERNAL MODULE: ./src/widgets/reviews-summary/reviews-summary.config.ts
var reviews_summary_config = __webpack_require__(77);

// EXTERNAL MODULE: ./src/store/reviews-summary-store.ts
var reviews_summary_store = __webpack_require__(76);

// EXTERNAL MODULE: ./src/widgets/submission/submission-loader.ts
var submission_loader = __webpack_require__(12);

// EXTERNAL MODULE: ./src/store/submission-store.ts
var submission_store = __webpack_require__(7);

// EXTERNAL MODULE: ./src/services/sso-service.ts
var sso_service = __webpack_require__(13);

// EXTERNAL MODULE: ./src/components/rating/actionable-rating-stars.ts
var actionable_rating_stars = __webpack_require__(93);

// EXTERNAL MODULE: ./src/layouts/grid/grid-layout.ts
var grid_layout = __webpack_require__(75);

// EXTERNAL MODULE: ./src/util/localization-utils.ts
var localization_utils = __webpack_require__(59);

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-rating.html
var summary_dim_rating = __webpack_require__(215);
var summary_dim_rating_default = /*#__PURE__*/__webpack_require__.n(summary_dim_rating);

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim.scss
var summary_dim = __webpack_require__(29);
var summary_dim_default = /*#__PURE__*/__webpack_require__.n(summary_dim);

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-rating.scss
var reviews_summary_summary_dim_rating = __webpack_require__(216);
var reviews_summary_summary_dim_rating_default = /*#__PURE__*/__webpack_require__.n(reviews_summary_summary_dim_rating);

// CONCATENATED MODULE: ./src/components/reviews-summary/summary-dim-rating.ts





/* harmony default export */ var components_reviews_summary_summary_dim_rating = (summary_dim_rating_default()(vue_runtime_esm["a" /* default */].extend({
    props: {
        label: { type: String },
        averageRating: {
            type: Number,
            default: 0.0
        }
    },
    computed: {
        ratingDisplay: function () {
            return this.label + ": " + Object(localization_utils["a" /* localizedNumber */])(this.averageRating) + " / " + Object(localization_utils["a" /* localizedNumber */])(5.0);
        },
        ratingPercentage: function () {
            return (this.averageRating / 5.0 * 100).toFixed(1) + "%";
        }
    }
})));

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-range.html
var summary_dim_range = __webpack_require__(217);
var summary_dim_range_default = /*#__PURE__*/__webpack_require__.n(summary_dim_range);

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-range.scss
var reviews_summary_summary_dim_range = __webpack_require__(218);
var reviews_summary_summary_dim_range_default = /*#__PURE__*/__webpack_require__.n(reviews_summary_summary_dim_range);

// CONCATENATED MODULE: ./src/components/reviews-summary/summary-dim-range.ts






/* harmony default export */ var components_reviews_summary_summary_dim_range = (summary_dim_range_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () { return { dotSize: 0 }; },
    props: {
        label: { type: String },
        averageRating: {
            type: Number,
            default: 0.0
        },
        showMiddleLabel: Boolean,
        values: {
            type: Array,
            default: function () { return []; }
        }
    },
    computed: {
        description: function () {
            return this.$msg('summaryRange.desc', [
                Object(localization_utils["b" /* localizedPercentage */])(this.percentage, 0),
                this.valueLabels[0],
                this.valueLabels[1]
            ]);
        },
        dotPositionPercentage: function () {
            // -1 on the values since it is a zero-based value
            var dotAdjustment = Math.round(this.dotSize * this.percentage);
            return "calc(" + (this.percentage * 100).toFixed(1) + "% - " + dotAdjustment + "px)";
        },
        percentage: function () {
            return this.averageRating / (this.values.length - 1);
        },
        valueLabels: function () {
            var _this = this;
            return this.values.filter(function (def, i) {
                // if first or last label
                if (i === 0 || i === _this.values.length - 1) {
                    return true;
                }
                else if (_this.showMiddleLabel && i === (_this.values.length === 3 ? 1 : 2)) {
                    // middle label is index 1 if there are 3, index 2 if there are 5
                    return true;
                }
                return false;
            }).map(function (def) { return def.label; });
        }
    },
    mounted: function () {
        var _this = this;
        dom_utils["a" /* default */].whenRefIsVisible(this.$refs, 'dot').then(function () {
            _this.dotSize = _this.$refs.dot.offsetWidth;
        }).catch(function () {
            // when initially hidden on page (e.g. under a tab), offsetWidth is 0.  This is a fallback
            // to the px equivalent to the rem(10) it is set to in css
            _this.dotSize = 10;
        });
    }
})));

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-select.html
var summary_dim_select = __webpack_require__(219);
var summary_dim_select_default = /*#__PURE__*/__webpack_require__.n(summary_dim_select);

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-select.scss
var reviews_summary_summary_dim_select = __webpack_require__(220);
var reviews_summary_summary_dim_select_default = /*#__PURE__*/__webpack_require__.n(reviews_summary_summary_dim_select);

// CONCATENATED MODULE: ./src/components/reviews-summary/summary-dim-select.ts




/* harmony default export */ var components_reviews_summary_summary_dim_select = (summary_dim_select_default()(vue_runtime_esm["a" /* default */].extend({
    props: {
        label: { type: String },
        values: {
            type: Array,
            default: function () { return []; }
        }
    },
    computed: {
        valueCounts: function () {
            return this.values.filter(function (item) {
                return item.count > 0;
            }).map(function (item) {
                return item.label + " (" + item.count + ")";
            }).join(', ');
        }
    }
})));

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-select-image.html
var summary_dim_select_image = __webpack_require__(221);
var summary_dim_select_image_default = /*#__PURE__*/__webpack_require__.n(summary_dim_select_image);

// EXTERNAL MODULE: ./src/components/reviews-summary/summary-dim-select-image.scss
var reviews_summary_summary_dim_select_image = __webpack_require__(222);
var reviews_summary_summary_dim_select_image_default = /*#__PURE__*/__webpack_require__.n(reviews_summary_summary_dim_select_image);

// CONCATENATED MODULE: ./src/components/reviews-summary/summary-dim-select-image.ts





/* harmony default export */ var components_reviews_summary_summary_dim_select_image = (summary_dim_select_image_default()(vue_runtime_esm["a" /* default */].extend({
    props: {
        label: { type: String },
        values: {
            type: Array,
            default: function () { return []; }
        }
    },
    methods: {
        imageUrl: function (imageId) {
            // tslint:disable-next-line:max-line-length
            return config["a" /* hostsConfig */].protocol + "://" + config["a" /* hostsConfig */].imageStoreBase + "/custom-dim/" + config["a" /* hostsConfig */].siteKey + "/" + imageId + ".png";
        }
    }
})));

// EXTERNAL MODULE: ./src/store/reviews-store.ts + 1 modules
var reviews_store = __webpack_require__(22);

// EXTERNAL MODULE: ./src/components/reviews-summary/ratings-breakdown.html
var ratings_breakdown = __webpack_require__(223);
var ratings_breakdown_default = /*#__PURE__*/__webpack_require__.n(ratings_breakdown);

// EXTERNAL MODULE: ./src/components/reviews-summary/ratings-breakdown.scss
var reviews_summary_ratings_breakdown = __webpack_require__(224);
var reviews_summary_ratings_breakdown_default = /*#__PURE__*/__webpack_require__.n(reviews_summary_ratings_breakdown);

// CONCATENATED MODULE: ./src/components/reviews-summary/ratings-breakdown.ts





var MIN_REVIEWS_FOR_FILTERING = 3;
/* harmony default export */ var components_reviews_summary_ratings_breakdown = (ratings_breakdown_default()(vue_runtime_esm["a" /* default */].extend({
    props: {
        ratingsBreakdown: {
            type: Array,
            default: function () { return []; }
        }
    },
    computed: {
        breakdownForDisplay: function () {
            var _this = this;
            return this.ratingsBreakdown.sort(function (a, b) { return b.rating - a.rating; })
                .map(function (item) {
                var percentage = (item.num / _this.total);
                // only going to apply a filter if this item has reviews and the overall total is
                // at least 3
                var isFilterable = _this.total >= MIN_REVIEWS_FOR_FILTERING && item.num > 0;
                return {
                    isFilterable: isFilterable,
                    num: item.num,
                    progressWidth: (percentage * 100).toFixed(1) + "%",
                    pctOfRatingsFormatted: item.pctOfRatingsFormatted,
                    rating: item.rating
                };
            });
        },
        total: function () {
            return this.ratingsBreakdown.reduce(function (acc, curr) { return acc + curr.num; }, 0);
        }
    },
    methods: {
        ratingSelected: function (ratingData) {
            if (!ratingData || !ratingData.isFilterable) {
                return;
            }
            // If the reviews list is present, this will apply the star rating to the filter
            var filterStore = reviews_store["a" /* default */].filterStore;
            var ratingsFilter = filterStore.getRatingsFilter();
            reviews_store["a" /* default */].searchTerm = '';
            if (ratingsFilter) {
                filterStore.clearFilters();
                filterStore.setFilterValue(ratingsFilter, [ratingData.rating]);
            }
            this.$nextTick(function () {
                // not great to so tightly couple the class name, but simpler than firing event to focus
                dom_utils["a" /* default */].safeFocus(document.querySelector('.tt-c-reviews-list__heading'));
            });
        }
    }
})));

// EXTERNAL MODULE: ./src/components/rating/rating-stars.ts
var rating_stars = __webpack_require__(34);

// EXTERNAL MODULE: ./src/components/user-toolbar/user-toolbar.ts
var user_toolbar = __webpack_require__(28);

// EXTERNAL MODULE: ./src/widgets/reviews-summary/reviews-summary.html
var reviews_summary = __webpack_require__(225);
var reviews_summary_default = /*#__PURE__*/__webpack_require__.n(reviews_summary);

// EXTERNAL MODULE: ./src/widgets/reviews-summary/reviews-summary.scss
var reviews_summary_reviews_summary = __webpack_require__(226);
var reviews_summary_reviews_summary_default = /*#__PURE__*/__webpack_require__.n(reviews_summary_reviews_summary);

// CONCATENATED MODULE: ./src/widgets/reviews-summary/reviews-summary.ts





























var JSON_LOADER_ID = 'tt-agg-json-ld';
// Needing to explicitly include here because for some reason Webpack is not using the Promise
// provided plugin need for a particular case here.  When the gallery is included as a widget
// on the same page where the gallery is included in the reviews summary, it is using a Promise
// to get the already included gallery component.  In other words, it does not need to be
// dynamically loaded since it is already included in the gallery widget.  This causes a Promise
// to be used in this component.  This is fine for most browsers that have a native Promise, but
// not for IE11 and such.  Part of TT-11452 fix.
// @ts-ignore - for noUnusedLocals
// tslint:disable-next-line:variable-name
var Promise = promiscuous_default.a;
/* harmony default export */ var widgets_reviews_summary_reviews_summary = __webpack_exports__["a"] = (reviews_summary_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            customDimensions: [],
            catItem: null,
            dataIsLoaded: false,
            isGalleryHidden: false,
            globalStore: global_store["a" /* default */],
            rating: 0.0,
            ratingFormatted: '',
            ratingsBreakdown: [],
            recommendedPercentageFormatted: '',
            reviewsCount: 0,
            reviewsSummaryConfig: reviews_summary_config["a" /* default */],
            submissionStore: submission_store["b" /* default */],
            showDetailsClicked: false
        };
    },
    components: {
        'tt-actionable-rating-stars': actionable_rating_stars["a" /* default */],
        'tt-ratings-breakdown': components_reviews_summary_ratings_breakdown,
        'tt-rating-stars': rating_stars["a" /* default */],
        'tt-grid-layout': grid_layout["a" /* default */],
        'tt-summary-custom-rating': components_reviews_summary_summary_dim_rating,
        'tt-summary-custom-range': components_reviews_summary_summary_dim_range,
        'tt-summary-custom-select': components_reviews_summary_summary_dim_select,
        'tt-summary-custom-select-image': components_reviews_summary_summary_dim_select_image,
        // tslint:disable-next-line
        'tt-gallery': function () { return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 434)); },
        // tslint:disable-next-line
        'tt-spectrum': function () { return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 435)); },
        'tt-user-toolbar': user_toolbar["a" /* default */]
    },
    mixins: [grid_layout_data_mixin["a" /* default */]],
    computed: {
        aggregateAttributes: function () {
            if (this.aggregateMetaOn && this.reviewsCount > 0) {
                return {
                    itemprop: 'aggregateRating',
                    itemscope: true,
                    itemtype: 'http://schema.org/AggregateRating'
                };
            }
            return {};
        },
        aggregateMetaOn: function () {
            return this.reviewsSummaryConfig.aggregateMetaOn;
        },
        currentSku: function () {
            return this.globalStore.sku;
        },
        displayShowDetails: function () {
            return !this.showDetailsClicked && ~this.allItemsInLayout.indexOf('showDetails') &&
                this.hasHiddenForDisplay;
        },
        galleryConfig: function () {
            return reviews_summary_config["a" /* default */].childWidgets['gallery'];
        },
        hasGallery: function () {
            return ~this.allItemsInLayout.indexOf('gallery');
        },
        hasSpectrum: function () {
            return ~this.allItemsInLayout.indexOf('spectrum');
        },
        // this determines whether any of the hidden items (after "show details") actually have data
        // for display. For example, customDim-5 should not be included if there are only 4 custom dims.
        // Used to determine whether or not "show details" should even display.
        // Just need to know that at least one of them does.
        hasHiddenForDisplay: function () {
            var _this = this;
            return Object(ts_utils["a" /* arrayFind */])(this.slotNamesAfterShowDetails, function (slotName) {
                if (slotName === 'recommend') {
                    return _this.recommendedPercentageFormatted;
                }
                else if (slotName.indexOf('customDim') === 0) {
                    var dimNum = parseInt(slotName.split('-')[1], 10);
                    return _this.customDimensions.length >= dimNum;
                }
                else if (slotName === 'spectrum') {
                    return _this.reviewsCount > 1; // TODOL is this correct?
                }
                else if (slotName !== 'gallery') {
                    // all other items should have data.  Returning true here to avoid having to make call
                    // to see if gallery has media or not
                    return true;
                }
                else if (slotName === 'gallery') {
                    if (_this.isGalleryHidden) {
                        return true;
                    }
                    // checking to see if there are any images in the gallery to be displayed
                    Object(media_service["b" /* getMediaList */])([_this.currentSku], [], 0, _this.galleryConfig)
                        .then(function (data) { return _this.isGalleryHidden = data.media.length > 0; });
                    // return false now that check has been kicked-off.  isGalleryHidden will change to
                    // true if there actually are images.
                    return false;
                }
            }) ? true : false;
        },
        isLaunchingWriteReview: function () {
            return this.submissionStore.isLaunchingWriteReview;
        },
        spectrumConfig: function () {
            return this.reviewsSummaryConfig.childWidgets['spectrum'];
        }
    },
    methods: {
        fetchData: function () {
            var _this = this;
            if (this.currentSku) {
                api_service["a" /* default */].reviewsSummary({
                    sku: this.currentSku
                }).then(function (data) {
                    if (!data) {
                        return;
                    }
                    _this.catItem = data.catItem;
                    _this.reviewsCount = data.reviewsCount;
                    _this.recommendedPercentageFormatted = data.recommendedPercentageFormatted;
                    _this.rating = data.rating;
                    _this.ratingFormatted = data.ratingFormatted;
                    _this.ratingsBreakdown = data.ratingsBreakdown;
                    _this.customDimensions = data.customDimensions;
                    _this.dataIsLoaded = !data.hideDisplay;
                    _this.$nextTick(function () { Object(turnto_utils["c" /* callTurnToConfigFn */])('reviewsSummary', 'onFinish'); });
                }).catch(function (e) {
                    if (e.errorCode === 'turnto-offline') {
                        logger["a" /* default */].info('TurnTo is in offline mode - Reviews Summary not loaded', e);
                    }
                    else {
                        logger["a" /* default */].error('Error loading data for the Reviews Summary widget', e);
                    }
                });
            }
        },
        isSlotHidden: function (slotName) {
            return !this.showDetailsClicked && ~this.slotNamesAfterShowDetails.indexOf(slotName);
        },
        loadJsonLd: function () {
            if (this.globalStore.sku && !this.aggregateMetaOn
                && reviews_summary_config["a" /* default */].aggregateJsonLdMetaOn) {
                Object(browser_utils["h" /* loadJs */])(http_client["a" /* CDN_URL */] + "/sitedata/" + config["a" /* hostsConfig */].siteKey + "/" + this.globalStore.sku +
                    ("/d/jsonld/" + config["b" /* turnToConfig */].locale + "/" + reviews_summary_store["a" /* default */].schemaOrgEntityType), JSON_LOADER_ID, true, false).then(function () { return document.getElementById(JSON_LOADER_ID).remove(); })
                    .catch(function (e) { return logger["a" /* default */].error('Error loading json-ld', e); });
            }
        },
        onShowDetailsClick: function () {
            this.showDetailsClicked = true;
        },
        writeReview: function (rating) {
            // if sso, this will be set back to false when ssoRegDone or loggedInDataFnDone is called
            submission_store["b" /* default */].isLaunchingWriteReview = true;
            if (global_config["a" /* default */].ssoEnabled) {
                if (global_config["a" /* default */].isPurchaseReq()) {
                    Object(sso_service["g" /* ssoCreateReview */])(this.currentSku, submission_store["a" /* Source */].INLINE, null, rating);
                }
                else {
                    Object(sso_service["i" /* ssoGetLoggedInDataForReview */])(this.currentSku, submission_store["a" /* Source */].INLINE, rating);
                }
                return;
            }
            var launchData = {
                source: submission_store["a" /* Source */].INLINE,
                startAction: 'review',
                // need to check since it could be a MouseEvent from the button click
                starSelected: typeof rating === 'number' ? rating : undefined
            };
            var page = { page: 'review-form', props: {} };
            var elem = this.$el.querySelector('.tt-c-reviews-summary__write-review');
            submission_store["b" /* default */].startRevFlow(this.currentSku, config["a" /* hostsConfig */].siteKey, page, launchData, elem);
            submission_loader["a" /* default */].load();
            submission_store["b" /* default */].isLaunchingWriteReview = false;
        }
    },
    watch: {
        //  whenever the currentSku changes, we need to reload the summary data
        currentSku: function () {
            this.fetchData();
            // TODO: believe the returning script will need to overwrite any existing json-ld, but
            // not sure that works or not
            this.loadJsonLd();
        },
        currentLayout: function (newLayout, oldLayout) {
            // something is causing this to be called when the layout hasn't changed
            // so checking just in case
            if (newLayout !== oldLayout) {
                this.showDetailsClicked = false;
            }
        }
    },
    created: function () {
        // set the layouts configuration.  This is a method in the gridLayoutDataMixin
        this.setLayoutsConfig(reviews_summary_config["a" /* default */].breakpoints);
        this.fetchData();
        this.loadJsonLd();
    }
})));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tt-c-summary-dim tt-c-summary-dim-rating tt-u-spacing--sm"
    },
    [
      _c(
        "div",
        { staticClass: "tt-c-summary-dim__heading tt-u-align-center" },
        [_vm._v(_vm._s(_vm.ratingDisplay))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tt-c-summary-dim-rating__bar-wrap" }, [
        _c("div", { staticClass: "tt-c-summary-dim-rating__bar" }, [
          _c("span", {
            staticClass: "tt-c-summary-dim-rating__progress",
            style: { width: _vm.ratingPercentage }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("e42acd9e", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("e42acd9e", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-summary-dim tt-c-summary-dim-range tt-u-spacing--sm" },
    [
      _c(
        "div",
        { staticClass: "tt-c-summary-dim__heading tt-u-align-center" },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tt-c-summary-dim-range__bar-wrap" }, [
        _c("div", { staticClass: "tt-c-summary-dim-range__bar" }, [
          _c("span", {
            ref: "dot",
            staticClass: "tt-c-summary-dim-range__dot",
            style: { left: _vm.dotPositionPercentage }
          })
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "tt-u-clip-hide",
          domProps: { innerHTML: _vm._s(_vm.description) }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tt-c-summary-dim-range__option-labels" },
        _vm._l(_vm.valueLabels, function(vLabel) {
          return _c(
            "span",
            {
              staticClass: "tt-c-summary-dim__text",
              attrs: { "aria-hidden": "true" }
            },
            [_vm._v(_vm._s(vLabel))]
          )
        })
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("7c34e747", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("7c34e747", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.valueCounts
    ? _c(
        "div",
        {
          staticClass:
            "tt-c-summary-dim tt-c-summary-dim-select tt-u-spacing--sm"
        },
        [
          _c(
            "div",
            { staticClass: "tt-c-summary-dim__heading tt-u-align-center" },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tt-c-summary-dim__text tt-u-align-center" },
            [_vm._v(_vm._s(_vm.valueCounts))]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("fad14d9c", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("fad14d9c", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tt-c-summary-dim tt-c-summary-dim-select-image tt-u-spacing--sm"
    },
    [
      _c(
        "div",
        { staticClass: "tt-c-summary-dim__heading tt-u-align-center" },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tt-c-summary-dim-select-image__images tt-u-align-center"
        },
        _vm._l(_vm.values, function(item) {
          return _c(
            "span",
            { staticClass: "tt-c-summary-dim-select-image__image-count" },
            [
              _c("img", {
                staticClass: "tt-c-summary-dim-select-image__image",
                attrs: { src: _vm.imageUrl(item.imageId) }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "tt-c-summary-dim-select-image__count tt-c-summary-dim__text"
                },
                [_vm._v(_vm._s(item.count))]
              )
            ]
          )
        })
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("6e7355e4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("6e7355e4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.breakdownForDisplay
    ? _c("div", { staticClass: "tt-c-ratings-breakdown tt-u-spacing--md" }, [
        _c("div", {
          staticClass: "tt-c-ratings-breakdown__heading tt-u-align-center",
          domProps: {
            innerHTML: _vm._s(
              _vm.$msg("ratingsBreakdown.ratings", [_vm.total], _vm.total)
            )
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tt-c-ratings-breakdown__table tt-u-spacing--xs" },
          [
            _vm._l(_vm.breakdownForDisplay, function(ratingData) {
              return [
                _c("p", {
                  staticClass: "tt-u-clip-hide",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$msg(
                        "ratingsBreakdown.pctOfReviews",
                        [ratingData.rating, ratingData.pctOfRatingsFormatted],
                        ratingData.rating
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  _vm._b(
                    {
                      staticClass: "tt-c-ratings-breakdown__bar-wrap",
                      attrs: {
                        "aria-label": ratingData.isFilterable
                          ? _vm.$msg("ratingsBreakdown.filterBy", [
                              ratingData.rating
                            ])
                          : null
                      },
                      on: {
                        keydown: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.ratingSelected(
                            ratingData.isFilterable ? ratingData : null
                          )
                        },
                        click: function($event) {
                          $event.preventDefault()
                          _vm.ratingSelected(
                            ratingData.isFilterable ? ratingData : null
                          )
                        }
                      }
                    },
                    "div",
                    ratingData.isFilterable
                      ? { role: "button", tabindex: 0 }
                      : {},
                    false
                  ),
                  [
                    _c(
                      "span",
                      { staticClass: "tt-c-ratings-breakdown__rating" },
                      [
                        _c("tt-icon", {
                          staticClass:
                            "tt-c-ratings-breakdown__star tt-c-rating__icon",
                          attrs: { name: "star--full", size: "sm" }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "tt-c-ratings-breakdown__rating-number",
                            attrs: { "aria-hidden": "true" }
                          },
                          [_vm._v(_vm._s(ratingData.rating))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "tt-c-ratings-breakdown__bar" }, [
                      _c("span", {
                        staticClass: "tt-c-ratings-breakdown__bar-progress",
                        style: { width: ratingData.progressWidth }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "tt-c-ratings-breakdown__percent",
                        attrs: { "aria-hidden": "true" }
                      },
                      [_vm._v(_vm._s(ratingData.pctOfRatingsFormatted))]
                    )
                  ]
                )
              ]
            })
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("713adca4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("713adca4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      { staticClass: "tt-w-reviews-summary" },
      "div",
      _vm.aggregateAttributes,
      false
    ),
    [
      _vm.dataIsLoaded
        ? [
            _c("tt-user-toolbar"),
            _vm._v(" "),
            _vm.reviewsCount === 0
              ? _c("div", { staticClass: "tt-c-reviews-summary__no-reivews" }, [
                  _c("div", {
                    staticClass: "tt-c-reviews-summary__heading tt-u-mb--xs",
                    domProps: {
                      innerHTML: _vm._s(_vm.$msg("reviewsSummary.noReviews"))
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "tt-c-reviews-summary__no-reivews-body tt-u-spacing--md"
                    },
                    [
                      _c("p", {
                        staticClass: "tt-c-reviews-summary__no-review-text",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$msg("reviewsSummary.beFirstToReview")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("tt-actionable-rating-stars", {
                        attrs: { starSize: "xl" },
                        on: { input: _vm.writeReview }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "tt-c-reviews-summary__write-review-wrap"
                        },
                        [
                          !_vm.isLaunchingWriteReview
                            ? _c("tt-button", {
                                staticClass:
                                  "tt-c-reviews-summary__write-review",
                                attrs: { type: "primary" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$msg("reviewsSummary.writeReview")
                                  )
                                },
                                on: { click: _vm.writeReview }
                              })
                            : _c("div", {
                                staticClass: "tt-o-spinner tt-o-spinner--submit"
                              })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.reviewsCount > 0 && _vm.aggregateMetaOn
              ? [
                  _c("meta", {
                    attrs: {
                      itemprop: "itemReviewed",
                      content: _vm.catItem.title
                    }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: {
                      itemprop: "name",
                      content: _vm.catItem.title + " reviews summary"
                    }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: { itemprop: "ratingValue", content: _vm.rating }
                  }),
                  _vm._v(" "),
                  _c("meta", {
                    attrs: {
                      itemprop: "reviewCount",
                      content: _vm.reviewsCount
                    }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.reviewsCount > 0
              ? _c(
                  "tt-grid-layout",
                  {
                    staticClass: "tt-c-reviews-summary__content",
                    attrs: {
                      layout: _vm.currentLayout,
                      classPrefix: "tt-c-reviews-summary"
                    }
                  },
                  [
                    !_vm.isSlotHidden("ratingsHeader")
                      ? _c("div", {
                          staticClass:
                            "tt-c-reviews-summary__heading tt-u-mb--xs",
                          attrs: { slot: "ratingsHeader" },
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$msg(
                                "reviewsSummary.ratingsCount",
                                [_vm.reviewsCount],
                                _vm.reviewsCount
                              )
                            )
                          },
                          slot: "ratingsHeader"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSlotHidden("rating")
                      ? _c(
                          "div",
                          {
                            staticClass: "tt-c-reviews-summary__rating",
                            attrs: { slot: "rating" },
                            slot: "rating"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "tt-c-reviews-summary__rating-number"
                              },
                              [_vm._v(_vm._s(_vm.ratingFormatted))]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "tt-c-reviews-summary__rating-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$msg("reviewsSummary.outOfStars")
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSlotHidden("stars")
                      ? _c("tt-rating-stars", {
                          staticClass:
                            "tt-c-reviews-summary__stars tt-u-mb--sm",
                          attrs: {
                            slot: "stars",
                            rating: _vm.rating,
                            starSize: "xl",
                            includeAccessibleText: false
                          },
                          slot: "stars"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.recommendedPercentageFormatted &&
                    !_vm.isSlotHidden("recommend")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "tt-c-reviews-summary__recommend tt-u-mb--md",
                            attrs: { slot: "recommend" },
                            slot: "recommend"
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "tt-c-reviews-summary__recommend-number"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.recommendedPercentageFormatted)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "tt-c-reviews-summary__recommend-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$msg("reviewsSummary.reviewersRecommend")
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSlotHidden("writeReview")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "tt-c-reviews-summary__write-review-wrap",
                            attrs: { slot: "writeReview" },
                            slot: "writeReview"
                          },
                          [
                            !_vm.isLaunchingWriteReview
                              ? _c("tt-button", {
                                  staticClass:
                                    "tt-c-reviews-summary__write-review tt-u-mb--xl tt-o-button--full",
                                  attrs: { type: "primary" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$msg("reviewsSummary.writeReview")
                                    )
                                  },
                                  on: { click: _vm.writeReview }
                                })
                              : _c("div", {
                                  staticClass:
                                    "tt-o-spinner tt-o-spinner--submit"
                                })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isSlotHidden("ratingsBreakdown")
                      ? _c("tt-ratings-breakdown", {
                          staticClass:
                            "tt-c-reviews-summary__ratings-breakdown",
                          attrs: {
                            slot: "ratingsBreakdown",
                            ratingsBreakdown: _vm.ratingsBreakdown
                          },
                          slot: "ratingsBreakdown"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.customDimensions, function(customDim, i) {
                      return [
                        customDim.type === 1 &&
                        !_vm.isSlotHidden("customDim-" + (i + 1))
                          ? _c("tt-summary-custom-rating", {
                              staticClass: "tt-c-reviews-summary__custom-dim",
                              attrs: {
                                slot: "customDim-" + (i + 1),
                                label: customDim.label,
                                averageRating: customDim.average
                              },
                              slot: "customDim-" + (i + 1)
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        customDim.type === 2 &&
                        !_vm.isSlotHidden("customDim-" + (i + 1))
                          ? _c("tt-summary-custom-range", {
                              staticClass: "tt-c-reviews-summary__custom-dim",
                              attrs: {
                                slot: "customDim-" + (i + 1),
                                label: customDim.label,
                                averageRating: customDim.average,
                                showMiddleLabel:
                                  _vm.reviewsSummaryConfig.showRangeMiddle,
                                values: customDim.values
                              },
                              slot: "customDim-" + (i + 1)
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        ~[3, 4].indexOf(customDim.type) &&
                        !_vm.isSlotHidden("customDim-" + (i + 1))
                          ? _c("tt-summary-custom-select", {
                              staticClass: "tt-c-reviews-summary__custom-dim",
                              attrs: {
                                slot: "customDim-" + (i + 1),
                                label: customDim.label,
                                values: customDim.values
                              },
                              slot: "customDim-" + (i + 1)
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        customDim.type === 5 &&
                        !_vm.isSlotHidden("customDim-" + (i + 1))
                          ? _c("tt-summary-custom-select-image", {
                              staticClass: "tt-c-reviews-summary__custom-dim",
                              attrs: {
                                slot: "customDim-" + (i + 1),
                                label: customDim.label,
                                values: customDim.values
                              },
                              slot: "customDim-" + (i + 1)
                            })
                          : _vm._e()
                      ]
                    }),
                    _vm._v(" "),
                    _vm.hasGallery && !_vm.isSlotHidden("gallery")
                      ? _c("tt-gallery", {
                          staticClass: "tt-c-reviews-summary__gallery",
                          attrs: {
                            slot: "gallery",
                            galleryConfig: _vm.galleryConfig,
                            skus: [_vm.currentSku]
                          },
                          slot: "gallery"
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayShowDetails
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "tt-c-reviews-summary__expander tt-o-expander tt-o-expander--with-dashed-border",
                            attrs: { slot: "showDetails" },
                            slot: "showDetails"
                          },
                          [
                            _c(
                              "tt-button",
                              {
                                staticClass: "tt-o-expander__button",
                                attrs: { type: "toolbar" },
                                on: { click: _vm.onShowDetailsClick }
                              },
                              [
                                _c("tt-icon", {
                                  staticClass:
                                    "tt-c-reviews-summary__expander-icon",
                                  attrs: { name: "options-expand", size: "sm" }
                                }),
                                _c("span", {
                                  staticClass: "tt-o-expander__text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$msg("reviewsSummary.showDetails")
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasSpectrum && !_vm.isSlotHidden("spectrum")
                      ? _c("tt-spectrum", {
                          staticClass: "tt-c-reviews-summary__spectrum",
                          attrs: {
                            slot: "spectrum",
                            spectrumConfig: _vm.spectrumConfig
                          },
                          slot: "spectrum"
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("51fee895", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("51fee895", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["loadWidget"] = loadWidget;
/* harmony export (immutable) */ __webpack_exports__["getInstance"] = getInstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_util_loader_helper__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_command_queue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reviews_list_commands__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reviews_list_widget_config__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reviews_list_widget__ = __webpack_require__(229);





var root;
var type = 'reviews-list';
function initialize() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_util_loader_helper__["a" /* createAndMountInstance */])(root, __WEBPACK_IMPORTED_MODULE_4__reviews_list_widget__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__reviews_list_widget_config__["b" /* default */].widgetDivId)
        .then(function (instance) { return root = instance; });
}
function loadWidget(widgetConfig) {
    return new Promise(function (resolve) {
        Object(__WEBPACK_IMPORTED_MODULE_3__reviews_list_widget_config__["c" /* loadConfig */])(widgetConfig);
        __WEBPACK_IMPORTED_MODULE_1_init_command_queue__["b" /* widgetLibraries */].reviewsList = __WEBPACK_IMPORTED_MODULE_2__reviews_list_commands__;
        initialize().then(function () { return resolve(); });
    });
}
function getInstance() {
    return root;
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["writeReview"] = writeReview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_init_global_store__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_init_config__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widgets_submission_submission_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store_submission_store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_services_sso_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_init_global_config__ = __webpack_require__(6);






function writeReview() {
    if (__WEBPACK_IMPORTED_MODULE_5_init_global_config__["a" /* default */].ssoEnabled) {
        if (__WEBPACK_IMPORTED_MODULE_5_init_global_config__["a" /* default */].isPurchaseReq()) {
            Object(__WEBPACK_IMPORTED_MODULE_4_services_sso_service__["g" /* ssoCreateReview */])(__WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].sku, __WEBPACK_IMPORTED_MODULE_3_store_submission_store__["a" /* Source */].INLINE);
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_4_services_sso_service__["i" /* ssoGetLoggedInDataForReview */])(__WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].sku, __WEBPACK_IMPORTED_MODULE_3_store_submission_store__["a" /* Source */].INLINE);
        }
    }
    else {
        __WEBPACK_IMPORTED_MODULE_3_store_submission_store__["b" /* default */].startRevFlow(__WEBPACK_IMPORTED_MODULE_0_init_global_store__["a" /* default */].sku, __WEBPACK_IMPORTED_MODULE_1_init_config__["a" /* hostsConfig */].siteKey, { page: 'review-form', props: {} }, { startAction: 'review', source: __WEBPACK_IMPORTED_MODULE_3_store_submission_store__["a" /* Source */].INLINE }, document.activeElement);
        __WEBPACK_IMPORTED_MODULE_2_widgets_submission_submission_loader__["a" /* default */].load();
    }
}


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(0);

// EXTERNAL MODULE: ./src/util/ts-utils.ts
var ts_utils = __webpack_require__(10);

// EXTERNAL MODULE: ./src/widgets/reviews-list/reviews-list-widget.config.ts
var reviews_list_widget_config = __webpack_require__(19);

// EXTERNAL MODULE: ./src/store/reviews-store.ts + 1 modules
var reviews_store = __webpack_require__(22);

// EXTERNAL MODULE: ./src/services/api-service.ts
var api_service = __webpack_require__(8);

// EXTERNAL MODULE: ./src/util/turnto-utils.ts
var turnto_utils = __webpack_require__(11);

// EXTERNAL MODULE: ./src/util/dom-utils.ts
var dom_utils = __webpack_require__(1);

// EXTERNAL MODULE: ./src/init/global.config.ts
var global_config = __webpack_require__(6);

// EXTERNAL MODULE: ./src/init/global-store.ts
var global_store = __webpack_require__(4);

// EXTERNAL MODULE: ./src/mixins/paginate-mixin.ts
var paginate_mixin = __webpack_require__(33);

// EXTERNAL MODULE: ./src/layouts/grid/grid-layout-data-mixin.ts
var grid_layout_data_mixin = __webpack_require__(38);

// EXTERNAL MODULE: ./src/components/review/review.ts + 5 modules
var review_review = __webpack_require__(73);

// EXTERNAL MODULE: ./src/components/reviews-list/related-reviews-list.html
var related_reviews_list = __webpack_require__(230);
var related_reviews_list_default = /*#__PURE__*/__webpack_require__.n(related_reviews_list);

// EXTERNAL MODULE: ./src/components/reviews-list/related-reviews-list.scss
var reviews_list_related_reviews_list = __webpack_require__(231);
var reviews_list_related_reviews_list_default = /*#__PURE__*/__webpack_require__.n(reviews_list_related_reviews_list);

// CONCATENATED MODULE: ./src/components/reviews-list/related-reviews-list.ts













/* harmony default export */ var components_reviews_list_related_reviews_list = (related_reviews_list_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            previousSku: '',
            reviews: [],
            showMoreDisabled: false,
            store: global_store["a" /* default */]
        };
    },
    components: {
        'tt-review': review_review["a" /* default */]
    },
    mixins: [grid_layout_data_mixin["a" /* default */], paginate_mixin["a" /* default */]],
    computed: {
        currentSku: function () {
            return this.store.sku;
        },
        mediaSize: function () {
            return this.reviewsListConfig.breakpoints[this.currentLayoutIndex || 0].mediaSize;
        },
        reviewsListConfig: function () {
            return reviews_list_widget_config["b" /* default */];
        },
        sortBy: function () {
            return reviews_list_widget_config["b" /* default */].defaultSortOption;
        },
        truncateLength: function () {
            return this.reviewsListConfig.breakpoints[this.currentLayoutIndex || 0].truncateLength;
        }
    },
    methods: {
        fetchData: Object(ts_utils["d" /* debounce */])(function cb(isPageChange) {
            var _this = this;
            if (this.currentSku && (this.offset === 0 || this.offset <= this.total)) {
                var limit = this.offset === 0 ? this.initialPageSize : this.pageSize;
                if (reviews_list_widget_config["b" /* default */].useShowMore && this.offset !== 0) {
                    this.showMoreDisabled = true;
                }
                var isFirstCall_1 = this.currentSku !== this.previousSku;
                api_service["a" /* default */].relatedReviewsList({
                    sku: this.currentSku,
                    offset: this.offset,
                    limit: limit,
                    sort: this.sortBy
                }).then(function (data) {
                    _this.previousSku = _this.currentSku;
                    _this.total = data.total;
                    if (reviews_list_widget_config["b" /* default */].useShowMore && _this.offset !== 0) {
                        data.reviews.forEach(function (review) {
                            _this.reviews.push(review);
                        });
                        _this.showMoreDisabled = false;
                    }
                    else {
                        _this.reviews = data.reviews;
                    }
                    if (isFirstCall_1) {
                        _this.$emit('relatedReviewsLoaded', _this.reviews);
                    }
                    else {
                        _this.$nextTick(function () {
                            if (isPageChange) {
                                // TT-11837 - focus header after scroll. safeFocus in case client hides the header
                                var focusFn = function () { return dom_utils["a" /* default */].safeFocus(function () { return _this.$refs.headingText; }); };
                                dom_utils["a" /* default */]
                                    .scrollUpToRef(_this.$refs, 'relReviewsList', global_config["a" /* default */].additionalPagingScroll)
                                    .then(focusFn)
                                    .catch(focusFn);
                            }
                            Object(turnto_utils["c" /* callTurnToConfigFn */])('relatedReviews', 'onUpdate');
                        });
                    }
                });
            }
        }, 100),
        openMediaModal: function (media, startingIndex) {
            if (startingIndex === void 0) { startingIndex = 0; }
            // passing it up one more level
            this.$emit('openMediaModal', media, startingIndex);
        }
    },
    created: function () {
        // initialPageSize and pageSize are in paginateMixin
        this.initialPageSize =
            reviews_list_widget_config["b" /* default */].relatedInitialPageSize || reviews_list_widget_config["b" /* default */].relatedPageSize;
        this.pageSize = reviews_list_widget_config["b" /* default */].relatedPageSize;
        // setLayoutConfig method in gridLayoutDataMixin
        this.setLayoutsConfig(reviews_list_widget_config["b" /* default */].breakpoints);
        this.fetchData();
    },
    watch: {
        currentSku: function () {
            // onQueryChange method in paginateMixin
            this.onQueryChange();
        }
    }
})));

// EXTERNAL MODULE: ./src/util/logger.ts
var logger = __webpack_require__(9);

// EXTERNAL MODULE: ./src/init/config.ts
var config = __webpack_require__(3);

// EXTERNAL MODULE: ./src/util/browser-utils.ts
var browser_utils = __webpack_require__(16);

// EXTERNAL MODULE: ./src/objects/listbox/listbox.html
var listbox = __webpack_require__(232);
var listbox_default = /*#__PURE__*/__webpack_require__.n(listbox);

// EXTERNAL MODULE: ./src/objects/listbox/listbox.scss
var listbox_listbox = __webpack_require__(233);
var listbox_listbox_default = /*#__PURE__*/__webpack_require__.n(listbox_listbox);

// CONCATENATED MODULE: ./src/objects/listbox/listbox.ts




/* harmony default export */ var objects_listbox_listbox = (listbox_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            activeIndex: -1,
            ident: Math.random().toString(16).slice(5),
            isExpanded: false,
            searchVal: '',
            value: '',
            values: [] // for multi-select
        };
    },
    props: {
        // when true, selecting a value that is already selected, deselects it.  When false, the value
        // remains selected.  This is to handle the disctinction between sort and a single value filter
        // such as "verified purchaser".
        // For sort, this is false.  For filters it is true.
        deselectable: Boolean,
        disabled: Boolean,
        isRating: Boolean,
        label: String,
        model: [Array, String, Number, Boolean],
        multiSelect: Boolean,
        options: { type: Array, required: true },
        subLabel: String
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    computed: {
        activeDesc: function () {
            return this.activeIndex > -1 ? this.optionsData[this.activeIndex].id : null;
        },
        btnValue: function () {
            var _this = this;
            if (this.subLabel) {
                return this.subLabel;
            }
            // assumption is subLabel is always populated for multiSelect listbox.  This only checks
            // for this.value
            var selectedOption = Object(ts_utils["a" /* arrayFind */])(this.options, function (opt) {
                return opt.value === _this.value;
            });
            return selectedOption ?
                (selectedOption.labelKey ? this.$msg(selectedOption.labelKey) : selectedOption.label) : '';
        },
        hasSelection: function () {
            return !!this.value || this.values.length > 0;
        },
        optionsData: function () {
            var _this = this;
            return this.options.map(function (opt, i) {
                var isSelected = _this.value === opt.value || _this.values.indexOf(opt.value) > -1;
                return {
                    id: "tt-option-" + _this.ident + "-" + i,
                    label: opt.labelKey ? _this.$msg(opt.labelKey) : opt.label,
                    isSelected: isSelected,
                    iconName: _this.multiSelect && isSelected ? 'checkbox--on' :
                        (_this.multiSelect && !isSelected ? 'checkbox--off' :
                            (!_this.multiSelect && isSelected ? 'check' : '')),
                    iconTitle: isSelected ? _this.$msg('listbox.check') : ''
                };
            });
        }
    },
    methods: {
        handleKeydown: function (e) {
            if (e.keyCode === 9) {
                this.setExpanded(false);
            }
            else if (e.keyCode === 27) {
                e.stopPropagation();
                this.setExpanded(false);
            }
            else if (e.keyCode === 38) {
                e.preventDefault();
                this.moveUp();
            }
            else if (e.keyCode === 40) {
                e.preventDefault();
                this.moveDown();
            }
            else if (e.keyCode === 36) {
                e.preventDefault();
                this.activeIndex = 0;
            }
            else if (e.keyCode === 35) {
                e.preventDefault();
                this.activeIndex = this.options.length - 1;
            }
            else if (e.keyCode === 32 || e.keyCode === 13) {
                e.preventDefault();
                if (this.deselectable || e.keyCode === 13) {
                    this.selectOption(this.activeIndex);
                }
            }
            else {
                this.searchVal = this.searchVal + String.fromCharCode(e.keyCode).toLowerCase();
                this.findByText();
            }
        },
        findByText: Object(ts_utils["d" /* debounce */])(function cb() {
            var lastItemIndex = this.options.length - 1;
            var currentIndex = this.activeIndex === lastItemIndex ? 0 : this.activeIndex + 1;
            for (var i = 0; i < lastItemIndex; i++) {
                if (this.options[currentIndex].label.toLowerCase().indexOf(this.searchVal) === 0) {
                    this.activeIndex = currentIndex;
                    break;
                }
                currentIndex = currentIndex === lastItemIndex ? 0 : currentIndex + 1;
            }
            this.searchVal = '';
        }, 300),
        moveDown: function () {
            if (this.activeIndex < this.options.length - 1) {
                this.activeIndex = this.activeIndex + 1;
            }
        },
        moveUp: function () {
            if (this.activeIndex > 0) {
                this.activeIndex = this.activeIndex - 1;
            }
        },
        onListBlur: function () {
            this.setExpanded(false);
        },
        open: function () {
            // this is opened by mousedown and keydown instead of click due to order of the events.
            // when a blur event is fired for clicking outside of the opened list, but the click is
            // back on the trigger, a click event fires "after" blur, leaving the list open.  The
            // mousedown event, on the other hand, fires "before" blur, allowing blur to close the list.
            // Tried to use e.relatedTarget in blur, but it's null in FireFox
            this.setExpanded(true);
        },
        selectOption: function (index) {
            var _this = this;
            var isSelected = this.optionsData[index].isSelected;
            var val = this.options[index].value;
            if (!this.deselectable) {
                this.value = val;
                this.$nextTick(function () { return _this.setExpanded(false); });
                return;
            }
            else if (!this.multiSelect) {
                this.value = isSelected ? '' : val;
            }
            else if (isSelected) {
                this.values.splice(this.values.indexOf(val), 1);
            }
            else {
                this.values.push(val);
            }
            this.activeIndex = index;
        },
        setValues: function () {
            if (this.model !== undefined) {
                if (this.multiSelect) {
                    this.values = this.model;
                }
                else {
                    this.value = this.model;
                }
            }
        },
        setExpanded: function (expand) {
            var _this = this;
            if (this.disabled && expand === true) {
                return;
            }
            this.isExpanded = expand;
            if (!this.isExpanded) {
                this.activeIndex = -1;
                // make sure list is closed before trying to focus.  Was not working on FF and Safari
                this.$nextTick(function () { return _this.$refs.trigger.focus(); });
                return;
            }
            this.$nextTick(function () {
                // focus goes on the list (ul). The appearance of focus on individual items (li) is
                // achieved with styling and with 'aria-activedescendant' on the list (ul)
                _this.$refs.list.focus();
                var firstValue = _this.value;
                if (_this.values.length > 0) {
                    firstValue = _this.values[0];
                }
                _this.activeIndex = !firstValue ? 0 :
                    _this.activeIndex = Object(ts_utils["b" /* arrayFindIndex */])(_this.options, function (opt) { return opt.value === firstValue; });
            });
        }
    },
    watch: {
        model: function () {
            this.setValues();
        },
        value: function () {
            this.$emit('change', this.value);
        },
        values: function () {
            this.$emit('change', this.values);
        }
    },
    created: function () {
        this.setValues();
    }
})));

// EXTERNAL MODULE: ./src/components/reviews-list/review-filters.html
var review_filters = __webpack_require__(234);
var review_filters_default = /*#__PURE__*/__webpack_require__.n(review_filters);

// EXTERNAL MODULE: ./src/components/reviews-list/review-filters.scss
var reviews_list_review_filters = __webpack_require__(235);
var reviews_list_review_filters_default = /*#__PURE__*/__webpack_require__.n(reviews_list_review_filters);

// CONCATENATED MODULE: ./src/components/reviews-list/review-filters.ts





/* harmony default export */ var components_reviews_list_review_filters = (review_filters_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            reviewsStore: reviews_store["a" /* default */]
        };
    },
    components: {
        'tt-listbox': objects_listbox_listbox
    },
    computed: {
        filterValues: function () {
            return this.reviewsStore.filterStore.filterValues;
        },
        listBoxValues: function () {
            var _this = this;
            var filters = reviews_store["a" /* default */].filterStore.filters;
            // want to make sure we have the filterValues set before including
            return filters.filter(function (filter) {
                return !!_this.filterValues[filter.group] &&
                    Object.keys(_this.filterValues[filter.group]).indexOf(filter.name) > -1;
            }).map(function (filter) {
                return {
                    filter: filter,
                    label: filters.length === 1 ? _this.$msg('reviewsList.filter') : '',
                    model: _this.filterValues[filter.group][filter.name],
                    multiSelect: filter.type === 'array',
                    subLabel: filter.labelKey ? _this.$msg(filter.labelKey) : filter.label
                };
            });
        }
    },
    methods: {
        onChange: function (filter, value) {
            reviews_store["a" /* default */].filterStore.setFilterValue(filter, value);
        }
    }
})));

// EXTERNAL MODULE: ./src/objects/form/search-field.ts
var search_field = __webpack_require__(70);

// EXTERNAL MODULE: ./src/services/sso-service.ts
var sso_service = __webpack_require__(13);

// EXTERNAL MODULE: ./src/widgets/submission/submission-loader.ts
var submission_loader = __webpack_require__(12);

// EXTERNAL MODULE: ./src/store/submission-store.ts
var submission_store = __webpack_require__(7);

// EXTERNAL MODULE: ./src/components/reviews-list/reviews-list-utilities.html
var reviews_list_utilities = __webpack_require__(236);
var reviews_list_utilities_default = /*#__PURE__*/__webpack_require__.n(reviews_list_utilities);

// EXTERNAL MODULE: ./src/components/reviews-list/reviews-list-utilities.scss
var reviews_list_reviews_list_utilities = __webpack_require__(237);
var reviews_list_reviews_list_utilities_default = /*#__PURE__*/__webpack_require__.n(reviews_list_reviews_list_utilities);

// CONCATENATED MODULE: ./src/components/reviews-list/reviews-list-utilities.ts















/* harmony default export */ var components_reviews_list_reviews_list_utilities = (reviews_list_utilities_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            filterStore: reviews_store["a" /* default */].filterStore,
            reviewsStore: reviews_store["a" /* default */],
            submissionStore: submission_store["b" /* default */],
            store: global_store["a" /* default */],
            toggleFiltersOn: false
        };
    },
    components: {
        'tt-listbox': objects_listbox_listbox,
        'tt-review-filters': components_reviews_list_review_filters,
        'tt-search-field': search_field["a" /* default */]
    },
    computed: {
        appliedFilterOptions: function () {
            return this.filterStore.appliedFilters;
        },
        hasSearchTerm: function () {
            return this.reviewsStore.trimmedSearchTerm.length > 0;
        },
        hideWriteReview: function () {
            return reviews_list_widget_config["b" /* default */].hideWriteReview;
        },
        numFilters: function () {
            return this.filterStore.filters.length;
        },
        isLaunchingWriteReview: function () {
            return submission_store["b" /* default */].isLaunchingWriteReview;
        },
        sortBy: function () {
            return this.reviewsStore.sort;
        },
        sortField: function () {
            var _this = this;
            var sortBy = this.reviewsStore.sort;
            return {
                model: sortBy,
                label: this.$msg("reviewsList.sortBy." + sortBy),
                options: reviews_list_widget_config["b" /* default */].sortOptions.map(function (option) {
                    return { value: option, label: _this.$msg("reviewsList.sortBy." + option) };
                })
            };
        },
        showFilters: function () {
            return (this.showFiltersToggle && this.toggleFiltersOn) ||
                (!this.showFiltersToggle && this.numFilters > 1);
        },
        showFiltersToggle: function () {
            return this.numFilters > 1 && ((reviews_list_widget_config["b" /* default */].toggleFiltersDesktop && !Object(browser_utils["f" /* isMobileDevice */])()) ||
                (reviews_list_widget_config["b" /* default */].toggleFiltersMobile && Object(browser_utils["f" /* isMobileDevice */])()));
        },
        toggleFiltersText: function () {
            return this.$msg(this.toggleFiltersOn ? 'reviewsList.hideFilters' : 'reviewsList.showFilters');
        }
    },
    methods: {
        clearAllFilters: function () {
            this.filterStore.clearFilters();
        },
        onSort: function (value) {
            reviews_store["a" /* default */].sort = value;
        },
        removeFilter: function (filter, value) {
            this.filterStore.removeFilterValue(filter, value);
        },
        toggleFilters: function () {
            this.toggleFiltersOn = !this.toggleFiltersOn;
        },
        writeReview: function (e) {
            // if sso, this will be set back to false when ssoRegDone or loggedInDataFnDone is called
            submission_store["b" /* default */].isLaunchingWriteReview = true;
            if (global_config["a" /* default */].ssoEnabled) {
                if (global_config["a" /* default */].isPurchaseReq()) {
                    Object(sso_service["g" /* ssoCreateReview */])(this.store.sku, submission_store["a" /* Source */].INLINE);
                }
                else {
                    Object(sso_service["i" /* ssoGetLoggedInDataForReview */])(this.store.sku, submission_store["a" /* Source */].INLINE);
                }
                return;
            }
            submission_store["b" /* default */].startRevFlow(this.store.sku, config["a" /* hostsConfig */].siteKey, { page: 'review-form', props: {} }, { startAction: 'review', source: submission_store["a" /* Source */].INLINE }, e.currentTarget);
            submission_loader["a" /* default */].load();
            submission_store["b" /* default */].isLaunchingWriteReview = false;
        }
    }
})));

// EXTERNAL MODULE: ./src/components/reviews-list/reviews-list.html
var reviews_list = __webpack_require__(238);
var reviews_list_default = /*#__PURE__*/__webpack_require__.n(reviews_list);

// EXTERNAL MODULE: ./src/components/reviews-list/reviews-list.scss
var reviews_list_reviews_list = __webpack_require__(239);
var reviews_list_reviews_list_default = /*#__PURE__*/__webpack_require__.n(reviews_list_reviews_list);

// CONCATENATED MODULE: ./src/components/reviews-list/reviews-list.ts
















var MIN_REVIEWS_FOR_TOOLBAR = 3;
/* harmony default export */ var components_reviews_list_reviews_list = (reviews_list_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            filterTotal: 0,
            previousSku: '',
            reviews: [],
            reviewsStore: reviews_store["a" /* default */],
            showMoreDisabled: false,
            store: global_store["a" /* default */],
            total: 0
        };
    },
    components: {
        'tt-review': review_review["a" /* default */],
        'tt-reviews-list-utilities': components_reviews_list_reviews_list_utilities
    },
    mixins: [grid_layout_data_mixin["a" /* default */], paginate_mixin["a" /* default */]],
    computed: {
        currentSku: function () {
            return this.store.sku;
        },
        filtersQueryString: function () {
            return this.reviewsStore.filterStore.encodedFiltersUrl;
        },
        hasMoreRslts: function () {
            // the "hasMore" in paginate-mixin does not take applied filters into account
            if (this.isFiltered) {
                return this.reviews.length < this.filterTotal;
            }
            return this.hasMore;
        },
        hasSearchTerm: function () {
            return this.reviewsStore.trimmedSearchTerm.length > 0;
        },
        headingText: function () {
            var totalItems = this.totalReviews;
            var numPages = this.numberOfPages;
            if (numPages <= 1) {
                var total = this.isFiltered ? this.filterTotal : this.total;
                return this.$msg('reviewsList.numberOfReviews', [total], total);
            }
            var startItem = reviews_list_widget_config["b" /* default */].useShowMore ? 1 : this.offset + 1;
            var endItem = this.reviews.length; // when using "show more"
            if (!this.reviewsListConfig.useShowMore) {
                var itemsPerPage = this.offset === 0 ? this.initialPageSize : this.pageSize;
                endItem = this.currentPage < numPages ? ((startItem - 1) + itemsPerPage) : totalItems;
            }
            return this.$msg('reviewsList.numberOfReviews.paged', [startItem, endItem, totalItems], totalItems);
        },
        isRelatedIncluded: function () {
            return reviews_list_widget_config["b" /* default */].relatedReviewsDisplay === reviews_list_widget_config["a" /* RelatedReviewsDisplayTypes */].INCLUDED;
        },
        mediaSize: function () {
            return this.reviewsListConfig.breakpoints[this.currentLayoutIndex || 0].mediaSize;
        },
        reviewsListConfig: function () {
            return reviews_list_widget_config["b" /* default */];
        },
        showUtilities: function () {
            // not to be shown if less than the min number of reviews or filters have been applied
            return this.total >= MIN_REVIEWS_FOR_TOOLBAR || this.isFiltered;
        },
        sortBy: function () {
            return this.reviewsStore.sort;
        },
        truncateLength: function () {
            return this.reviewsListConfig.breakpoints[this.currentLayoutIndex || 0].truncateLength;
        },
        searchTerm: function () {
            return this.reviewsStore.trimmedSearchTerm;
        },
        isFiltered: function () {
            return this.reviewsStore.filterStore.appliedFilters.length > 0 ||
                !!this.reviewsStore.trimmedSearchTerm;
        },
        totalReviews: function () {
            return this.isFiltered ? this.filterTotal : this.total;
        },
        numberOfPages: function () {
            var totalItems = this.totalReviews;
            if (this.pageSize === 0 || totalItems === 0) {
                return 0;
            }
            if (totalItems <= this.initialPageSize) {
                return 1;
            }
            var totalLessInitialPageSize = totalItems - this.initialPageSize;
            return Math.ceil(totalLessInitialPageSize / this.pageSize) + (this.initialPageSize ? 1 : 0);
        },
        noFilterResults: function () {
            return this.isFiltered && this.filterTotal === 0;
        }
    },
    methods: {
        fetchData: Object(ts_utils["d" /* debounce */])(function cb(isPageChange) {
            var _this = this;
            if (this.currentSku && (this.offset === 0 || this.offset <= this.totalReviews)) {
                var limit = this.offset === 0 ? this.initialPageSize : this.pageSize;
                if (reviews_list_widget_config["b" /* default */].useShowMore && this.offset !== 0) {
                    this.showMoreDisabled = true;
                }
                var isFirstCall_1 = this.currentSku !== this.previousSku;
                api_service["a" /* default */].reviewsList({
                    sku: this.currentSku,
                    offset: this.offset,
                    limit: limit,
                    filters: this.filtersQueryString,
                    sort: !this.hasSearchTerm ? this.sortBy : 'NONE',
                    includeRelated: this.isRelatedIncluded,
                    includeFilters: isFirstCall_1,
                    searchText: this.hasSearchTerm ? encodeURIComponent(this.searchTerm) : ''
                }).then(function (data) {
                    _this.previousSku = _this.currentSku;
                    global_store["a" /* default */].catItemId = data.catalogItemId;
                    global_store["a" /* default */].parentCategoryIds = data.parentCategoryIds;
                    global_store["a" /* default */].brand = data.brand;
                    if (isFirstCall_1 && data.filters) {
                        reviews_store["a" /* default */].filterStore.filters = data.filters;
                    }
                    if (data.productReviewsJsonLdEnabled && isFirstCall_1) {
                        _this.$emit('reviewsLoaded', data.reviews, data.catalogItemTitle);
                    }
                    if (_this.isFiltered) {
                        _this.filterTotal = data.total;
                    }
                    else {
                        _this.total = data.total;
                        _this.filterTotal = 0;
                    }
                    if (reviews_list_widget_config["b" /* default */].useShowMore && _this.offset !== 0) {
                        data.reviews.forEach(function (review) {
                            _this.reviews.push(review);
                        });
                        _this.showMoreDisabled = false;
                    }
                    else {
                        _this.reviews = data.reviews;
                    }
                    _this.$nextTick(function () {
                        if (isPageChange) {
                            // not first time, so may have paginated.  Will only scroll up, not down
                            // TT-11837 - focus header after scroll. safeFocus in case client hides the header
                            var focusFn = function () { return dom_utils["a" /* default */].safeFocus(function () { return _this.$refs.headingText; }); };
                            dom_utils["a" /* default */]
                                .scrollUpToRef(_this.$refs, 'reviewsList', global_config["a" /* default */].additionalPagingScroll)
                                .then(focusFn)
                                .catch(focusFn);
                        }
                        // IF the client has these function defined under turnToConfig.reviewsList, they will be
                        // called
                        isFirstCall_1 ? Object(turnto_utils["c" /* callTurnToConfigFn */])('reviewsList', 'onFinish') :
                            Object(turnto_utils["c" /* callTurnToConfigFn */])('reviewsList', 'onUpdate');
                    });
                }).catch(function (e) {
                    logger["a" /* default */].info('Error loading reviews list widget', e);
                });
            }
        }, 200),
        openMediaModal: function (media, startingIndex) {
            if (startingIndex === void 0) { startingIndex = 0; }
            // passing it up one more level
            this.$emit('openMediaModal', media, startingIndex);
        }
    },
    created: function () {
        // initialPageSize and pageSize are in paginateMixin
        this.initialPageSize = reviews_list_widget_config["b" /* default */].initialPageSize || reviews_list_widget_config["b" /* default */].pageSize;
        this.pageSize = reviews_list_widget_config["b" /* default */].pageSize;
        // setLayoutConfig method in gridLayoutDataMixin
        this.setLayoutsConfig(reviews_list_widget_config["b" /* default */].breakpoints);
        this.reviewsStore.sort = reviews_list_widget_config["b" /* default */].defaultSortOption;
        this.fetchData();
    },
    watch: {
        currentSku: function () {
            this.reviewsStore.sort = reviews_list_widget_config["b" /* default */].defaultSortOption;
            this.reviewsStore.searchTerm = '';
            this.reviewsStore.filterStore.clearFilters();
            // method in paginateMixin
            this.onQueryChange();
        },
        searchTerm: function () {
            this.onQueryChange();
        }
    }
})));

// EXTERNAL MODULE: ./src/components/user-toolbar/user-toolbar.ts
var user_toolbar = __webpack_require__(28);

// EXTERNAL MODULE: ./src/filters/format-name.ts
var format_name = __webpack_require__(20);

// EXTERNAL MODULE: ./src/widgets/reviews-list/reviews-list-widget.html
var reviews_list_widget = __webpack_require__(240);
var reviews_list_widget_default = /*#__PURE__*/__webpack_require__.n(reviews_list_widget);

// EXTERNAL MODULE: ./src/widgets/reviews-list/reviews-list-widget.scss
var reviews_list_reviews_list_widget = __webpack_require__(241);
var reviews_list_reviews_list_widget_default = /*#__PURE__*/__webpack_require__.n(reviews_list_reviews_list_widget);

// CONCATENATED MODULE: ./src/widgets/reviews-list/reviews-list-widget.ts











/* harmony default export */ var widgets_reviews_list_reviews_list_widget = __webpack_exports__["a"] = (reviews_list_widget_default()(vue_runtime_esm["a" /* default */].extend({
    data: function () {
        return {
            catalogItemTitle: '',
            relatedReviewsJsonLdReady: false,
            reviews: [],
            relatedReviews: [],
            reviewsStore: reviews_store["a" /* default */],
            globalStore: global_store["a" /* default */]
        };
    },
    components: {
        'tt-related-reviews-list': components_reviews_list_related_reviews_list,
        'tt-reviews-list': components_reviews_list_reviews_list,
        'tt-user-toolbar': user_toolbar["a" /* default */]
    },
    computed: {
        currentSku: function () {
            return this.globalStore.sku;
        },
        showRelatedList: function () {
            return reviews_list_widget_config["b" /* default */].relatedReviewsDisplay === reviews_list_widget_config["a" /* RelatedReviewsDisplayTypes */].SEPARATE;
        },
        showUserToolbar: function () {
            return reviews_list_widget_config["b" /* default */].displayUserToolbar;
        },
        showSearchResults: function () {
            return this.reviewsStore.searchTerm;
        },
        jsonLdReady: function () {
            return this.catalogItemTitle.length > 0 // reviews has emitted
                // related reviews have emitted or not present
                && (this.relatedReviewsJsonLdReady || !this.showRelatedList)
                // There are reviews to include
                && (this.reviews.length > 0 || this.relatedReviews.length > 0);
        }
    },
    methods: {
        loadJsonLd: Object(ts_utils["d" /* debounce */])(function () {
            var _this = this;
            if (this.jsonLdReady) {
                var jsonLdData_1 = {
                    '@context': 'http://schema.org',
                    '@type': 'Product',
                    '@id': window.location.href,
                    name: this.catalogItemTitle,
                    review: []
                };
                this.reviews.forEach(function (review) {
                    jsonLdData_1.review.push(_this.buildJsonLdReview(review));
                });
                this.relatedReviews.forEach(function (review) {
                    jsonLdData_1.review.push(_this.buildJsonLdReview(review));
                });
                var script = document.createElement('script');
                script.type = 'application/ld+json';
                script.innerHTML = JSON.stringify(jsonLdData_1);
                document.head.appendChild(script);
            }
        }, 10),
        buildJsonLdReview: function (review) {
            return {
                '@type': 'Review',
                author: Object(format_name["a" /* default */])(review.user),
                datePublished: new Date(review.dateCreatedMillis).toISOString(),
                description: review.text,
                name: review.title,
                reviewRating: {
                    '@type': 'Rating',
                    bestRating: '5',
                    ratingValue: "" + review.rating,
                    worstRating: '1'
                }
            };
        },
        openMediaModal: function (media, startingIndex) {
            if (startingIndex === void 0) { startingIndex = 0; }
            // tslint:disable-next-line
            __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 433)).then(function (mediaModalLoader) {
                mediaModalLoader.default.load({ media: media, startingIndex: startingIndex });
            });
        },
        relatedReviewsLoaded: function (relatedReviews) {
            this.relatedReviewsJsonLdReady = true;
            this.relatedReviews = relatedReviews;
            this.loadJsonLd();
        },
        reviewsLoaded: function (reviews, catalogItemTitle) {
            this.catalogItemTitle = catalogItemTitle;
            this.reviews = reviews;
            this.loadJsonLd();
        }
    },
    created: function () {
        // used by both direct and related reviews lists, so setting here
        reviews_store["a" /* default */].sort = reviews_list_widget_config["b" /* default */].defaultSortOption;
    }
})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.total > 0
    ? _c(
        "div",
        { ref: "relReviewsList", staticClass: "tt-c-related-reviews-list" },
        [
          _c(
            "div",
            { staticClass: "tt-c-related-reviews-list__header tt-u-mb--md" },
            [
              _c("div", {
                ref: "headingText",
                staticClass: "tt-c-related-reviews-list__heading",
                attrs: { tabindex: "-1" },
                domProps: {
                  innerHTML: _vm._s(_vm.$msg("relatedReviewsList.header"))
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tt-c-related-reviews-list__content" },
            _vm._l(_vm.reviews, function(review) {
              return _c("tt-review", {
                key: review.id,
                attrs: {
                  allItemsInLayout: _vm.allItemsInLayout,
                  currentLayout: _vm.currentLayout,
                  isRelatedReview: true,
                  mediaSize: _vm.mediaSize,
                  review: review,
                  slotNamesAfterShowDetails: _vm.slotNamesAfterShowDetails,
                  truncateLength: _vm.truncateLength
                },
                on: { openMediaModal: _vm.openMediaModal }
              })
            })
          ),
          _vm._v(" "),
          _vm.reviewsListConfig.useShowMore
            ? _c(
                "div",
                { staticClass: "tt-c-related-reviews-list__show-more" },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMoreDisabled,
                        expression: "showMoreDisabled"
                      }
                    ],
                    staticClass: "tt-o-spinner"
                  }),
                  _vm._v(" "),
                  _c("tt-button", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showMoreDisabled && _vm.hasMore,
                        expression: "!showMoreDisabled && hasMore"
                      }
                    ],
                    staticClass: "tt-c-related-reviews-list__show-more-btn",
                    attrs: { type: "primary" },
                    domProps: {
                      innerHTML: _vm._s(_vm.$msg("relatedReviewsList.showMore"))
                    },
                    on: { click: _vm.showMore }
                  })
                ],
                1
              )
            : !_vm.reviewsListConfig.useShowMore
              ? _c("tt-pagination", {
                  attrs: {
                    currentPage: _vm.currentPage,
                    total: _vm.total,
                    initialPageSize: _vm.initialPageSize,
                    pageSize: _vm.pageSize
                  },
                  on: { updatePage: _vm.pageChange }
                })
              : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3e7e1e0c", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3e7e1e0c", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tt-o-listbox" }, [
    _c(
      "button",
      {
        ref: "trigger",
        staticClass: "tt-o-listbox__btn",
        class: { "tt-o-listbox__btn--with-label": !!_vm.label },
        attrs: {
          type: "button",
          "aria-haspopup": "listbox",
          "aria-labelledby": "tt-lb-btn-" + _vm.ident,
          id: "tt-lb-btn-" + _vm.ident,
          "aria-expanded": _vm.isExpanded.toString(),
          disabled: _vm.disabled
        },
        on: {
          mousedown: _vm.open,
          keydown: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.open($event)
          }
        }
      },
      [
        _vm.label
          ? _c("span", {
              staticClass: "tt-o-listbox__label",
              domProps: { innerHTML: _vm._s(_vm.label) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", {
          staticClass: "tt-o-listbox__btn-label",
          domProps: { innerHTML: _vm._s(_vm.btnValue) }
        }),
        _vm._v(" "),
        _c("tt-icon", {
          staticClass: "tt-o-listbox__btn-icon",
          class: { "tt-o-listbox__btn-icon--open": _vm.isExpanded },
          attrs: { size: "sm", name: "caret-down" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isExpanded,
            expression: "isExpanded"
          }
        ],
        ref: "list",
        staticClass: "tt-o-listbox__list",
        class: { "tt-o-listbox__list--has-selection": _vm.hasSelection },
        attrs: {
          tabindex: "-1",
          role: "listbox",
          "aria-activedescendant": _vm.activeDesc,
          "aria-labelledby": "tt-lb-btn-" + _vm.ident
        },
        on: { blur: _vm.onListBlur, keydown: _vm.handleKeydown }
      },
      _vm._l(_vm.optionsData, function(opt, index) {
        return _c(
          "li",
          {
            ref: "option",
            refInFor: true,
            staticClass: "tt-o-listbox__option",
            class: [
              { "tt-o-listbox__option--is-active": index === _vm.activeIndex }
            ],
            attrs: {
              id: opt.id,
              role: "option",
              "aria-selected": opt.isSelected
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.selectOption(index)
              }
            }
          },
          [
            _c(
              "span",
              { staticClass: "tt-o-listbox__option-icon-wrap" },
              [
                opt.iconName
                  ? _c("tt-icon", {
                      staticClass: "tt-o-listbox__option-icon",
                      attrs: {
                        name: opt.iconName,
                        size: "md",
                        ariaHidden: !opt.isSelected,
                        title: opt.iconTitle
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.isRating
              ? _c(
                  "div",
                  {
                    staticClass: "tt-o-listbox__rating-option",
                    attrs: { "aria-label": opt.label }
                  },
                  _vm._l(5, function(n) {
                    return _c("tt-icon", {
                      staticClass: "tt-c-rating__rating-option-icon",
                      attrs: {
                        name: "star--" + (5 - index >= n ? "full" : "empty")
                      }
                    })
                  })
                )
              : _c("span", {
                  staticClass: "tt-o-listbox__option-text",
                  domProps: { innerHTML: _vm._s(opt.label) }
                })
          ]
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("ce2180c4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("ce2180c4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-c-review-filters" },
    _vm._l(_vm.listBoxValues, function(lbv) {
      return _c("tt-listbox", {
        key: lbv.filter.group + "-" + lbv.filter.name,
        attrs: {
          deselectable: true,
          model: lbv.model,
          isRating: lbv.filter.isRating,
          label: lbv.label,
          multiSelect: lbv.multiSelect,
          options: lbv.filter.options,
          subLabel: lbv.subLabel
        },
        on: {
          change: function($event) {
            _vm.onChange(lbv.filter, $event)
          }
        }
      })
    })
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("3b1bd138", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("3b1bd138", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tt-c-reviews-list-utilities" }, [
    _c(
      "div",
      { staticClass: "tt-c-reviews-toolbar" },
      [
        _c("tt-listbox", {
          staticClass: "tt-c-reviews-toolbar__sort",
          attrs: {
            model: _vm.sortBy,
            disabled: _vm.hasSearchTerm,
            label: _vm.$msg("reviewsList.sort"),
            multiSelect: false,
            options: _vm.sortField.options,
            subLabel: _vm.sortField.label
          },
          on: { change: _vm.onSort }
        }),
        _vm._v(" "),
        _c("label", {
          staticClass: "tt-u-clip-hide",
          attrs: { for: "tt-c-reviews-list-search-field" },
          domProps: { innerHTML: _vm._s(_vm.$msg("reviewsList.searchReviews")) }
        }),
        _vm._v(" "),
        _c("tt-search-field", {
          staticClass: "tt-c-reviews-toolbar__search",
          attrs: {
            fieldId: "tt-c-reviews-list-search-field",
            placeholder: _vm.$msg("reviewsList.searchReviews"),
            showSearchIcon: true
          },
          model: {
            value: _vm.reviewsStore.searchTerm,
            callback: function($$v) {
              _vm.$set(_vm.reviewsStore, "searchTerm", $$v)
            },
            expression: "reviewsStore.searchTerm"
          }
        }),
        _vm._v(" "),
        _vm.numFilters === 1
          ? _c("tt-review-filters")
          : _vm.showFiltersToggle
            ? _c(
                "tt-button",
                {
                  staticClass: "tt-c-reviews-toolbar__filters-toggle",
                  attrs: { type: "toolbar" },
                  on: { click: _vm.toggleFilters }
                },
                [
                  _c("span", {
                    staticClass: "tt-c-reviews-toolbar__filters-toggle-text",
                    domProps: { innerHTML: _vm._s(_vm.toggleFiltersText) }
                  }),
                  _c("tt-icon", { attrs: { name: "controls", size: "sm" } })
                ],
                1
              )
            : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "tt-c-reviews-toolbar__spacer" }),
        _vm._v(" "),
        !_vm.hideWriteReview && !_vm.isLaunchingWriteReview
          ? _c("tt-button", {
              staticClass: "tt-c-reviews-toolbar__write-review",
              attrs: { type: "primary" },
              domProps: {
                innerHTML: _vm._s(_vm.$msg("reviewsList.writeReview"))
              },
              on: { click: _vm.writeReview }
            })
          : !_vm.hideWriteReview && _vm.isLaunchingWriteReview
            ? _c("div", { staticClass: "tt-o-spinner tt-o-spinner--submit" })
            : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _vm.showFilters
      ? _c(
          "div",
          { staticClass: "tt-c-reviews-filters-row tt-u-spacing--sm" },
          [_c("tt-review-filters")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.appliedFilterOptions.length > 0,
            expression: "appliedFilterOptions.length > 0"
          }
        ],
        staticClass: "tt-c-reviews-applied-filters"
      },
      [
        _c(
          "div",
          { staticClass: "tt-c-reviews-applied-filters__inner" },
          [
            _c("tt-button", {
              staticClass: "tt-c-reviews-applied-filters__clear",
              attrs: { type: "compact-text" },
              domProps: { innerHTML: _vm._s(_vm.$msg("reviewsList.clearAll")) },
              on: { click: _vm.clearAllFilters }
            }),
            _vm._v(" "),
            _vm._l(_vm.appliedFilterOptions, function(filterOption) {
              return _c(
                "tt-button",
                {
                  staticClass: "tt-c-reviews-applied-filters__filter",
                  attrs: {
                    type: "chip",
                    "aria-label": _vm.$msg("reviewsList.removeFilter", [
                      filterOption.label
                    ])
                  },
                  on: {
                    click: function($event) {
                      _vm.removeFilter(filterOption.filter, filterOption.value)
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "tt-c-reviews-applied-filters__filter-text",
                    domProps: { innerHTML: _vm._s(filterOption.label) }
                  }),
                  _vm._v(" "),
                  _c("tt-icon", { attrs: { name: "close", size: "xxs" } })
                ],
                1
              )
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("54c5f291", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("54c5f291", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.total > 0 || _vm.showUtilities
    ? _c(
        "div",
        { ref: "reviewsList", staticClass: "tt-c-reviews-list" },
        [
          _c("div", { staticClass: "tt-c-reviews-list__header tt-u-mb--md" }, [
            _c("div", {
              ref: "headingText",
              staticClass: "tt-c-reviews-list__heading",
              attrs: { tabindex: "-1" },
              domProps: { innerHTML: _vm._s(_vm.headingText) }
            })
          ]),
          _vm._v(" "),
          _vm.showUtilities ? _c("tt-reviews-list-utilities") : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tt-c-reviews-list__content" },
            [
              _vm._l(_vm.reviews, function(review) {
                return _c("tt-review", {
                  key: review.id,
                  attrs: {
                    allItemsInLayout: _vm.allItemsInLayout,
                    currentLayout: _vm.currentLayout,
                    isRelatedReview: _vm.currentSku !== review.catItem.sku,
                    mediaSize: _vm.mediaSize,
                    review: review,
                    showPurchaserBadge:
                      _vm.reviewsListConfig.showPurchaserBadge,
                    slotNamesAfterShowDetails: _vm.slotNamesAfterShowDetails,
                    truncateLength: _vm.truncateLength
                  },
                  on: { openMediaModal: _vm.openMediaModal }
                })
              }),
              _vm._v(" "),
              _vm.noFilterResults
                ? _c("div", {
                    staticClass: "tt-c-reviews-list__text-content",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$msg("reviewsList.numberOfReviews.filtered.none")
                      )
                    }
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.reviewsListConfig.useShowMore
            ? _c(
                "div",
                { staticClass: "tt-c-reviews-list__show-more" },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMoreDisabled,
                        expression: "showMoreDisabled"
                      }
                    ],
                    staticClass: "tt-o-spinner"
                  }),
                  _vm._v(" "),
                  _c("tt-button", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showMoreDisabled && _vm.hasMoreRslts,
                        expression: "!showMoreDisabled && hasMoreRslts"
                      }
                    ],
                    staticClass: "tt-c-reviews-list__show-more-btn",
                    attrs: { type: "primary" },
                    domProps: {
                      innerHTML: _vm._s(_vm.$msg("reviewsList.showMore"))
                    },
                    on: { click: _vm.showMore }
                  })
                ],
                1
              )
            : !_vm.reviewsListConfig.useShowMore
              ? _c("tt-pagination", {
                  attrs: {
                    currentPage: _vm.currentPage,
                    total: _vm.totalReviews,
                    initialPageSize: _vm.initialPageSize,
                    pageSize: _vm.pageSize
                  },
                  on: { updatePage: _vm.pageChange }
                })
              : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("cafae7a4", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("cafae7a4", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tt-w-reviews-list" },
    [
      _vm.showUserToolbar ? _c("tt-user-toolbar") : _vm._e(),
      _vm._v(" "),
      _c("tt-reviews-list", {
        on: {
          openMediaModal: _vm.openMediaModal,
          reviewsLoaded: _vm.reviewsLoaded
        }
      }),
      _vm._v(" "),
      _vm.showRelatedList && !_vm.showSearchResults
        ? _c("tt-related-reviews-list", {
            on: {
              openMediaModal: _vm.openMediaModal,
              relatedReviewsLoaded: _vm.relatedReviewsLoaded
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

module.exports = function (_exports) {
  var options = typeof _exports === 'function'
    ? _exports.options
    : _exports
  options.render = render
  options.staticRenderFns = staticRenderFns
  if (false) {
    api.createRecord("2c4b0abc", options)
  }
  return _exports
}
var api = null
if (false) {(function () {
  api = require("vue-hot-reload-api")
  api.install(require("vue"))
  if (!api.compatible) return
  module.hot.accept()
  if (module.hot.data) {
    api.rerender("2c4b0abc", { render: render, staticRenderFns: staticRenderFns })
  }
})()}


/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./arrow-fill.svg": 243,
	"./back-arrow.svg": 244,
	"./bell.svg": 245,
	"./caret-down.svg": 246,
	"./caret-left.svg": 247,
	"./caret-right.svg": 248,
	"./check.svg": 249,
	"./checkbox--off.svg": 250,
	"./checkbox--on.svg": 251,
	"./close.svg": 252,
	"./controls.svg": 253,
	"./delete.svg": 254,
	"./error.svg": 255,
	"./flag-off.svg": 256,
	"./flag-on.svg": 257,
	"./heart.svg": 258,
	"./helpful-off.svg": 259,
	"./helpful-on.svg": 260,
	"./info.svg": 261,
	"./logout.svg": 262,
	"./moderate.svg": 263,
	"./more-H.svg": 264,
	"./next-arrow.svg": 265,
	"./options-collapse.svg": 266,
	"./options-expand.svg": 267,
	"./photo.svg": 268,
	"./posts.svg": 269,
	"./profile.svg": 270,
	"./question.svg": 271,
	"./quote.svg": 272,
	"./reply.svg": 273,
	"./search.svg": 274,
	"./settings.svg": 275,
	"./social-facebook.svg": 276,
	"./social-google.svg": 277,
	"./social-pinterest.svg": 278,
	"./social-twitter.svg": 279,
	"./sort.svg": 280,
	"./star--empty.svg": 281,
	"./star--full.svg": 282,
	"./star--half.svg": 283,
	"./unhelpful-off.svg": 284,
	"./unhelpful-on.svg": 285,
	"./video.svg": 286,
	"./vote-off.svg": 287,
	"./vote-on.svg": 288,
	"./write.svg": 289
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-arrow-fill\" viewBox=\"0 0 24 24\"><path d=\"M0 6.09C3.9 10 8.1 14 12 17.91 16.1 14 19.9 10 24 6.09z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-back-arrow\" viewBox=\"0 0 24 24\"><path d=\"M24 10.53v2.94H5.75l8.36 8.42L12 24 0 12 12 0l2.11 2.11-8.36 8.42H24z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-bell\" viewBox=\"0 0 24 24\"><path d=\"M4.25 17.19h15.5a7 7 0 0 1-2.56-5.4V8.1a5.19 5.19 0 0 0-10.38 0v3.69a7 7 0 0 1-2.56 5.4zm19.44 2.6H.31v-3.53L1.2 16a4.39 4.39 0 0 0 3-4.17V8.1a7.79 7.79 0 0 1 15.58 0v3.69a4.39 4.39 0 0 0 3 4.17l.89.3zm-16.16 1.3h8.94a5.14 5.14 0 0 1-8.94 0z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-caret-down\" viewBox=\"0 0 24 24\"><path d=\"M2.7 5.23L.16 7.6 12 18.77 23.84 7.6 21.3 5.23l-9.3 8.8-9.3-8.8z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-caret-left\" viewBox=\"0 0 24 24\"><path d=\"M18.86 2.57L16.46 0 5.14 12l11.32 12 2.4-2.57L9.94 12l8.92-9.43z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-caret-right\" viewBox=\"0 0 24 24\"><path d=\"M14.06 12l-8.92 9.43L7.54 24l11.32-12L7.54 0l-2.4 2.57L14.06 12z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-check\" viewBox=\"0 0 24 24\"><path d=\"M7.47 21.98L.14 14.65l2.63-2.63 4.57 4.58L20.92 1.67l2.75 2.5-16.2 17.81z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-checkbox--off\" viewBox=\"0 0 32 32\"><path d=\"M28 0H4C1.8 0 0 1.8 0 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm0 28H4V4h24v24z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-checkbox--on\" viewBox=\"0 0 32 32\"><path d=\"M28 0H4C1.8 0 0 1.8 0 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zM14 24.828l-7.414-7.414 2.828-2.828L14 19.172l9.586-9.586 2.828 2.828L14 24.828z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-close\" viewBox=\"0 0 24 24\"><path d=\"M23.44 2.86L14.3 12l9.14 9.14-2.3 2.3L12 14.3l-9.14 9.14-2.3-2.3L9.7 12 .56 2.86l2.3-2.3L12 9.7 21.14.56z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-controls\" viewBox=\"0 0 24 24\"><path d=\"M.17 5.85v2.39h3.92a3.77 3.77 0 0 0 3.7 2.68 3.79 3.79 0 0 0 3.71-2.68h12.33V5.85H11.52a4.11 4.11 0 0 0-3.73-2.72 4.13 4.13 0 0 0-3.73 2.72zM19.91 14.93a4.11 4.11 0 0 0-3.73-2.72 4.13 4.13 0 0 0-3.73 2.72H.17v2.39h12.31a3.76 3.76 0 0 0 3.7 2.68 3.78 3.78 0 0 0 3.71-2.68h3.94v-2.39z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-delete\" viewBox=\"0 0 24 24\"><path d=\"M3.34 21.28a2.48 2.48 0 0 0 2.47 2.47h12.37a2.48 2.48 0 0 0 2.47-2.47V6.43H3.34zM5.82 8.91h12.36v12.37H5.82zm9.89-6.18h7.42V5.2H.87V2.72h7.42V.25h7.42zm-7.42 8.65v7.42h2.47v-7.42zm4.95 0v7.42h2.47v-7.42z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-error\" viewBox=\"0 0 24 24\"><path d=\"M23.65 11.15L12.85.35a1.2 1.2 0 0 0-1.7 0L.35 11.15a1.2 1.2 0 0 0 0 1.7l10.8 10.8a1.21 1.21 0 0 0 1.7 0l10.8-10.8a1.2 1.2 0 0 0 0-1.7zM12 21.1L2.9 12 12 2.9l9.1 9.1z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M10.8 7.2h2.4v7.2h-2.4z\"/><circle cx=\"12\" cy=\"16.8\" r=\"1.5\"/></symbol>"

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-flag-off\" viewBox=\"0 0 24 24\"><path d=\"M16.52 2.64l5.75.36v13.83h-8.44l-2.75-2.72h-6.7v9.66H1.73V.23h12.1zm-.87 2.26l-2.32-2.15H4.25v8.43h7.66l2.95 2.32L20 14.61V6.22z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-flag-on\" viewBox=\"0 0 24 24\"><path d=\"M16.52 2.64l5.75.36v13.83h-8.44l-2.75-2.72h-6.7v9.66H1.73V.23h12.1z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-heart\" viewBox=\"0 0 24 24\"><path d=\"M12.11 19.6q2.67-2.39 4-3.62t2.78-2.9a12.35 12.35 0 0 0 2.09-3 6 6 0 0 0 .58-2.51 4 4 0 0 0-1.2-3 4.09 4.09 0 0 0-3-1.17 4.65 4.65 0 0 0-2.59.78 4 4 0 0 0-1.64 2h-2.24a4 4 0 0 0-1.64-2 4.65 4.65 0 0 0-2.59-.78 4.09 4.09 0 0 0-3 1.17 4 4 0 0 0-1.2 3 6 6 0 0 0 .58 2.51 12.35 12.35 0 0 0 2.09 3q1.5 1.67 2.78 2.9t4 3.62l.11.11zm5.24-18.49A6.26 6.26 0 0 1 22 3a6.34 6.34 0 0 1 1.87 4.62 8.4 8.4 0 0 1-.61 3.15A12.65 12.65 0 0 1 21 14.2q-1.64 1.89-3 3.17t-4.29 4L12 22.89l-1.73-1.5q-3.84-3.46-5.54-5.19a23.1 23.1 0 0 1-3.15-4.06A8.58 8.58 0 0 1 .14 7.63 6.34 6.34 0 0 1 2 3a6.26 6.26 0 0 1 4.65-1.89A6.7 6.7 0 0 1 12 3.62a6.7 6.7 0 0 1 5.35-2.51z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M17.35 1.11A6.26 6.26 0 0 1 22 3a6.34 6.34 0 0 1 1.87 4.62 8.4 8.4 0 0 1-.61 3.15A12.65 12.65 0 0 1 21 14.2q-1.64 1.89-3 3.17t-4.29 4L12 22.89l-1.73-1.5q-3.84-3.46-5.54-5.19a23.1 23.1 0 0 1-3.15-4.06A8.58 8.58 0 0 1 .14 7.63 6.34 6.34 0 0 1 2 3a6.26 6.26 0 0 1 4.65-1.89A6.7 6.7 0 0 1 12 3.62a6.7 6.7 0 0 1 5.35-2.51z\"/></symbol>"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-helpful-off\" viewBox=\"0 0 24 24\"><path d=\"M12.11 19.69c1.81-1.61 3.14-2.84 4-3.66s1.81-1.8 2.82-2.93a12.41 12.41 0 0 0 2.11-3 6 6 0 0 0 .59-2.53 4 4 0 0 0-1.21-3 4.12 4.12 0 0 0-3-1.18 4.68 4.68 0 0 0-2.62.79 4 4 0 0 0-1.66 2h-2.27a4 4 0 0 0-1.66-2 4.68 4.68 0 0 0-2.62-.79 4.12 4.12 0 0 0-3 1.18 4 4 0 0 0-1.21 3A6 6 0 0 0 3 10.11a12.41 12.41 0 0 0 2.11 3C6.08 14.23 7 15.2 7.89 16s2.19 2 4 3.66l.11.11zM17.41 1a6.31 6.31 0 0 1 4.7 1.91A6.42 6.42 0 0 1 24 7.58a8.53 8.53 0 0 1-.62 3.18 12.77 12.77 0 0 1-2.28 3.47c-1.11 1.27-2.11 2.34-3 3.21s-2.34 2.19-4.33 4L12 23l-1.75-1.52c-2.59-2.33-4.46-4.07-5.6-5.24a23.08 23.08 0 0 1-3.19-4.11A8.75 8.75 0 0 1 0 7.58 6.42 6.42 0 0 1 1.89 2.9 6.31 6.31 0 0 1 6.59 1 6.78 6.78 0 0 1 12 3.52 6.78 6.78 0 0 1 17.41 1z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-helpful-on\" viewBox=\"0 0 24 24\"><path d=\"M17.41 1a6.31 6.31 0 0 1 4.7 1.91A6.42 6.42 0 0 1 24 7.58a8.53 8.53 0 0 1-.62 3.18 12.77 12.77 0 0 1-2.28 3.47c-1.11 1.27-2.11 2.34-3 3.21s-2.34 2.19-4.33 4L12 23l-1.75-1.52c-2.59-2.33-4.46-4.07-5.6-5.24a23.08 23.08 0 0 1-3.19-4.11A8.75 8.75 0 0 1 0 7.58 6.42 6.42 0 0 1 1.89 2.9 6.31 6.31 0 0 1 6.59 1c2.18 0 4 2.17 5.41 3.86C13.43 3.16 15.23 1 17.41 1z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-info\" viewBox=\"0 0 24 24\"><path d=\"M12 .25A11.75 11.75 0 1 0 23.75 12 11.76 11.76 0 0 0 12 .25zm0 21.15a9.4 9.4 0 1 1 9.4-9.4 9.41 9.41 0 0 1-9.4 9.4z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M13.18 15.53v-4.7A1.17 1.17 0 0 0 12 9.65H9.65V12h1.17v3.53H8.48v2.35h7.05v-2.35z\"/><circle cx=\"12\" cy=\"7.3\" r=\"1.47\"/></symbol>"

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-logout\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M18.23 10.87H5.77v2.26h12.46v3.4L23.89 12l-5.66-4.53zm-3.4 4.53h-2.26v4.53H2.37V4.07h10.2V8.6h2.26V1.81H.11v20.38h14.72z\"/></symbol>"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-moderate\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0V0z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z\"/></symbol>"

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-more-h\" viewBox=\"0 0 24 24\"><path d=\"M14.59 12A2.59 2.59 0 1 1 12 9.41 2.59 2.59 0 0 1 14.59 12zm9.07 0a2.59 2.59 0 1 1-2.59-2.59 2.59 2.59 0 0 1 2.6 2.59zM5.52 12a2.59 2.59 0 1 1-2.59-2.59A2.59 2.59 0 0 1 5.52 12z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-next-arrow\" viewBox=\"0 0 24 24\"><path d=\"M18.25 10.53L9.89 2.11 12 0l12 12-12 12-2.11-2.11 8.36-8.42H0v-2.94h18.25z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-options-collapse\" viewBox=\"0 0 24 24\"><path d=\"M5.47 0L3.69 1.66 12 9.5l8.31-7.84L18.53 0 12 6.17 5.47 0zM12 17.82L18.53 24l1.78-1.66L12 14.5l-8.31 7.84L5.47 24 12 17.82z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-options-expand\" viewBox=\"0 0 24 24\"><path d=\"M12 3.33l6.53 6.17 1.78-1.66L12 0 3.69 7.84 5.47 9.5 12 3.33zM5.47 14.5l-1.78 1.66L12 24l8.31-7.84-1.78-1.66L12 20.68 5.47 14.5z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-photo\" viewBox=\"0 0 24 24\"><path d=\"M23.07 4.54a2.2 2.2 0 0 0-1.63-.71h-3.75l-2.16-2.28H8.47L6.31 3.83H2.56a2.2 2.2 0 0 0-1.63.71 2.27 2.27 0 0 0-.69 1.64v13.93a2.27 2.27 0 0 0 .69 1.63 2.2 2.2 0 0 0 1.63.71h18.88a2.2 2.2 0 0 0 1.63-.71 2.27 2.27 0 0 0 .69-1.63V6.18a2.27 2.27 0 0 0-.69-1.64zm-1.27 14a1.82 1.82 0 0 1-.57 1.33 1.86 1.86 0 0 1-1.36.57H4.13a1.86 1.86 0 0 1-1.36-.57 1.82 1.82 0 0 1-.57-1.33v-11a1.82 1.82 0 0 1 .57-1.33 1.86 1.86 0 0 1 1.36-.57h3.13l1.8-2.13h5.89l1.79 2.13h3.13a1.86 1.86 0 0 1 1.36.57 1.82 1.82 0 0 1 .57 1.33z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M16.17 8.51A5.69 5.69 0 0 0 12 6.77a5.69 5.69 0 0 0-4.17 1.74 5.69 5.69 0 0 0-1.74 4.17 5.69 5.69 0 0 0 1.74 4.17A5.69 5.69 0 0 0 12 18.59a5.69 5.69 0 0 0 4.17-1.74 5.69 5.69 0 0 0 1.74-4.17 5.69 5.69 0 0 0-1.74-4.17zm-1.52 6.79a3.73 3.73 0 0 1-5.3 0 3.73 3.73 0 0 1 0-5.3 3.73 3.73 0 0 1 5.3 0 3.73 3.73 0 0 1 0 5.3z\"/></symbol>"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-posts\" viewBox=\"0 0 24 24\"><path d=\"M10.71 3H3v18h18v-7.7H10.71zm2.58 1.8v5.9h5.9zm9.63 7.2h.66v9A2.67 2.67 0 0 1 21 23.58H3a2.46 2.46 0 0 1-1.84-.78A2.54 2.54 0 0 1 .42 21V3a2.54 2.54 0 0 1 .75-1.8A2.46 2.46 0 0 1 3 .42h9v.66l.6-.6L23.52 11.4z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-profile\" viewBox=\"0 0 24 24\"><path d=\"M15.87 13.86l1 .21a14.51 14.51 0 0 1 4.8 2.07c1.45 1 2.18 2.05 2.18 3.25v4.42H.18v-4.42c0-1.2.73-2.28 2.18-3.25a14.51 14.51 0 0 1 4.8-2.07l1-.21a7.8 7.8 0 0 1-1.36-1.07 7 7 0 0 1-2.17-5.17A7.18 7.18 0 0 1 6.8 2.4 7.06 7.06 0 0 1 12 .2a7.06 7.06 0 0 1 5.2 2.2 7.18 7.18 0 0 1 2.17 5.22 7 7 0 0 1-2.17 5.17 7.8 7.8 0 0 1-1.33 1.07zM12 16.28a16.64 16.64 0 0 0-6 1.14c-2 .76-3 1.42-3 2V21h18v-1.61c0-.55-1-1.21-3-2a16.64 16.64 0 0 0-6-1.11zM11.84 3a4.25 4.25 0 0 0-3.15 1.31 4.34 4.34 0 0 0-1.27 3.18 4.18 4.18 0 0 0 1.27 3.13 4.33 4.33 0 0 0 3.15 1.24A4.32 4.32 0 0 0 15 10.62a4.19 4.19 0 0 0 1.28-3.13A4.35 4.35 0 0 0 15 4.31 4.25 4.25 0 0 0 11.84 3z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-question\" viewBox=\"0 0 24 24\"><path d=\"M12 4.89a4.55 4.55 0 0 1 3.33 1.39 4.55 4.55 0 0 1 1.39 3.33 4.35 4.35 0 0 1-1.78 3.08q-1.78 1.58-1.78 2.86h-2.33a4.16 4.16 0 0 1 .56-2.2A3.93 3.93 0 0 1 12.61 12a5.82 5.82 0 0 0 1.22-1 2 2 0 0 0 .56-1.39A2.2 2.2 0 0 0 13.67 8a2.35 2.35 0 0 0-3.32 0 2.2 2.2 0 0 0-.72 1.64H7.28a4.55 4.55 0 0 1 1.39-3.36A4.55 4.55 0 0 1 12 4.89z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M20.36 3.63A11.4 11.4 0 0 0 12 .16a11.4 11.4 0 0 0-8.36 3.48A11.4 11.4 0 0 0 .16 12a11.4 11.4 0 0 0 3.48 8.37A11.4 11.4 0 0 0 12 23.84a11.4 11.4 0 0 0 8.37-3.48A11.4 11.4 0 0 0 23.84 12a11.4 11.4 0 0 0-3.48-8.37zM18.7 18.69A9.14 9.14 0 0 1 12 21.5a9.14 9.14 0 0 1-6.7-2.8A9.14 9.14 0 0 1 2.5 12a9.14 9.14 0 0 1 2.8-6.7A9.14 9.14 0 0 1 12 2.5a9.14 9.14 0 0 1 6.7 2.8 9.14 9.14 0 0 1 2.8 6.7 9.14 9.14 0 0 1-2.8 6.69z\"/><path d=\"M10.83 19.16v-2.44h2.33v2.39l-2.33.05z\"/></symbol>"

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-quote\" viewBox=\"0 0 24 24\"><path d=\"M.28 14.81c0 4.11 2.65 6.44 5.62 6.44a5 5 0 0 0 5-5 4.29 4.29 0 0 0-4.3-4.54 3.11 3.11 0 0 0-1.26.19 11 11 0 0 1 4.93-6L6.79 3.13A14.36 14.36 0 0 0 .28 14.81zm12.88 0c0 4.11 2.59 6.44 5.56 6.44a5 5 0 0 0 5-5 4.27 4.27 0 0 0-4.23-4.55 3.11 3.11 0 0 0-1.26.19c.51-2.27 2.91-4.93 4.93-6l-3.55-2.76a14.3 14.3 0 0 0-6.44 11.68z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-reply\" viewBox=\"0 0 24 24\"><path d=\"M5.43 10.21l4.28-4.56-1.82-2L.5 11.57l7.39 7.9 1.82-2-4.35-4.6a29.76 29.76 0 0 1 10.46 1.71 19.12 19.12 0 0 1 7.68 5.75c-.66-3.33-3.09-5.75-6.13-7.46-2.68-1.51-7.07-2.51-11.94-2.66z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-search\" viewBox=\"0 0 24 24\"><path d=\"M21.707 20.293L16.314 14.9A7.928 7.928 0 0 0 18 10a7.945 7.945 0 0 0-2.344-5.656A7.94 7.94 0 0 0 10 2a7.94 7.94 0 0 0-5.656 2.344A7.945 7.945 0 0 0 2 10c0 2.137.833 4.146 2.344 5.656A7.94 7.94 0 0 0 10 18a7.922 7.922 0 0 0 4.9-1.686l5.393 5.392 1.414-1.413zM10 16a5.959 5.959 0 0 1-4.242-1.757A5.958 5.958 0 0 1 4 10c0-1.602.624-3.109 1.758-4.242A5.956 5.956 0 0 1 10 4c1.603 0 3.109.624 4.242 1.758A5.957 5.957 0 0 1 16 10c0 1.603-.624 3.11-1.758 4.243A5.959 5.959 0 0 1 10 16z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-settings\" viewBox=\"0 0 24 24\"><path d=\"M23.75 14v-4h-2.16a9.65 9.65 0 0 0-1.43-3.43l1.53-1.54-2.76-2.73-1.54 1.54A9.65 9.65 0 0 0 14 2.41V.25h-4v2.16a9.73 9.73 0 0 0-3.39 1.43L5.08 2.31 2.31 5.08l1.53 1.53A9.65 9.65 0 0 0 2.41 10H.25v4h2.16a9.49 9.49 0 0 0 1.44 3.43l-1.54 1.5 2.77 2.76 1.53-1.53a9.7 9.7 0 0 0 3.44 1.43v2.16H14v-2.16a9.76 9.76 0 0 0 3.43-1.43l1.54 1.53 2.76-2.77-1.53-1.53A9.73 9.73 0 0 0 21.59 14zM12 18.53A6.53 6.53 0 1 1 18.53 12 6.53 6.53 0 0 1 12 18.53z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-facebook\" viewBox=\"0 0 24 24\"><path d=\"M13.84 23.86V13h3.63L18 8.82h-4.16V6.13c0-1.22.34-2.05 2.09-2.05h2.23V.31A29.87 29.87 0 0 0 14.9.14c-3.22 0-5.42 2-5.42 5.57v3.11H5.84V13h3.64v10.86z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-google\" viewBox=\"0 0 24 24\"><path d=\"M.47 11.41A11.77 11.77 0 0 1 12.23.21a12 12 0 0 1 7.88 2.91 42 42 0 0 1-3 3.1C14.44 4.37 10.63 3.84 7.95 6a7.55 7.55 0 0 0-.32 11.77C11.21 21 18 19.39 19 14.41c-2.25 0-4.5 0-6.75-.07v-4h11.27c.23 3.15-.19 6.51-2.13 9.12C18.44 23.57 12.55 24.77 8 23A11.8 11.8 0 0 1 .47 11.41z\" fill=\"#fff\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-pinterest\" viewBox=\"0 0 24 24\"><path d=\"M7.07 21a14 14 0 0 1 0-3.68c.22-1 1.52-6.5 1.52-6.5a6.15 6.15 0 0 1-.32-1.95C8.27 7 9.35 5.7 10.65 5.7a1.65 1.65 0 0 1 1.62 1.84c0 1.08-.76 2.81-1.08 4.33a1.91 1.91 0 0 0 1.95 2.38c2.27 0 4.11-2.38 4.11-6A5.14 5.14 0 0 0 11.84 3 5.64 5.64 0 0 0 6 8.62a5 5 0 0 0 1 2.92.4.4 0 0 1 .11.32 13.08 13.08 0 0 0-.32 1.52c-.11.22-.22.32-.43.22-1.62-.76-2.6-3.14-2.6-5 0-4.11 3-7.9 8.55-7.9 4.55 0 8 3.25 8 7.47 0 4.44-2.81 8.12-6.71 8.12a3.49 3.49 0 0 1-3-1.52s-.65 2.49-.76 3.14a39.63 39.63 0 0 1-2.45 5.3c1.02.35-.14-.87-.32-2.21z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-social-twitter\" viewBox=\"0 0 24 24\"><path d=\"M20.87 5.58A4.56 4.56 0 0 0 22.93 3a11.17 11.17 0 0 1-3 1.11 4.49 4.49 0 0 0-3.45-1.51 4.66 4.66 0 0 0-3.4 1.4 4.58 4.58 0 0 0-1.38 3.34 3.35 3.35 0 0 0 .15 1.05A12.74 12.74 0 0 1 2 3.46a4.76 4.76 0 0 0-.66 2.38 4.59 4.59 0 0 0 2.12 4 5.26 5.26 0 0 1-2.12-.6 4.72 4.72 0 0 0 1.06 3.07 4.66 4.66 0 0 0 2.72 1.66 5.07 5.07 0 0 1-1.26.15A2.36 2.36 0 0 1 3 14a4.55 4.55 0 0 0 1.7 2.36 4.7 4.7 0 0 0 2.77 1 9.27 9.27 0 0 1-5.89 2 8 8 0 0 1-1.16 0 13.11 13.11 0 0 0 7.3 2.04A13 13 0 0 0 15 19.3a13.1 13.1 0 0 0 4.68-5.11 13.86 13.86 0 0 0 1.51-6.3v-.6a10 10 0 0 0 2.37-2.47 10.48 10.48 0 0 1-2.69.76z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-sort\" viewBox=\"0 0 24 24\"><path d=\"M4.12 10.63h15.77v2.74H4.12zM.09 4.04h23.82v2.74H.09zM9.15 17.21h5.71v2.74H9.15z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-star--empty\" viewBox=\"0 0 24 24\"><path d=\"M12 18l-6.4 3.88 1.73-7.33-5.66-4.93L9.09 9 12 2.09 14.91 9l7.42.64-5.63 5 1.72 7.34z\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-star--full\" viewBox=\"0 0 24 24\"><path d=\"M12 18.66l-7.44 4.35 1.98-8.16L0 9.36l8.62-.7L12 .99l3.38 7.67 8.62.7-6.54 5.49 1.98 8.16L12 18.66z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-star--half\" viewBox=\"0 0 24 24\"><path fill=\"currentColor\" d=\"M12 2.09L9.09 9l-7.42.62 5.66 4.93-1.72 7.32 1.07-.65L12 17.97V2.09z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M12 2.09L14.91 9l7.42.62-5.66 4.93 1.72 7.32-1.07-.65L12 17.97V2.09z\"/></symbol>"

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-unhelpful-off\" viewBox=\"0 0 24 24\"><path d=\"M12 4.2l-.11.11c-1.81 1.61-3.14 2.84-4 3.69s-1.81 1.77-2.82 2.9a12.41 12.41 0 0 0-2.11 3 6 6 0 0 0-.59 2.53 4 4 0 0 0 1.21 3 4.12 4.12 0 0 0 3 1.18 4.68 4.68 0 0 0 2.62-.79 4 4 0 0 0 1.66-2h2.26a4 4 0 0 0 1.66 2 4.68 4.68 0 0 0 2.62.79 4.12 4.12 0 0 0 3-1.18 4 4 0 0 0 1.21-3 6 6 0 0 0-.61-2.54 12.41 12.41 0 0 0-2.11-3C17.92 9.77 17 8.8 16.11 8s-2.19-2-4-3.66zm0 16.28A6.78 6.78 0 0 1 6.59 23a6.31 6.31 0 0 1-4.7-1.91A6.42 6.42 0 0 1 0 16.42a8.75 8.75 0 0 1 1.46-4.56 23.08 23.08 0 0 1 3.19-4.11c1.14-1.17 3-2.91 5.6-5.24L12 1l1.75 1.57q3 2.72 4.33 4c.91.87 1.91 1.94 3 3.21a12.77 12.77 0 0 1 2.28 3.47 8.53 8.53 0 0 1 .64 3.17 6.42 6.42 0 0 1-1.89 4.68 6.31 6.31 0 0 1-4.7 1.9A6.78 6.78 0 0 1 12 20.48z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-unhelpful-on\" viewBox=\"0 0 24 24\"><path d=\"M12 19.15C10.57 20.84 8.77 23 6.59 23a6.31 6.31 0 0 1-4.7-1.91A6.42 6.42 0 0 1 0 16.42a8.75 8.75 0 0 1 1.46-4.56 23.08 23.08 0 0 1 3.19-4.11c1.14-1.17 3-2.91 5.6-5.24L12 1l1.75 1.57q3 2.72 4.33 4c.91.87 1.91 1.94 3 3.21a12.77 12.77 0 0 1 2.28 3.47 8.53 8.53 0 0 1 .64 3.17 6.42 6.42 0 0 1-1.89 4.68 6.31 6.31 0 0 1-4.7 1.9c-2.18 0-3.98-2.16-5.41-3.85z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-video\" viewBox=\"0 0 24 24\"><path d=\"M23.1 3.28a2.18 2.18 0 0 0-1.63-.72H2.53a2.18 2.18 0 0 0-1.63.72 2.29 2.29 0 0 0-.7 1.66v14.12a2.29 2.29 0 0 0 .7 1.66 2.18 2.18 0 0 0 1.63.72h18.94a2.18 2.18 0 0 0 1.63-.72 2.29 2.29 0 0 0 .7-1.66V4.94a2.29 2.29 0 0 0-.7-1.66zM8.46 16.93V7.4l9.44 4.81z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-vote-off\" viewBox=\"0 0 24 24\"><path d=\"M13.71 4.32c2.92 4.52 10 14 10 14a2.34 2.34 0 0 1-2.33 2.33H2.62a2.34 2.34 0 0 1-2.33-2.36s6.81-9.48 10.29-14a1.8 1.8 0 0 1 3.13.03zm-11.08 14h18.74L12 6.64z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-vote-on\" viewBox=\"0 0 24 24\"><path d=\"M13.71 4.32c2.92 4.52 10 14 10 14a2.35 2.35 0 0 1-2.33 2.33H2.62A2.34 2.34 0 0 1 .29 18.3s6.81-9.48 10.29-14A1.8 1.8 0 0 1 13 3.64a1.82 1.82 0 0 1 .71.68z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "<symbol id=\"tt-icon-write\" viewBox=\"0 0 24 24\"><path d=\"M22.39 1.61a4.74 4.74 0 0 0-6.71 0L2.24 15a1.5 1.5 0 0 0-.31.54L.25 22.32a1.18 1.18 0 0 0 .31 1.12 1.18 1.18 0 0 0 1.12.31l6.72-1.68a1.49 1.49 0 0 0 .54-.31H9L22.39 8.32a4.75 4.75 0 0 0 0-6.71zm-7.55 4.18l3.37 3.37-10.09 10.1-3.37-3.38zM3 21l.7-2.8 2.1 2.1zM20.73 3.27a2.45 2.45 0 0 1 0 3.37l-.85.85-3.37-3.37.85-.85a2.44 2.44 0 0 1 3.37 0z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"

/***/ })
],[179]);


// WEBPACK FOOTER //
// Rdhcya1h7lLN3rcsite/js/pdp-page.js